export const trainingModules = {
  'leadership-vision-integrity': {
    id: 'leadership-vision-integrity',
    title: 'Leadership Vision & Integrity',
    modulenumber: '1.3.1',
    department: 'Management & Administration',
    videoUrl: '/videos/leadership.mp4',
    duration: 80,
    description: 'Visionary leadership, integrity, values-based decision making, and building sustainable organizational culture',
    requiredRoles: ['ceo', 'manager','quality-control'],
    validityMinutes: 259200, // 6 months in minutes
    quiz: [
      {
        id: 1,
        question: "What is the core leadership motto at Kajja Galleries?",
        options: [
          "Manage with Authority, Act with Speed",
          "Lead with Vision, Act with Integrity",
          "Direct with Power, Execute with Force",
          "Plan with Strategy, Deliver with Precision"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "What four elements must the GM ensure are delivered according to the mission?",
        options: [
          "Speed, Quality, Profit, Growth",
          "Quality, Creativity, Efficiency, Trust",
          "Innovation, Tradition, Excellence, Loyalty",
          "Production, Marketing, Sales, Service"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "What should every decision embody according to the training?",
        options: [
          "Maximum profit and minimum cost",
          "Personal convenience and team preference",
          "International quality, operational discipline, and ethical conduct",
          "Speed of execution above all else"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "What fuels accountability and growth according to the training?",
        options: [
          "Flexible rules and spontaneous decisions",
          "Clear systems and rigorous reporting",
          "Individual heroics and personal initiative",
          "External consultants and market trends"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "What are the core values mentioned that must be embraced?",
        options: [
          "Profitability, expansion, dominance, recognition",
          "Integrity, innovative methods, collaborative teamwork, customer focus",
          "Tradition, stability, hierarchy, routine",
          "Competition, secrecy, speed, aggression"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "How should challenges be tackled according to the leadership principles?",
        options: [
          "By avoiding risks and maintaining status quo",
          "By aligning diverse leadership styles and resolving conflicts with fairness",
          "By assigning blame and enforcing strict punishments",
          "By outsourcing problems to external experts"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What should be leveraged to foster trust, empathy, and sustainable progress?",
        options: [
          "Financial incentives and bonuses",
          "Strict rules and regulations",
          "Emotional intelligence",
          "Market competition and pressure"
        ],
        correctAnswer: 2
      },
      {
        id: 8,
        question: "What kind of processes should be built according to the training?",
        options: [
          "Rigid processes that eliminate flexibility",
          "Structured processes that empower teams and ensure transparent outcomes",
          "Minimal processes to reduce bureaucracy",
          "Complex processes that require expert management"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "How should leadership be modeled?",
        options: [
          "With authority, distance, and formality",
          "With presence, responsibility, and predictability",
          "With charisma, popularity, and visibility",
          "With secrecy, control, and autonomy"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What should leadership transform challenges into?",
        options: [
          "Problems to be avoided in the future",
          "Opportunities for growth and improvement",
          "Reasons to change strategy frequently",
          "Evidence of system failures"
        ],
        correctAnswer: 1
      },
      {
        id: 11,
        question: "What kind of legacy should leadership create?",
        options: [
          "A temporary success that boosts short-term profits",
          "An enduring legacy that fuels continuous innovation and nurtures talent",
          "A personal achievement record for the leader",
          "A competitive advantage over local rivals"
        ],
        correctAnswer: 1
      },
      {
        id: 12,
        question: "What should leadership unite according to the training?",
        options: [
          "Only the management team",
          "Shareholders and investors",
          "Our global family (all stakeholders)",
          "The production department only"
        ],
        correctAnswer: 2
      }
    ]
  }, 
  'brand-awareness-fundamentals': {
    id: 'brand-awareness-fundamentals',
    title: 'Brand Awareness & Fundamentals',
    modulenumber: '2.3.0',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768813003/media1_k0c5rs.mp4',
    duration: 80,
    description: 'Kajja brand identity, target audience definition, brand voice guidelines, and social media etiquette',
    requiredRoles: ['social_media_manager', 'marketing_manager', 'marketing-sales', 'content_creator'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Our main audience is:",
        options: [
          "People buying one kitchen spoon",
          "Commercial clients (developers, banks, offices, hotels)",
          "Teenagers looking for fashion",
          "People asking for free furniture"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Brand voice must be:",
        options: [
          "Funny & childish",
          "Professional, reliable, innovative",
          "Angry & defensive",
          "Casual always"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Posting without watermark:",
        options: [
          "Increases theft of our photos",
          "Improves credibility",
          "Has no effect",
          "Is recommended"
        ],
        correctAnswer: 0
      },
      {
        id: 4,
        question: "We must avoid:",
        options: [
          "Tagging clients without permission",
          "Reviewing captions before posting",
          "Scheduling posts",
          "Showing quality evidence"
        ],
        correctAnswer: 0
      },
      {
        id: 5,
        question: "Kajja social media exists to:",
        options: [
          "Entertain friends",
          "Show professionalism and attract commercial projects",
          "Hide our work",
          "Argue with strangers"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is Kajja's brand promise?",
        options: [
          "Only low prices",
          "Efficiency, creativity, trust",
          "Fast delivery only",
          "Home decorations"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Who should we NOT attract?",
        options: [
          "Property developers",
          "Low-budget household buyers",
          "Office managers",
          "Hotel owners"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "How should we respond to comments?",
        options: [
          "Politely within 2 hours",
          "After 2 days",
          "Ignore all comments",
          "Respond rudely if needed"
        ],
        correctAnswer: 0
      },
      {
        id: 9,
        question: "What should never be posted?",
        options: [
          "Completed projects",
          "Messy workshop photos or team eating lazily onsite",
          "Quality controls",
          "Professional installations"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must social media prove about Kajja?",
        options: [
          "We are entertainment company",
          "We are serious commercial furniture partner",
          "We are cheap option",
          "We are household carpenters"
        ],
        correctAnswer: 1
      }
    ]
  }, 
  'engagement-community-management': {
    id: 'engagement-community-management',
    title: 'Engagement & Community Management',
    modulenumber: '2.3.4',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768895979/media5_wvlmjz.mp4',
    duration: 85,
    description: 'Comment responses, lead management, negative feedback handling, referral strategies, and value-based community building',
    requiredRoles: ['social_media_manager', 'customer_service', 'marketing-sales', 'content_creator'],
    validityMinutes: 259200,
    quiz:[
      {
        id: 1,
        question: "According to the training, how should you handle every comment?",
        options: [
          "Ignore them if they're not important",
          "Reply professionally and promptly",
          "Only reply to positive comments",
          "Delete negative comments immediately"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "What shows that we care about customer inquiries?",
        options: [
          "Responding within 24 hours",
          "Fast answers within two hours",
          "Responding only during business hours",
          "Waiting for them to follow up"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "How should you handle negative customer feedback?",
        options: [
          "Argue back to defend the company",
          "Thank customers and move conversation offline",
          "Ignore negative comments completely",
          "Delete them immediately"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "What should satisfied clients be encouraged to do?",
        options: [
          "Keep their experience private",
          "Tag a friend and share positive experience",
          "Only share on personal pages",
          "Write formal reviews only"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "What type of content helps build our brand?",
        options: [
          "Only promotional sales content",
          "Thoughtful, value-driven educational content",
          "Entertaining memes and jokes",
          "Competitor comparisons"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What makes every digital handshake count?",
        options: [
          "Automated responses",
          "Quick, friendly, and genuine engagement",
          "Formal corporate language",
          "Delayed but detailed responses"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What strengthens our reputation according to the training?",
        options: [
          "Lowest prices",
          "Every prompt reply",
          "Fancy graphics",
          "Celebrity endorsements"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What do our interactions showcase?",
        options: [
          "Only our products",
          "Our commitment and expertise",
          "Our company size",
          "Our pricing strategy"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What do we become by mastering these engagement steps?",
        options: [
          "The cheapest option",
          "The experts our customers rely on",
          "The most popular brand",
          "The fastest deliverer"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What do we build through proper engagement?",
        options: [
          "Only sales numbers",
          "Trust, community, and expertise",
          "Social media followers",
          "Competitor advantages"
        ],
        correctAnswer: 1
      }
    ]
  },
  'content-creation-rules': {
    id: 'content-creation-rules',
    title: 'Content Creation Rules',
    modulenumber: '2.3.1',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768815409/media2_dr6rdb.mp4',
    duration: 85,
    description: 'Photography standards, before-after transformations, installation storytelling, reels creation, and caption writing',
    requiredRoles: ['social_media_manager', 'content_creator', 'marketing-sales', 'photographer'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Best time for photos:",
        options: [
          "When workshop is messy",
          "When space is clean and well-lit",
          "In the dark",
          "When carpenters are eating"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Before/After photos show:",
        options: [
          "Nothing",
          "Transformation and value",
          "Confusion",
          "Waste"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Caption focus should be:",
        options: [
          "Slang and personal gossip",
          "Client benefits and clear results",
          "Riddles",
          "Only emojis"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Reels must:",
        options: [
          "Match brand professionalism",
          "Include random jokes",
          "Be very long",
          "Use stolen music"
        ],
        correctAnswer: 0
      },
      {
        id: 5,
        question: "Hashtags help:",
        options: [
          "Reach the wrong people",
          "Attract relevant commercial audiences",
          "Hide posts",
          "Break brand positioning"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What must every picture be good enough for?",
        options: [
          "Only WhatsApp",
          "Put in a brochure",
          "Throw away",
          "Personal collection"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What shots should you take?",
        options: [
          "Only selfies",
          "Wide shots and detail shots",
          "Only close-ups",
          "Only dark photos"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What should reels show about Kajja?",
        options: [
          "Chaos and disorganization",
          "We deliver systems not just furniture",
          "Personal parties",
          "Competitor weaknesses"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "How long should reels be?",
        options: [
          "1-2 minutes minimum",
          "10–30 seconds max",
          "5 minutes minimum",
          "No time limit"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "When can you tag clients?",
        options: [
          "Always without asking",
          "Only with written approval",
          "Never tag anyone",
          "Only tag competitors"
        ],
        correctAnswer: 1
      }
    ]
  },
  'platforms-strategy': {
    id: 'platforms-strategy',
    title: 'Platforms & Strategy',
    modulenumber: '2.3.2',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768818752/media3_hhkkmx.mp4',
    duration: 85,
    description: 'Platform-specific strategies for Instagram, LinkedIn, TikTok, YouTube, and posting schedules',
    requiredRoles: ['social_media_manager', 'marketing_manager', 'marketing-sales', 'content_creator'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Which platform targets corporate and institutional clients?",
        options: [
          "TikTok",
          "LinkedIn",
          "Snapchat",
          "Random WhatsApp statuses"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Instagram's main purpose for Kajja is:",
        options: [
          "Entertaining friends",
          "Visual lead attraction + brand proof",
          "Debating politics",
          "Posting only fun selfies"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "YouTube is for:",
        options: [
          "Deep project stories and testimonials",
          "One-second clips only",
          "Posting memes",
          "Hiding our strengths"
        ],
        correctAnswer: 0
      },
      {
        id: 4,
        question: "TikTok content rule:",
        options: [
          "Premium tone + transformation focus",
          "Unprofessional jokes",
          "No watermarks",
          "Low-quality shots"
        ],
        correctAnswer: 0
      },
      {
        id: 5,
        question: "Content schedule priorities:",
        options: [
          "Post once a month",
          "Consistent weekly plan across platforms",
          "Guessing content ideas randomly",
          "No tracking"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Who is LinkedIn's audience?",
        options: [
          "Only teenagers",
          "CEOs, Property Developers, Procurement Heads",
          "Only competitors",
          "Random people"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "How often post on Instagram?",
        options: [
          "Once a year",
          "Minimum 3× per week",
          "Never",
          "Only on weekends"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What shows Kajja is a serious commercial partner?",
        options: [
          "Personal photos",
          "Case studies with results on LinkedIn",
          "Funny jokes",
          "Silence"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What content works on TikTok?",
        options: [
          "Political debates",
          "CNC cutting process and fast installation transitions",
          "Only selfies",
          "Competitor criticism"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What is the weekly posting standard?",
        options: [
          "No plan",
          "Consistent schedule across platforms",
          "Random posting",
          "Only when remembered"
        ],
        correctAnswer: 1
      }
    ]
  },
  'portfolio-showroom-content': {
    id: 'portfolio-showroom-content',
    title: 'Portfolio & Showroom Content',
    modulenumber: '2.3.3',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768821172/media4_pynkmo.mp4',
    duration: 85,
    description: 'Showroom presentation, craftsmanship details, project storytelling, team features, and testimonial usage',
    requiredRoles: ['social_media_manager', 'content_creator', 'photographer', 'marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Showroom content must look:",
        options: [
          "Cluttered and dusty",
          "Premium and clean",
          "Like a random warehouse",
          "Dark and messy"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Detail shots show:",
        options: [
          "Quality craftsmanship",
          "Irrelevant backgrounds",
          "Worker gossip",
          "Poor lighting"
        ],
        correctAnswer: 0
      },
      {
        id: 3,
        question: "A strong project story includes:",
        options: [
          "Only the final photo",
          "Design → Production → Installation → Final",
          "Random clips",
          "One bad photo"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Team workshop features must show:",
        options: [
          "Disorganization",
          "Safety and skill",
          "Lazy behavior",
          "No uniforms"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Testimonials help by:",
        options: [
          "Boring followers",
          "Building trust with real success stories",
          "Revealing confidential discussions",
          "Reducing confidence"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What must the showroom look like?",
        options: [
          "A roadside workshop",
          "A commercial design gallery",
          "A storage room",
          "A construction site"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What detail shots sell?",
        options: [
          "Only prices",
          "Quality sells trust",
          "Confusion",
          "Uncertainty"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What proves Kajja has systems?",
        options: [
          "Single photos",
          "Full journey from design to delivery",
          "Silence",
          "Only complaints"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What must workers wear in videos?",
        options: [
          "Casual clothes",
          "PPE (Personal Protective Equipment)",
          "No uniform",
          "Competitor logos"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "When can you tag clients?",
        options: [
          "Always without asking",
          "Only after asking for permission",
          "Never tag anyone",
          "Only tag competitors"
        ],
        correctAnswer: 1
      }
    ]
  },
  'social-media-sales-collaboration': {
    id: 'social-media-sales-collaboration',
    title: 'Social Media + Sales Collaboration',
    modulenumber: '2.3.5',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768897886/media6_dm4fyc.mp4',
    duration: 80,
    description: 'Pipeline support, lead handover, performance tracking, weekly reporting, and cross-team coordination',
    requiredRoles: ['social_media_manager', 'sales_manager', 'marketing-sales', 'client_relations_officer'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Social Media's role:",
        options: [
          "Just posting anything",
          "Support sales through trust-building & lead generation",
          "Making jokes for fun",
          "Posting personal life"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Once a lead enquires:",
        options: [
          "Ignore them",
          "Immediately hand over to CRO with details",
          "Start negotiating prices",
          "Ask them to wait one week"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "If a post doesn't generate inquiries:",
        options: [
          "Repeat it more",
          "Stop or improve it",
          "Fight followers",
          "Hide analytics"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Weekly report must show:",
        options: [
          "How many selfies posted",
          "What content produced leads & insights",
          "Gossip from workshop",
          "Random ideas without data"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Collaboration helps:",
        options: [
          "Show wrong stories",
          "Create accurate, trust-building content",
          "Confuse the company",
          "Spread secrets"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is the social media pipeline flow?",
        options: [
          "Random posting only",
          "Social Media → Lead → Qualification → Site Visit → Proposal → Installation → Referral",
          "Only entertainment",
          "No pipeline needed"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What must be completed before handing to CRO?",
        options: [
          "Nothing",
          "Name, company, contact, needs, timeline, location",
          "Only first name",
          "Random guesses"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What should be tracked weekly?",
        options: [
          "Only likes",
          "What type of posts produce direct DMs, WhatsApp clicks, phone calls, website visits",
          "Personal popularity",
          "Competitor posts"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Who receives the weekly report?",
        options: [
          "No one",
          "Head of Marketing, Sales/CRO, GM",
          "Only family members",
          "Competitors"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must you ask before posting?",
        options: [
          "Nothing",
          "Operations for installation milestones, Design for visuals, QC for improvements",
          "Random people online",
          "Only for likes"
        ],
        correctAnswer: 1
      }
    ]
  },
  'analytics-growth': {
    id: 'analytics-growth',
    title: 'Analytics & Growth',
    modulenumber: '2.3.6',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768899483/media7_ow1h47.mp4',
    duration: 85,
    description: 'Performance metrics, monthly reporting, content optimization, competitor monitoring, and brand safety',
    requiredRoles: ['social_media_manager', 'marketing_manager', 'marketing-sales', 'ceo', 'analyst'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "What outweighs 300 likes according to the training?",
        options: [
          "Three funny comments",
          "Three qualified enquiries",
          "Three shares",
          "Three profile visits"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "What matters more than likes?",
        options: [
          "Only followers",
          "Leads matter more than likes",
          "Only comments",
          "Only saves"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "What is the best success indicator for Kajja?",
        options: [
          "Number of followers",
          "Number of qualified enquiries",
          "Amount of likes",
          "Video views"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "What can't be improved if it can't be measured?",
        options: [
          "Team motivation",
          "Social media performance",
          "Client relationships",
          "Product quality"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "What should you track to understand performance?",
        options: [
          "Only likes",
          "Reach, engagement, saves, and click actions",
          "Only comments",
          "Only shares"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What should the monthly dashboard feature?",
        options: [
          "Personal achievements",
          "Follower growth and lead insights",
          "Office gossip",
          "Competitor secrets"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What should you do when a post performs well?",
        options: [
          "Delete it",
          "Repeat and improve the strategy",
          "Ignore it",
          "Hide it from competitors"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What is the optimization cycle?",
        options: [
          "Post, forget, repeat",
          "Repeat, improve, scale",
          "Create, delete, ignore",
          "Share, hide, delete"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What is competitive monitoring used for?",
        options: [
          "Copying everything",
          "Spotting trends and staying ahead",
          "Attacking competitors",
          "Sharing secrets"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What protects the company and builds trust?",
        options: [
          "Sharing everything publicly",
          "Professionalism online",
          "Responding to all rumors",
          "Posting internal conflicts"
        ],
        correctAnswer: 1
      }
    ] 
  },
  'professional-skills': {
    id: 'professional-skills',
    title: 'Professional Skills',
    modulenumber: '2.3.7',
    department: 'Social Media',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768906814/media8_qpzajc.mp4',
    duration: 80,
    description: 'Time discipline, editing skills, file organization, brand accountability, and personal development',
    requiredRoles: ['social_media_manager', 'content_creator', 'marketing-sales', 'all_staff'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Professional content posting requires:",
        options: [
          "Posting whenever you remember",
          "Following deadlines and weekly plan",
          "Guessing every day",
          "Ignoring management"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Editing tools improve:",
        options: [
          "Brand confidence and quality",
          "Confusion",
          "Mistakes",
          "Blurry videos"
        ],
        correctAnswer: 0
      },
      {
        id: 3,
        question: "Good file organization helps:",
        options: [
          "Lose content",
          "Work faster and avoid repeated work",
          "Create chaos",
          "Block teamwork"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Brand reputation must be protected by:",
        options: [
          "Careless posting",
          "Seeking approval & avoiding sensitive info",
          "Rumors",
          "Angry replies"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Self-development includes:",
        options: [
          "Learning and improving every month",
          "Refusing feedback",
          "Never trying new things",
          "Relying on luck"
        ],
        correctAnswer: 0
      },
      {
        id: 6,
        question: "What is the definition of professionalism?",
        options: [
          "Doing random things occasionally",
          "Doing the right thing on time — every time",
          "Working only when watched",
          "Posting without planning"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What should be in your editing checklist?",
        options: [
          "Nothing - just post",
          "Bright visuals, smooth transitions, text overlays, logo watermark",
          "Only add loud music",
          "Make everything blurry"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What is the folder structure rule?",
        options: [
          "Store everything on desktop",
          "Organized folders = faster work - reduce mistakes",
          "Use random names",
          "No folders needed"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What should your mindset be about posting?",
        options: [
          "Post anything interesting",
          "'I protect Kajja's reputation with every post'",
          "Share internal secrets",
          "Post rumors for attention"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "How should you approach learning?",
        options: [
          "Avoid all training",
          "High standards today → leadership opportunities tomorrow",
          "Stay the same forever",
          "Ignore industry trends"
        ],
        correctAnswer: 1
      }
    ]
  },
  'marketing-foundation-brand-identity': {
    id: 'marketing-foundation-brand-identity',
    title: 'Marketing Foundation & Brand Identity',
    modulenumber: '2.1.0',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768207783/marketing1_vqktkr.mp4',
    duration: 90,
    description: 'Kajja Galleries brand positioning, marketing role, customer segmentation, and marketing-sales alignment',
    requiredRoles: ['marketing_manager', 'head_of_marketing', 'sales_manager','marketing-sales','ceo'],
    validityMinutes: 259200, // 6 months in minutes
    quiz: [
      {
        id: 1,
        question: "The role of marketing at Kajja is to:",
        options: [
          "Build Instagram only",
          "Drive brand demand and generate qualified leads",
          "Wait for referrals only",
          "Focus only on small clients"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Kajja must be positioned mainly as:",
        options: [
          "A shop for home carpentry",
          "Uganda's leader in commercial and bulk furniture solutions",
          "Only a kitchen maker",
          "A handyman service"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "What do developers care most about?",
        options: [
          "Small decorative items",
          "Bulk supply, timeline, and reliability",
          "One dining table",
          "Only color choices"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "'Trust' as a brand value is shown by:",
        options: [
          "Promises without proof",
          "Testimonials, warranties, and consistency",
          "Low prices only",
          "Silence online"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Marketing vs Sales:",
        options: [
          "Work alone",
          "Marketing creates leads; Sales converts them",
          "Fight to show who is better",
          "Sales only uses WhatsApp"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is the primary responsibility of the Head of Marketing regarding visibility?",
        options: [
          "Build brand visibility only in Kampala",
          "Build brand visibility across Uganda & East Africa",
          "Focus only on international markets",
          "Wait for sales team to request visibility"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Which of these is NOT part of Kajja's brand promise?",
        options: [
          "Efficiency",
          "Creativity",
          "Trust",
          "Luxury"
        ],
        correctAnswer: 3
      },
      {
        id: 8,
        question: "When marketing to hotels/apartments, what should we highlight?",
        options: [
          "Single custom pieces",
          "Room packages: beds, wardrobes, TV units",
          "Only price discounts",
          "Home decoration items"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What should marketing provide during the proposal stage?",
        options: [
          "Nothing - sales handles everything",
          "Branded proposals and project images",
          "Payment collection methods",
          "Installation labor only"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Marketing must avoid branding Kajja as:",
        options: [
          "A commercial furniture leader",
          "A 'household carpenter'",
          "A B2B solutions provider",
          "A bulk order specialist"
        ],
        correctAnswer: 1
      }
    ]
  },
  'customer-insight-value-proposition': {
    id: 'customer-insight-value-proposition',
    title: 'Customer Insight & Value Proposition',
    modulenumber: '2.1.1',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768211242/marketting2_sjpfjc.mp4',
    duration: 95,
    description: 'Competitor analysis, differentiation strategy, client pain points mapping, and storytelling through case studies',
    requiredRoles: ['marketing_manager', 'head_of_marketing', 'sales_manager', 'ceo','marketing-sales'],
    validityMinutes: 259200, // 6 months in minutes
    quiz: [
      {
        id: 1,
        question: "Why is competitor analysis important?",
        options: [
          "To copy everything they do",
          "To position Kajja better with compelling value",
          "So we can criticize them online",
          "It's not necessary"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Kajja's strongest differentiator for commercial clients is:",
        options: [
          "Cheap labor",
          "Systems and reliability with quality execution",
          "Only appearance",
          "We guess timelines"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Case studies help by:",
        options: [
          "Guessing success",
          "Showing real proof of ability & trust",
          "Confusing clients",
          "Hiding results"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "What do commercial clients buy from Kajja?",
        options: [
          "Just furniture",
          "Peace of mind + quality + on-time delivery",
          "Panic and delays",
          "Unskilled installation"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Storytelling must include:",
        options: [
          "Random photos",
          "Problem → Solution → Verified Result",
          "Only selfies",
          "Boring text"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "According to the framework, what should you analyze about competitors' pricing?",
        options: [
          "Only their lowest price",
          "Bulk pricing, MOQ, and hidden costs",
          "Just their advertised prices",
          "Their employee salaries"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What is the objective of competitor research?",
        options: [
          "To position Kajja as cheaper than everyone",
          "To position Kajja as equal or better on all key points — especially B2B scale & professionalism",
          "To avoid competitors completely",
          "To focus only on small local carpenters"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "How should marketing prove Kajja's differentiation?",
        options: [
          "By saying 'We are better' repeatedly",
          "By showing results, systems, scale, and case studies",
          "By criticizing competitors publicly",
          "By lowering prices drastically"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What are we REALLY selling to commercial clients?",
        options: [
          "Just furniture pieces",
          "Peace of mind and brand confidence",
          "Only installation services",
          "Marketing materials"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What should a complete case study include?",
        options: [
          "Only before photos",
          "Before challenge, solution, results, and evidence",
          "Just client testimonials",
          "Only pricing information"
        ],
        correctAnswer: 1
      }
    ]
  },
  'digital-content-marketing': {
    id: 'digital-content-marketing',
    title: 'Digital & Content Marketing',
    modulenumber: '2.1.2',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768213332/marketting3_u1x60o.mp4',
    duration: 100,
    description: 'Social media strategy, content planning, visual storytelling, and SEO for Kajja Galleries',
    requiredRoles: ['marketing_manager', 'head_of_marketing', 'marketing-sales','marketing-sales', 'social_media_manager','ceo'],
    validityMinutes: 259200, // 6 months in minutes
    quiz: [
      {
        id: 1,
        question: "LinkedIn is mainly for:",
        options: [
          "Teen entertainment",
          "B2B professional outreach & credibility",
          "Random jokes",
          "Only employees"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Video storytelling should:",
        options: [
          "Confuse clients",
          "Educate and show system-driven excellence",
          "Avoid showing real results",
          "Only show funny clips"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Photos must:",
        options: [
          "Be taken casually with clutter",
          "Highlight craftsmanship & finishing",
          "Hide furniture flaws",
          "Forget watermarks"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Content must:",
        options: [
          "Be random",
          "Follow a calendar with consistent posting",
          "Be once per year",
          "Be only about management team"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "SEO helps by:",
        options: [
          "Making website invisible",
          "Attracting organic commercial leads",
          "Reducing online presence",
          "Removing trust"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What should Instagram content focus on?",
        options: [
          "Only company policies",
          "Before/After visuals and project reels",
          "Financial reports",
          "Internal meetings"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "How often should you post on social media?",
        options: [
          "Once a month",
          "Minimum 3x weekly",
          "Only during holidays",
          "When the manager remembers"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What is the main purpose of educational videos?",
        options: [
          "To entertain with jokes",
          "To attract leads from serious buyers, not window shoppers",
          "To hide company processes",
          "To replace sales staff"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What should every photo have?",
        options: [
          "No identification",
          "Watermark with 'Kajja Galleries'",
          "Random filters",
          "Other company logos"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must website content clearly communicate?",
        options: [
          "Only company history",
          "'Commercial & Bulk Furniture for Businesses'",
          "Employee birthdays",
          "Stock market updates"
        ],
        correctAnswer: 1
      }
    ]
  },
  'b2b-brand-growth': {
    id: 'b2b-brand-growth',
    title: 'B2B Brand Growth',
    modulenumber: '2.1.3',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768215244/marketing4_isyz2o.mp4',
    duration: 85,
    description: 'B2B marketing materials, networking strategy, referral partnerships, testimonials, and tender branding',
    requiredRoles: ['marketing_manager', 'head_of_marketing', 'sales_manager', 'ceo', 'marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Company profile is for:",
        options: [
          "Decoration",
          "Professional pitch for corporate & institutional clients",
          "Internal HR only",
          "Random printing"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Best place to win commercial referrals:",
        options: [
          "Parties only",
          "Contractors, architects, and developers",
          "Random WhatsApp groups",
          "Anonymous Facebook accounts"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Testimonials help because:",
        options: [
          "They are fictional",
          "They prove quality through client voices",
          "They take time",
          "Clients don't care"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Exhibition success requires:",
        options: [
          "Sitting quietly and waiting",
          "Structured follow-up within 48 hours",
          "No brochures",
          "No lead collection"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Bid branding matters because:",
        options: [
          "Institutions are casual",
          "Professional documentation builds trust & compliance",
          "Clients never read proposals",
          "It's unnecessary"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What should a company profile highlight?",
        options: [
          "Employee birthdays",
          "Bulk capacity and CNC technology",
          "Office gossip",
          "Competitor weaknesses"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Which partners influence 80% of furniture decisions in commercial projects?",
        options: [
          "Delivery drivers",
          "Architects and interior designers",
          "Security guards",
          "Cafeteria staff"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "When should you follow up with exhibition leads?",
        options: [
          "After 2 months",
          "Within 48 hours",
          "Never follow up",
          "Only during holidays"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What must bid documents include to build credibility?",
        options: [
          "Only price lists",
          "Case studies and compliance certifications",
          "Personal opinions",
          "Social media links only"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What shortens the sales cycle when done effectively?",
        options: [
          "Avoiding client meetings",
          "Site visit showcases of installed quality",
          "Hiding project photos",
          "Delayed responses"
        ],
        correctAnswer: 1
      }
    ]
  },
  'lead-generation-conversion': {
    id: 'lead-generation-conversion',
    title: 'Lead Generation & Conversion',
    modulenumber: '2.1.4',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768217240/marketing5_litiql.mp4',
    duration: 90,
    description: 'Lead qualification, CRM management, follow-up standards, sales-marketing alignment, and win-loss analysis',
    requiredRoles: ['marketing_manager', 'head_of_marketing', 'sales_manager', 'marketing-sales', 'ceo','marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "CRM exists to:",
        options: [
          "Decorate computer",
          "Ensure no lead is lost and pipeline is visible",
          "Make work harder",
          "Store jokes"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Lead qualification ensures:",
        options: [
          "We waste time with wrong clients",
          "We focus on profitable and serious leads",
          "We stop marketing",
          "Everyone gets a free site visit"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Response time promise:",
        options: [
          "3 days",
          "Within 2 hours for new leads",
          "Whenever we finish lunch",
          "Only when client complains"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Win-loss analysis:",
        options: [
          "Helps blame people",
          "Improves future chances & messaging",
          "Should be ignored",
          "Makes us weaker"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Best communication for follow-up:",
        options: [
          "'Just checking in...'",
          "Provide value with each touchpoint",
          "Silence",
          "Send memes"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What indicates a qualified B2B lead?",
        options: [
          "Asking for one chair",
          "Clear timeline with decision-maker involved",
          "No budget mentioned",
          "Only casual shopping"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "When must CRM be updated?",
        options: [
          "Once a month",
          "Same day after every call or site visit",
          "Never update",
          "Only when MD asks"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What should weekly marketing-sales alignment review?",
        options: [
          "Only football scores",
          "Leads generated, conversion stages, and blockers",
          "Personal gossip",
          "Competitor salaries"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What's better than 'just checking in' during follow-ups?",
        options: [
          "Silence",
          "Adding value with photos or case studies",
          "Complaining about delays",
          "Asking for favors"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What should win-loss analysis identify?",
        options: [
          "Only who to blame",
          "Why client didn't choose us and corrective actions",
          "Client personal secrets",
          "Competitor illegal activities"
        ],
        correctAnswer: 1
      }
    ]
  },
  'reputation-trust-management': {
    id: 'reputation-trust-management',
    title: 'Managing Reputation & Trust',
    modulenumber: '2.1.5',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768218327/marketing6_xaefxu.mp4',
    duration: 85,
    description: 'Online reputation management, warranty communication, crisis response, brand voice, and PR strategy',
    requiredRoles: ['marketing_manager', 'head_of_marketing', 'sales_manager', 'ceo', 'marketing-sales','customer_service'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Online complaints must be:",
        options: [
          "Ignored",
          "Replied to politely and quickly",
          "Deleted with anger",
          "Handled by arguing publicly"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Warranty messages must be:",
        options: [
          "Different every time",
          "Consistent and confidence-building",
          "Hidden from clients",
          "Full of excuses"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Crisis communication is successful when:",
        options: [
          "We panic",
          "We respond honestly with clear actions",
          "We blame the supplier",
          "We avoid client communication"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Brand voice must be:",
        options: [
          "Rude and casual",
          "Clear, respectful, confident, helpful",
          "Gossip-heavy",
          "Unpredictable"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "PR success builds:",
        options: [
          "Silence in the market",
          "Brand authority and trust from decision-makers",
          "Confusion",
          "Small complaints"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "How quickly should you respond to online reviews?",
        options: [
          "Within one week",
          "Within 24 hours",
          "Never respond",
          "Only respond to positive reviews"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What should you do with warranty issues?",
        options: [
          "Ignore them",
          "Register in CRM and coordinate repair within 72 hours",
          "Blame the client",
          "Ask for more money"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What's the crisis response formula?",
        options: [
          "Ignore, deny, blame",
          "Acknowledge, apologize, act, assure",
          "Hide, delay, make excuses",
          "Complain, argue, threaten"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What should media messaging focus on?",
        options: [
          "Project budgets and internal costs",
          "Professional value and knowledge leadership",
          "Employee salaries",
          "Competitor weaknesses"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "When emotions rise during crisis, what happens to tone?",
        options: [
          "It becomes angry and defensive",
          "It becomes even calmer and more professional",
          "It becomes sarcastic",
          "It becomes silent"
        ],
        correctAnswer: 1
      }
    ]
  },
  'budget-reporting-roi': {
    id: 'budget-reporting-roi',
    title: 'Budget, Reporting & ROI',
    modulenumber: '2.1.6',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768219634/marketing7_nquju3.mp4',
    duration: 90,
    description: 'Marketing budget planning, ROI calculation, KPI reporting, cross-department collaboration, and data-driven decision making',
    requiredRoles: ['marketing_manager', 'head_of_marketing', 'ceo', 'finance_manager', 'operations_manager','marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Marketing budget must:",
        options: [
          "Be random",
          "Align with business goals & ROI expectations",
          "Depend only on Instagram likes",
          "Be guessed yearly"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "What does ROMI measure?",
        options: [
          "Happiness",
          "Revenue generated from marketing vs cost spent",
          "Employee personality",
          "Competition gossip"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Marketing KPIs dashboard helps:",
        options: [
          "Track success, find improvement areas",
          "Decorate office",
          "Hide performance",
          "Avoid accountability"
        ],
        correctAnswer: 0
      },
      {
        id: 4,
        question: "Operations collaboration ensures:",
        options: [
          "Promising things Ops cannot deliver",
          "Marketing supports real capability",
          "Weak teamwork",
          "Confusion"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Data-driven decisions mean:",
        options: [
          "Using personal opinions",
          "Acting based on measured results",
          "Following trends blindly",
          "Guessing"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What's the ROMI formula?",
        options: [
          "Cost ÷ Revenue",
          "(Revenue from marketing − Marketing cost) ÷ Marketing cost",
          "Revenue × Cost",
          "Cost only"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What must be in marketing monthly reports?",
        options: [
          "Only team photos",
          "Qualified B2B leads and conversion rates",
          "Office gossip",
          "Competitor salaries"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "When should marketing stop activities?",
        options: [
          "Never stop anything",
          "When they fail to produce ROI",
          "When team is bored",
          "When MD is traveling"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Budget priority should focus on:",
        options: [
          "Random posting for likes",
          "Campaigns that produce qualified leads",
          "Personal entertainment",
          "Competitor spying"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Why collaborate with finance department?",
        options: [
          "To get free lunches",
          "To align budget timing with cashflow and pricing messaging",
          "To avoid each other",
          "To share social media passwords"
        ],
        correctAnswer: 1
      }
    ]
  },
  'leadership-team-skills': {
    id: 'leadership-team-skills',
    title: 'Leadership & Team Skills',
    modulenumber: '2.1.7',
    department: 'Marketing',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768220866/marketing8_oax1ld.mp4',
    duration: 85,
    description: 'Team delegation, brand quality assurance, cross-department collaboration, professional presentation skills, and industry trend awareness',
    requiredRoles: ['head_of_marketing', 'marketing-sales','marketing_manager', 'ceo', 'design_manager', 'team_leader'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "The Head of Marketing's job is to:",
        options: [
          "Do all tasks personally",
          "Lead the team, delegate tasks & ensure brand consistency",
          "Only post on Instagram",
          "Avoid creative people"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Brand quality assurance ensures:",
        options: [
          "We look like a roadside workshop",
          "Materials consistently reflect professional leadership",
          "Clients don't trust us",
          "Errors everywhere"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Best source of marketing stories:",
        options: [
          "Guesswork",
          "Real successes from design and operations",
          "Fake numbers",
          "Unverified photos"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Client presentation success relies on:",
        options: [
          "Poor appearance",
          "Confidence, clarity, and strong case studies",
          "No preparation",
          "Apologies in advance"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Staying ahead requires:",
        options: [
          "Ignoring trends",
          "Constant learning from global industry sources",
          "Waiting for clients to complain",
          "Copying random competitors"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What should delegation include?",
        options: [
          "Just giving orders",
          "Explaining why tasks matter with clear deadlines",
          "No feedback",
          "Random assignments"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What does poor branding make Kajja look like?",
        options: [
          "A commercial leader",
          "Ordinary carpenters",
          "Global brand",
          "Tech company"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "How should marketing get real stories?",
        options: [
          "Make them up",
          "Attend production meetings and document improvements",
          "Ask competitors",
          "Use stock photos"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What's essential for professional appearance?",
        options: [
          "Casual clothes only",
          "Business professional dress at all client meetings",
          "Sleepwear",
          "Competitor uniforms"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "How often should industry learning be shared?",
        options: [
          "Never",
          "Monthly presentations to GM and design team",
          "Once a year",
          "Only when asked"
        ],
        correctAnswer: 1
      }
    ]
  },
  'client-experience-communication': {
    id: 'client-experience-communication',
    title: 'Client Experience & Communication Excellence',
    modulenumber: '2.2.0',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768293215/crelations1_rz9dde.mp4',
    duration: 85,
    description: 'Client journey management, professional communication standards, expectations management, and cross-team coordination',
    requiredRoles: ['client_relations_officer', 'sales_manager', 'customer_service', 'marketing-sales', 'ceo'],
    validityMinutes: 259200, // 6 months in minutes
    quiz: [
      {
        id: 1,
        question: "The CRO's role is to:",
        options: [
          "Ignore clients after sale",
          "Support clients throughout the journey",
          "Focus only on sales",
          "Only deliver furniture"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Communication must be:",
        options: [
          "Guessing and slang",
          "Clear, polite, documented",
          "Aggressive",
          "Verbal only"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Managing expectations reduces:",
        options: [
          "Complaints and confusion",
          "Professionalism",
          "Sales",
          "Work quality"
        ],
        correctAnswer: 0
      },
      {
        id: 4,
        question: "Who is the client communication bridge?",
        options: [
          "Carpenter",
          "Client Relations Officer",
          "Driver",
          "Machine technician"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "What creates brand reputation?",
        options: [
          "Anger",
          "Professional tone and consistency",
          "Silence",
          "Promising lies"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What does the client experience journey include?",
        options: [
          "Only installation",
          "Inquiry, qualification, design, production, installation, warranty",
          "Only payment collection",
          "Only email communication"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "When do clients leave according to the training?",
        options: [
          "Because of silence and surprises",
          "Because of perfect service",
          "Because of free gifts",
          "Because of fast replies"
        ],
        correctAnswer: 0
      },
      {
        id: 8,
        question: "What should you never do without confirmation?",
        options: [
          "Send thank you messages",
          "Promise timelines or features without confirming with operations",
          "Greet clients",
          "Take notes"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Why use client brief forms and signed approvals?",
        options: [
          "To create paperwork",
          "To set clear expectations and prevent misunderstandings",
          "To delay projects",
          "To avoid communication"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must communication flow be?",
        options: [
          "Client to carpenter directly",
          "Client ↔ CRO ↔ Internal Teams only",
          "Random with no system",
          "Through social media only"
        ],
        correctAnswer: 1
      }
    ]
  },
  'sales-support-communication': {
    id: 'sales-support-communication',
    title: 'Sales Support & Communication',
    modulenumber: '2.2.1',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768295455/crelations2_acvfqc.mp4',
    duration: 90,
    description: 'Communication hierarchy, client etiquette, project discovery, documentation, and approval management',
    requiredRoles: ['client_relations_officer', 'sales_manager', 'marketing-sales', 'customer_service'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Who should handle all client communication?",
        options: [
          "Carpenters",
          "Client Relations Officer",
          "Machine technician",
          "Random employees"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Work must only begin after:",
        options: [
          "Verbal excitement",
          "Signed approvals and documented instructions",
          "Rumors",
          "A handshake"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Why ask discovery questions?",
        options: [
          "To waste time",
          "To fully understand client needs and avoid rework",
          "To confuse sales",
          "To show power"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Documentation helps:",
        options: [
          "Protect the project and ensure clarity",
          "Create confusion",
          "Replace communication",
          "Delay timelines"
        ],
        correctAnswer: 0
      },
      {
        id: 5,
        question: "Who manages meeting scheduling?",
        options: [
          "The client alone",
          "CRO through calendar & follow-ups",
          "Carpenter",
          "The workshop cleaner"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is the correct communication hierarchy?",
        options: [
          "Client directly to workshop team",
          "Client ↔ CRO ↔ Sales/Design/Operations ↔ Workshop",
          "Only through social media",
          "Random communication without structure"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What is the maximum response time for inquiries?",
        options: [
          "1 week",
          "Maximum 2 hours",
          "Next business day",
          "When convenient"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What should NEVER be used as approval?",
        options: [
          "Email confirmation",
          "Signed documents",
          "Verbal approvals only",
          "Written WhatsApp messages"
        ],
        correctAnswer: 2
      },
      {
        id: 9,
        question: "What must every meeting record include?",
        options: [
          "Only names",
          "Discussions, agreements, next actions, responsibilities",
          "Only dates",
          "Only complaints"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must you record for every client interaction?",
        options: [
          "Only payments",
          "Phone calls, messages, emails, instructions, complaints, approvals",
          "Only positive feedback",
          "Only installation dates"
        ],
        correctAnswer: 1
      }
    ]
  },
  'quality-fundamentals': {
    id: 'quality-fundamentals',
    title: 'Quality Fundamentals',
    modulenumber: '4.2.0',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769674378/q1_gtemae.mp4',
    duration: 90,
    description: 'Quality definition, brand alignment, QC officer responsibilities and authority, and communication procedures.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "At Kajja, quality means:",
        options: [
          "Working as fast as possible regardless of errors",
          "Products matching approved drawings, with accurate dimensions and clean finishing",
          "Using the cheapest available materials to save costs",
          "Skipping inspections to speed up delivery"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Poor quality results in:",
        options: [
          "More client referrals and positive reviews",
          "Faster project completion times",
          "Client complaints and loss of brand trust",
          "Higher profit margins for the company"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Kajja's brand promise is:",
        options: [
          "Strength, Speed, and Sales above all",
          "Efficiency, Creativity, and Trust in every product",
          "Low Price, High Profit, and Popularity",
          "Wood, Steel, and Fabric materials only"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "QC contributes to Kajja's vision by:",
        options: [
          "Decorating the workshop walls beautifully",
          "Selling more products than competitors",
          "Ensuring consistent and reliable quality in every product",
          "Paying suppliers faster than other companies"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "The QC Officer's main responsibility is to:",
        options: [
          "Handle marketing and client presentations",
          "Design new furniture concepts",
          "Inspect, approve, or reject work based on standards",
          "Calculate and pay worker salaries"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "A QC Officer has authority to:",
        options: [
          "Ignore minor defects to keep production moving",
          "Stop production immediately when serious faults are found",
          "Approve all work to avoid conflicts",
          "Work only when specifically asked by management"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "QC decisions should be based on:",
        options: [
          "Personal friendships with workshop staff",
          "The need to complete work quickly",
          "Fear of stopping production lines",
          "Facts, measurements, and clear standards"
        ],
        correctAnswer: 3
      },
      {
        id: 8,
        question: "If materials delivered are wrong, QC should:",
        options: [
          "Ignore the issue and use them anyway",
          "Hide the problem to avoid delays",
          "Personally fix the materials if possible",
          "Inform Stores and Procurement departments immediately"
        ],
        correctAnswer: 3
      },
      {
        id: 9,
        question: "If repeated defects appear, QC should:",
        options: [
          "Keep quiet to protect the workshop team",
          "Punish the workers responsible directly",
          "Personally fix the defects without reporting",
          "Escalate to the Head of Production for action"
        ],
        correctAnswer: 3
      },
      {
        id: 10,
        question: "Silence in QC when defects are seen means:",
        options: [
          "Discipline and professional restraint",
          "Respect for the production team's work",
          "Tacit approval of substandard work",
          "A desire to speed up the process"
        ],
        correctAnswer: 2
      }
    ]
  },
  'workshop-quality-standards': {
    id: 'workshop-quality-standards',
    title: 'Workshop Quality Standards',
    modulenumber: '4.2.1',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769675923/q2_wdpqhw.mp4',
    duration: 90,
    description: 'Panel accuracy tolerances, edge band inspection, drilling alignment, assembly standards, finishing checks, and hardware quality.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Panel accuracy means:",
        options: [
          "Panels are heavy enough to feel substantial",
          "Panels match drawing dimensions and have square corners",
          "Panels have colorful finishes regardless of size",
          "Panels are shiny and reflective"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Inaccurate panels cause:",
        options: [
          "Perfect fitting during assembly",
          "Gaps, misalignment, and increased rework",
          "Faster production times",
          "Stronger, more durable joints"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Edge banding is used to:",
        options: [
          "Increase the weight of panels",
          "Protect panel edges from moisture and give clean finish",
          "Store panels more efficiently in the workshop",
          "Join metal parts to wooden panels"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "A peeling edge band means:",
        options: [
          "The adhesive is working perfectly",
          "Defective finishing that will be visible to clients",
          "The edge band was applied correctly",
          "Extra protection for the panel edge"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Drilling accuracy ensures:",
        options: [
          "Doors will be crooked and misaligned",
          "Proper hardware alignment and strong joints",
          "Joints will be loose and unstable",
          "Random assembly without following drawings"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Poor drilling leads to:",
        options: [
          "Smooth drawer operation",
          "Misaligned hinges and doors that don't close properly",
          "Better surface finishing results",
          "No noticeable impact on the final product"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Assembly without visible gaps indicates:",
        options: [
          "Poor quality workmanship",
          "Good workmanship and proper fitting",
          "Wrong design specifications",
          "Missing components in the assembly"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Wobbly furniture should be:",
        options: [
          "Approved for delivery to save time",
          "Rejected until made solid and stable",
          "Delivered to the client anyway",
          "Ignored if the wobble is small"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Good surface finishing must be:",
        options: [
          "Rough to provide better grip",
          "Smooth to the touch with even color",
          "Sticky to show fresh application",
          "Dusty from the workshop environment"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Scratches on finished surfaces mean:",
        options: [
          "An accepted standard at Kajja",
          "Defective finishing that needs correction",
          "A sign of strong, durable coating",
          "Evidence of fast, efficient work"
        ],
        correctAnswer: 1
      }
    ]
  },
  'pre-delivery-inspections': {
    id: 'pre-delivery-inspections',
    title: 'Pre-Delivery Inspections',
    modulenumber: '4.2.2',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769678733/q3_gbmxsb.mp4',
    duration: 90,
    description: 'Final defect inspection, load-out verification, packaging standards, labeling procedures, and photo documentation.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Final inspection ensures products:",
        options: [
          "Are packed as quickly as possible",
          "Have no visible defects and match approved drawings",
          "Are as cheap as possible to produce",
          "Are heavy enough to feel expensive"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Scratches and dents should be:",
        options: [
          "Accepted if they are small",
          "Hidden under packaging materials",
          "Rejected before dispatch from workshop",
          "Ignored to meet delivery deadlines"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Load-out verification is done to:",
        options: [
          "Count how many workers are present",
          "Ensure the correct items and quantities are dispatched",
          "Decorate the delivery trucks beautifully",
          "Test vehicle engines before loading"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Loading without Job Card verification leads to:",
        options: [
          "Faster work completion",
          "Wrong or missing items arriving at site",
          "Better quality control outcomes",
          "A cleaner workshop environment"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Packaging is important to:",
        options: [
          "Increase the weight of the products",
          "Protect products from damage during transport",
          "Improve the furniture design",
          "Replace the need for QC inspections"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Bubble wrap and corner protectors are used to:",
        options: [
          "Decorate the products for better appearance",
          "Prevent scratches and impact damage during transit",
          "Increase the overall cost of the product",
          "Make items shine under showroom lights"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Labeling helps installers to:",
        options: [
          "Guess where items should be placed",
          "Identify correct rooms and items efficiently",
          "Delay work while they read labels",
          "Call QC for clarification repeatedly"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Missing labels cause:",
        options: [
          "Faster installation without reading",
          "Site confusion, delays, and incorrect placement",
          "Better communication among the team",
          "No effect on the installation process"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Photo documentation is important because:",
        options: [
          "It wastes valuable dispatch time",
          "It provides evidence of product condition before leaving",
          "It replaces the need for physical inspection",
          "It decorates the client report nicely"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "No photo documentation means:",
        options: [
          "Lower risk for the company",
          "No evidence in case of disputes about condition",
          "Better marketing materials for the future",
          "Faster dispatch process"
        ],
        correctAnswer: 1
      }
    ]
  },
  'installation-quality-standards': {
    id: 'installation-quality-standards',
    title: 'Installation Quality Standards',
    modulenumber: '4.2.3',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769679871/q4_tfzcr8.mp4',
    duration: 90,
    description: 'Leveling and plumb checks, wall anchoring safety, door/drawer alignment, joint sealing, and site cleanliness standards.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Leveling ensures that:",
        options: [
          "Cabinets have colorful finishes",
          "Doors are heavy and substantial",
          "Cabinets sit flat and horizontal on floors",
          "Shelves are extra deep for storage"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Plumb checks ensure that:",
        options: [
          "Panels are vertical, straight, and not leaning",
          "Panels have a shiny reflective surface",
          "Drawers slide with minimal effort",
          "Hinges have soft-closing mechanisms"
        ],
        correctAnswer: 0
      },
      {
        id: 3,
        question: "Poor leveling can cause:",
        options: [
          "A better visual appearance",
          "Doors swinging open or drawers sliding by themselves",
          "Faster installation times",
          "Stronger wall anchoring"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Tall cabinets must be anchored to:",
        options: [
          "Save time during installation",
          "Increase the overall cost appropriately",
          "Prevent falling and ensure client safety",
          "Improve the design aesthetics"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Missing wall anchors are:",
        options: [
          "Acceptable for small cabinets",
          "A decorative choice by installers",
          "A temporary measure only",
          "A serious safety defect requiring correction"
        ],
        correctAnswer: 3
      },
      {
        id: 6,
        question: "Door and drawer alignment focuses on:",
        options: [
          "Matching handle colors perfectly",
          "Ensuring even gaps and smooth closing operation",
          "Maximizing cabinet weight for stability",
          "Increasing shelf depth for functionality"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Uneven gaps make furniture look:",
        options: [
          "Premium and custom-made",
          "Cheap and poorly finished",
          "Stronger and more durable",
          "Waterproof and resistant"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Joint sealing prevents:",
        options: [
          "Faster assembly on site",
          "Dust collection and water penetration",
          "Better painting adhesion later",
          "More operational noise"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Excess sealant smears are:",
        options: [
          "A sign of good quality workmanship",
          "Poor finishing that needs cleaning",
          "Evidence of strong bonding",
          "A required part of the process"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Site cleanliness shows:",
        options: [
          "How quickly the team worked",
          "Professionalism and respect for client property",
          "Laziness in the installation crew",
          "No impact on client satisfaction"
        ],
        correctAnswer: 1
      }
    ]
  },
  "wood-finisher-introduction-brand": {
    "id": "wood-finisher-introduction-brand",
    "title": "Introduction & Brand Expectations",
    "modulenumber": "4.15.0",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771398847/wd1_h5jqjs.mp4",
    "duration": 90,
    "description": "To clearly define the role, responsibility, standards, and expectations of a Wood Finisher at Kajja Galleries, ensuring that finishing quality consistently reflects the company's brand promise: Efficiency • Creativity • Trust",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "The Wood Finisher is mainly responsible for:",
        "options": [
          "Measuring sites",
          "Final surface appearance and protection",
          "Procurement",
          "Transport"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Finishing includes:",
        "options": [
          "Only painting",
          "Surface preparation, coating, drying and inspection",
          "Only sanding",
          "Packaging"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "A skilled finisher is known for:",
        "options": [
          "Speed only",
          "Consistency and quality control",
          "Loud communication",
          "Working alone"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Efficiency in finishing means:",
        "options": [
          "Rushing drying time",
          "Doing work correctly with minimal rework",
          "Skipping sanding",
          "Using extra paint"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Trust includes:",
        "options": [
          "Hiding defects",
          "Honest reporting of issues",
          "Diluting materials secretly",
          "Skipping inspection"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Customers judge furniture primarily by:",
        "options": [
          "Internal joints",
          "Packaging",
          "Finishing quality",
          "Workshop size"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Proper finishing protects against:",
        "options": [
          "Noise",
          "Moisture and wear",
          "Weight",
          "Dust only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Dust in finishing area causes:",
        "options": [
          "Better texture",
          "Surface defects",
          "Faster drying",
          "Stronger coating"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Smoking in finishing area is:",
        "options": [
          "Allowed",
          "Professional",
          "Prohibited",
          "Required"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "A professional finisher inspects work:",
        "options": [
          "Only after complaint",
          "Before QC",
          "After delivery",
          "Never"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "wood-finisher-tools-ppe-safety": {
    "id": "wood-finisher-tools-ppe-safety",
    "title": "Tools, PPE & Safety",
    "modulenumber": "4.15.1",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771400646/wd2_exh2bq.mp4",
    "duration": 90,
    "description": "To ensure Wood Finishers use sanding and spray tools correctly, handle chemicals safely, prevent fire and health risks, maintain proper ventilation, and wear appropriate PPE at all times. Finishing involves chemicals and flammable materials. Safety is not optional — it is survival discipline.",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Poor sanding results in:",
        "options": [
          "Better coating",
          "Visible defects after finishing",
          "Faster drying",
          "Stronger wood"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Sanding should follow:",
        "options": [
          "Random grit",
          "Progressive grit sequence",
          "One grit only",
          "No sanding"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Over-sanding edges can:",
        "options": [
          "Improve sharpness",
          "Destroy edge details",
          "Increase thickness",
          "Improve adhesion"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Spray passes should:",
        "options": [
          "Be random",
          "Overlap evenly",
          "Stop mid-panel",
          "Be curved"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Spray guns must be cleaned:",
        "options": [
          "Weekly",
          "After each use",
          "When broken",
          "Only before QC"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Paint and thinners are often:",
        "options": [
          "Harmless",
          "Flammable",
          "Water-based only",
          "Safe to inhale"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Smoking in finishing area is:",
        "options": [
          "Allowed",
          "Safe",
          "Prohibited",
          "Encouraged"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Ventilation helps to:",
        "options": [
          "Increase dust",
          "Remove harmful fumes",
          "Increase heat",
          "Slow drying"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "If feeling dizzy while spraying, you should:",
        "options": [
          "Continue working",
          "Ignore it",
          "Stop and inform supervisor",
          "Remove mask"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Goggles protect against:",
        "options": [
          "Dust and splashes",
          "Weight",
          "Heat",
          "Noise"
        ],
        "correctAnswer": 0
      }
    ]
  },
  'rework-prevention-rca': {
    id: 'rework-prevention-rca',
    title: 'Rework Prevention & RCA',
    modulenumber: '4.2.4',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769681195/q5_nvz5nh.mp4',
    duration: 90,
    description: 'Common defect identification, early detection strategies, root cause analysis, zero-blame culture, and weekly QC reviews.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Common production defects include:",
        options: [
          "Clean, scratch-free finishing on all surfaces",
          "Perfect, tight-fitting joinery every time",
          "Wrong panel measurements and misaligned drilling",
          "Smooth, perfectly sliding drawers in every unit"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Finding defects in the workshop is:",
        options: [
          "More expensive than finding them at the client site",
          "Unimportant compared to final inspection",
          "Cheaper and prevents client impact",
          "A waste of time that slows production"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Site-detected defects cause:",
        options: [
          "Better brand image and client referrals",
          "Faster project completion times",
          "No significant impact on the company",
          "Client dissatisfaction and higher correction costs"
        ],
        correctAnswer: 3
      },
      {
        id: 4,
        question: "Root Cause Analysis (RCA) means:",
        options: [
          "Fixing only the visible symptoms of a defect",
          "Blaming the worker who made the mistake",
          "Finding the real underlying reason the defect occurred",
          "Ignoring documentation to save time"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Asking 'Why?' repeatedly helps to:",
        options: [
          "Waste valuable production time",
          "Hide defects from management",
          "Confuse the production team",
          "Identify the true root cause of problems"
        ],
        correctAnswer: 3
      },
      {
        id: 6,
        question: "RCA documentation is important because:",
        options: [
          "It decorates the quality control files nicely",
          "It delays work to create more paperwork",
          "It increases mistakes by over-analyzing",
          "It prevents the same defect from repeating"
        ],
        correctAnswer: 3
      },
      {
        id: 7,
        question: "Zero-blame culture means:",
        options: [
          "Punishing every mistake severely",
          "Encouraging honest reporting of problems without fear",
          "Ignoring defects to maintain team harmony",
          "Hiding issues from management"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "If workers fear blame, they will:",
        options: [
          "Report problems early and openly",
          "Hide mistakes and avoid reporting",
          "Improve quality on their own",
          "Work faster to avoid scrutiny"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "QC should focus on:",
        options: [
          "Personal attacks when defects are found",
          "Rumors about who might be responsible",
          "Facts, data, and process improvement",
          "Punishment as the primary solution"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "Weekly QC review meetings help to:",
        options: [
          "Delay production with unnecessary meetings",
          "Decorate reports with colorful charts",
          "Track defects and agree on improvement actions",
          "Reduce communication between departments"
        ],
        correctAnswer: 2
      }
    ]
  },
  "wood-finisher-surface-preparation": {
    "id": "wood-finisher-surface-preparation",
    "title": "Surface Preparation",
    "modulenumber": "4.15.2",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771402729/wd3_zjbnlu.mp4",
    "duration": 90,
    "description": "To ensure that every surface is properly prepared before coating, eliminating defects, ensuring adhesion, and delivering smooth, premium-quality finishes. Remember: A bad surface cannot produce a good finish.",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Surface preparation affects:",
        "options": [
          "Packaging",
          "Final finish quality",
          "Transport only",
          "Weight"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Inspection must be done:",
        "options": [
          "After painting",
          "Before sanding and coating",
          "After delivery",
          "During installation only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Skipping sanding steps causes:",
        "options": [
          "Faster work",
          "Visible scratch lines",
          "Better adhesion",
          "Stronger joints"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Sanding should generally move from:",
        "options": [
          "Fine to coarse",
          "Rough to smooth grits",
          "Random sequence",
          "No grit change"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Filler must be sanded until it is:",
        "options": [
          "Raised",
          "Flush with surface",
          "Rough",
          "Soft"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Applying paint over dust causes:",
        "options": [
          "Smooth finish",
          "Bumpy texture",
          "Faster drying",
          "Stronger coating"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Sharp edges tend to:",
        "options": [
          "Hold paint well",
          "Chip easily",
          "Improve adhesion",
          "Look premium"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Joint gaps should be:",
        "options": [
          "Ignored",
          "Painted over",
          "Fixed before coating",
          "Covered with extra paint"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Between-coat sanding helps to:",
        "options": [
          "Remove dust nibs",
          "Remove structure",
          "Damage coating",
          "Increase cracks"
        ],
        "correctAnswer": 0
      },
      {
        "id": 10,
        "question": "Dust removal should be done:",
        "options": [
          "After coating",
          "Before coating",
          "Only once",
          "Never"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "wood-finisher-staining-coloring": {
    "id": "wood-finisher-staining-coloring",
    "title": "Staining & Coloring",
    "modulenumber": "4.15.3",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771404435/wd14_fnivth.mp4",
    "duration": 90,
    "description": "To ensure that all staining and coloring work is consistent across panels, matches approved designer samples, enhances natural wood grain, dries properly before next process, and reflects premium finishing standards. Color mistakes are visible immediately. Color discipline = brand discipline.",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "A stain primarily:",
        "options": [
          "Hides wood grain",
          "Penetrates and enhances grain",
          "Builds thick surface",
          "Fills holes"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Water-based stains tend to:",
        "options": [
          "Dry slower",
          "Raise wood grain slightly",
          "Have no odor",
          "Be oil-based"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Patchiness is often caused by:",
        "options": [
          "Proper sanding",
          "Uneven application",
          "Controlled wiping",
          "Testing samples"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Before staining full panels, you should:",
        "options": [
          "Start immediately",
          "Test on sample piece",
          "Skip testing",
          "Guess the tone"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Matching samples requires checking under:",
        "options": [
          "Random lighting",
          "Consistent lighting",
          "Dark room only",
          "Flashlight"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Wiping should generally follow:",
        "options": [
          "Circular motion",
          "Against grain",
          "Along the grain",
          "Random direction"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Over-wiping can cause:",
        "options": [
          "Even color",
          "Light patches",
          "Stronger stain",
          "Faster drying"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Stacking wet panels can cause:",
        "options": [
          "Faster drying",
          "Surface damage",
          "Strong adhesion",
          "Even tone"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Rushing drying time may cause:",
        "options": [
          "Better bonding",
          "Peeling or wrinkling",
          "Faster curing",
          "Stronger color"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Different woods absorb stain:",
        "options": [
          "Identically",
          "Differently",
          "Not at all",
          "Only on edges"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "wood-finisher-painting-coating": {
    "id": "wood-finisher-painting-coating",
    "title": "Painting & Clear Coating",
    "modulenumber": "4.15.4",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771405816/wd5_nr2pgv.mp4",
    "duration": 90,
    "description": "To ensure that all painted and clear-coated surfaces have even coverage, are smooth and defect-free, follow correct layering discipline, achieve consistent sheen (Gloss, Matte, Semi), and reflect premium Kajja finishing standards. Painting and clear coating require technical precision, patience, and discipline.",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Primer is important because it:",
        "options": [
          "Replaces topcoat",
          "Seals and improves adhesion",
          "Adds gloss only",
          "Removes dents"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Uneven primer causes:",
        "options": [
          "Stronger finish",
          "Uneven topcoat",
          "Faster drying",
          "Thicker coating"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Spraying too close may cause:",
        "options": [
          "Thin film",
          "Runs and sags",
          "Faster drying",
          "Matte finish"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Moving spray gun too fast causes:",
        "options": [
          "Thick coating",
          "Patchy coverage",
          "Runs",
          "Gloss increase"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Orange peel texture looks:",
        "options": [
          "Mirror smooth",
          "Rough and dimpled",
          "Flat",
          "Transparent"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Thin coats are preferred because they:",
        "options": [
          "Take longer to dry",
          "Reduce defects",
          "Cause more runs",
          "Increase bubbles"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Before applying next coat, surface must be:",
        "options": [
          "Wet",
          "Fully dry",
          "Sticky",
          "Rough"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Between-coat sanding helps to:",
        "options": [
          "Remove structure",
          "Improve smoothness",
          "Reduce adhesion",
          "Increase defects"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Gloss finish shows:",
        "options": [
          "No defects",
          "All surface defects clearly",
          "Only color",
          "Less shine"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Matte finish requires proper:",
        "options": [
          "Sanding only",
          "Mixing for consistent sheen",
          "Over-thinning",
          "Skipping primer"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "wood-finisher-quality-defect-prevention": {
    "id": "wood-finisher-quality-defect-prevention",
    "title": "Quality & Defect Prevention",
    "modulenumber": "4.15.5",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771407177/wd6_novkzg.mp4",
    "duration": 90,
    "description": "To train finishers to inspect properly between coats, identify and correct finishing defects, prevent surface damage after finishing, collaborate effectively with QC, and develop a 'first-time-right' professional mindset. Finishing defects are visible forever. Quality control begins with the finisher.",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Inspecting between coats helps to:",
        "options": [
          "Increase defects",
          "Prevent defect buildup",
          "Delay work",
          "Skip sanding"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Light sanding between coats helps to:",
        "options": [
          "Remove structure",
          "Smooth imperfections",
          "Reduce adhesion",
          "Cause peeling"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Fisheyes are usually caused by:",
        "options": [
          "Proper sanding",
          "Oil contamination",
          "Thin coating",
          "Clean air"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Sags and drips are caused by:",
        "options": [
          "Thin coats",
          "Excess material",
          "Fast movement",
          "Clean surface"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Wet sags should be:",
        "options": [
          "Wiped immediately",
          "Left to dry before correction",
          "Ignored",
          "Covered with more paint"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Dust nibs result from:",
        "options": [
          "Clean room",
          "Poor dust control",
          "Light sanding",
          "Proper ventilation"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Finished surfaces must be:",
        "options": [
          "Treated casually",
          "Protected carefully",
          "Stacked without padding",
          "Used as tool tables"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "QC exists to:",
        "options": [
          "Slow production",
          "Protect company standards",
          "Create conflict",
          "Replace finishing"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "First-time-right saves:",
        "options": [
          "Nothing",
          "Time and cost",
          "Only paint",
          "Only effort"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "A professional finisher aims for:",
        "options": [
          "Maximum rework",
          "Minimal defects and consistency",
          "Speed only",
          "Guessing standards"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "wood-finisher-finishing-durability": {
    "id": "wood-finisher-finishing-durability",
    "title": "Finishing for Durability",
    "modulenumber": "4.15.6",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771408511/wd7_cykueh.mp4",
    "duration": 90,
    "description": "To ensure that all finishes applied at Kajja Galleries are durable, resistant to scratches and wear, protected against moisture, safe from chemical reactions, and suitable for client usage conditions. A beautiful finish that fails after 3 months is not quality.",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Surface hardness is important because it:",
        "options": [
          "Adds color",
          "Prevents scratches",
          "Speeds drying",
          "Reduces weight"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "A surface that is dry to touch is always:",
        "options": [
          "Fully cured",
          "Fully hardened",
          "Not necessarily cured",
          "Ready for stacking"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Premature stacking may cause:",
        "options": [
          "Stronger surface",
          "Surface damage",
          "Faster curing",
          "Better adhesion"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Moisture commonly affects:",
        "options": [
          "Only metal",
          "Kitchens and bathrooms",
          "Packaging",
          "Lighting"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Unsealed MDF edges may:",
        "options": [
          "Resist water",
          "Absorb moisture",
          "Increase hardness",
          "Improve shine"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Finished surfaces should be handled with:",
        "options": [
          "Bare dirty hands",
          "Clean gloves",
          "Rough tools",
          "Sandpaper"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Direct panel-to-panel stacking may cause:",
        "options": [
          "Shine",
          "Scratches",
          "Hardness",
          "Gloss"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Silicone contamination may cause:",
        "options": [
          "Smooth finish",
          "Fisheyes",
          "Strong adhesion",
          "Hard coating"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Commercial furniture requires:",
        "options": [
          "Weaker finish",
          "Higher durability",
          "Fewer coats",
          "Thin film only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Durable finishing at Kajja means:",
        "options": [
          "Beauty only",
          "Beauty plus long-term protection",
          "Speed only",
          "Thin coats only"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "distributor-role-culture": {
    "id": "distributor-role-culture",
    "title": "Delivery Role & Kajja Culture",
    "modulenumber": "5.1.0",
    "department": "Distribution",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771496985/ds1_mt3vqk.mp4",
    "duration": 90,
    "description": "To ensure that every Distributor understands their strategic importance, represents Kajja's brand with professionalism, communicates clearly and respectfully, and operates with integrity and discipline. Delivery is not transport. Delivery is brand execution.",
    "requiredRoles": ["distributor", "logistics-assistant"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "A Distributor is responsible for:",
        "options": [
          "Driving only",
          "Final product handover and coordination",
          "Production design",
          "Purchasing materials"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Delivery determines brand reputation because it is:",
        "options": [
          "Hidden process",
          "Client's first physical experience",
          "Unimportant",
          "Separate from company"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Distributor has authority to:",
        "options": [
          "Ignore missing items",
          "Stop unsafe dispatch",
          "Skip documentation",
          "Argue with client"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Professional appearance affects:",
        "options": [
          "Nothing",
          "Client confidence",
          "Fuel cost",
          "Workshop"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Smoking at client site is:",
        "options": [
          "Professional",
          "Unacceptable",
          "Required",
          "Encouraged"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Distributor must confirm:",
        "options": [
          "Route only",
          "QC clearance before dispatch",
          "Paint color",
          "Installer salary"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "If issue arises on site, distributor should:",
        "options": [
          "Argue",
          "Escalate properly",
          "Ignore",
          "Leave immediately"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Distributor represents:",
        "options": [
          "Driver only",
          "Kajja's brand",
          "Installer only",
          "Warehouse"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Before handover, distributor must:",
        "options": [
          "Leave immediately",
          "Re-check product condition",
          "Ignore scratches",
          "Skip accessories"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Internal conflicts should be discussed:",
        "options": [
          "In front of client",
          "Internally only",
          "Publicly",
          "Loudly"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "distributor-product-handling": {
    "id": "distributor-product-handling",
    "title": "Product Handling Basics",
    "modulenumber": "5.1.1",
    "department": "Distribution",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771498632/ds2_lkhhxv.mp4",
    "duration": 90,
    "description": "To ensure that every Distributor lifts and carries furniture safely, prevents breakage and surface damage, protects themselves from injury, inspects items before loading, and handles fragile components with precision. Proper handling protects both product and people.",
    "requiredRoles": ["distributor", "logistics-assistant"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Proper lifting requires:",
        "options": [
          "Bending back",
          "Bending knees",
          "Twisting body",
          "Jerking upward"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Large panels should be lifted:",
        "options": [
          "Alone",
          "By a coordinated team",
          "Dragged",
          "Thrown"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Panels are best carried:",
        "options": [
          "Flat with one hand",
          "Vertically and supported",
          "Dragged across floor",
          "On corners"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Glass should be transported:",
        "options": [
          "Flat under heavy load",
          "Upright and padded",
          "Loose",
          "Stacked without separation"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Corners are vulnerable because they:",
        "options": [
          "Are strongest",
          "Chip easily",
          "Are flexible",
          "Are hidden"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Before loading, Distributor must:",
        "options": [
          "Ignore condition",
          "Inspect visible surfaces",
          "Rush",
          "Trust assumption"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Pre-existing defects must be:",
        "options": [
          "Hidden",
          "Documented",
          "Ignored",
          "Repainted secretly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Fragile items require:",
        "options": [
          "Speed",
          "Extra care and padding",
          "Rough stacking",
          "Tight compression"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Tools must be:",
        "options": [
          "Mixed with furniture",
          "Stored separately and secured",
          "Left loose",
          "Placed on panels"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Sliding finished panels on rough surfaces may cause:",
        "options": [
          "Shine",
          "Scratches",
          "Strength",
          "Stability"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "distributor-packing-loading": {
    "id": "distributor-packing-loading",
    "title": "Packing & Loading Standards",
    "modulenumber": "5.1.2",
    "department": "Distribution",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771500255/ds3_hk5dkh.mp4",
    "duration": 90,
    "description": "To ensure that the Distributor inspects packaging before loading, uses proper protection materials, controls loading order logically, prevents dents and pressure damage, and confirms completeness before departure. The truck must never leave with 'hope.' It must leave with certainty.",
    "requiredRoles": ["distributor", "logistics-assistant"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Packaging inspection prevents:",
        "options": [
          "Shine",
          "Transport damage",
          "Delivery",
          "Installation"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Shrink-wrap should be:",
        "options": [
          "Loose",
          "Tight but not compressing surface",
          "Removed",
          "Optional"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Blankets are used to:",
        "options": [
          "Add weight",
          "Prevent scratches",
          "Speed loading",
          "Increase pressure"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Straps must avoid:",
        "options": [
          "Security",
          "Direct contact with finished surfaces",
          "Padding",
          "Stability"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Heavy items should be placed:",
        "options": [
          "On top of fragile items",
          "At bottom",
          "At edge only",
          "Randomly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Loading order should follow:",
        "options": [
          "Driver preference",
          "Room schedule",
          "Vehicle color",
          "Random placement"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Pressure points may cause:",
        "options": [
          "Gloss",
          "Dents",
          "Stability",
          "Protection"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "After loading, Distributor must:",
        "options": [
          "Leave immediately",
          "Inspect entire load",
          "Ignore straps",
          "Skip checks"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Cross-checking prevents:",
        "options": [
          "Completeness",
          "Missing items",
          "Installation",
          "Efficiency"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "A Distributor must never depart without:",
        "options": [
          "Fuel",
          "Full job card verification",
          "Music",
          "Conversation"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "distributor-transport-safety": {
    "id": "distributor-transport-safety",
    "title": "Transport Conduct & Safety",
    "modulenumber": "5.1.3",
    "department": "Distribution",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771501745/ds4_wagak5.mp4",
    "duration": 90,
    "description": "To ensure that every Distributor maintains load stability during transport, drives with discipline and caution, protects furniture from road hazards, follows safety rules inside the truck, and reports damage honestly and immediately. Safe transport protects product, people, and profit.",
    "requiredRoles": ["distributor", "logistics-assistant"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Load stability prevents:",
        "options": [
          "Shine",
          "Internal damage",
          "Installation",
          "Fuel usage"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "If load can move, it:",
        "options": [
          "Will remain stable",
          "Will shift and cause damage",
          "Improves safety",
          "Is acceptable"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Sudden braking may cause:",
        "options": [
          "Stability",
          "Furniture collision inside truck",
          "Stronger joints",
          "Faster delivery"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Climbing on furniture is:",
        "options": [
          "Efficient",
          "Unsafe and damaging",
          "Required",
          "Professional"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Heavy loads require:",
        "options": [
          "Faster speed",
          "Controlled slower driving",
          "Aggressive driving",
          "Ignoring road conditions"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Fuel discipline protects:",
        "options": [
          "Paint",
          "Company profit",
          "Installation",
          "Weight"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Driving courtesy reflects:",
        "options": [
          "Weakness",
          "Company culture",
          "Delay",
          "Fuel waste"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Damage must be reported:",
        "options": [
          "Later",
          "Immediately",
          "Only if visible",
          "After installation"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Hidden damage creates:",
        "options": [
          "Trust",
          "Bigger problems",
          "Stability",
          "Promotion"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Professional integrity means:",
        "options": [
          "Adjusting reports",
          "Honest reporting",
          "Hiding issues",
          "Avoiding documentation"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "distributor-site-delivery": {
    "id": "distributor-site-delivery",
    "title": "Site Delivery Rules",
    "modulenumber": "5.1.4",
    "department": "Distribution",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771502688/ds5_zduuhq.mp4",
    "duration": 90,
    "description": "To ensure that the Distributor arrives on time, respects client property, places items safely, coordinates clearly with installers, and maintains safety and cleanliness standards. Delivery at site is a live performance of Kajja's professionalism.",
    "requiredRoles": ["distributor", "logistics-assistant"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Arriving on time shows:",
        "options": [
          "Speed only",
          "Professional discipline",
          "Fuel efficiency",
          "Workshop quality"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "If delay occurs, Distributor must:",
        "options": [
          "Ignore it",
          "Inform relevant parties immediately",
          "Hide it",
          "Arrive silently"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Respect for building means:",
        "options": [
          "Ignoring walls",
          "Protecting floors and surfaces",
          "Dragging panels",
          "Rushing movement"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "After unloading, packaging waste must be:",
        "options": [
          "Left behind",
          "Removed",
          "Hidden",
          "Burned"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Temporary placement must avoid:",
        "options": [
          "Stability",
          "Blocking walkways",
          "Communication",
          "Labels"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Before leaving site, Distributor must:",
        "options": [
          "Leave quickly",
          "Confirm with installer",
          "Ignore accessories",
          "Skip communication"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Blocking emergency exits is:",
        "options": [
          "Acceptable",
          "Dangerous and unprofessional",
          "Efficient",
          "Required"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "PPE at site shows:",
        "options": [
          "Weakness",
          "Safety awareness",
          "Delay",
          "Inexperience"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Double movement increases:",
        "options": [
          "Shine",
          "Damage risk",
          "Speed",
          "Profit"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Clean walkways reduce:",
        "options": [
          "Safety",
          "Accident risk",
          "Speed",
          "Stability"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "distributor-personal-conduct-growth": {
    "id": "distributor-personal-conduct-growth",
    "title": "Personal Conduct & Growth",
    "modulenumber": "5.1.7",
    "department": "Distribution",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771505295/ds7_yciiuq.mp4",
    "duration": 90,
    "description": "To ensure every Distributor maintains high personal discipline, supports team culture, develops professional maturity, learns continuously, and understands career progression opportunities. Delivery Officer is not a final position — it is a foundation role.",
    "requiredRoles": ["distributor", "logistics-assistant"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Alcohol or drug use at work leads to:",
        "options": [
          "Better focus",
          "Increased accident risk",
          "Faster delivery",
          "Promotion"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Zero tolerance means:",
        "options": [
          "Warning only",
          "No acceptance under any condition",
          "Occasional allowance",
          "Flexible rule"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Teamwork prevents:",
        "options": [
          "Cooperation",
          "Dropped panels and confusion",
          "Efficiency",
          "Discipline"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Supporting junior staff shows:",
        "options": [
          "Weakness",
          "Leadership",
          "Delay",
          "Competition"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Positive attitude involves:",
        "options": [
          "Complaining",
          "Solution-focused behavior",
          "Blaming others",
          "Avoiding responsibility"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Distributor should learn:",
        "options": [
          "Vehicle color only",
          "Furniture names and categories",
          "Office gossip",
          "Client secrets"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Product knowledge improves:",
        "options": [
          "Confusion",
          "Communication accuracy",
          "Speed only",
          "Fuel use"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Career growth depends on:",
        "options": [
          "Luck",
          "Performance and discipline",
          "Gossip",
          "Seniority only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Spreading rumors is:",
        "options": [
          "Team building",
          "Unprofessional",
          "Marketing",
          "Leadership"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Delivery role is:",
        "options": [
          "Final career position",
          "Foundation for growth",
          "Temporary only",
          "Unimportant"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "distributor-paperwork-reporting": {
    "id": "distributor-paperwork-reporting",
    "title": "Paperwork & Reporting",
    "modulenumber": "5.1.6",
    "department": "Distribution",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771504091/ds6_cbdrpt.mp4",
    "duration": 90,
    "description": "To ensure every Distributor completes documentation accurately, protects the company with photo evidence, reports issues immediately, communicates clearly in company channels, and tracks returned items properly. Documentation is protection. If it is not recorded, it did not happen.",
    "requiredRoles": ["distributor", "logistics-assistant"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Delivery note signature protects:",
        "options": [
          "Client only",
          "Company legally",
          "Driver only",
          "Installer only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Before requesting signature, Distributor must:",
        "options": [
          "Rush client",
          "Confirm item count",
          "Ignore accessories",
          "Skip inspection"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Signing on behalf of client is:",
        "options": [
          "Acceptable",
          "Unacceptable",
          "Efficient",
          "Required"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Before unloading, photos should show:",
        "options": [
          "Driver selfie",
          "Packed item condition",
          "Weather",
          "Fuel gauge"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "After delivery photos protect against:",
        "options": [
          "Speed",
          "False claims",
          "Installation",
          "Packaging"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Missing items must be reported:",
        "options": [
          "Later",
          "Immediately",
          "Weekly",
          "Quietly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "WhatsApp updates should be:",
        "options": [
          "Emotional",
          "Clear and brief",
          "Casual",
          "Unrelated"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Sharing client property publicly without approval is:",
        "options": [
          "Professional",
          "Unacceptable",
          "Marketing",
          "Smart"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Returned items must be labeled:",
        "options": [
          "Delivered",
          "REWORK",
          "Scrap",
          "Complete"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "If it is not recorded, it:",
        "options": [
          "Happened",
          "Did not happen",
          "Is assumed",
          "Is ignored"
        ],
        "correctAnswer": 1
      }
    ]
  },
  'distribution-logistics-leadership': {
    id: 'distribution-logistics-leadership',
    title: 'Distribution & Logistics Leadership',
    modulenumber: '5.2.0',
    department: 'Logistics',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771586140/ld1_wheieb.mp4',
    duration: 90,
    description: 'Equip Distribution team with understanding of strategic importance, brand representation, delivery chain process, coordination with internal teams and clients.',
    requiredRoles: ['distribution-driver', 'logistics-lead', 'delivery-team', 'distributor'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Distribution is responsible for:",
        options: [
          "Production only",
          "Safe and timely delivery",
          "Design work",
          "Procurement"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Most product damage happens during:",
        options: [
          "Drawing",
          "Loading and transport",
          "Design review",
          "Marketing"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Before loading, team must confirm items against:",
        options: [
          "Personal notes",
          "Job card",
          "Verbal instruction",
          "Memory"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Efficiency in distribution means timely and:",
        options: [
          "Fast driving",
          "Organized delivery",
          "Skipping checks",
          "Rushing only"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Trust in distribution means honest reporting and:",
        options: [
          "Hiding damage",
          "Professional conduct",
          "Blaming others",
          "Ignoring issues"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "During transport, drivers must avoid sudden braking and:",
        options: [
          "Smooth driving",
          "Sharp cornering",
          "Monitoring load",
          "Careful speed"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Upon site arrival, first confirm:",
        options: [
          "Return time",
          "Delivery location",
          "Fuel level",
          "Lunch break"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Offloading must be done by careful lifting, not:",
        options: [
          "Teamwork",
          "Dragging",
          "Planning",
          "Protecting floors"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Distribution reflects brand because it is the:",
        options: [
          "First stage",
          "Final visible stage",
          "Hidden process",
          "Unimportant step"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "If delay occurs, distribution must report:",
        options: [
          "Never",
          "Early",
          "After site visit",
          "Only if asked"
        ],
        correctAnswer: 1
      }
    ]
  },
  'packing-product-protection': {
    id: 'packing-product-protection',
    title: 'Packing & Product Protection',
    modulenumber: '5.2.1',
    department: 'Logistics',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771587529/ld2_d0dbxj.mp4',
    duration: 90,
    description: 'Ensure finished products are packed correctly, protected against scratches and impact, labeled clearly, cross-checked before loading, arrive damage-free.',
    requiredRoles: ['distribution-driver', 'delivery-team', 'distributor'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Finished surfaces scratch easily and are:",
        options: [
          "Strong",
          "Vulnerable",
          "Durable",
          "Resistant"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Finished panels must be lifted, not:",
        options: [
          "Carried",
          "Dragged",
          "Held",
          "Moved"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Corners are the most:",
        options: [
          "Strong",
          "Vulnerable",
          "Decorative",
          "Hidden"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Labels must include client and:",
        options: [
          "Color only",
          "Room details",
          "Driver name",
          "Vehicle plate"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Wrapping prevents panel-to-panel:",
        options: [
          "Stacking",
          "Contact",
          "Movement",
          "Stability"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Before loading, cross-check with:",
        options: [
          "Memory",
          "Job card",
          "Guess",
          "Rush"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Glass must be transported upright and:",
        options: [
          "Flat",
          "Protected",
          "Loose",
          "Heavy"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Exposed sharp edges cause injury and:",
        options: [
          "Stability",
          "Scratches",
          "Alignment",
          "Speed"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Painted surfaces must be separated with:",
        options: [
          "Direct touch",
          "Foam",
          "Tight stack",
          "Exposure"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Missing items at site cause delays and:",
        options: [
          "Efficiency",
          "Return trips",
          "Speed",
          "Savings"
        ],
        correctAnswer: 1
      }
    ]
  },
  'loading-transport-discipline': {
    id: 'loading-transport-discipline',
    title: 'Loading & Transport Discipline',
    modulenumber: '5.2.2',
    department: 'Logistics',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771588612/ld3_f5jnkl.mp4',
    duration: 90,
    description: 'Ensure loading follows SOP, weight balanced, furniture secured, weather risks controlled, driving prevents accidents and damage.',
    requiredRoles: ['distribution-driver', 'delivery-team', 'distributor'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Proper weight balancing ensures:",
        options: [
          "Faster speed",
          "Vehicle stability",
          "Lower fuel only",
          "Easier unloading"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Heavy items placed at bottom and:",
        options: [
          "On fragile items",
          "Centered",
          "Near doors",
          "Randomly"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Straps must be padded where touching:",
        options: [
          "Metal only",
          "Finished surfaces",
          "Floor only",
          "Other straps"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Load movement during transport causes:",
        options: [
          "Protection",
          "Damage",
          "Stability",
          "Shine"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Corners chip easily and are:",
        options: [
          "Hidden",
          "Vulnerable",
          "Strong",
          "Flexible"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Rain exposure causes board swelling and:",
        options: [
          "Better finish",
          "Stains",
          "Stronger board",
          "Faster curing"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Defensive driving means predictable and:",
        options: [
          "Speeding",
          "Cautious",
          "Sudden braking",
          "Racing"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Pre-trip inspection includes checking brakes and:",
        options: [
          "Music system",
          "Tires",
          "Truck color",
          "Client name"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Sudden braking causes internal collision of:",
        options: [
          "Stability",
          "Furniture",
          "Smooth ride",
          "Protection"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Tools inside truck must be secured separately, not:",
        options: [
          "Stored",
          "Mixed with furniture",
          "Organized",
          "Counted"
        ],
        correctAnswer: 1
      }
    ]
  },
  "wood-finisher-cleanliness-professional-image": {
    "id": "wood-finisher-cleanliness-professional-image",
    "title": "Cleanliness & Professional Image",
    "modulenumber": "4.15.7",
    "department": "Finishing",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771410162/wd8_pi4ux2.mp4",
    "duration": 90,
    "description": "To ensure that Wood Finishers maintain a dust-free finishing environment, clean tools and spray equipment properly, store chemicals safely and professionally, understand their direct impact on Kajja's brand image, and take pride and ownership in every visible surface. Finishing is the final impression. Cleanliness is part of quality.",
    "requiredRoles": ["wood-polisher", "finishing-artisan"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Dust in finishing room causes:",
        "options": [
          "Shine improvement",
          "Surface defects",
          "Faster drying",
          "Stronger film"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Spray guns must be cleaned:",
        "options": [
          "Weekly",
          "After each use",
          "Monthly",
          "When clogged only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Dirty spray guns cause:",
        "options": [
          "Smooth coating",
          "Uneven spray pattern",
          "Better gloss",
          "Faster atomization"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Chemicals should be stored:",
        "options": [
          "Near open flames",
          "In sealed, labeled containers",
          "Opened always",
          "Mixed randomly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Expired chemicals may cause:",
        "options": [
          "Better bonding",
          "Surface failure",
          "Faster curing",
          "Gloss increase"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Finishing defines brand because:",
        "options": [
          "It is hidden",
          "It is visible to clients",
          "It reduces weight",
          "It lowers cost"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "A premium finish increases:",
        "options": [
          "Complaints",
          "Client confidence",
          "Rework",
          "Dust"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Before QC, finisher must:",
        "options": [
          "Skip inspection",
          "Self-inspect carefully",
          "Ignore edges",
          "Rush delivery"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Chemical storage area must be:",
        "options": [
          "Hot",
          "Ventilated and safe",
          "Exposed to sunlight",
          "Near sparks"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Professional growth as a finisher depends on:",
        "options": [
          "Complaints",
          "Cleanliness and consistent quality",
          "Speed only",
          "Guesswork"
        ],
        "correctAnswer": 1
      }
    ]
  },
  'project-coordination-followup': {
    id: 'project-coordination-followup',
    title: 'Project Coordination & Follow-Up',
    modulenumber: '2.2.2',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768298417/crelations3_ldfou2.mp4',
    duration: 85,
    description: 'Project flow tracking, design approvals, payment compliance, production monitoring, and installation coordination',
    requiredRoles: ['client_relations_officer', 'sales_manager', 'operations_manager', 'marketing-sales', 'ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "The CRO's job during production:",
        options: [
          "Stay silent",
          "Follow up timelines and update the client",
          "Leave everything to workshop",
          "Ignore issues"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Work starts only after:",
        options: [
          "Client excitement",
          "Signed design & payment confirmation",
          "Verbal nod",
          "Random approvals"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Production delays must be:",
        options: [
          "Hidden",
          "Communicated early with a solution",
          "Blamed on client",
          "Ignored"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Site visit readiness includes:",
        options: [
          "No access",
          "Tools missing",
          "Clear space, client available, access confirmed",
          "Workers guessing"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Installation updates must be:",
        options: [
          "Daily with photos and progress",
          "Once after installation",
          "Only if client asks",
          "Never"
        ],
        correctAnswer: 0
      },
      {
        id: 6,
        question: "What is the CRO's role in project flow?",
        options: [
          "Only collect payments",
          "Track progress through every stage and update client weekly",
          "Avoid communication",
          "Handle only complaints"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "When must CRO follow up after sending designs?",
        options: [
          "After 2 weeks",
          "48 hours after client receives drawings",
          "Never follow up",
          "Only when client calls"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What must happen before workshop booking?",
        options: [
          "Nothing needed",
          "Deposit must be paid",
          "Client visit to workshop",
          "Random selection"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What must CRO attend to monitor production?",
        options: [
          "Client parties",
          "Weekly production meetings",
          "Competitor shops",
          "Social events"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must client sign at installation completion?",
        options: [
          "Nothing",
          "Random papers",
          "Handover Form",
          "Blank cheques"
        ],
        correctAnswer: 2
      }
    ]
  },
  'handling-complaints-recovery': {
    id: 'handling-complaints-recovery',
    title: 'Handling Complaints & Recovery',
    modulenumber: '2.2.3',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768302007/crelations4_ibcdac.mp4',
    duration: 80,
    description: 'Complaint management, de-escalation skills, early reporting, delay transparency, and service recovery',
    requiredRoles: ['client_relations_officer', 'customer_service', 'sales_manager','marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Complaints must be:",
        options: [
          "Ignored",
          "Listened to, acknowledged & documented",
          "Taken personally",
          "Rejected immediately"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "De-escalation means:",
        options: [
          "Raising your voice",
          "Staying calm & listening fully before responding",
          "Arguing",
          "Denying issues"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Delays must be communicated:",
        options: [
          "When client discovers them",
          "Early with solutions & new timeline",
          "Never",
          "With blame on someone"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Feedback follow-up ensures:",
        options: [
          "Client disappears",
          "Full closure & restored trust",
          "More anger",
          "Legal disputes"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "CRM documentation helps:",
        options: [
          "Problems repeat forever",
          "Track issues and strengthen systems",
          "Hide information",
          "Encourage confusion"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is the first response to product quality complaints?",
        options: [
          "Argue with client",
          "Apologize, document, fast QC assessment",
          "Ignore the complaint",
          "Blame the workshop"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What should you never do when a client complains?",
        options: [
          "Take notes",
          "Argue or interrupt",
          "Stay calm",
          "Listen fully"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "When must you report small issues?",
        options: [
          "After one week",
          "Same day to GM and Ops",
          "Never report",
          "Only if client shouts"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What reduces client anger by 90% according to training?",
        options: [
          "Giving discounts",
          "Early communication before client asks",
          "Silence",
          "Complex explanations"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What happens after fixing an issue?",
        options: [
          "Forget about it",
          "Call client to ask if fully satisfied",
          "Avoid the client",
          "Send more complaints"
        ],
        correctAnswer: 1
      }
    ]
  },
  'customer-documentation-crm': {
    id: 'customer-documentation-crm',
    title: 'Customer Documentation & CRM',
    modulenumber: '2.2.4',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768303706/crelations5_pmbgzu.mp4',
    duration: 85,
    description: 'CRM data accuracy, client file management, weekly reporting, confidentiality, and professional note-taking',
    requiredRoles: ['client_relations_officer', 'sales_manager', 'customer_service', 'marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "CRM must be updated:",
        options: [
          "Only once a month",
          "Immediately after client updates",
          "When we remember",
          "When client complains"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Filing client documents prevents:",
        options: [
          "Smooth work",
          "Confusion and legal issues",
          "Clear communication",
          "Accountability"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Weekly report must include:",
        options: [
          "Jokes",
          "Pipeline + risks + complaints",
          "Only compliments",
          "Random updates"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Confidentiality protects:",
        options: [
          "Company reputation & client trust",
          "Gossiping",
          "Competitors",
          "Chaos"
        ],
        correctAnswer: 0
      },
      {
        id: 5,
        question: "Smart note-taking ensures:",
        options: [
          "No one knows what is happening",
          "Clear instructions and smooth handovers",
          "Endless arguments",
          "Delays"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is the CRM?",
        options: [
          "A decoration tool",
          "The single source of truth about every client",
          "A social media platform",
          "A payment system"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "When should all new enquiries be captured?",
        options: [
          "After one week",
          "The same day they arrive",
          "Never captured",
          "Only if client pays"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "How must documents be named?",
        options: [
          "Random names",
          "With dates and version numbers",
          "Single word only",
          "No naming needed"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What should never be shared without approval?",
        options: [
          "Company address",
          "Drawings or quotations",
          "Business hours",
          "Website link"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What do handover briefs eliminate?",
        options: [
          "Team meetings",
          "Last-minute surprises",
          "Client calls",
          "Email communication"
        ],
        correctAnswer: 1
      }
    ]
  },
  'on-site-conduct': {
    id: 'on-site-conduct',
    title: 'On-Site Conduct',
    modulenumber: '2.2.5',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768305620/crelations6_dsnpwe.mp4',
    duration: 80,
    description: 'Professional site presence, installation standards, photography, space respect, and handover etiquette',
    requiredRoles: ['client_relations_officer', 'operations_manager', 'installation_team', 'marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "CRO should behave:",
        options: [
          "Casually and loud",
          "Professionally with respectful communication",
          "Disorganized and careless",
          "Like they own the client's space"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "On-site photos are:",
        options: [
          "Only for WhatsApp statuses",
          "Documentation for QC and marketing",
          "Unnecessary",
          "Taken randomly"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Mess and dust after installation should:",
        options: [
          "Be left behind",
          "Be cleaned before leaving the site",
          "Be the client's job",
          "Be pushed under the furniture"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Who signs the handover document?",
        options: [
          "Carpenter",
          "CRO & Client",
          "A stranger",
          "No one"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Delays or defects during installation must be:",
        options: [
          "Hidden",
          "Reported immediately",
          "Blamed on client",
          "Ignored until final day"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What should clients feel about Kajja on-site?",
        options: [
          "They are dealing with amateurs",
          "'We are in the hands of professionals'",
          "Confused and uncertain",
          "Like they need to supervise everything"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What must CRO check during installation?",
        options: [
          "Nothing - not their job",
          "Clean panel joints, aligned doors, no scratches",
          "Only the invoice",
          "Weather forecast"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What photos are mandatory?",
        options: [
          "Only selfies",
          "Before installation, during, and after installation",
          "Only of finished work",
          "None required"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What is the Zero Mess Policy?",
        options: [
          "Leave everything for client to clean",
          "Clean dust and waste before leaving site",
          "Hide mess under furniture",
          "Only clean if client complains"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must be collected at handover?",
        options: [
          "Nothing",
          "Client signature on handover form",
          "Only payment balance",
          "Complaints only"
        ],
        correctAnswer: 1
      }
    ]
  },
  'building-long-term-relationships': {
    id: 'building-long-term-relationships',
    title: 'Building Long-Term Relationships',
    modulenumber: '2.2.6',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768305620/crelations6_dsnpwe.mp4',
    duration: 85,
    description: 'Trust building, key account management, referral requests, milestone celebrations, and repeat business follow-up',
    requiredRoles: ['client_relations_officer', 'sales_manager', 'marketing-sales', 'customer_service'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "What builds trust?",
        options: [
          "Silence",
          "Reliability & honest communication",
          "Hidden problems",
          "Broken promises"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Who are key accounts?",
        options: [
          "Small impulse buyers only",
          "Banks, developers, institutions — high-value clients",
          "Random individuals",
          "Only friends"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Best time to ask for referrals?",
        options: [
          "When client is angry",
          "After successful completion and satisfaction",
          "At first phone call",
          "During delays"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Follow-up after installation:",
        options: [
          "Only when client calls",
          "Structured schedule for continued care",
          "Never again",
          "When we need money"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Celebrating clients means:",
        options: [
          "Ignoring them",
          "Appreciating milestones professionally",
          "Sending jokes",
          "Asking for favors constantly"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is the biggest driver of repeat business?",
        options: [
          "Lowest prices",
          "Reliability",
          "Fast delivery only",
          "Large discounts"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "How often should key accounts get check-ins?",
        options: [
          "Once a year",
          "Weekly check-ins",
          "Never check in",
          "Only when they complain"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What should you do with mistakes?",
        options: [
          "Hide them",
          "Admit early and show solution steps",
          "Blame others",
          "Ignore completely"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "When is the 7-day follow-up?",
        options: [
          "Quality check call",
          "Payment reminder",
          "New sales pitch",
          "Complaint collection"
        ],
        correctAnswer: 0
      },
      {
        id: 10,
        question: "What builds loyalty according to training?",
        options: [
          "Ignoring clients",
          "Small gestures like appreciation messages",
          "Constant price changes",
          "Being unavailable"
        ],
        correctAnswer: 1
      }
    ]
  },
  'personal-skills-growth': {
    id: 'personal-skills-growth',
    title: 'Personal Skills & Growth',
    modulenumber: '2.2.7',
    department: 'Client Relations',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768309126/crelations8_gnxiqt.mp4',
    duration: 85,
    description: 'Time management, emotional intelligence, problem-solving, confidence building, and personal development planning',
    requiredRoles: ['client_relations_officer', 'all_staff', 'marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Time management helps:",
        options: [
          "Miss deadlines",
          "Respond on time and keep projects moving",
          "Create confusion",
          "Ignore clients"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Emotional intelligence means:",
        options: [
          "Arguing back",
          "Staying calm and professional with stressed clients",
          "Running away",
          "Laughing at clients"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Best response to a problem you don't know?",
        options: [
          "'Not my job.'",
          "'Let me find out and get back to you.'",
          "Ignoring the client",
          "Blaming carpenters"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Confidence shows the client:",
        options: [
          "You are unsure",
          "Kajja is dependable",
          "We guess everything",
          "We fear responsibility"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Personal development helps CRO:",
        options: [
          "Become less capable",
          "Grow to deliver better client experiences",
          "Avoid work",
          "Forget responsibilities"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What should you prioritize first?",
        options: [
          "Non-work chats",
          "High urgency and high impact tasks",
          "Avoid all work",
          "Only easy tasks"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "How should you handle client anger?",
        options: [
          "Argue back",
          "Never take anger personally and respond with empathy",
          "Hang up the phone",
          "Complain to your manager"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What should you never say to clients?",
        options: [
          "Thank you",
          "'I don't know' or 'It's not my job'",
          "Good morning",
          "Progress updates"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What shows confidence in communication?",
        options: [
          "Speaking too fast",
          "Clear speech, friendly eye contact, prepared information",
          "Looking away",
          "Unsure language"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What should be in a personal development plan?",
        options: [
          "Only salary goals",
          "Skills to improve, actions to build skills, timeline for progress",
          "Vacation plans",
          "Gossip topics"
        ],
        correctAnswer: 1
      }
    ]
  },
    "safety-risk-control": {
      "id": "safety-risk-control",
      "title": "Safety & Risk Control",
      "modulenumber": "1.5.5",
      "department": "Operations Department",
      "videoUrl": "/videos/safety.mp4",
      "duration": 95,
      "description": "Workplace safety enforcement, PPE rules, machine safety, emergency response, incident reporting, and preventive action systems",
      "requiredRoles": ["manager","quality-control", "production-staff", "ceo"],
      "validityMinutes": 259200,
       quiz: [
        {
          "id": 1,
          "question": "Why must PPE be enforced?",
          "options": [
            "For uniform beauty",
            "To protect staff from injuries and hazards",
            "To make work slower",
            "Optional depending on the weather"
          ],
          "correctAnswer": 1
        },
        {
          "id": 2,
          "question": "Who ensures machine users are trained?",
          "options": [
            "The newest worker",
            "The Ops Manager",
            "Clients",
            "Anyone who wants to"
          ],
          "correctAnswer": 1
        },
        {
          "id": 3,
          "question": "A fire drill must be conducted:",
          "options": [
            "Every 3 years",
            "Whenever someone feels like",
            "Quarterly",
            "Never"
          ],
          "correctAnswer": 2
        },
        {
          "id": 4,
          "question": "Transport protection prevents:",
          "options": [
            "Profit",
            "Damage and client complaints",
            "Team bonding",
            "Faster driving"
          ],
          "correctAnswer": 1
        },
        {
          "id": 5,
          "question": "Incident reporting is important because:",
          "options": [
            "It helps in blaming staff",
            "It prevents repeat accidents and improves systems",
            "It wastes time",
            "It embarrasses supervisors"
          ],
          "correctAnswer": 1
        },
        {
          "id": 6,
          "question": "What PPE is required for sanding and spraying?",
          "options": [
            "Only safety shoes",
            "Dust masks, gloves, and coveralls",
            "Goggles only",
            "No special PPE needed"
          ],
          "correctAnswer": 1
        },
        {
          "id": 7,
          "question": "What is the first step in the daily machine startup check?",
          "options": [
            "Check fuel levels",
            "Ensure machine guards are installed",
            "Test maximum speed",
            "Clean the workshop floor"
          ],
          "correctAnswer": 1
        },
        {
          "id": 8,
          "question": "During an emergency, what should happen immediately after stopping machines?",
          "options": [
            "Take photos for reporting",
            "Evacuate to the assembly point",
            "Call the client",
            "Save all work files"
          ],
          "correctAnswer": 1
        },
        {
          "id": 9,
          "question": "What should be done when loading furniture for transport?",
          "options": [
            "Stack heavy pieces on delicate ones to save space",
            "Wrap fragile edges and secure properly with straps",
            "Load quickly without checking",
            "Let the driver decide how to pack"
          ],
          "correctAnswer": 1
        },
        {
          "id": 10,
          "question": "What type of culture does proper incident reporting help create?",
          "options": [
            "A blame-focused culture",
            "A high-learning culture with zero-blame",
            "A secretive culture",
            "A competitive culture"
          ],
          "correctAnswer": 1
        }
      ]
    },  
      "operational-finance-efficiency": {
        "id": "operational-finance-efficiency",
        "title": "Operational Finance & Efficiency",
        "modulenumber": "1.5.7",
        "department": "Operations Department",
        "videoUrl": "/videos/financeeffeciency.mp4",
        "duration": 85,
        "description": "Material waste prevention, rework cost control, productivity KPIs, basic budget management, and procurement accountability",
        "requiredRoles": ["manager","quality-control" ,"ceo"],
        "validityMinutes": 259200,
        quiz: [
          {
            "id": 1,
            "question": "Lean 5S helps:",
            "options": [
              "Create more confusion",
              "Maintain order, reduce waste, improve efficiency",
              "Decorate workshop",
              "Reduce productivity"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "What is the biggest financial danger in production?",
            "options": [
              "Ridiculous dancing",
              "Reworks and delays",
              "Asking for help",
              "Following job cards"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "Weekly operations KPIs must:",
            "options": [
              "Only show successes",
              "Include problems and improvement plans",
              "Be forgotten",
              "Be verbal only"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Petty cash must be controlled using:",
            "options": [
              "Verbal approval",
              "Written receipts & weekly reconciliation",
              "Trust alone",
              "Memory"
            ],
            "correctAnswer": 1
          },
          {
            "id": 5,
            "question": "Resource allocation means:",
            "options": [
              "Giving people random jobs",
              "Assigning people/tools/money according to priority and efficiency",
              "Hiring everyone who walks in",
              "Ignoring budget"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "Which Lean 5S step focuses on 'Same rules everywhere'?",
            "options": [
              "Sort",
              "Set in Order",
              "Standardize",
              "Sustain"
            ],
            "correctAnswer": 2
          },
          {
            "id": 7,
            "question": "What should the Ops Manager track when rework occurs?",
            "options": [
              "Only the cost of materials",
              "Who caused it, what SOP failed, and what training is needed",
              "How to hide it from management",
              "Which client to blame"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "What is the target for rework percentage?",
            "options": [
              "Less than 20% monthly",
              "Less than 5% monthly",
              "Less than 50% monthly",
              "No specific target"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "What is the purpose of material requisition signatures?",
            "options": [
              "To create more paperwork",
              "To ensure accountability and prevent unauthorized purchases",
              "To delay procurement",
              "To impress suppliers"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "What does 'Efficiency is Profit, Waste is Loss' mean?",
            "options": [
              "Profit comes from charging higher prices",
              "Every efficiency gain directly increases profit; every waste directly reduces it",
              "Efficiency is not related to profit",
              "Waste is acceptable if work is fast"
            ],
            "correctAnswer": 1
          }
        ]
      },
        "crisis-handling-client-protection": {
          "id": "crisis-handling-client-protection",
          "title": "Crisis Handling & Client Protection",
          "modulenumber": "1.5.9",
          "department": "Operations Department",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1767777203/crisis_iuzjre.mp4",
          "duration": 80,
          "description": "Complaint resolution, delay communication, conflict management, brand protection, and structured recovery planning",
          "requiredRoles": ["manager","quality-control","quality-control", "ceo"],
          "validityMinutes": 259200,
          quiz: [
            {
              "id": 1,
              "question": "Biggest rule for client complaints:",
              "options": [
                "Ignore until they calm down",
                "Respond quickly & respectfully with a clear action plan",
                "Argue to prove we are right",
                "Blame design team"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "Delays must be communicated:",
              "options": [
                "Only after deadline passes",
                "Immediately with solution & timeline updates",
                "If client asks angrily",
                "Never mention"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "Workshop vs site conflicts must be:",
              "options": [
                "Solved publicly in front of client",
                "Investigated privately & fact-based",
                "Handled by shouting",
                "Ignored until worse"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "Brand protection during crisis means:",
              "options": [
                "Hiding problems",
                "Confident, calm communication & solution focus",
                "Arrogance",
                "Rudeness"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "Recovery plans must include:",
              "options": [
                "Blame history",
                "Clear actions, timeline, responsibility & QC verification",
                "Gossip",
                "Guesswork"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "What is the first thing to do when a client complains?",
              "options": [
                "Defend the company immediately",
                "Listen completely before responding",
                "Ask for proof",
                "Transfer to another department"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "Who should be notified immediately about a client complaint?",
              "options": [
                "Only the Ops Manager",
                "GM, QC, and Sales team",
                "Only the finance department",
                "Wait until end of day"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "What is the golden rule for brand protection during crises?",
              "options": [
                "When emotions are high, professionalism must be higher",
                "Match the client's emotional level",
                "Remain silent until emotions pass",
                "Let the client vent without response"
              ],
              "correctAnswer": 0
            },
            {
              "id": 9,
              "question": "What should happen after resolving a workshop-site conflict?",
              "options": [
                "Celebrate victory over the other team",
                "Debrief and document root cause internally",
                "Punish the losing side",
                "Forget about it and move on"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "What should be included in daily progress updates during a delay?",
              "options": [
                "Only positive news",
                "What happened, what is being done, and new timeline",
                "Technical details the client won't understand",
                "Blame assignment"
              ],
              "correctAnswer": 1
            }
          ]
        },
      
        "technology-records": {
          "id": "technology-records",
          "title": "Technology & Records",
          "modulenumber": "1.5.8",
          "department": "Operations Department",
          "videoUrl": "/videos/technology.mp4",
          "duration": 75,
          "description": "Digital tool use, job card completion, systematic filing, data accuracy enforcement, and confidentiality protocols",
          "requiredRoles": ["manager","quality-control", "ceo"],
          "validityMinutes": 259200,
          quiz: [
            {
              "id": 1,
              "question": "Why must job cards be completed fully?",
              "options": [
                "For decoration",
                "To provide accurate accountability and traceability",
                "Because Ops Manager likes paperwork",
                "Optional for small jobs"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "The correct policy for digital records:",
              "options": [
                "Update only when boss is watching",
                "Consistent daily inputs with photo evidence",
                "Guess data when not sure",
                "Keep information in memory"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "File storage should:",
              "options": [
                "Be organized with approvals, receipts & photos",
                "Be messy",
                "Depend on verbal memory",
                "Not exist"
              ],
              "correctAnswer": 0
            },
            {
              "id": 4,
              "question": "Accuracy in reporting means:",
              "options": [
                "Give any answer quickly",
                "Confirm facts before reporting",
                "Hide problems",
                "Hope for the best"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "Confidentiality helps:",
              "options": [
                "Protect company reputation and trust",
                "Make gossip more interesting",
                "Leak client secrets",
                "Sell drawings to others"
              ],
              "correctAnswer": 0
            },
            {
              "id": 6,
              "question": "What is the core principle of technology and records at Kajja?",
              "options": [
                "If it's expensive, it must be good",
                "If it's not recorded, it didn't happen",
                "Technology always beats paper",
                "Records are for auditors only"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "What should be attached to job cards before closing them?",
              "options": [
                "Only the invoice",
                "Approved drawings, QC checklist, and photos from workshop to installation",
                "Only client contact details",
                "Supplier quotations"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "Which information should NEVER be shared without authorization?",
              "options": [
                "Workshop safety rules",
                "Pricing details, client contacts, and supplier margins",
                "Company address",
                "Product catalog photos"
              ],
              "correctAnswer": 1
            },
            {
              "id": 9,
              "question": "What is better than giving a wrong update?",
              "options": [
                "Giving a partial update",
                "Saying 'I don't know yet' and confirming facts first",
                "Blaming someone else",
                "Giving an estimated guess"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "Who should have access to project files?",
              "options": [
                "Only the Ops Manager",
                "Ops, Design, Sales, and GM teams",
                "Only the CEO",
                "Anyone in the company"
              ],
              "correctAnswer": 1
            }
          ]
        },
      
     
      "people-team-management": {
        "id": "people-team-management",
        "title": "People & Team Management",
        "modulenumber": "1.5.6",
        "department": "Operations Department",
        "videoUrl": "/videos/people.mp4",
        "duration": 80,
        "description": "Supervision techniques, time discipline, on-job coaching, conflict resolution, and performance motivation systems",
        "requiredRoles": ["manager","quality-control", "ceo"],
        "validityMinutes": 259200,
        quiz: [
          {
            "id": 1,
            "question": "Supervising requires:",
            "options": [
              "Guessing what workers are doing",
              "Clear instructions & continuous follow-up",
              "Waiting in the office until day ends",
              "Complaining after failure"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "On-job coaching should:",
            "options": [
              "Embarrass staff publicly",
              "Be calm, respectful and instructional",
              "Focus on personality flaws",
              "Happen only after client complaints"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "Conflict should be handled:",
            "options": [
              "By shouting",
              "Privately, fairly and fast",
              "By taking sides",
              "Ignoring it until it explodes"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "What drives performance motivation best?",
            "options": [
              "Daily praise, growth opportunities, clear KPIs",
              "Fear and confusion",
              "Unpredictable rules",
              "No recognition"
            ],
            "correctAnswer": 0
          },
          {
            "id": 5,
            "question": "Time discipline must be:",
            "options": [
              "Optional",
              "Enforced with reporting and consequences",
              "Determined by each worker",
              "Ignored"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "What does the coaching framework S.O.S stand for?",
            "options": [
              "Shout, Order, Scold",
              "Show the issue, Offer correct method, Supervise retry",
              "Stop, Observe, Start over",
              "See, Organize, Submit"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "What is the progressive discipline process for late workers?",
            "options": [
              "Immediate dismissal",
              "Verbal notice → Written warning → Escalate to HR & GM",
              "Only warnings, no consequences",
              "Reduce salary immediately"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "What should you investigate when idle time is observed?",
            "options": [
              "Worker's personal life",
              "Material shortage, machine downtime, or low discipline",
              "Only the supervisor's management style",
              "Client payment status"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "What is the golden rule for giving feedback?",
            "options": [
              "Praise in public, correct in private",
              "Correct in public to set an example",
              "Only give positive feedback",
              "Let workers figure out their mistakes"
            ],
            "correctAnswer": 0
          },
          {
            "id": 10,
            "question": "What should performance evaluations track daily?",
            "options": [
              "Only attendance",
              "Quantity, quality, time discipline, and team behavior",
              "Only the number of breaks taken",
              "Personal opinions about workers"
            ],
            "correctAnswer": 1
          }
        ]
      },
  
    'hr-strategy-reporting': {
      id: 'hr-strategy-reporting',
      title: 'HR Strategy & Reporting',
      modulenumber: '1.4.9',
      department: 'Human Resources',
      videoUrl: '/videos/hreporting.mp4',
      duration: 80,
      description: 'HR dashboards, workforce planning, succession strategies, data-driven decision making, and business alignment',
      requiredRoles: ['hr-admin', 'ceo', 'manager','office-staff'],
      validityMinutes: 259200, // 6 months in minutes
      quiz: [
        {
          "id": 1,
          "question": "What is the purpose of HR dashboards?",
          "options": [
            "Decoration for meetings",
            "Show progress and guide improvement decisions",
            "Confuse management",
            "Hide problems"
          ],
          "correctAnswer": 1
        },
        {
          "id": 2,
          "question": "Workforce planning means:",
          "options": [
            "Hiring only when people quit",
            "Predicting staffing needs before they become urgent",
            "Reducing workforce only",
            "Waiting for GM to panic"
          ],
          "correctAnswer": 1
        },
        {
          "id": 3,
          "question": "Succession planning ensures:",
          "options": [
            "Chaos when leaders leave",
            "Smooth transitions and internal growth",
            "Only outsiders get promoted",
            "Only apprentices lead"
          ],
          "correctAnswer": 1
        },
        {
          "id": 4,
          "question": "Data-driven HR means decisions based on:",
          "options": [
            "Emotions and favoritism",
            "Facts, performance numbers & documentation",
            "Rumors from colleagues",
            "Anger"
          ],
          "correctAnswer": 1
        },
        {
          "id": 5,
          "question": "HR alignment with business goals requires:",
          "options": [
            "Working without leadership input",
            "Making decisions that support growth and performance",
            "Hiring without job descriptions",
            "Avoiding KPIs"
          ],
          "correctAnswer": 1
        },
        {
          "id": 6,
          "question": "What is HR's ultimate role according to the module?",
          "options": [
            "Only to process payroll",
            "Hire, grow, and protect the people who produce Kajja's success",
            "Only to handle disciplinary actions",
            "To create company policies"
          ],
          "correctAnswer": 1
        },
        {
          "id": 7,
          "question": "What is the ideal total hiring cycle timeline?",
          "options": [
            "1-2 weeks",
            "3-4 weeks",
            "6-8 weeks",
            "No timeline needed"
          ],
          "correctAnswer": 1
        },
        {
          "id": 8,
          "question": "What does the growth pathway model show?",
          "options": [
            "Only salary progression",
            "Apprentice → Assistant Artisan → Skilled Artisan → Supervisor → Manager",
            "Direct hiring into management",
            "Only technical skill development"
          ],
          "correctAnswer": 1
        },
        {
          "id": 9,
          "question": "Before making any HR decision, what should be checked?",
          "options": [
            "Personal feelings about the employee",
            "Data, behavior, results, and documentation",
            "What other employees think",
            "The employee's personal background"
          ],
          "correctAnswer": 1
        },
        {
          "id": 10,
          "question": "How should HR evaluate its own activities?",
          "options": [
            "By the number of policies created",
            "By asking 'How does this decision help Kajja grow?'",
            "By employee popularity",
            "By reducing HR department costs"
          ],
          "correctAnswer": 1
        }
      ]
  
    }, 
      'quality-control-systems': {
        id: 'quality-control-systems',
        title: 'Quality Control Systems',
        modulenumber: '1.5.3',
        department: 'Operations Department',
        videoUrl: '/videos/qualitycontrol.mp4',
        duration: 85,
        description: 'Quality standards enforcement, inspection protocols, pre-production checks, workshop and site QC procedures, and rework prevention systems',
        requiredRoles: ['manager', 'ceo','quality-control'],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            "id": 1,
            "question": "QC must happen:",
            "options": [
              "Only after installation",
              "Throughout cutting → finishing → installation",
              "Only when client complains",
              "Once a year"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "Panel cutting tolerance at Kajja:",
            "options": [
              "±10mm",
              "±5mm",
              "±1mm",
              "Approximate is ok"
            ],
            "correctAnswer": 2
          },
          {
            "id": 3,
            "question": "If defect is found mid-production:",
            "options": [
              "Continue, install, hope client doesn't see",
              "Stop and fix immediately",
              "Hide it with paint",
              "Ignore"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Site QC includes:",
            "options": [
              "Clean handover + proper alignment + zero visible damage",
              "Leave dust for client to clean",
              "Remove labels later",
              "Guess measurements"
            ],
            "correctAnswer": 0
          },
          {
            "id": 5,
            "question": "Reworks must be:",
            "options": [
              "Ignored if small",
              "Recorded, costed, and assigned accountability",
              "Charged to client",
              "Accepted as normal"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "What is Kajja's quality motto?",
            "options": [
              "We fix it later",
              "We do it right the first time",
              "Close enough is good enough",
              "Speed over perfection"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "What is the maximum gap allowed between doors?",
            "options": [
              "5mm uniform",
              "2mm uniform",
              "10mm varying",
              "No specific measurement"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "When should pre-production checks be done?",
            "options": [
              "After cutting has started",
              "Before ANY timber is cut",
              "During installation",
              "After client complains"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "What must the QC Supervisor do at each production stage?",
            "options": [
              "Give verbal approval only",
              "Sign the Job Card for that stage",
              "Take photos for social media",
              "Report directly to the client"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "What is the consequence for a third-time rework caused by the same issue?",
            "options": [
              "Extra pay for overtime",
              "Performance discipline",
              "Promotion to supervisor",
              "No consequence"
            ],
            "correctAnswer": 1
          }
        ]
      },
        "installation-operations": {
          "id": "installation-operations",
          "title": "Installation Operations",
          "modulenumber": "1.5.4",
          "department": "Operations Department",
          "videoUrl": "/videos/installations.mp4",
          "duration": 90,
          "description": "Pre-installation checks, site conduct standards, change management, handover procedures, and after-service warranty protocols",
          "requiredRoles": ["manager","quality-control", "production-staff","ceo"],
          "validityMinutes": 259200,
          quiz: [
            {
              "id": 1,
              "question": "What must happen before loading furniture for delivery?",
              "options": [
                "Assume tools are available",
                "Confirm QC approval, tools, and site readiness",
                "Rush because the client is waiting",
                "Send handyman alone"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "What should installation staff do if site measurements differ?",
              "options": [
                "Install anyway",
                "Hide the mistake",
                "Stop → report → wait for approval",
                "Argue with client"
              ],
              "correctAnswer": 2
            },
            {
              "id": 3,
              "question": "Sign-off form ensures:",
              "options": [
                "Nothing important",
                "Written proof of client satisfaction and warranty start",
                "Installer has good handwriting",
                "Extra paperwork"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "What communication standard must be followed on-site?",
              "options": [
                "Shouting instructions",
                "Only installer lead communicates with client respectfully",
                "Discuss personal issues with client",
                "No need to communicate"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "After-service visits help:",
              "options": [
                "Waste fuel",
                "Build client loyalty & identify improvement opportunities",
                "Hurt company brand",
                "Reduce referrals"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "What is Kajja's installation motto?",
              "options": [
                "Fast and cheap",
                "Professional from Factory to Finish",
                "Install now, fix later",
                "Whatever works"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "What should installation staff do before drilling or altering walls?",
              "options": [
                "Do it quickly before client notices",
                "Ask for client permission",
                "Assume it's part of the job",
                "Leave it for the client to do later"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "When is installation considered complete?",
              "options": [
                "When furniture is placed in the room",
                "After sign-off form is signed by client",
                "When the team leaves the site",
                "After the invoice is sent"
              ],
              "correctAnswer": 1
            },
            {
              "id": 9,
              "question": "What is the response time for warranty complaints?",
              "options": [
                "Within 7 days",
                "Within 72 hours",
                "Within 2 weeks",
                "When convenient"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "What happens if tools are missing during installation preparation?",
              "options": [
                "Borrow from client",
                "Delays and embarrassment - unacceptable",
                "Use alternative methods",
                "Skip that part of installation"
              ],
              "correctAnswer": 1
            }
          ]
        },
        'workshop-leadership-brand-culture': {
          id: 'workshop-leadership-brand-culture',
          title: 'Workshop Leadership & Brand Culture',
          modulenumber: '4.5.0',
          department: 'Production',
          videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770277012/w1_xtqr1x.mp4',
          duration: 90,
          description: 'Equip Workshop Manager with leadership, discipline and brand-driven operational skills to improve productivity, quality, accountability and team culture.',
          requiredRoles: ['workshop-manager', 'head_of_production'],
          validityMinutes: 259200,
          quiz: [
            {
              id: 1,
              question: "Workshop Manager is single point of accountability for:",
              options: [
                "Only material ordering",
                "Client meetings",
                "All production output quality and delivery",
                "Staff attendance only"
              ],
              correctAnswer: 2
            },
            {
              id: 2,
              question: "Workshop Manager translates approved designs into products meeting:",
              options: [
                "Only deadlines",
                "Design intent, specifications, timelines, quality",
                "Worker preferences",
                "Only budget"
              ],
              correctAnswer: 1
            },
            {
              id: 3,
              question: "Failure to report problems early is considered:",
              options: [
                "Management failure",
                "Worker mistake",
                "Finance problem",
                "Minor issue"
              ],
              correctAnswer: 0
            },
            {
              id: 4,
              question: "Workshop Manager must think like:",
              options: [
                "Client only",
                "Designer",
                "Business owner",
                "Only supervisor"
              ],
              correctAnswer: 2
            },
            {
              id: 5,
              question: "Brand promise must be seen in:",
              options: [
                "Only marketing",
                "Client gifts",
                "Office decor",
                "Work accuracy, clean workmanship, consistency"
              ],
              correctAnswer: 3
            },
            {
              id: 6,
              question: "Internal mistakes must be corrected:",
              options: [
                "During installation",
                "Next month",
                "Before reaching client",
                "After client complains"
              ],
              correctAnswer: 2
            },
            {
              id: 7,
              question: "Professional communication follows hierarchy to:",
              options: [
                "Avoid conflicting instructions and protect accountability",
                "Slow work",
                "Reduce pay",
                "Increase meetings"
              ],
              correctAnswer: 0
            },
            {
              id: 8,
              question: "Workshop Manager resolves conflicts using:",
              options: [
                "Worker popularity",
                "Facts, job cards, drawings, procedures",
                "Client preferences",
                "Personal opinions"
              ],
              correctAnswer: 1
            },
            {
              id: 9,
              question: "Discipline in workshop ensures:",
              options: [
                "Consistent results and safety",
                "Punishment system",
                "Less pay",
                "Fewer workers"
              ],
              correctAnswer: 0
            },
            {
              id: 10,
              question: "Workshop Manager leads by:",
              options: [
                "Avoiding staff",
                "Strict warnings only",
                "Example: early arrival, visible on floor, problem-solving",
                "Office work only"
              ],
              correctAnswer: 2
            }
          ]
        },
        "machine-technician-role": {
          "id": "machine-technician-role",
          "title": "Role & Responsibility",
          "modulenumber": "4.7.0",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770806250/m1_mcptek.mp4",
          "duration": 85,
          "description": "To define the professional role of the Machine Technician, link machine performance directly to company success, establish professional behaviour standards, and clarify communication responsibilities with the Head of Production, Workshop Manager and QC team.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "A Machine Technician at Kajja Galleries is mainly responsible for:",
              "options": [
                "Supervising installers",
                "Preparing client quotations",
                "Operating, maintaining and ensuring accuracy of machines",
                "Controlling procurement"
              ],
              "correctAnswer": 2
            },
            {
              "id": 2,
              "question": "A Machine Technician is best described as:",
              "options": [
                "A general workshop helper",
                "A machine operator only",
                "A technical custodian of production capacity",
                "A store assistant"
              ],
              "correctAnswer": 2
            },
            {
              "id": 3,
              "question": "Which activity is part of a Machine Technician's core role?",
              "options": [
                "Approving job cards",
                "Setting up and aligning machines correctly",
                "Preparing invoices",
                "Assigning workers"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "Why is machine performance critical to Kajja Galleries' success?",
              "options": [
                "It reduces paperwork",
                "It supports marketing activities",
                "It enables precision, consistency and bulk production",
                "It reduces staff numbers"
              ],
              "correctAnswer": 2
            },
            {
              "id": 5,
              "question": "Which is a direct effect of poor machine performance?",
              "options": [
                "Improved teamwork",
                "Reduced rework",
                "Scrap, rework and delivery delays",
                "Faster installations"
              ],
              "correctAnswer": 2
            },
            {
              "id": 6,
              "question": "One ignored machine abnormal sound can result in:",
              "options": [
                "Faster cutting",
                "Better finish",
                "Production disruption and losses",
                "Less tool wear"
              ],
              "correctAnswer": 2
            },
            {
              "id": 7,
              "question": "Which behaviour reflects professional conduct?",
              "options": [
                "Hiding mistakes",
                "Bypassing safety devices",
                "Reporting machine problems early",
                "Using machines for personal work"
              ],
              "correctAnswer": 2
            },
            {
              "id": 8,
              "question": "Which action is NOT allowed for a Machine Technician?",
              "options": [
                "Cleaning machines after use",
                "Reporting faults",
                "Operating machines without authorization",
                "Supporting maintenance"
              ],
              "correctAnswer": 2
            },
            {
              "id": 9,
              "question": "When production pressure increases, the Machine Technician must:",
              "options": [
                "Ignore quality checks",
                "Work faster even if unsafe",
                "Protect safety and accuracy",
                "Skip setup procedures"
              ],
              "correctAnswer": 2
            },
            {
              "id": 10,
              "question": "QC should be treated by the Machine Technician as:",
              "options": [
                "A policing unit",
                "A reporting obstacle",
                "A partner for quality improvement",
                "A management replacement"
              ],
              "correctAnswer": 2
            }
          ]
        },
        "machine-operations": {
          "id": "machine-operations",
          "title": "Machine Operations",
          "modulenumber": "4.7.1",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770807214/m2_elp8in.mp4",
          "duration": 90,
          "description": "To equip Machine Technicians with practical operational understanding of CNC, panel saw, edge bander and drilling systems, and to enforce safe, accurate and repeatable production.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "The CNC machine mainly supports Kajja Galleries by enabling:",
              "options": [
                "Faster packing",
                "Manual production",
                "Accurate and repeatable cutting and routing",
                "Marketing activities"
              ],
              "correctAnswer": 2
            },
            {
              "id": 2,
              "question": "Which must be verified before running a CNC job?",
              "options": [
                "Delivery schedule",
                "Tool numbers and material thickness",
                "Staff attendance",
                "Client approval"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "Why is nesting review important before CNC cutting?",
              "options": [
                "To reduce file size",
                "To prevent collisions, missing parts and wastage",
                "To increase feed rate",
                "To reduce machine noise"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "Which is a nesting red flag?",
              "options": [
                "Parts placed inside the sheet",
                "Proper spacing between parts",
                "Parts extending outside the board boundary",
                "Grain direction followed"
              ],
              "correctAnswer": 2
            },
            {
              "id": 5,
              "question": "The main role of the technician at the panel saw is to ensure:",
              "options": [
                "Faster cutting",
                "Correct blade, setup and cutting accuracy",
                "Tool purchasing",
                "Operator supervision only"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "Edge bander feed rate must be controlled mainly to:",
              "options": [
                "Reduce noise",
                "Improve machine life only",
                "Ensure proper bonding and trimming quality",
                "Increase electricity use"
              ],
              "correctAnswer": 2
            },
            {
              "id": 7,
              "question": "Running an edge bander before glue reaches correct temperature will likely cause:",
              "options": [
                "Better finish",
                "Faster production",
                "Poor bonding and lifting edges",
                "Less trimming"
              ],
              "correctAnswer": 2
            },
            {
              "id": 8,
              "question": "Why is first-piece drilling approval mandatory?",
              "options": [
                "To train helpers",
                "To save time",
                "To confirm accuracy before batch drilling",
                "To reduce machine wear"
              ],
              "correctAnswer": 2
            },
            {
              "id": 9,
              "question": "Which situation requires immediate use of an emergency stop?",
              "options": [
                "When material is finished",
                "When a tool breaks or material lifts dangerously",
                "When production is slow",
                "When a supervisor is nearby"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "Before clearing a jam or changing a tool, the technician must:",
              "options": [
                "Work quickly",
                "Ask a helper",
                "Stop and isolate the machine",
                "Continue while slowing the machine"
              ],
              "correctAnswer": 2
            }
          ]
        },
        "preventive-maintenance": {
          "id": "preventive-maintenance",
          "title": "Preventive Maintenance",
          "modulenumber": "4.7.3",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770809220/m4_kh4i23.mp4",
          "duration": 90,
          "description": "To equip Machine Technicians with disciplined preventive maintenance practices that protect machine accuracy, extend equipment life, reduce downtime and support consistent production quality.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "Preventive maintenance mainly helps to:",
              "options": [
                "Increase paperwork",
                "Improve marketing",
                "Reduce downtime and protect machine accuracy",
                "Reduce staff numbers"
              ],
              "correctAnswer": 2
            },
            {
              "id": 2,
              "question": "Which is a daily maintenance task?",
              "options": [
                "Bearing replacement",
                "Cleaning machine beds and rails",
                "Motor overhaul",
                "Electrical rewiring"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "Why is correct lubrication important?",
              "options": [
                "To make machines shiny",
                "To reduce dust only",
                "To reduce wear and maintain movement accuracy",
                "To increase speed"
              ],
              "correctAnswer": 2
            },
            {
              "id": 4,
              "question": "Over-lubrication can:",
              "options": [
                "Improve cutting quality",
                "Be harmless",
                "Cause dust build-up and mechanical problems",
                "Reduce machine noise"
              ],
              "correctAnswer": 2
            },
            {
              "id": 5,
              "question": "Which component must be checked daily for wear?",
              "options": [
                "Office computers",
                "Router bits and saw blades",
                "Racks and shelves",
                "Delivery vehicles"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "What should be done when a blade or bit is dull or damaged?",
              "options": [
                "Continue using it",
                "Slow the machine",
                "Replace or sharpen it immediately",
                "Ignore until QC complains"
              ],
              "correctAnswer": 2
            },
            {
              "id": 7,
              "question": "Why must the glue system be cleaned regularly?",
              "options": [
                "To reduce glue use",
                "To protect the machine paint",
                "To ensure strong bonding and clean finish",
                "To increase feed rate"
              ],
              "correctAnswer": 2
            },
            {
              "id": 8,
              "question": "Which action confirms correct glue system calibration?",
              "options": [
                "Checking colour only",
                "Verifying temperature, pressure and glue spread",
                "Increasing feed speed",
                "Changing edge tape"
              ],
              "correctAnswer": 1
            },
            {
              "id": 9,
              "question": "Which of the following is an early-warning sign of machine problems?",
              "options": [
                "Quiet operation",
                "Consistent cutting",
                "Abnormal vibration or noise",
                "Clean machine bed"
              ],
              "correctAnswer": 2
            },
            {
              "id": 10,
              "question": "When abnormal behaviour is noticed, the technician must first:",
              "options": [
                "Ignore it",
                "Continue production",
                "Stop and report immediately",
                "Finish the batch"
              ],
              "correctAnswer": 2
            }
          ]
        },
        "tooling-consumables-management": {
          "id": "tooling-consumables-management",
          "title": "Tooling & Consumables Management",
          "modulenumber": "4.7.4",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770810315/m5_joqqmt.mp4",
          "duration": 85,
          "description": "To equip Machine Technicians with disciplined tooling and consumables control practices that protect machine accuracy, reduce waste, improve safety, and control production costs at Kajja Galleries.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "Why is correct bit or blade selection important?",
              "options": [
                "To reduce noise",
                "To improve storage",
                "To avoid defects and tool damage",
                "To increase cutting speed"
              ],
              "correctAnswer": 2
            },
            {
              "id": 2,
              "question": "Which tool is best suited for laminated boards where both top and bottom faces must be clean?",
              "options": [
                "Straight bit",
                "Compression bit",
                "Down-cut bit",
                "Boring bit"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "Which practice is safe when handling sharp tools?",
              "options": [
                "Holding cutting edges",
                "Carrying loose bits in pockets",
                "Using protective holders",
                "Placing tools on machine beds"
              ],
              "correctAnswer": 2
            },
            {
              "id": 4,
              "question": "Router bits and drills should be stored:",
              "options": [
                "Mixed in one box",
                "In labelled holders",
                "On machine tables",
                "In tool bags"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "Which condition indicates a tool must be replaced?",
              "options": [
                "Normal machine sound",
                "Improved finish",
                "Burning marks and chipping",
                "Faster cutting"
              ],
              "correctAnswer": 2
            },
            {
              "id": 6,
              "question": "What is the first step before replacing a tool?",
              "options": [
                "Inform QC",
                "Continue cutting",
                "Stop and isolate the machine",
                "Increase feed rate"
              ],
              "correctAnswer": 2
            },
            {
              "id": 7,
              "question": "Why must tool holders and spindles be cleaned before fitting new tools?",
              "options": [
                "For appearance",
                "To prevent vibration and run-out",
                "To reduce tool length",
                "To reduce glue use"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "Tooling logs are mainly used to:",
              "options": [
                "Train new staff",
                "Control tool life and costs",
                "Approve purchases",
                "Schedule shifts"
              ],
              "correctAnswer": 1
            },
            {
              "id": 9,
              "question": "Which item is considered a high-cost consumable?",
              "options": [
                "Paper towels",
                "Edge banding tape",
                "Pencils",
                "Labels"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "Who is responsible for controlling tooling waste at Kajja Galleries?",
              "options": [
                "Store Manager only",
                "QC only",
                "Machine Technicians",
                "Procurement only"
              ],
              "correctAnswer": 2
            }
          ]
        },
        "safety-workshop-order": {
          "id": "safety-workshop-order",
          "title": "Safety & Workshop Order",
          "modulenumber": "4.7.5",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770810983/m6_llrsfx.mp4",
          "duration": 85,
          "description": "To ensure that every Machine Technician maintains a safe, disciplined and orderly workstation that protects people, machines, and Kajja Galleries' production continuity.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "Why is PPE mandatory for Machine Technicians?",
              "options": [
                "For company image only",
                "To comply with uniforms",
                "To protect against injury, noise and dust",
                "To reduce machine wear"
              ],
              "correctAnswer": 2
            },
            {
              "id": 2,
              "question": "Which PPE is mandatory when working near CNC and panel saws?",
              "options": [
                "Helmet only",
                "Ear protection",
                "Apron only",
                "Face shield only"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "Gloves should mainly be used by machine technicians when:",
              "options": [
                "Operating rotating tools",
                "Handling boards and tools",
                "Operating CNC programs",
                "Cleaning electrical panels"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "Why must dust extraction always be switched on before cutting starts?",
              "options": [
                "To improve lighting",
                "To reduce electricity use",
                "To reduce fire and health risks",
                "To increase cutting speed"
              ],
              "correctAnswer": 2
            },
            {
              "id": 5,
              "question": "If dust extraction is weak or not working, the technician must:",
              "options": [
                "Continue production slowly",
                "Ignore the problem",
                "Stop production and report immediately",
                "Clean the floor only"
              ],
              "correctAnswer": 2
            },
            {
              "id": 6,
              "question": "Which sign indicates a possible electrical fire risk?",
              "options": [
                "Clean machine table",
                "Low dust levels",
                "Burning smell or overheating",
                "Proper cable routing"
              ],
              "correctAnswer": 2
            },
            {
              "id": 7,
              "question": "When lifting large panels, the correct practice is to:",
              "options": [
                "Lift quickly alone",
                "Drag the panel on the floor",
                "Use two-person lifting or mechanical aids",
                "Lift while twisting"
              ],
              "correctAnswer": 2
            },
            {
              "id": 8,
              "question": "Which lifting behaviour is correct?",
              "options": [
                "Twisting while carrying",
                "Keeping the load close to the body",
                "Carrying above shoulder height",
                "Running with panels"
              ],
              "correctAnswer": 1
            },
            {
              "id": 9,
              "question": "Which situation creates a safety risk at a workstation?",
              "options": [
                "Clean floor",
                "Proper tool storage",
                "Off-cuts and scrap around machines",
                "Labelled storage areas"
              ],
              "correctAnswer": 2
            },
            {
              "id": 10,
              "question": "What must be done at the end of every shift?",
              "options": [
                "Leave off-cuts for the next shift",
                "Switch off lights only",
                "Clean the area and leave the machine safe",
                "Store panels near walkways"
              ],
              "correctAnswer": 2
            }
          ]
        },
        "troubleshooting-basics": {
          "id": "troubleshooting-basics",
          "title": "Troubleshooting Basics",
          "modulenumber": "4.7.6",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770812283/m8_tznoyg.mp4 ",
          "duration": 85,
          "description": "To equip Machine Technicians with practical, non-technical troubleshooting skills that allow fast problem identification, safe first checks, correct escalation, and calm decision-making that protects machines, people and production schedules.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "Non-technical troubleshooting mainly means:",
              "options": [
                "Repairing machine electronics",
                "Resetting alarms only",
                "Performing safe first checks and escalating correctly",
                "Modifying machine programs"
              ],
              "correctAnswer": 2
            },
            {
              "id": 2,
              "question": "Which is a common CNC alarm situation a technician must recognize?",
              "options": [
                "Staff shortage",
                "Emergency stop activated",
                "Low stock",
                "Missing job card"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "Which check is allowed as a first-level CNC check?",
              "options": [
                "Opening control panels",
                "Adjusting servo drives",
                "Checking safety doors and air/vacuum supply",
                "Rewriting the program"
              ],
              "correctAnswer": 2
            },
            {
              "id": 4,
              "question": "Which edge banding fault indicates poor bonding?",
              "options": [
                "Clean trimming",
                "Tape lifting from the panel",
                "Smooth corners",
                "Even glue spread"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "Which condition requires stopping the edge bander immediately?",
              "options": [
                "One clean panel",
                "Slight dust on boards",
                "Repeated tape lifting on multiple parts",
                "Warm machine cover"
              ],
              "correctAnswer": 2
            },
            {
              "id": 6,
              "question": "Which action is a correct machine operator 'do'?",
              "options": [
                "Ignoring alarms",
                "Running full batches without first-piece checks",
                "Stopping production when abnormal behaviour appears",
                "Adjusting parameters freely"
              ],
              "correctAnswer": 2
            },
            {
              "id": 7,
              "question": "Which action is strictly prohibited for a Machine Technician?",
              "options": [
                "Reporting faults",
                "Running first-piece checks",
                "Bypassing safety devices",
                "Cleaning machines"
              ],
              "correctAnswer": 2
            },
            {
              "id": 8,
              "question": "Why must persistent faults be escalated early?",
              "options": [
                "To reduce documentation",
                "To increase machine use",
                "To prevent serious damage and scrap",
                "To reduce supervision"
              ],
              "correctAnswer": 2
            },
            {
              "id": 9,
              "question": "Who must be informed first when a machine fault cannot be resolved by basic checks?",
              "options": [
                "Store Manager",
                "Installation supervisor",
                "Workshop Manager or Head of Production",
                "Finance officer"
              ],
              "correctAnswer": 2
            },
            {
              "id": 10,
              "question": "Restarting a machine repeatedly without understanding the cause is:",
              "options": [
                "Normal practice",
                "Recommended during pressure",
                "Prohibited",
                "A fast solution"
              ],
              "correctAnswer": 2
            }
          ]
        },
        "machine-reporting-documentation": {
          "id": "machine-reporting-documentation",
          "title": " Machine ,Reporting & Documentation",
          "modulenumber": "4.7.7",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770811638/m7_uccccj.mp4",
          "duration": 80,
          "description": "To build strong reporting discipline among Machine Technicians so that production data, maintenance history and quality issues are captured accurately, shared early and used for continuous improvement across Kajja Galleries.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "Why are production logs important?",
              "options": [
                "To support staff discipline",
                "To track machine use, quality and downtime",
                "To control procurement",
                "To replace QC"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "Which information must be recorded in a production log?",
              "options": [
                "Supplier details",
                "Job number and quantity processed",
                "Staff attendance",
                "Client phone numbers"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "When should production logs be updated?",
              "options": [
                "At the end of the month",
                "Only when problems occur",
                "During or immediately after the run",
                "When QC requests"
              ],
              "correctAnswer": 2
            },
            {
              "id": 4,
              "question": "Why must maintenance checklists be updated?",
              "options": [
                "For decoration",
                "For audits and machine history",
                "To increase paperwork",
                "To replace maintenance staff"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "Which activity must be recorded in maintenance checklists?",
              "options": [
                "Staff meetings",
                "Lubrication and inspections",
                "Client approvals",
                "Purchasing decisions"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "When must QC be notified?",
              "options": [
                "Only at the end of the project",
                "When repeated or abnormal defects appear",
                "When production finishes",
                "Only when management asks"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "Why is early QC notification important?",
              "options": [
                "To increase inspections",
                "To prevent large volumes of defective output",
                "To delay production",
                "To reduce documentation"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "What is the main purpose of photo or video evidence?",
              "options": [
                "Marketing",
                "Training only",
                "Clear fault communication and support for diagnosis",
                "Staff evaluation"
              ],
              "correctAnswer": 2
            },
            {
              "id": 9,
              "question": "Which item should be captured in a fault photo?",
              "options": [
                "Finished packaging",
                "Staff attendance sheet",
                "Machine alarm screen",
                "Job card"
              ],
              "correctAnswer": 2
            },
            {
              "id": 10,
              "question": "Transparency mainly means:",
              "options": [
                "Sharing rumours",
                "Reporting mistakes and problems honestly",
                "Reporting only good results",
                "Avoiding responsibility"
              ],
              "correctAnswer": 1
            }
          ]
        },
        "accuracy-quality-control": {
          "id": "accuracy-quality-control",
          "title": "Accuracy & Quality Control",
          "modulenumber": "4.7.2",
          "department": "Production",
          "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770808198/m3_a0bbtl.mp4",
          "duration": 85,
          "description": "To equip Machine Technicians with practical inspection and quality-control discipline that prevents defective parts from reaching assembly, protects brand standards, and eliminates rework at the machine level.",
          "requiredRoles": ["machine-operator", "machine-technician"],
          "validityMinutes": 259200,
          "quiz": [
            {
              "id": 1,
              "question": "Why must panel squareness be checked after cutting?",
              "options": [
                "To improve storage layout",
                "To avoid assembly and fitting problems",
                "To reduce dust",
                "To speed up packing"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "Which method confirms a panel is square?",
              "options": [
                "Visual inspection only",
                "Checking one side only",
                "Measuring diagonals and opposite sides",
                "Weighing the panel"
              ],
              "correctAnswer": 2
            },
            {
              "id": 3,
              "question": "One common cause of out-of-square panels is:",
              "options": [
                "Slow feed rate",
                "Warped boards or misaligned fences",
                "Dust extraction",
                "Wrong packing"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "Proper edge band adhesion is confirmed by:",
              "options": [
                "Fast feed rate",
                "Strong bonding with no lifting at corners",
                "Shiny tape surface",
                "Thick glue lines"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "If edge tape starts lifting during inspection, the technician must:",
              "options": [
                "Continue production",
                "Ask assembly to fix it",
                "Stop and adjust machine settings",
                "Ignore small lifts"
              ],
              "correctAnswer": 2
            },
            {
              "id": 6,
              "question": "Which factor is most important for accurate hinge and runner drilling?",
              "options": [
                "Faster drilling",
                "Correct reference edge and jig/program",
                "Larger drill bit",
                "Stronger vacuum"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "Why is first-piece drilling verification mandatory?",
              "options": [
                "To train helpers",
                "To reduce tool wear",
                "To confirm hole position before batch drilling",
                "To speed up production"
              ],
              "correctAnswer": 2
            },
            {
              "id": 8,
              "question": "Which output must be rejected immediately by the technician?",
              "options": [
                "Cleanly cut panels",
                "Correctly drilled parts",
                "Chipped edges and wrong dimensions",
                "Approved first pieces"
              ],
              "correctAnswer": 2
            },
            {
              "id": 9,
              "question": "Defective parts must be:",
              "options": [
                "Mixed with good parts",
                "Passed to assembly",
                "Isolated and clearly marked",
                "Hidden until QC"
              ],
              "correctAnswer": 2
            },
            {
              "id": 10,
              "question": "Why is 'silent correction' not allowed?",
              "options": [
                "It increases machine wear",
                "It hides root causes and prevents improvement",
                "It delays production",
                "It increases dust"
              ],
              "correctAnswer": 1
            }
          ]
        },
        'workflow-management': {
          id: 'workflow-management',
          title: 'Workflow Management',
          modulenumber: '4.5.1',
          department: 'Production',
          videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770279979/w2_f2l74t.mp4',
          duration: 90,
          description: 'Equip Workshop Manager with practical systems for controlling workflow, production planning, material coordination and delivery reliability in commercial bulk-production environment.',
          requiredRoles: ['workshop-manager', 'production_supervisor'],
          validityMinutes: 259200,
          quiz: [
            {
              id: 1,
              question: "Job card is the official production instruction document containing:",
              options: [
                "Client payment records",
                "Only worker names",
                "Approved drawings, dimensions, materials, accessories, quantities",
                "Supplier contact details"
              ],
              correctAnswer: 2
            },
            {
              id: 2,
              question: "No work should start without:",
              options: [
                "A valid job card",
                "Client approval",
                "Supervisor permission only",
                "Materials ordered"
              ],
              correctAnswer: 0
            },
            {
              id: 3,
              question: "Workshop Manager must break each job into tasks like cutting, edging, assembly and:",
              options: [
                "Only cleaning",
                "Client meetings",
                "Quality control tasks",
                "Sales calls"
              ],
              correctAnswer: 2
            },
            {
              id: 4,
              question: "Daily production plan must answer what is being produced and:",
              options: [
                "Client preferences",
                "Supplier discounts",
                "Office schedules",
                "Who is working which task, which machines used, what materials needed"
              ],
              correctAnswer: 3
            },
            {
              id: 5,
              question: "Daily plans must prioritize delivery-critical projects and:",
              options: [
                "Oldest projects",
                "Easiest projects",
                "Installation-linked projects and bulk orders",
                "Newest projects"
              ],
              correctAnswer: 2
            },
            {
              id: 6,
              question: "Workshop Manager must adjust plan when machines fail or materials delay to:",
              options: [
                "Protect delivery commitments",
                "Stop all work",
                "Wait for instructions",
                "Blame procurement"
              ],
              correctAnswer: 0
            },
            {
              id: 7,
              question: "Structured flow ensures predictable production and:",
              options: [
                "More confusion",
                "Slower work",
                "Higher costs",
                "Better quality control"
              ],
              correctAnswer: 3
            },
            {
              id: 8,
              question: "Preventing backward movement requires dimensional verification:",
              options: [
                "After assembly",
                "Never needed",
                "Before forwarding between workstations",
                "Only at end"
              ],
              correctAnswer: 2
            },
            {
              id: 9,
              question: "A bottleneck is any stage that limits:",
              options: [
                "Worker breaks",
                "Office work",
                "Overall production speed",
                "Client calls"
              ],
              correctAnswer: 2
            },
            {
              id: 10,
              question: "On-time delivery directly affects Kajja's professional image and:",
              options: [
                "Office decor",
                "Worker uniforms",
                "Client trust and repeat business",
                "Tool colors"
              ],
              correctAnswer: 2
            }
          ]
        },
        'machine-operations-oversight': {
          id: 'machine-operations-oversight',
          title: 'Machine Operations Oversight',
          modulenumber: '4.5.2',
          department: 'Production',
          videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770281622/w3_duxr8c.mp4',
          duration: 90,
          description: 'Equip Workshop Manager with control systems for supervising CNC and workshop machinery, maintaining accuracy, preventing defects, minimizing machine downtime in commercial furniture production.',
          requiredRoles: ['workshop-manager','production_supervisor'],
          validityMinutes: 259200,
          quiz: [
            {
              id: 1,
              question: "Workshop Manager ensures CNC operations use correct:",
              options: [
                "Client addresses",
                "Office supplies",
                "Production drawings and settings",
                "Delivery trucks"
              ],
              correctAnswer: 2
            },
            {
              id: 2,
              question: "Before CNC cutting, confirm drawing version and:",
              options: [
                "Material thickness",
                "Client names",
                "Installation dates",
                "Office hours"
              ],
              correctAnswer: 0
            },
            {
              id: 3,
              question: "Test piece production verifies accuracy before:",
              options: [
                "Mass cutting",
                "Training staff",
                "Cleaning machines",
                "Ordering materials"
              ],
              correctAnswer: 0
            },
            {
              id: 4,
              question: "Panel saw supervision prevents irreversible:",
              options: [
                "Time waste",
                "Material waste",
                "Paper waste",
                "Energy waste"
              ],
              correctAnswer: 1
            },
            {
              id: 5,
              question: "Edge banding quality requires clean trimming and:",
              options: [
                "Loose corners",
                "Visible glue",
                "Firm bonding",
                "Burn marks"
              ],
              correctAnswer: 2
            },
            {
              id: 6,
              question: "Edge banding before drilling prevents damage to:",
              options: [
                "Finished parts",
                "Office furniture",
                "Staff uniforms",
                "Delivery vans"
              ],
              correctAnswer: 0
            },
            {
              id: 7,
              question: "Free-hand drilling causes inconsistency and:",
              options: [
                "Faster work",
                "Misalignment",
                "Less noise",
                "Lower cost"
              ],
              correctAnswer: 1
            },
            {
              id: 8,
              question: "Jigs ensure repeatability and:",
              options: [
                "Speed only",
                "Accuracy",
                "Comfort",
                "Quietness"
              ],
              correctAnswer: 1
            },
            {
              id: 9,
              question: "First-piece approval ensures batch correctness before:",
              options: [
                "Staff breaks",
                "Full production",
                "Machine cleaning",
                "Shift end"
              ],
              correctAnswer: 1
            },
            {
              id: 10,
              question: "Workshop Manager controls tools like router bits and:",
              options: [
                "Saw blades",
                "Office chairs",
                "Delivery schedules",
                "Client lists"
              ],
              correctAnswer: 0
            }
          ]
        },
        'workmanship-quality-standards': {
          id: 'workmanship-quality-standards',
          title: 'Workmanship Quality Standards',
          modulenumber: '4.5.3',
          department: 'Production',
          videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770284838/w4_lnjtyb.mp4',
          duration: 90,
          description: 'Equip Workshop Manager with workmanship control standards for accuracy, structural integrity, visual quality and zero-defect handover to Quality Control and installation teams.',
          requiredRoles: ['workshop-manager', 'quality_controller'],
          validityMinutes: 259200,
          quiz: [
            {
              id: 1,
              question: "Panel sizing accuracy prevents misalignment and:",
              options: [
                "Paper waste",
                "Rework and wastage",
                "Staff breaks",
                "Office work"
              ],
              correctAnswer: 1
            },
            {
              id: 2,
              question: "Critical panels tolerance is:",
              options: [
                "±2.0 mm",
                "±1.5 mm",
                "±1.0 mm",
                "±0.5 mm"
              ],
              correctAnswer: 3
            },
            {
              id: 3,
              question: "Before edging and drilling, always do:",
              options: [
                "Packing",
                "First-piece sizing check",
                "Installation plan",
                "Transport book"
              ],
              correctAnswer: 1
            },
            {
              id: 4,
              question: "Acceptable joinery has tight, flush and:",
              options: [
                "Visible gaps",
                "Forced assembly",
                "Aligned joints",
                "Loose fittings"
              ],
              correctAnswer: 2
            },
            {
              id: 5,
              question: "Not approved unless specified:",
              options: [
                "Cam fittings",
                "Dowels and glue",
                "Improvised nails",
                "Confirmat screws"
              ],
              correctAnswer: 2
            },
            {
              id: 6,
              question: "Trial assembly confirms fitting and:",
              options: [
                "Training needs",
                "Labour hours",
                "Alignment",
                "Packaging"
              ],
              correctAnswer: 2
            },
            {
              id: 7,
              question: "Pre-QC inspection prevents basic errors from:",
              options: [
                "Reaching QC",
                "Being fixed",
                "Being recorded",
                "Being seen"
              ],
              correctAnswer: 0
            },
            {
              id: 8,
              question: "Before QC, confirm functional fittings and:",
              options: [
                "Transport booking",
                "Staff attendance",
                "Complete accessories",
                "Client payment"
              ],
              correctAnswer: 2
            },
            {
              id: 9,
              question: "Not ready for packing if glue stains and:",
              options: [
                "Clean surfaces",
                "Untrimmed edges",
                "Cured paint",
                "Wrapping available"
              ],
              correctAnswer: 1
            },
            {
              id: 10,
              question: "Paint must cure fully to prevent surface:",
              options: [
                "Darkening",
                "Damage and sticking",
                "Dust collection",
                "Shrinkage"
              ],
              correctAnswer: 1
            }
          ]
        },
        'cost-waste-control': {
    id: 'cost-waste-control',
    title: 'Cost & Waste Control',
    modulenumber: '4.5.4',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770287201/w5_cojfrj.mp4',
    duration: 90,
    description: 'Equip Workshop Manager with cost-control systems to reduce material waste, protect hardware, improve productivity, expose rework losses, support profitability.',
    requiredRoles: ['workshop-manager','production_supervisor'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Materials are the largest direct:",
        options: [
          "Office expense",
          "Marketing cost",
          "Production cost",
          "Travel expense"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Materials issued strictly against:",
        options: [
          "Worker requests",
          "Approved job cards",
          "Supplier offers",
          "Client calls"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Acceptable waste category is:",
        options: [
          "Wrong drilling",
          "Incorrect machining",
          "Avoidable mistakes",
          "Unavoidable trimming"
        ],
        correctAnswer: 3
      },
      {
        id: 4,
        question: "Waste reduced by optimized nesting and:",
        options: [
          "Faster cutting",
          "Cutting lists",
          "More workers",
          "Ignoring waste"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Hardware includes hinges, slides and:",
        options: [
          "Boards only",
          "Handles and screws",
          "Paint brushes",
          "Delivery vans"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Poor hardware control leads to incomplete jobs and:",
        options: [
          "Less paperwork",
          "Emergency purchases",
          "More overtime",
          "Fewer meetings"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Labour time affects profitability and:",
        options: [
          "Vehicle color",
          "Delivery reliability",
          "Office decor",
          "Staff uniforms"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Control time losses by reducing waiting for:",
        options: [
          "Lunch breaks",
          "Materials and machines",
          "Weekends",
          "Payday"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Rework includes re-cutting panels and:",
        options: [
          "First assembly",
          "Initial packing",
          "Re-drilling components",
          "Planning meetings"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "Record rework to enable improvement and:",
        options: [
          "Discipline workers",
          "Cost visibility",
          "More reports",
          "Client invoices"
        ],
        correctAnswer: 1
      }
    ]
      },
      'people-performance-management': {
        id: 'people-performance-management',
        title: 'People & Performance Management',
        modulenumber: '4.5.5',
        department: 'Production',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770289000/w6_mnf6rd.mp4',
        duration: 90,
        description: 'Equip Workshop Manager with leadership, coaching and people-management skills to improve productivity, discipline, morale and skills growth.',
        requiredRoles: ['workshop-manager','production_supervisor'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Supervision ensures right people perform:",
            options: [
              "Any available tasks",
              "Right tasks to required standard",
              "Only easy work",
              "What they prefer"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Clear expectations include quality and:",
            options: [
              "Social connections",
              "Completion time",
              "Pay amount",
              "Break length"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Develop junior staff by pairing with skilled staff and:",
            options: [
              "Leaving alone",
              "Supervised exposure",
              "Random rotation",
              "Critical tasks immediately"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Coaching happens while work performed at:",
            options: [
              "Annual training",
              "Meetings only",
              "Workstation",
              "After mistakes"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "Repeated mistakes indicate:",
            options: [
              "Laziness only",
              "Skills gap",
              "Disobedience",
              "Poor salary"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Recommend staff based on demonstrated:",
            options: [
              "Friendship",
              "Length of service",
              "Skill and performance",
              "Attendance only"
            ],
            correctAnswer: 2
          },
          {
            id: 7,
            question: "Punctuality protects production planning and:",
            options: [
              "Paperwork",
              "Delivery commitments",
              "Machine maintenance",
              "Overtime"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Enforcement must be consistent and free from:",
            options: [
              "Rules",
              "Favoritism",
              "Judgment",
              "HR involvement"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Prohibited supervisor behavior:",
            options: [
              "Giving instructions",
              "Shouting and humiliation",
              "Recording mistakes",
              "Coaching"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Discipline corrects behavior and protects:",
            options: [
              "Punishment",
              "Staff reduction",
              "Performance",
              "Authority"
            ],
            correctAnswer: 2
          }
        ]
      },
      'safety-workshop-orderliness': {
        id: 'safety-workshop-orderliness',
        title: 'Safety & Workshop Orderliness',
        modulenumber: '4.5.6',
        department: 'Production',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770290411/w7_chxv7f.mp4',
        duration: 90,
        description: 'Equip Workshop Manager with safety leadership and workplace-order systems to prevent injuries, protect equipment, improve productivity, ensure professional workshop environment.',
        requiredRoles: ['workshop-manager','production_supervisor'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Workshop Manager enforces compulsory use of:",
            options: [
              "Casual shoes",
              "Safety boots and eye protection",
              "Personal jewelry",
              "Street clothes"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Stop work if PPE is not:",
            options: [
              "Expensive",
              "Fashionable",
              "Worn",
              "New"
            ],
            correctAnswer: 2
          },
          {
            id: 3,
            question: "First action in accident: stop machine and:",
            options: [
              "Continue work",
              "Isolate power",
              "Clean area",
              "Call client"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Heavy panels require two-person lifting or:",
            options: [
              "One strong worker",
              "Mechanical aids",
              "Helpers only",
              "Any person"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Unsafe with sharp tools: placing hands near:",
            options: [
              "Storage holders",
              "Moving blades",
              "Trained staff",
              "Dull tools"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Major fire risk: wood dust and:",
            options: [
              "Attendance records",
              "Flammable chemicals",
              "Tool cabinets",
              "Packing only"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "Fire extinguishers must be visible and:",
            options: [
              "Locked away",
              "Inspected",
              "Hidden",
              "Used rarely"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Handle chemicals: label containers and:",
            options: [
              "Keep open",
              "Clean spills",
              "Store food nearby",
              "Mix freely"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "5S system improves safety, efficiency and:",
            options: [
              "Decoration",
              "Paperwork",
              "Quality",
              "Supervision"
            ],
            correctAnswer: 2
          },
          {
            id: 10,
            question: "Clean workshop reduces searching time and:",
            options: [
              "Staff numbers",
              "Decoration",
              "Rework",
              "Storage"
            ],
            correctAnswer: 2
          }
        ]
      },
      'foundations-stores-role': {
        id: 'foundations-stores-role',
        title: 'Foundations of the Stores Role',
        modulenumber: '4.6.0',
        department: 'Stores',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770711870/s1_rq9ubx.mp4',
        duration: 90,
        description: 'Equip Store Manager with operational foundation supporting production flow, protecting materials and hardware, strengthening coordination, safeguarding Kajja Galleries reputation.',
        requiredRoles: ['store-manager', 'stores-officer'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Store supports production flow and:",
            options: [
              "Only marketing",
              "Protects resources",
              "Client meetings",
              "Office decor"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Store Manager receives, stores and:",
            options: [
              "Issues materials correctly",
              "Manages production",
              "Supervises installers",
              "Prepares quotations"
            ],
            correctAnswer: 0
          },
          {
            id: 3,
            question: "Poor store control causes emergency purchases and:",
            options: [
              "Faster work",
              "Production delays",
              "Better quality",
              "More profits"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Store supports brand by ensuring timely and:",
            options: [
              "Cheap materials",
              "Correct materials to production",
              "Flexible substitutions",
              "Less paperwork"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Support timeliness by preparing materials before:",
            options: [
              "Weekend",
              "Production starts",
              "Machines stop",
              "Client visits"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Protect quality by isolating damaged or:",
            options: [
              "Any materials",
              "Wrong materials",
              "All boards",
              "Some hardware"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "Communicate shortages early and:",
            options: [
              "Weekly",
              "Immediately",
              "When stopped",
              "Through others"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Issue materials only with approved job card or:",
            options: [
              "Verbal instruction",
              "WhatsApp message",
              "Requisition",
              "Urgent call"
            ],
            correctAnswer: 2
          },
          {
            id: 9,
            question: "Communication must be clear, respectful and:",
            options: [
              "Fast only",
              "Documented",
              "Verbal only",
              "Limited"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Store Manager responsible for safety inside:",
            options: [
              "Office only",
              "Storage areas",
              "Client sites",
              "Vehicles"
            ],
            correctAnswer: 1
          }
        ]
      },
      'administrative-duties-reporting': {
        id: 'administrative-duties-reporting',
        title: 'Administrative Duties & Reporting',
        modulenumber: '4.5.7',
        department: 'Production',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770291435/w8_ugqbls.mp4',
        duration: 90,
        description: 'Equip Workshop Manager with administrative and reporting systems for management visibility, delivery protection, continuous improvement, and professional accountability.',
        requiredRoles: ['workshop-manager' ,'general_manager'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Daily reports provide management visibility and:",
            options: [
              "Client entertainment",
              "Early problem detection",
              "Staff parties",
              "Vehicle cleaning"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Daily report must show job numbers and:",
            options: [
              "Personal details",
              "Planned vs actual output",
              "Client phone numbers",
              "Vehicle schedules"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "KPI dashboard supports decisions and:",
            options: [
              "Staff discipline",
              "Performance improvement",
              "Marketing reports",
              "Paper reduction"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Quality KPI measures reworked items and:",
            options: [
              "Attendance rate",
              "Right-first-time items",
              "Suppliers count",
              "Planned output"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Efficiency KPI compares actual time vs:",
            options: [
              "Helper numbers",
              "Standard time",
              "Monthly revenue",
              "Machine count"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Delay communication must include causes and:",
            options: [
              "Blaming others",
              "Recovery plan",
              "Client direct calls",
              "Ignoring minor"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "Honest communication protects company:",
            options: [
              "Credibility and planning",
              "Manager reputation",
              "Payment schedule",
              "Staff attendance"
            ],
            correctAnswer: 0
          },
          {
            id: 8,
            question: "Workshop and QC relationship should be:",
            options: [
              "Competitive",
              "Independent",
              "Partnership for improvement",
              "Reporting only"
            ],
            correctAnswer: 2
          },
          {
            id: 9,
            question: "QC feedback reviewed weekly for:",
            options: [
              "Complaints only",
              "Corrective actions",
              "Audits only",
              "Year end"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Improvement loop includes implementing and:",
            options: [
              "Writing reports",
              "Identifying problems",
              "Verifying actions",
              "Replacing workers"
            ],
            correctAnswer: 2
          }
        ]
      },
      'store-setup-organization': {
        id: 'store-setup-organization',
        title: 'Store Setup & Organization',
        modulenumber: '4.6.1',
        department: 'Stores',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770714198/s2_avaqub.mp4',
        duration: 90,
        description: 'Equip Store Manager with layout, labeling and organization systems to improve accuracy, protect materials, reduce losses, improve safety and support workshop operations.',
        requiredRoles: ['store-manager', 'stores-officer'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Zoning reduces picking errors and:",
            options: [
              "Increases space",
              "Improves decoration",
              "Improves control",
              "Reduces paper"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "Mandatory zone includes board materials and:",
            options: [
              "Marketing zone",
              "Hardware zone",
              "Client zone",
              "Installation"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Store labels show item name and:",
            options: [
              "Supplier phone",
              "Specification",
              "Staff name",
              "Vehicle number"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "FIFO prevents expiry and:",
            options: [
              "Speeds issuing",
              "Material aging",
              "Reduces docs",
              "Increases stock"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Apply FIFO by placing new stock behind:",
            options: [
              "Older stock",
              "Mixed stock",
              "Anywhere",
              "Hidden"
            ],
            correctAnswer: 0
          },
          {
            id: 6,
            question: "Tools stored in lockable cabinets with:",
            options: [
              "Open access",
              "No records",
              "Log book",
              "Anywhere"
            ],
            correctAnswer: 2
          },
          {
            id: 7,
            question: "Chemicals stored in ventilated areas to reduce:",
            options: [
              "Inventory",
              "Safety risks",
              "Access speed",
              "Appearance"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Heavy items stored at:",
            options: [
              "Top shelves",
              "Lower levels",
              "Overloaded racks",
              "Floor only"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Improve safety using ladders and:",
            options: [
              "Blocking walkways",
              "Climbing shelves",
              "Clear walkways",
              "Random storage"
            ],
            correctAnswer: 2
          },
          {
            id: 10,
            question: "Workshop-store boundaries prevent:",
            options: [
              "More staff",
              "Uncontrolled picking",
              "Less supervision",
              "Communication"
            ],
            correctAnswer: 1
          }
        ]
      },
      "stock-receiving-documentation": {
        "id": "stock-receiving-documentation",
        "title": "Stock Receiving & Documentation",
        "modulenumber": "4.6.2",
        "department": "Stores",
        "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770715881/s3_vrkqug.mp4",
        "duration": 95,
        "description": "To equip the Store Manager with strict receiving, verification and documentation practices that prevent losses, protect quality, and ensure accurate inventory for production planning and financial control.",
        "requiredRoles": ["store-manager", "stores-officer"],
        "validityMinutes": 259200,
        "quiz": [
          {
            "id": 1,
            "question": "What is the main purpose of a GRN?",
            "options": [
              "To approve supplier payments",
              "To record physical receipt and verification of goods",
              "To authorize production",
              "To prepare client invoices"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "When must a GRN be prepared?",
            "options": [
              "Only for imported items",
              "Only for expensive items",
              "For every supplier delivery",
              "Only at month end"
            ],
            "correctAnswer": 2
          },
          {
            "id": 3,
            "question": "Before signing a GRN, the Store Manager must first:",
            "options": [
              "Check prices",
              "Call procurement",
              "Physically verify quantities and condition",
              "File the invoice"
            ],
            "correctAnswer": 2
          },
          {
            "id": 4,
            "question": "The three-way match refers to checking:",
            "options": [
              "Store, workshop and finance",
              "Supplier, store and driver",
              "LPO, invoice and physical receipt",
              "Quotation, LPO and GRN"
            ],
            "correctAnswer": 2
          },
          {
            "id": 5,
            "question": "If delivered quantities exceed the LPO, the Store Manager should:",
            "options": [
              "Accept everything",
              "Issue excess to workshop",
              "Record and seek authorization",
              "Ignore the difference"
            ],
            "correctAnswer": 2
          },
          {
            "id": 6,
            "question": "Which defect must be checked when receiving boards?",
            "options": [
              "Wrong supplier logo",
              "Moisture damage or warping",
              "Packaging colour",
              "Driver uniform"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "When damaged items are discovered, the Store Manager must:",
            "options": [
              "Issue them first",
              "Ignore small defects",
              "Report immediately on the GRN",
              "Return them to shelves"
            ],
            "correctAnswer": 2
          },
          {
            "id": 8,
            "question": "What is the correct action for rejected or damaged items?",
            "options": [
              "Store them with good stock",
              "Use them on less important jobs",
              "Quarantine and label 'NOT FOR USE'",
              "Dispose without records"
            ],
            "correctAnswer": 2
          },
          {
            "id": 9,
            "question": "Which documents must be filed by the store?",
            "options": [
              "Only supplier invoices",
              "Only job cards",
              "LPOs, GRNs and delivery notes",
              "Only stock cards"
            ],
            "correctAnswer": 2
          },
          {
            "id": 10,
            "question": "Traceability means the Store Manager can identify:",
            "options": [
              "Who cut the board",
              "Which driver delivered",
              "Which delivery and GRN an item came from",
              "Which supplier gave best price"
            ],
            "correctAnswer": 2
          }
        ]
      },
      "material-issuing-procedures": {
        "id": "material-issuing-procedures",
        "title": "Material Issuing Procedures",
        "modulenumber": "4.6.3",
        "department": "Stores",
        "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770723175/s4_x983ps.mp4",
        "duration": 90,
        "description": "To equip the Store Manager with strict and traceable issuing procedures that prevent losses, ensure correct materials reach the correct workstations, support production flow, and protect Kajja Galleries' profitability.",
        "requiredRoles": ["store-manager", "stores-officer"],
        "validityMinutes": 259200,
        "quiz": [
          {
            "id": 1,
            "question": "What authorizes withdrawal of stock from the store?",
            "options": [
              "Verbal request",
              "WhatsApp message",
              "Approved job card",
              "Supervisor request only"
            ],
            "correctAnswer": 2
          },
          {
            "id": 2,
            "question": "Which detail must be verified before issuing any item?",
            "options": [
              "Supplier name",
              "Approval on the job card",
              "Driver's name",
              "Invoice amount"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "Why are issuing records mandatory?",
            "options": [
              "To increase paperwork",
              "To control accountability and job costing",
              "To slow down issuing",
              "To reduce procurement"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Which information must always appear in an issuing record?",
            "options": [
              "Supplier contact",
              "Item colour only",
              "Job number and quantity issued",
              "Staff phone number"
            ],
            "correctAnswer": 2
          },
          {
            "id": 5,
            "question": "Panels should be recorded by:",
            "options": [
              "Weight only",
              "Colour only",
              "Size, type and thickness",
              "Supplier name"
            ],
            "correctAnswer": 2
          },
          {
            "id": 6,
            "question": "Why must materials be issued to the correct workstation?",
            "options": [
              "To reduce walking distance",
              "To improve appearance",
              "To avoid damage, confusion and rework",
              "To reduce supervision"
            ],
            "correctAnswer": 2
          },
          {
            "id": 7,
            "question": "What must be done with unused materials after a shift?",
            "options": [
              "Leave them at the workstation",
              "Return and update issuing records",
              "Discard them",
              "Ignore them"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "Returned materials must be checked for:",
            "options": [
              "Colour preference",
              "Packaging brand",
              "Damage and correct condition",
              "Price"
            ],
            "correctAnswer": 2
          },
          {
            "id": 9,
            "question": "Who is responsible for preventing unauthorized access to store stock?",
            "options": [
              "Workshop Manager",
              "Procurement officer",
              "Store Manager",
              "Installation supervisor"
            ],
            "correctAnswer": 2
          },
          {
            "id": 10,
            "question": "If urgent work is requested without a job card, the Store Manager should:",
            "options": [
              "Issue immediately",
              "Refuse and ignore",
              "Escalate and obtain formal approval",
              "Issue and record later"
            ],
            "correctAnswer": 2
          }
        ]
      },
      "inventory-management": {
        "id": "inventory-management",
        "title": "Inventory Management",
        "modulenumber": "4.6.4",
        "department": "Stores",
        "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770724494/s5_latvqp.mp4",
        "duration": 95,
        "description": "To equip the Store Manager with practical inventory control systems that maintain accurate stock records, prevent shortages, expose losses, control board wastage and support reliable production planning.",
        "requiredRoles": ["store-manager", "stores-officer"],
        "validityMinutes": 259200,
        "quiz": [
          {
            "id": 1,
            "question": "The main purpose of stock cards is to:",
            "options": [
              "Track supplier prices",
              "Record attendance",
              "Maintain accurate inventory records",
              "Control machine usage"
            ],
            "correctAnswer": 2
          },
          {
            "id": 2,
            "question": "When must stock cards be updated?",
            "options": [
              "At the end of the month",
              "When convenient",
              "Immediately after every receipt and issue",
              "Only during audits"
            ],
            "correctAnswer": 2
          },
          {
            "id": 3,
            "question": "Reorder levels mainly exist to:",
            "options": [
              "Increase stock value",
              "Prevent shortages and production stoppages",
              "Reduce supplier numbers",
              "Improve storage layout"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Who should the Store Manager work with to set reorder levels?",
            "options": [
              "Installation supervisor only",
              "Marketing team",
              "Procurement and Workshop Manager",
              "Drivers"
            ],
            "correctAnswer": 2
          },
          {
            "id": 5,
            "question": "When should a reorder alert be raised?",
            "options": [
              "After stock is finished",
              "When stock reaches the minimum level",
              "At the end of the week",
              "Only during audits"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "Which items must be included in weekly stock counts?",
            "options": [
              "All items only once per year",
              "Fast-moving and high-value items",
              "Office supplies only",
              "Finished products only"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "A monthly full stock audit mainly involves:",
            "options": [
              "Checking only hardware",
              "Physical counting of all store items",
              "Updating prices",
              "Changing suppliers"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "When a difference is found between physical count and records, the Store Manager must:",
            "options": [
              "Adjust the records silently",
              "Ignore small differences",
              "Investigate, explain and document",
              "Report only to workshop staff"
            ],
            "correctAnswer": 2
          },
          {
            "id": 9,
            "question": "Which is an example of lost or damaged stock?",
            "options": [
              "Issued boards",
              "Returned good hardware",
              "Expired glue",
              "Newly received materials"
            ],
            "correctAnswer": 2
          },
          {
            "id": 10,
            "question": "The Store Manager should collaborate with the Workshop Manager mainly to:",
            "options": [
              "Approve job cards",
              "Classify and record board wastage",
              "Supervise artisans",
              "Prepare quotations"
            ],
            "correctAnswer": 1
          }
        ]
      },
      "health-store": {
        "id": "health-store",
        "title": "Health, Safety & Cleanliness",
        "modulenumber": "4.6.7",
        "department": "Stores",
        "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770801855/s8_kcuddd.mp4",
        "duration": 85,
        "description": "To equip the Store Manager with practical safety and housekeeping controls that prevent injuries, protect materials and equipment, comply with workshop safety standards, and present a professional brand image.",
        "requiredRoles": ["store-manager", "stores-officer"],
        "validityMinutes": 259200,
        "quiz": [
          {
            "id": 1,
            "question": "Trip hazards in stores mainly come from:",
            "options": [
              "Fire extinguishers",
              "Loose off-cuts and items left on walkways",
              "Labels and signs",
              "Racks and shelves"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "The Store Manager must remove trip hazards:",
            "options": [
              "Weekly",
              "Only when accidents occur",
              "Immediately when noticed",
              "Only during audits"
            ],
            "correctAnswer": 2
          },
          {
            "id": 3,
            "question": "Which item increases fire risk in the store?",
            "options": [
              "Stock cards",
              "Wood dust and chemicals",
              "Labels",
              "Pallets only"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Fire extinguishers must always be:",
            "options": [
              "Locked in the office",
              "Placed near chemicals only",
              "Visible and accessible",
              "Hidden behind shelves"
            ],
            "correctAnswer": 2
          },
          {
            "id": 5,
            "question": "Chemicals must be stored:",
            "options": [
              "Anywhere convenient",
              "With food items",
              "In a clearly marked chemical zone",
              "Inside tool cabinets"
            ],
            "correctAnswer": 2
          },
          {
            "id": 6,
            "question": "When lifting heavy boards, which PPE is mandatory?",
            "options": [
              "Face shield only",
              "Safety boots",
              "Ear protection",
              "Helmet only"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "Large panels should normally be lifted by:",
            "options": [
              "One strong worker",
              "Any available person",
              "Two people or mechanical aids",
              "Helpers only"
            ],
            "correctAnswer": 2
          },
          {
            "id": 8,
            "question": "Clear walkways are important mainly because they:",
            "options": [
              "Improve decoration",
              "Support emergency access and safe movement",
              "Reduce storage space",
              "Improve stock valuation"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "A clean store mainly supports which of the following?",
            "options": [
              "Marketing",
              "Safety and accuracy",
              "Purchasing power",
              "Staff leave planning"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "Who is responsible for cleanliness inside the store?",
            "options": [
              "The cleaner only",
              "The workshop staff",
              "The Store Manager",
              "The drivers"
            ],
            "correctAnswer": 2
          }
        ]
      },
      "tools-equipment-control": {
        "id": "tools-equipment-control",
        "title": "Tools & Equipment Control",
        "modulenumber": "4.6.5",
        "department": "Stores",
        "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770725716/s6_hlwdzo.mp4",
        "duration": 90,
        "description": "To equip the Store Manager with practical systems for controlling tools and equipment, preventing losses and misuse, coordinating maintenance, and protecting company assets in a high-value production environment.",
        "requiredRoles": ["store-manager", "stores-officer"],
        "validityMinutes": 259200,
        "quiz": [
          {
            "id": 1,
            "question": "Why is tool tracking important in the store?",
            "options": [
              "To increase paperwork",
              "To control staff movement",
              "To prevent losses and ensure accountability",
              "To support marketing"
            ],
            "correctAnswer": 2
          },
          {
            "id": 2,
            "question": "Which information must appear in a tool issue record?",
            "options": [
              "Supplier name",
              "Tool name, user and time of issue",
              "Purchase price only",
              "Delivery date"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "When a tool is returned, the Store Manager must first:",
            "options": [
              "Put it on the shelf",
              "Check its physical condition",
              "Call procurement",
              "Record it later"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Who coordinates maintenance and repair of store-controlled tools?",
            "options": [
              "Workshop helpers",
              "Procurement",
              "Store Manager",
              "Finance"
            ],
            "correctAnswer": 2
          },
          {
            "id": 5,
            "question": "Which is the correct action when a tool is reported faulty?",
            "options": [
              "Re-issue it to another worker",
              "Keep it on the normal shelf",
              "Label it 'OUT OF SERVICE' and isolate it",
              "Ignore if still working"
            ],
            "correctAnswer": 2
          },
          {
            "id": 6,
            "question": "Which tools must receive the highest control priority?",
            "options": [
              "Old manual tools",
              "Low-value items",
              "Expensive and portable power tools",
              "Packaging tools"
            ],
            "correctAnswer": 2
          },
          {
            "id": 7,
            "question": "Charging batteries should only be done:",
            "options": [
              "Anywhere near workstations",
              "In offices",
              "In designated, ventilated charging areas",
              "In the main store aisle"
            ],
            "correctAnswer": 2
          },
          {
            "id": 8,
            "question": "Which battery must never be charged?",
            "options": [
              "Fully charged battery",
              "Old battery",
              "Swollen or damaged battery",
              "Cold battery"
            ],
            "correctAnswer": 2
          },
          {
            "id": 9,
            "question": "What does 'protect company property as if it's yours' mainly mean?",
            "options": [
              "Taking tools home",
              "Ignoring small damage",
              "Acting responsibly and stopping misuse",
              "Delegating responsibility"
            ],
            "correctAnswer": 2
          },
          {
            "id": 10,
            "question": "The Store Manager's personal example mainly influences:",
            "options": [
              "Procurement prices",
              "Client satisfaction",
              "Staff attitude towards tools and company assets",
              "Installation schedules"
            ],
            "correctAnswer": 2
          }
        ]
      },
      "communication-coordination": {
        "id": "communication-coordination",
        "title": "Communication & Department Coordination",
        "modulenumber": "4.6.6",
        "department": "Stores",
        "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770800689/s7_p3neh9.mp4",
        "duration": 85,
        "description": "To equip the Store Manager with professional communication and coordination skills that ensure timely purchasing, early shortage alerts, accurate production support, respectful issue resolution and strong participation in operations management.",
        "requiredRoles": ["store-manager", "stores-officer"],
        "validityMinutes": 259200,
        "quiz": [
          {
            "id": 1,
            "question": "Why must the Store Manager work closely with Procurement?",
            "options": [
              "To negotiate supplier prices",
              "To approve purchases",
              "To provide accurate stock and consumption information",
              "To supervise suppliers"
            ],
            "correctAnswer": 2
          },
          {
            "id": 2,
            "question": "Which is a correct responsibility when coordinating with procurement?",
            "options": [
              "Selecting suppliers",
              "Sharing stock balances and delivery risks",
              "Approving invoices",
              "Negotiating lead times"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "Shortage prediction mainly depends on:",
            "options": [
              "Supplier reports",
              "Memory",
              "Daily stock review and reorder levels",
              "Workshop requests only"
            ],
            "correctAnswer": 2
          },
          {
            "id": 4,
            "question": "Which item must be reported early as a potential shortage?",
            "options": [
              "Any item not used in production",
              "Items approaching minimum stock level",
              "Items already fully delivered",
              "Office stationery"
            ],
            "correctAnswer": 1
          },
          {
            "id": 5,
            "question": "Late shortage reporting mainly causes:",
            "options": [
              "Improved coordination",
              "Production stoppages and emergency buying",
              "Faster installations",
              "Reduced documentation"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "Which information must be provided to the Head of Production?",
            "options": [
              "Supplier bank details",
              "Accurate available quantities and expected deliveries",
              "Purchase prices",
              "Invoice numbers only"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "Which behaviour is NOT acceptable when supporting production planning?",
            "options": [
              "Verifying balances before sharing",
              "Checking stock cards",
              "Guessing quantities",
              "Confirming expected delivery dates"
            ],
            "correctAnswer": 2
          },
          {
            "id": 8,
            "question": "A stock discrepancy should first be addressed by:",
            "options": [
              "Blaming the last user",
              "Adjusting records immediately",
              "Confirming the physical count and records",
              "Reporting directly to the client"
            ],
            "correctAnswer": 2
          },
          {
            "id": 9,
            "question": "Which is the correct way to handle a discrepancy with workshop staff?",
            "options": [
              "Public confrontation",
              "Informal discussion without records",
              "Respectful and factual discussion",
              "Ignoring the issue"
            ],
            "correctAnswer": 2
          },
          {
            "id": 10,
            "question": "In weekly operations meetings, the Store Manager must mainly present:",
            "options": [
              "Staff attendance",
              "Marketing plans",
              "Stock status, shortages and risks",
              "Supplier contracts"
            ],
            "correctAnswer": 2
          }
        ]
      },
    
      'operations-excellence-introduction': {
        id: 'operations-excellence-introduction',
        title: 'Introduction to Operations Excellence',
        modulenumber: '1.5.1',
        department: 'Operations Department',
        videoUrl: '/videos/opsexcellence.mp4',
        duration: 75,
        description: 'Foundational principles of operations management, coordination between departments, professional communication, and upholding Kajja values in production execution',
        requiredRoles: ['manager', 'ceo','quality-control'],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            "id": 1,
            "question": "The main job of Operations is to:",
            "options": [
              "Work like a carpenter",
              "Ensure work is done efficiently, on time, with quality",
              "Replace the GM",
              "Handle only installation"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "Communication in operations must be:",
            "options": [
              "Verbal only",
              "Documented, clear, timely",
              "Aggressive to show authority",
              "Only when problems explode"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "Coordination between departments is needed because:",
            "options": [
              "Work happens in stages and depends on others",
              "Everyone should guess what's next",
              "Departments must compete",
              "Errors don't affect anyone"
            ],
            "correctAnswer": 0
          },
          {
            "id": 4,
            "question": "Which of these supports Kajja's mission?",
            "options": [
              "Reworks and delays",
              "Quality execution, low waste, client trust",
              "Hiding mistakes from management",
              "Late reporting"
            ],
            "correctAnswer": 1
          },
          {
            "id": 5,
            "question": "When should the Operations Manager report issues?",
            "options": [
              "When client calls angry",
              "Immediately when a risk is seen",
              "Next month during reviews",
              "Never"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "What is the Operations Manager described as?",
            "options": [
              "The bridge between Sales, Design, Production, Distribution and Installation",
              "The company CEO",
              "Only a workshop supervisor",
              "The marketing director"
            ],
            "correctAnswer": 0
          },
          {
            "id": 7,
            "question": "Which value from Kajja's mission is directly linked to 'keeping promises and delivering what was approved'?",
            "options": [
              "Quality",
              "Creativity",
              "Efficiency",
              "Trust"
            ],
            "correctAnswer": 3
          },
          {
            "id": 8,
            "question": "What happens if Operations management fails?",
            "options": [
              "Nothing significant",
              "Delays, reworks, losses, and angry clients",
              "More creative freedom",
              "Lower costs"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "What is a key cultural expectation in Operations?",
            "options": [
              "Flexible deadlines",
              "No excuses — facts + solutions",
              "Avoiding documentation",
              "Working in isolation"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "What must the Operations Manager ensure during the Design → Workshop stage?",
            "options": [
              "Double-check drawings and approvals",
              "Immediately start production",
              "Change designs without consulting",
              "Reduce material costs by 50%"
            ],
            "correctAnswer": 0
          }
        ]
      },
        'production-workflow-mastery': {
          id: 'production-workflow-mastery',
          title: 'Production Workflow Mastery',
          modulenumber: '1.5.2',
          department: 'Operations Department',
          videoUrl: '/videos/workflow.mp4',
          duration: 90,
          description: 'End-to-end production systems, job card management, scheduling techniques, workstation optimization, material coordination, and subcontractor oversight',
          requiredRoles: ['manager', 'ceo','quality-control'],
          validityMinutes: 259200, // 6 months in minutes
          quiz: [
            {
              "id": 1,
              "question": "Why must a job card always be used?",
              "options": [
                "For decoration",
                "To track work, ensure accountability, and ensure correct execution",
                "To confuse carpenters",
                "Only for big jobs"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "Which workstation determines the overall production speed?",
              "options": [
                "Storage department",
                "The slowest workstation (the bottleneck)",
                "Reception area",
                "MD's office"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "What is the main purpose of production scheduling?",
              "options": [
                "To waste time planning",
                "To ensure materials, machines, and people are ready and efficient",
                "To show power",
                "To delay decisions"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "When should material shortages be addressed?",
              "options": [
                "After clients complain",
                "Immediately and ideally prevented with planning",
                "Only if GM asks",
                "At the end of the month"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "When is outsourcing successful?",
              "options": [
                "When subcontractors decide quality standards",
                "When work is controlled and inspected based on Kajja standards",
                "No documentation needed",
                "When deadlines are flexible"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "What is the first step in the Kajja furniture production workflow?",
              "options": [
                "Cutting & Machining",
                "Sales Brief",
                "Client Sign-Off",
                "Material Confirmation"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "What should a job card include?",
              "options": [
                "Only the project name",
                "Approved final design drawing, task breakdown, material requisition, and QC checkpoints",
                "Only the client's phone number",
                "The Ops Manager's personal notes"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "What is the main benefit of clustering similar projects in scheduling?",
              "options": [
                "To confuse workers",
                "To reduce machine switching time and increase efficiency",
                "To make the schedule look full",
                "To increase material waste"
              ],
              "correctAnswer": 1
            },
            {
              "id": 9,
              "question": "What should happen when subcontractors are used?",
              "options": [
                "Give them complete freedom to decide standards",
                "Provide clear drawings, set deadlines, and inspect work before accepting delivery",
                "Pay them immediately without inspection",
                "Let them communicate directly with clients"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "What is the principle about material shortages?",
              "options": [
                "Operations must start jobs even if materials might run out",
                "Operations must never start a job that cannot finish",
                "Material shortages are the store manager's problem only",
                "Shortages can be fixed after production starts"
              ],
              "correctAnswer": 1
            }
          ]
        },
      
  
    'performance-management': {
      id: 'performance-management',
      title: 'Performance Management',
      modulenumber: '1.4.4',
      department: 'Human Resources',
      videoUrl: '/videos/perfomance.mp4',
      duration: 90,
      description: 'KPI frameworks, performance review systems, coaching methods, performance improvement plans, and recognition strategies',
      requiredRoles: ['hr-admin', 'ceo', 'manager', 'office-staff'],
      validityMinutes: 259200, // 6 months in minutes
      quiz: [
        {
          "id": 1,
          "question": "KPIs are important because they:",
          "options": [
            "Confuse employees",
            "Provide clear performance expectations and tracking",
            "Replace supervision",
            "Are optional"
          ],
          "correctAnswer": 1
        },
        {
          "id": 2,
          "question": "Performance reviews should be done:",
          "options": [
            "Once a year only",
            "Weekly and monthly for continuous improvement",
            "Only when there is a problem",
            "Only for senior staff"
          ],
          "correctAnswer": 1
        },
        {
          "id": 3,
          "question": "What is the purpose of a PIP?",
          "options": [
            "To threaten employees",
            "To support improvement with structure and monitoring",
            "To reduce workload of HR",
            "To punish good staff"
          ],
          "correctAnswer": 1
        },
        {
          "id": 4,
          "question": "Coaching works best when:",
          "options": [
            "Teaching and follow-up are provided",
            "Only warnings are given",
            "HR ignores staff challenges",
            "Employees solve problems alone"
          ],
          "correctAnswer": 0
        },
        {
          "id": 5,
          "question": "Rewards should be:",
          "options": [
            "Random",
            "Given only to HR team",
            "Based on performance and behavior aligned to values",
            "Hidden from staff"
          ],
          "correctAnswer": 2
        },
        {
          "id": 6,
          "question": "What does SMART stand for in KPI setting?",
          "options": [
            "Simple, Meaningful, Achievable, Relevant, Timely",
            "Specific, Measurable, Achievable, Relevant, Time-bound",
            "Strategic, Manageable, Accountable, Realistic, Trackable",
            "Standard, Measured, Approved, Reviewed, Tested"
          ],
          "correctAnswer": 1
        },
        {
          "id": 7,
          "question": "Who should be involved in enforcing a Performance Improvement Plan (PIP)?",
          "options": [
            "HR alone",
            "HR, supervisor, and GM together",
            "Only the employee",
            "Only the CEO"
          ],
          "correctAnswer": 1
        },
        {
          "id": 8,
          "question": "What is the foundation of performance management at Kajja?",
          "options": [
            "Fear and punishment",
            "Clarity, accountability, development, and fair recognition",
            "Only financial incentives",
            "Random evaluations"
          ],
          "correctAnswer": 1
        },
        {
          "id": 9,
          "question": "What should HR store in employee files monthly?",
          "options": [
            "Only salary information",
            "Monthly performance scorecards",
            "Personal contact details only",
            "Social media profiles"
          ],
          "correctAnswer": 1
        },
        {
          "id": 10,
          "question": "Why do people often leave companies according to the module?",
          "options": [
            "Because of high salaries elsewhere",
            "Because of bad managers or lack of appreciation",
            "Because of too many rewards",
            "Because of strict performance standards"
          ],
          "correctAnswer": 1
        }
      ]
    },
    
      'health-safety-wellbeing': {
        id: 'health-safety-wellbeing',
        title: 'Health, Safety & Employee Well-Being',
        modulenumber: '1.4.7',
        department: 'Human Resources',
        videoUrl: '/videos/health.mp4',
        duration: 90,
        description: 'Workplace safety protocols, PPE enforcement, mental health support, harassment prevention, and dignified exit management',
        requiredRoles: ['hr-admin', 'ceo', 'manager','office-staff', 'production-staff'],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            "id": 1,
            "question": "PPE rules exist to:",
            "options": [
              "Improve appearance",
              "Protect employees from injuries",
              "Slow down work",
              "Annoy staff"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "Harassment and discrimination must be:",
            "options": [
              "Ignored",
              "Resolved quietly by employees",
              "Investigated immediately and fairly by HR",
              "Treated as jokes"
            ],
            "correctAnswer": 2
          },
          {
            "id": 3,
            "question": "First Aid escalation requires:",
            "options": [
              "Relying on the injured person to decide",
              "Clinic/hospital visit for serious injuries + incident report",
              "Keeping it a secret",
              "Waiting until payroll day"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Exit interviews help HR:",
            "options": [
              "Punish employees who leave",
              "Reduce future issues and learn from feedback",
              "Show power",
              "Create rumors"
            ],
            "correctAnswer": 1
          },
          {
            "id": 5,
            "question": "Workplace respect is important because:",
            "options": [
              "It makes HR comfortable",
              "It builds mental well-being and performance",
              "It helps the company hide issues",
              "Law doesn't care"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "What is HR's responsibility regarding safety orientation?",
            "options": [
              "Only for new managers",
              "Conduct safety orientation on Day 1 for all employees",
              "Let supervisors handle it when convenient",
              "Only when accidents happen"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "What does zero-tolerance policy apply to?",
            "options": [
              "Tardiness only",
              "Sexual harassment and discrimination",
              "All workplace mistakes",
              "Only production errors"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "What should HR watch for as signs of burnout?",
            "options": [
              "Increased productivity",
              "Sudden absences, performance drop, emotional changes",
              "Employees working overtime",
              "Team social events"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "What is the consequence for PPE breaches?",
            "options": [
              "Immediate promotion",
              "Discipline (verbal → written → removal from site)",
              "Extra pay",
              "No consequence"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "Why are exit interviews conducted?",
            "options": [
              "To delay final payments",
              "To understand why they're leaving and identify improvements",
              "To embarrass the employee",
              "To increase paperwork"
            ],
            "correctAnswer": 1
          }
        ]
      },
        'training-team-development': {
          id: 'training-team-development',
          title: 'Training & Team Development',
          modulenumber: '1..5',
          department: 'Human Resources',
          videoUrl: '/videos/trainingteam.mp4',
          duration: 85,
          description: 'Skills gap analysis, structured training planning, apprenticeship programs, certification support, and learning culture development',
          requiredRoles: ['hr-admin', 'ceo', 'manager','production-staff', 'office-staff'],
          validityMinutes: 259200, // 6 months in minutes
          quiz: [
            {
              "id": 1,
              "question": "Skills gap analysis helps HR:",
              "options": [
                "Guess what training is needed",
                "Identify real performance weaknesses to fix",
                "Create unnecessary work",
                "Punish employees"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "Training plans must be:",
              "options": [
                "Random",
                "Organized, measurable, and aligned to company goals",
                "Only for managers",
                "Done when employees complain"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "Apprentices grow best when:",
              "options": [
                "Left alone without guidance",
                "Coached and reviewed consistently",
                "Given all complex tasks immediately",
                "Ignored until they improve"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "Certification programs help:",
              "options": [
                "Create confusion",
                "Increase staff skills and company professionalism",
                "Reduce performance",
                "Waste HR budget"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "Positive learning culture means:",
              "options": [
                "Mocking mistakes",
                "Encouraging growth, celebrating effort and improvement",
                "No training needed",
                "Only leaders learn"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "What is training considered at Kajja Galleries?",
              "options": [
                "An unnecessary cost",
                "An investment in quality, innovation, and retention",
                "Only for new hires",
                "A punishment for poor performance"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "What should be the output of a skills gap analysis?",
              "options": [
                "A list of employee salaries",
                "A list of specific skill gaps impacting quality, safety, and efficiency",
                "A list of employee personal issues",
                "A list of company profits"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "What is the recommended approach for training apprentices?",
              "options": [
                "Show → Practice → Correct → Approve",
                "Leave them to figure it out",
                "Give them complex tasks immediately",
                "Only allow observation"
              ],
              "correctAnswer": 0
            },
            {
              "id": 9,
              "question": "What is Kajja's motto for growth?",
              "options": [
                "We never change",
                "We improve every month — no one stays the same",
                "Training is optional",
                "Only managers need to grow"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "What type of training should HR include?",
              "options": [
                "Only internal trainers",
                "Combine internal and external trainers with cross-functional learning",
                "Only external expensive courses",
                "Only when requested by CEO"
              ],
              "correctAnswer": 1
            }
          ]
        },
      
    
      'payroll-records-administration': {
        id: 'payroll-records-administration',
        title: 'Payroll, Records & Administration',
        modulenumber: '1.4.6',
        department: 'Human Resources',
        videoUrl: '/videos/payroll.mp4',
        duration: 85,
        description: 'Payroll accuracy, NSSF/PAYE compliance, staff loans management, secure record keeping, and HR documentation standards',
        requiredRoles: ['hr-admin', 'ceo', 'manager','office-staff'],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            "id": 1,
            "question": "Payroll must be:",
            "options": [
              "Estimated monthly",
              "Accurate, on time, and well-documented",
              "Paid only if company feels like",
              "Done once a year"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "Overtime is valid only when:",
            "options": [
              "Employee works longer secretly",
              "Approved in writing before work begins",
              "HR feels generous",
              "Supervisor says verbally"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "NSSF contributions:",
            "options": [
              "Employer 5%, Employee 10%",
              "Employer 10%, Employee 5%",
              "Optional",
              "Paid yearly"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "Why must HR keep secure employee files?",
            "options": [
              "To protect confidential information and legal compliance",
              "Because HR likes filing",
              "So employees fear HR",
              "For decoration"
            ],
            "correctAnswer": 0
          },
          {
            "id": 5,
            "question": "Documentation standards require:",
            "options": [
              "All approvals must be verbal",
              "No signatures needed",
              "Written approvals with proper filing and signatures",
              "HR to destroy forms monthly"
            ],
            "correctAnswer": 2
          },
          {
            "id": 6,
            "question": "What protects the company from payroll fraud and legal penalties?",
            "options": [
              "HR's personal memory",
              "Payroll accuracy, legal compliance, and proper documentation",
              "Avoiding written records",
              "Paying employees late"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "What is the maximum salary advance allowed per month?",
            "options": [
              "50% of monthly gross pay",
              "30% of monthly net pay",
              "100% of monthly salary",
              "No limit"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "Who must approve overtime at Kajja?",
            "options": [
              "The employee themselves",
              "GM in writing before work begins",
              "Any supervisor verbally",
              "HR after work is completed"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "What is the consequence for unauthorized absence?",
            "options": [
              "Extra pay",
              "Salary deduction and warning",
              "Promotion",
              "No consequence"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "What is HR's role regarding payroll data?",
            "options": [
              "Share with all departments",
              "Custodian of truth in employee financial matters",
              "Keep no records",
              "Decide salaries randomly"
            ],
            "correctAnswer": 1
          }
        ]
      },
    
      'workplace-discipline-compliance': {
        id: 'workplace-discipline-compliance',
        title: 'Workplace Discipline & Compliance',
        modulenumber: '1.4.5',
        department: 'Human Resources',
        videoUrl: '/videos/compliance.mp4',
        duration: 95,
        description: 'Discipline policies, attendance management, misconduct handling, conflict resolution, and Uganda labor law compliance',
        requiredRoles: ['hr-admin', 'ceo', 'manager','office-staff'],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            "id": 1,
            "question": "Why must warnings be documented?",
            "options": [
              "To scare staff",
              "To control their personal life",
              "To ensure fairness and evidence of process",
              "To waste paper"
            ],
            "correctAnswer": 2
          },
          {
            "id": 2,
            "question": "Fighting or theft is:",
            "options": [
              "Verbal warning",
              "Normal behavior",
              "Serious misconduct — can trigger final action",
              "Not HR's issue"
            ],
            "correctAnswer": 2
          },
          {
            "id": 3,
            "question": "Conflict resolution must always be:",
            "options": [
              "Public",
              "Aggressive",
              "Private, neutral, documented",
              "Ignored"
            ],
            "correctAnswer": 2
          },
          {
            "id": 4,
            "question": "Attendance discipline is key because:",
            "options": [
              "It pleases HR",
              "Time impacts productivity and deadlines",
              "Staff must suffer",
              "Clients don't care about time"
            ],
            "correctAnswer": 1
          },
          {
            "id": 5,
            "question": "Termination must:",
            "options": [
              "Follow Uganda labor laws and fair process",
              "Be instant when HR is angry",
              "Be decided by one angry colleague",
              "Not require documentation"
            ],
            "correctAnswer": 0
          },
          {
            "id": 6,
            "question": "What is the purpose of discipline at Kajja?",
            "options": [
              "Punishment only",
              "Behavior correction and culture protection",
              "To make HR feel powerful",
              "To reduce employee benefits"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "What should HR investigate before taking disciplinary action?",
            "options": [
              "Based on personal feelings",
              "Based on facts and evidence (photos, witnesses, SOPs)",
              "Based on rumors from other employees",
              "Based on the employee's past mistakes only"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "What is the consequence for being late 3 times according to Kajja's policy?",
            "options": [
              "Promotion",
              "One written warning",
              "No consequence",
              "Immediate termination"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "How should counseling be conducted with employees?",
            "options": [
              "In front of other staff to set an example",
              "Privately, focusing on behavior not personality",
              "Through email only",
              "During team meetings"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "What is the NSSF contribution breakdown in Uganda?",
            "options": [
              "Employer 5%, Employee 10%",
              "Employer 10%, Employee 5%",
              "Optional contributions",
              "Employer 15%, Employee 0%"
            ],
            "correctAnswer": 1
          }
        ]
      },
      'material-knowledge-technical-skills': {
        id: 'material-knowledge-technical-skills',
        title: 'Material Knowledge & Technical Skills',
        modulenumber: '4.3.5',
        department: 'Design',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770023613/d6_obz03b.mp4',
        duration: 90,
        description: 'Select correct board materials, choose suitable hardware, specify finishes for performance, design for strength and load capacity, apply ergonomic principles in commercial environments.',
        requiredRoles: ['head_of_design', 'designer', 'head_of_production'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Material choice at Kajja is a:",
            options: [
              "Procurement decision",
              "Client decision",
              "Production decision",
              "Design decision"
            ],
            correctAnswer: 3
          },
          {
            id: 2,
            question: "MDF is best for:",
            options: [
              "Wet environments",
              "Painted or wrapped surfaces",
              "Structural frames",
              "High load shelves"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Plywood is preferred when:",
            options: [
              "Cost must be lowest",
              "Surface finish only matters",
              "Only painting required",
              "Strength and screw holding needed"
            ],
            correctAnswer: 3
          },
          {
            id: 4,
            question: "HDF is commonly used for:",
            options: [
              "Main structural carcasses",
              "Thick countertops",
              "Door frames",
              "Drawer bottoms and backs"
            ],
            correctAnswer: 3
          },
          {
            id: 5,
            question: "Laminates are:",
            options: [
              "Structural boards",
              "Hardware types",
              "Paint categories",
              "Decorative surface finishes"
            ],
            correctAnswer: 3
          },
          {
            id: 6,
            question: "Hardware selection must consider:",
            options: [
              "Load and frequency of use",
              "Colour only",
              "Price only",
              "Trends only"
            ],
            correctAnswer: 0
          },
          {
            id: 7,
            question: "Full extension slides allow:",
            options: [
              "Cheaper costs",
              "Modern appearance",
              "Full drawer access",
              "Reduced depth"
            ],
            correctAnswer: 2
          },
          {
            id: 8,
            question: "Cheap hardware causes:",
            options: [
              "Early failures and complaints",
              "Better appearance",
              "Higher strength",
              "Faster installation"
            ],
            correctAnswer: 0
          },
          {
            id: 9,
            question: "Ergonomic design focuses on:",
            options: [
              "Decoration",
              "Manufacturing ease",
              "Cost reduction",
              "Human comfort and usability"
            ],
            correctAnswer: 3
          },
          {
            id: 10,
            question: "Good materials make good furniture. Correct materials make:",
            options: [
              "Beautiful furniture",
              "Heavy furniture",
              "Cheap furniture",
              "Durable furniture"
            ],
            correctAnswer: 3
          }
        ]
      },
      'quality-continuous-improvement': {
        id: 'quality-continuous-improvement',
        title: 'Quality & Continuous Improvement',
        modulenumber: '4.3.6',
        department: 'Design',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770024706/d7_fvcdlc.mp4',
        duration: 90,
        description: 'Run structured design review meetings using QC feedback, eliminate repeat design defects, enforce full design accountability, track design mistakes and solutions, drive learning through research.',
        requiredRoles: ['head_of_design', 'designer', 'quality_controller'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Every design must make:",
            options: [
              "The client happy",
              "The next one better",
              "Production faster",
              "Costs lower"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Great design leaders prevent problems from:",
            options: [
              "Being discussed",
              "Returning",
              "Being documented",
              "Being solved"
            ],
            correctAnswer: 3
          },
          {
            id: 3,
            question: "Design review meetings must include:",
            options: [
              "Only designers",
              "Sales team only",
              "QC and production representatives",
              "Clients always"
            ],
            correctAnswer: 2
          },
          {
            id: 4,
            question: "QC feedback is design:",
            options: [
              "Criticism to avoid",
              "Improvement data to use",
              "Production's problem",
              "Sales information"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Typical design errors include:",
            options: [
              "Perfect drawings",
              "Missing dimensions and unclear details",
              "Too many colors",
              "Good communication"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Zero missing information means design package must have:",
            options: [
              "Fewer drawings",
              "All views, dimensions, materials, hardware",
              "Only renderings",
              "Client photos"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "Design accountability means owning:",
            options: [
              "Only beautiful renders",
              "Drawing accuracy and completeness",
              "Sales targets",
              "Installation problems"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Tracking design mistakes helps to:",
            options: [
              "Hide errors",
              "Prevent repetition",
              "Increase blame",
              "Slow work"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Design improvement log records errors, causes and:",
            options: [
              "Salaries",
              "Solutions",
              "Client names",
              "Meeting times"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Design quality is measured by problems reaching:",
            options: [
              "Production and site",
              "Client approval",
              "Marketing",
              "Budget meetings"
            ],
            correctAnswer: 0
          }
        ]
      },
      'design-team-leadership': {
        id: 'design-team-leadership',
        title: 'Design Team Leadership',
        modulenumber: '4.3.7',
        department: 'Design',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770025989/d8_cypwkq.mp4',
        duration: 90,
        description: 'Delegate design tasks effectively, monitor and guide junior designers, coach and build technical skills, create structured creativity forums, develop professional growth paths, build culture of excellence.',
        requiredRoles: ['head_of_design','designer', 'senior_designer'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "You grow designs by:",
            options: [
              "Using better software",
              "Growing designers",
              "Working longer hours",
              "Hiring more people"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Delegation increases department capacity and:",
            options: [
              "Reduces quality",
              "Builds junior capability",
              "Creates confusion",
              "Slows work"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Every delegated task must include clear scope, standards and:",
            options: [
              "Only drawings",
              "Deadline",
              "Client photos",
              "Marketing info"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Monitoring should include mid-task review:",
            options: [
              "After errors occur",
              "Before full completion",
              "Never done",
              "Only at end"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Most learning happens during:",
            options: [
              "Classroom training",
              "Live projects and corrections",
              "Watching videos",
              "Reading manuals"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Correction without explanation:",
            options: [
              "Builds confidence",
              "Does not build skill",
              "Is best practice",
              "Improves quality"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "Creativity workshops help to share ideas and:",
            options: [
              "Waste time",
              "Solve problems collectively",
              "Create conflict",
              "Replace production"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Collective reviews must be:",
            options: [
              "Personal and emotional",
              "Respectful and factual",
              "Secret meetings",
              "Only for seniors"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Professional growth includes training and:",
            options: [
              "Only experience",
              "Certifications",
              "Only salary",
              "Only supervision"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Strong leaders:",
            options: [
              "Protect only their own talent",
              "Multiply talent",
              "Avoid delegation",
              "Work alone"
            ],
            correctAnswer: 1
          }
        ]
      },
      'design-team-foundations': {
        id: 'design-team-foundations',
        title: 'Design Team Foundations',
        modulenumber: '4.4.0',
        department: 'Design',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770028550/d9_ooopbu.mp4',
        duration: 90,
        description: 'Understand Kajja vision, mission, values and brand promise, behave professionally with clients and colleagues, understand B2B target clients, and recognize responsibilities in project success.',
        requiredRoles: ['designer', 'junior_designer', 'senior_designer'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Your drawing becomes someone else's:",
            options: [
              "Problem to solve",
              "Creative inspiration",
              "Work, time and cost",
              "Marketing material"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "Kajja's brand promise is:",
            options: [
              "Efficiency, Creativity, Trust",
              "Quality, Speed, Low price",
              "Design, Sales, Production",
              "Style, Colour, Finish"
            ],
            correctAnswer: 0
          },
          {
            id: 3,
            question: "Efficiency in design means:",
            options: [
              "Fast drawing only",
              "Many colours and renderings",
              "Clear, complete drawings, minimal revisions",
              "Complex designs"
            ],
            correctAnswer: 2
          },
          {
            id: 4,
            question: "Creativity at Kajja means:",
            options: [
              "Decoration only",
              "Making designs complex",
              "Solving functional and space problems",
              "Copying internet images"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "Trust is built when delivered furniture:",
            options: [
              "Allows client changes on site",
              "Matches approved drawings",
              "Is artistic",
              "Has designer explanations"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Designers must behave professionally because they:",
            options: [
              "Get personal payments",
              "Are salespeople",
              "Represent Kajja Galleries",
              "Must convince clients"
            ],
            correctAnswer: 2
          },
          {
            id: 7,
            question: "A designer should never:",
            options: [
              "Ask questions",
              "Guess answers to clients",
              "Clarify drawings",
              "Attend meetings"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Kajja's main clients are:",
            options: [
              "Individual home owners",
              "Walk-in customers",
              "Furniture retailers only",
              "B2B bulk commercial clients"
            ],
            correctAnswer: 3
          },
          {
            id: 9,
            question: "B2B clients mainly care about:",
            options: [
              "Decoration trends",
              "Colour variety",
              "Designer style",
              "Durability and repeatability"
            ],
            correctAnswer: 3
          },
          {
            id: 10,
            question: "Designers represent Kajja to clients, production and:",
            options: [
              "Installers and management",
              "Only management",
              "Competitors",
              "Suppliers only"
            ],
            correctAnswer: 0
          }
        ]
      },
      'client-centered-design-skills': {
        id: 'client-centered-design-skills',
        title: 'Client-Centered Design Skills',
        modulenumber: '4.4.1',
        department: 'Design',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770030242/d91_nea6x0.mp4',
        duration: 90,
        description: 'Listen properly and ask smart discovery questions, read site information and verify assumptions, plan spaces correctly, translate functional needs into drawings, control revisions professionally, present designs business-ready.',
        requiredRoles: ['designer', 'senior_designer'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Design what the client truly needs, not what you:",
            options: [
              "Think is beautiful",
              "Assume",
              "Saw online",
              "Like personally"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Smart design questions focus on:",
            options: [
              "Colour preferences only",
              "Function, operations, constraints",
              "Budget only",
              "Timeline only"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Never start drawing before understanding:",
            options: [
              "Latest trends",
              "How the space will be used",
              "Production capacity",
              "Material costs"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Designers must never assume walls are:",
            options: [
              "Important",
              "Straight and floors are level",
              "Measured correctly",
              "Painted"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Always design using verified site information, not:",
            options: [
              "Sales reports",
              "Memory",
              "Client photos",
              "Internet images"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Space planning is about movement and use, not only:",
            options: [
              "Cost",
              "Fitting furniture",
              "Colour matching",
              "Branding"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "A beautiful design that fails function is:",
            options: [
              "Acceptable",
              "Rejected by real users",
              "Good for marketing",
              "Cheaper to produce"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Revisions are normal, but chaos is:",
            options: [
              "Also normal",
              "Not acceptable",
              "Faster",
              "Cheaper"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Speed without control causes:",
            options: [
              "Faster approvals",
              "Production errors",
              "Happier clients",
              "Lower costs"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Professional presentation builds trust faster than:",
            options: [
              "Good visuals alone",
              "Low prices",
              "Fast delivery",
              "Many options"
            ],
            correctAnswer: 0
          }
        ]
      },
      'technical-design-documentation': {
        id: 'technical-design-documentation',
        title: 'Technical Design & Documentation',
        modulenumber: '4.4.2',
        department: 'Design',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770031799/d92_ssaiiq.mp4',
        duration: 90,
        description: 'Work consistently in ArchiCAD/CAD, apply standard module sizes and tolerances, design for CNC production, specify correct hardware, produce complete technical drawings and accurate BoMs, apply labelling standards, control files and versions.',
        requiredRoles: ['designer', 'senior_designer', 'head_of_design'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "If production must guess:",
            options: [
              "They learn better",
              "The drawing is not ready",
              "It's normal process",
              "Design is creative"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Consistent CAD use means production can:",
            options: [
              "Read drawings easily",
              "Guess dimensions",
              "Ignore standards",
              "Work slower"
            ],
            correctAnswer: 0
          },
          {
            id: 3,
            question: "Standard modules improve:",
            options: [
              "Only client approval",
              "Manufacturability and reduce errors",
              "Designer creativity only",
              "Rendering speed"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Tolerances are needed because:",
            options: [
              "Designers make mistakes",
              "Sites have irregularities",
              "Materials shrink",
              "Clients change minds"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "'Think CNC first' means design parts that:",
            options: [
              "Look beautiful only",
              "Cut efficiently and repeatably",
              "Use many materials",
              "Ignore board sizes"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Panel optimization involves:",
            options: [
              "Creating unique sizes",
              "Repeating identical parts",
              "Using curved panels",
              "Ignoring waste"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "Hardware must specify type and:",
            options: [
              "Colour only",
              "Performance requirements",
              "Supplier name",
              "Cost only"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Production drawings need plans, elevations and:",
            options: [
              "Only 3D views",
              "Sections",
              "Internet images",
              "Client photos"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "BoM accuracy prevents:",
            options: [
              "Fast purchasing",
              "Material shortages and wrong orders",
              "Good nesting",
              "Easy installation"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Design finishes when production can work without:",
            options: [
              "Asking questions",
              "Using tools",
              "Checking samples",
              "Waiting approval"
            ],
            correctAnswer: 0
          }
        ]
      },   
      'creativity-continuous-improvement': {
       id: 'creativity-continuous-improvement',
    title: 'Creativity & Continuous Improvement',
    modulenumber: '4.4.5',
    department: 'Design',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770036711/d95_xn2vea.mp4',
    duration: 90,
    description: 'Stay updated with global furniture trends, develop ideas through sketching and prototypes, use shape language correctly, build professional portfolio, practice weekly learning and self-development.',
    requiredRoles: ['designer', 'senior_designer'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Good designers copy trends. Great designers:",
        options: [
          "Ignore trends",
          "Translate them into buildable solutions",
          "Only make renders",
          "Follow only old styles"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Creativity is valuable only when it can be:",
        options: [
          "Beautiful",
          "Manufactured and installed successfully",
          "Expensive",
          "Trendy"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Designers should follow trends but always ask:",
        options: [
          "Is it popular?",
          "Can Kajja manufacture this efficiently?",
          "Is it cheap?",
          "Do clients like it?"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Sketching first helps to:",
        options: [
          "Skip CAD work",
          "Test ideas quickly before detailing",
          "Make perfect drawings",
          "Avoid prototypes"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Rapid prototyping detects design problems:",
        options: [
          "Late in production",
          "Early, before full detailing",
          "Never",
          "Only on site"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Shape language includes curves, profiles and:",
        options: [
          "Colours only",
          "Forms and ergonomics",
          "Logos",
          "Fonts"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Commercial furniture shapes must respect:",
        options: [
          "Only trends",
          "Human use and machine capability",
          "Only cost",
          "Only beauty"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "A good portfolio includes drawings and:",
        options: [
          "Only sketches",
          "Real project results and photos",
          "Client emails",
          "Only renders"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Weekly learning goals help designers:",
        options: [
          "Avoid work",
          "Improve skills continuously",
          "Reduce meetings",
          "Skip training"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Creativity must grow every week, not only when:",
        options: [
          "Clients ask",
          "Project demands it",
          "Managers order",
          "Sales need"
        ],
        correctAnswer: 1
      }
    ]
  },
      'coordination-production-site-teams': {
        id: 'coordination-production-site-teams',
        title: 'Coordination with Production & Site Teams',
        modulenumber: '4.4.3',
        department: 'Design',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770033284/d93_wksac7.mp4',
        duration: 90,
        description: 'Hand over designs to production without missing information, communicate clearly with workshop supervisors, detail joinery to prevent rework, translate site constraints correctly into drawings, support problem-solving during installation changes.',
        requiredRoles: ['designer', 'senior_designer', 'head_of_production'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Design is finished only when:",
            options: [
              "Client approves",
              "Production and installation succeed",
              "Renders are done",
              "Drawings are printed"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Handover package must include final drawings, BoM, and:",
            options: [
              "Only client photos",
              "Hardware specs and finish references",
              "Internet images",
              "Personal notes"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "If production must call for basic information:",
            options: [
              "They are learning",
              "Handover failed",
              "It's normal",
              "Design is complex"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Complex details with hidden fixings need:",
            options: [
              "Only drawings",
              "Clear explanation to workshop",
              "Ignoring",
              "Client approval only"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Clear explanation today prevents:",
            options: [
              "More meetings",
              "Cutting mistakes tomorrow",
              "Faster work",
              "Less drawing"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "Poor joinery design causes:",
            options: [
              "Beautiful furniture",
              "Weak structures and misalignment",
              "Faster assembly",
              "Less material"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "If joint is difficult to assemble:",
            options: [
              "It's innovative",
              "It will be assembled wrongly",
              "Production likes challenges",
              "It saves time"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Site constraints like uneven walls must:",
            options: [
              "Be ignored",
              "Appear in drawings",
              "Only be remembered",
              "Fixed on site"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Quick decisions without updated drawings create:",
            options: [
              "Efficiency",
              "Confusion and rework",
              "Happy clients",
              "Less work"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Good coordination protects time, cost and:",
            options: [
              "Only materials",
              "Reputation",
              "Only drawings",
              "Office space"
            ],
            correctAnswer: 1
          }
        ]
      },
      'sales-foundations-brand': {
        id: 'sales-foundations-brand',
        title: 'Sales Foundations & Brand Representation',
        modulenumber: '2.4.0',
        department: 'Sales',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768912614/sale1_nbzwjd.mp4',
        duration: 85,
        description: 'Sales responsibilities, brand positioning, value proposition, communication skills, and professional presentation',
        requiredRoles: ['sales_manager', 'sales_representative', 'client_relations_officer', 'marketing-sales', 'ceo'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "The main responsibility of a Kajja Sales Person is:",
            options: [
              "Waiting for calls",
              "Create opportunities & guide clients into our system",
              "Only chat with friends",
              "Focus only on residential buyers"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "What does Kajja really sell?",
            options: [
              "Only wood",
              "Systems, reliability & trust",
              "Cheap furniture",
              "Unverified products"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Professional communication means:",
            options: [
              "Gossip",
              "Confidence + clarity + active listening",
              "Speaking unclear",
              "Arguing"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Sales must avoid:",
            options: [
              "Business language",
              "Neutral facts",
              "Negative talk about company operations",
              "Clear communication"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "First impression must show:",
            options: [
              "Confusion",
              "Amateur vibe",
              "Confidence & professionalism",
              "Tiredness"
            ],
            correctAnswer: 2
          },
          {
            id: 6,
            question: "Who are Kajja's target clients?",
            options: [
              "Only residential home owners",
              "Developers, banks, offices, restaurants - commercial partners",
              "Only small individual buyers",
              "Only international clients"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What must sales messages always reflect?",
            options: [
              "Only low prices",
              "Efficiency, Creativity, Trust",
              "Fast delivery only",
              "Competitor weaknesses"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What should clients receive from Kajja?",
            options: [
              "Just furniture pieces",
              "Reliable timelines, design accuracy, durable quality, professional installation, warranty",
              "Only cheapest option",
              "Guesswork and delays"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "How should sales speak to clients?",
            options: [
              "In slang and casual language",
              "Speak in benefits, not features",
              "Using technical jargon only",
              "Avoiding eye contact"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What must sales personnel carry?",
            options: [
              "Only mobile phone",
              "Notebook + pen + tablet/phone with portfolio",
              "Nothing",
              "Personal items only"
            ],
            correctAnswer: 1
          }
        ]
      },
      'finance-leadership-foundations': {
        id: 'finance-leadership-foundations',
        title: 'Finance Leadership Foundations',
        modulenumber: '3.1.0',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769072162/account1_r6b45i.mp4',
        duration: 90,
        description: 'Finance leadership role, vision alignment, ethical culture, and cross-department coordination',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant', 'director'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "The Head of Finance is primarily:",
            options: [
              "A cashier",
              "A guardian of the company's financial health",
              "Only a report writer",
              "A sales assistant"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Finance decisions must align with:",
            options: [
              "Personal opinions",
              "Kajja's vision and long-term goals",
              "Random spending needs",
              "Emergency pressure only"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Ethical finance means:",
            options: [
              "Hiding mistakes",
              "Transparent, documented, and accountable processes",
              "Adjusting numbers to look good",
              "Ignoring rules"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Which department should finance NOT coordinate with?",
            options: [
              "Sales",
              "Operations",
              "Procurement",
              "None — finance coordinates with all"
            ],
            correctAnswer: 3
          },
          {
            id: 5,
            question: "Poor finance leadership results in:",
            options: [
              "Controlled growth",
              "Financial leakage and business failure",
              "Strong trust",
              "Clear reporting"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What are the core responsibilities of Head of Finance?",
            options: [
              "Only counting cash",
              "Protect cash flow, ensure profitability, prevent financial leakage, enforce spending discipline",
              "Only sales support",
              "Only HR functions"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What must the Head of Finance constantly ask?",
            options: [
              "How to spend more",
              "'Does this decision strengthen Kajja in 1, 3, 5 years?'",
              "Only about daily expenses",
              "No questions needed"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What are non-negotiable ethics?",
            options: [
              "Hidden transactions",
              "No hidden transactions, no undocumented payments, clear audit trails",
              "Adjusting figures",
              "Personal use of company funds"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What happens when finance trust is lost?",
            options: [
              "Nothing changes",
              "Entire company collapses",
              "Only finance suffers",
              "Sales increase"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Finance is the ______ of Kajja.",
            options: [
              "Optional department",
              "Central nervous system",
              "Least important",
              "Only for emergencies"
            ],
            correctAnswer: 1
          }
        ]
      },
      'selling-kajja-solutions': {
        id: 'selling-kajja-solutions',
        title: 'Selling Kajja Solutions',
        modulenumber: '2.4.3',
        department: 'Sales',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768987912/sale4_wvzftq.mp4',
        duration: 85,
        description: 'Storytelling framework, case study usage, upselling strategies, revision management, and value-based negotiation',
        requiredRoles: ['sales_manager', 'sales_representative', 'marketing-sales', 'ceo'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Storyselling means:",
            options: [
              "Talking about wood only",
              "Showing how Kajja solves business problems",
              "Ignoring the client",
              "Telling jokes only"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Case studies help:",
            options: [
              "Show proof and credibility",
              "Confuse clients",
              "Reveal weaknesses",
              "Waste time"
            ],
            correctAnswer: 0
          },
          {
            id: 3,
            question: "Upselling should:",
            options: [
              "Add value for client & company",
              "Force unwanted products",
              "Reduce trust",
              "Be done secretly"
            ],
            correctAnswer: 0
          },
          {
            id: 4,
            question: "Revisions must be:",
            options: [
              "Verbal",
              "Written and costed before work continues",
              "Ignored",
              "Done for free"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Negotiation should:",
            options: [
              "Destroy company margin",
              "Show value and maintain profitability",
              "Agree to all discounts",
              "Disrespect company brand"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What is the storyselling framework?",
            options: [
              "Only show products",
              "Problem → Design → Installation → Aftercare",
              "Only talk about price",
              "Ignore client needs"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What case studies build?",
            options: [
              "Only confusion",
              "Instant credibility",
              "Doubt",
              "Suspicion"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What is bulk discount strategy?",
            options: [
              "Always give maximum discount",
              "'Since you're doing 20 units, we can increase efficiency — apply better rate'",
              "Never give discounts",
              "Hide extra costs"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What must revisions include?",
            options: [
              "Nothing",
              "New design approval, adjusted pricing + timeline",
              "Only verbal agreement",
              "Free changes always"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "How should you respond to discount requests?",
            options: [
              "Immediately reduce price",
              "Offer alternative materials or phased delivery while protecting margin",
              "Accept all requests",
              "Get angry"
            ],
            correctAnswer: 1
          }
        ]
      },
      'financial-reporting-analysis': {
        id: 'financial-reporting-analysis',
        title: 'Financial Reporting & Analysis',
        modulenumber: '3.1.1',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769073694/account2_y399sl.mp4',
        duration: 100,
        description: 'Financial statements, profit analysis, cash flow, variance analysis, cost structure, and KPI monitoring',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "The 25–35% target at Kajja refers to:",
            options: [
              "Gross margin",
              "Net profit after all costs",
              "Mark-up",
              "Before expenses"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Profit & Loss mainly answers:",
            options: [
              "How much cash we have",
              "Whether the business is profitable over time",
              "How many machines we own",
              "How many staff we have"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Cash flow is critical because:",
            options: [
              "Profit guarantees cash",
              "Cash determines survival",
              "It only matters yearly",
              "It is optional"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Variance analysis helps:",
            options: [
              "Hide mistakes",
              "Understand why results differ from plan",
              "Ignore budgets",
              "Guess outcomes"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "KPIs are used to:",
            options: [
              "Punish staff",
              "Measure and protect business health",
              "Create fear",
              "Delay decisions"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What is the difference between gross margin and net profit?",
            options: [
              "No difference",
              "Gross margin minus ALL costs = net profit (Management Cost)",
              "Only accounting terms",
              "Gross margin is always higher"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What must monthly reporting include?",
            options: [
              "Only cash",
              "Profit & Loss, cash position, receivables, payables, project costs, rework report",
              "Only sales data",
              "Only expenses"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What silently destroys net profit?",
            options: [
              "More sales",
              "Rework and wastage",
              "More clients",
              "Better marketing"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What does a balance sheet show?",
            options: [
              "Only profits",
              "Assets = Liabilities + Equity - financial position snapshot",
              "Only cash flow",
              "Only future predictions"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What are KPIs?",
            options: [
              "Punishment tools",
              "Early warning systems measuring business health",
              "Random numbers",
              "Optional reports"
            ],
            correctAnswer: 1
          }
        ]
      },
      'pricing-revenue-management': {
        id: 'pricing-revenue-management',
        title: 'Pricing & Revenue Management',
        modulenumber: '3.1.2',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769074770/account3_laljcj.mp4',
        duration: 95,
        description: 'Pricing strategy, margin control, quote approval, revenue recognition, risk pricing, and client qualification',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant', 'sales_manager'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Pricing must always support:",
            options: [
              "Gross margin only",
              "Sales volume",
              "25–35% NET PROFIT after all costs",
              "Client happiness only"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "Discounts are dangerous because they:",
            options: [
              "Increase profit",
              "Reduce net profit first",
              "Improve cash flow",
              "Remove risk"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Finance should get involved in pricing:",
            options: [
              "After losses occur",
              "Before quotations are approved",
              "Only at year end",
              "Never"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "High-risk projects require:",
            options: [
              "Same pricing as normal jobs",
              "Lower prices",
              "Risk-adjusted pricing",
              "No documentation"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "Reliable revenue comes from:",
            options: [
              "Any client",
              "Qualified clients aligned with finance rules",
              "Fast talkers",
              "Free consultations"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What must every price cover?",
            options: [
              "Only materials",
              "Direct costs, indirect costs, risk allowance, 25–35% NET PROFIT",
              "Only labor",
              "Only overheads"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What is 'Management Cost' internally?",
            options: [
              "Marketing expense",
              "NET PROFIT",
              "Transport cost",
              "Salary bonus"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What must finance monitor per project?",
            options: [
              "Only total sales",
              "Margins per project, flag projects below 25% net",
              "Only client names",
              "Only payment dates"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "When is revenue earned?",
            options: [
              "When quote sent",
              "When value delivered - deposit received, production, delivery, client sign-off",
              "When client calls",
              "When promised"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What indicates client risk?",
            options: [
              "Pays deposit",
              "Refuses deposit, wants free work, delays approvals, poor payment history",
              "Clear requirements",
              "On-time payments"
            ],
            correctAnswer: 1
          }
        ]
      },
      'cash-flow-mastery': {
        id: 'cash-flow-mastery',
        title: 'Cash Flow Mastery',
        modulenumber: '3.1.3',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769076958/account4_csojxh.mp4',
        duration: 95,
        description: 'Working capital management, cash flow forecasting, payment terms, leak prevention, and emergency cash strategies',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Working capital is:",
            options: [
              "Profit",
              "Money needed to run daily operations",
              "Long-term investment only",
              "Sales value"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Cash flow forecasting helps by:",
            options: [
              "Guessing",
              "Preventing cash shortages",
              "Increasing expenses",
              "Hiding problems"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Production should start only when:",
            options: [
              "Client promises verbally",
              "Deposit is received",
              "Materials arrive by chance",
              "Sales feels confident"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Rework affects cash by:",
            options: [
              "Improving profits",
              "Creating unexpected costs",
              "Speeding production",
              "Reducing expenses"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Emergency cash planning is important because:",
            options: [
              "Emergencies never happen",
              "Cash shortages can destroy a business",
              "Profit solves all problems",
              "It is optional"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What is cash needed for day-to-day?",
            options: [
              "Only dividends",
              "Buy materials, pay workers, fuel trucks before clients pay",
              "Only investments",
              "Only bonuses"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What must weekly cash forecast track?",
            options: [
              "Only sales",
              "Expected client payments, planned expenses, opening/closing cash balance",
              "Only profits",
              "Only future projects"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What are Kajja's standard payment terms?",
            options: [
              "Pay after 3 months",
              "70% deposit before production, 30% before delivery/installation",
              "100% after completion",
              "No deposit needed"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What are common cash leaks?",
            options: [
              "Higher sales",
              "Delayed client payments, free site visits, rework, material theft, unapproved discounts",
              "More clients",
              "Better quality"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What emergency protection should finance maintain?",
            options: [
              "No protection",
              "Cash buffer/reserve, prioritize essential payments, delay non-critical spending",
              "Only more loans",
              "Ignore emergencies"
            ],
            correctAnswer: 1
          }
        ]
      },
      'procurement-inventory-cost-control': {
        id: 'procurement-inventory-cost-control',
        title: 'Procurement, Inventory & Cost Control',
        modulenumber: '3.1.4',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769083727/account5_w7kgtu.mp4',
        duration: 100,
        description: 'Purchase controls, supplier management, inventory tracking, waste prevention, and rework cost analysis',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant', 'operations_manager', 'procurement'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Purchase controls exist to:",
            options: [
              "Delay work",
              "Control how money leaves the business",
              "Frustrate staff",
              "Increase paperwork only"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Inventory is dangerous when:",
            options: [
              "Well controlled",
              "Poorly tracked",
              "Properly planned",
              "Audited"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Supplier discipline helps to:",
            options: [
              "Increase risk",
              "Protect margins and reliability",
              "Delay projects",
              "Hide costs"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Wastage affects:",
            options: [
              "Only operations",
              "Only finance",
              "NET PROFIT directly",
              "Nothing"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "Rework must be:",
            options: [
              "Ignored",
              "Hidden",
              "Tracked, costed, and analyzed",
              "Accepted as normal"
            ],
            correctAnswer: 2
          },
          {
            id: 6,
            question: "What is the strict rule for purchases?",
            options: [
              "Buy first, ask later",
              "No Purchase Order = No payment",
              "No controls needed",
              "Only verbal approval"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What is inventory?",
            options: [
              "Only waste",
              "Cash sitting on shelves - ties up cash, increases theft risk",
              "Only profit",
              "Unimportant items"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What finance must ask suppliers?",
            options: [
              "No questions",
              "'Is this price fair, consistent, and aligned with our margin targets?'",
              "Only about delivery time",
              "Personal questions"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What does rework use?",
            options: [
              "No resources",
              "Extra materials, extra labor, delays delivery",
              "Only time",
              "Only scrap"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What gets corrected according to finance?",
            options: [
              "Only what is ignored",
              "What is measured gets corrected",
              "Only random issues",
              "Only major losses"
            ],
            correctAnswer: 1
          }
        ]
      },
      'compliance-tax-administration': {
        id: 'compliance-tax-administration',
        title: 'Compliance & Tax Administration',
        modulenumber: '3.1.5',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769084972/account6_idlxoo.mp4',
        duration: 95,
        description: 'URA compliance, VAT, EFRIS, PAYE/NSSF management, audit readiness, legal documentation, and fraud prevention',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "URA compliance is important because:",
            options: [
              "It is optional",
              "Penalties and audits can destroy the business",
              "Only big companies need it",
              "It delays growth"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "EFRIS is used to:",
            options: [
              "Hide sales",
              "Track invoices electronically with URA",
              "Replace accounting",
              "Delay invoicing"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "PAYE and NSSF are:",
            options: [
              "Company income",
              "Employee trust deductions",
              "Optional benefits",
              "Marketing expenses"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Documentation protects Kajja because:",
            options: [
              "It increases paperwork",
              "It provides legal and audit evidence",
              "It slows decisions",
              "It is only for auditors"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Fraud prevention works best through:",
            options: [
              "Punishment only",
              "Strong internal controls",
              "Ignoring warning signs",
              "Trusting everyone blindly"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What is VAT?",
            options: [
              "Optional tax",
              "Tax charged on sales, recovered on purchases, paid to URA monthly",
              "Only for imports",
              "One-time payment"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What happens if sales not in EFRIS?",
            options: [
              "Nothing",
              "Considered tax evasion risk",
              "Only delayed",
              "Only affects marketing"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What are PAYE and NSSF?",
            options: [
              "Company profits",
              "Trust money — not company money",
              "Optional deductions",
              "Only for directors"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What must finance enforce for legal protection?",
            options: [
              "Only verbal agreements",
              "Documentation for contracts, quotations, purchase orders, payment receipts",
              "No records needed",
              "Only bank statements"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What are fraud prevention controls?",
            options: [
              "Only trusting staff",
              "Segregation of duties, approval hierarchies, regular reconciliations",
              "No controls needed",
              "Only annual reviews"
            ],
            correctAnswer: 1
          }
        ]
      },
      'payroll-hr-finance-alignment': {
        id: 'payroll-hr-finance-alignment',
        title: 'Payroll & HR Finance Alignment',
        modulenumber: '3.1.6',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769086526/account7_xtzuje.mp4',
        duration: 90,
        description: 'Payroll structure, performance incentives, leave/overtime management, staff loans, confidentiality, and HR collaboration',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant', 'hr_manager', 'ceo'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Payroll must be:",
            options: [
              "Emotional",
              "Affordable, compliant, and performance-linked",
              "Random",
              "Secret"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Performance incentives should be:",
            options: [
              "Paid regardless of results",
              "Funded from profit",
              "Guaranteed monthly",
              "Uncontrolled"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Overtime usually indicates:",
            options: [
              "Efficiency",
              "Poor planning if excessive",
              "High motivation always",
              "Cost savings"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Staff loans must be:",
            options: [
              "Verbal",
              "Documented with repayment plans",
              "Unlimited",
              "Ignored"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Finance–HR collaboration ensures:",
            options: [
              "Conflict",
              "Fair, sustainable performance rewards",
              "Confusion",
              "Delays"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What is fixed pay?",
            options: [
              "Only bonuses",
              "Guaranteed component covering attendance, role responsibility, basic job expectations",
              "Only overtime",
              "Only allowances"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What must incentives reward?",
            options: [
              "Only attendance",
              "Output, not presence - align with company profitability",
              "Only seniority",
              "Only complaints"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What is finance responsibility for leave?",
            options: [
              "Ignore leave",
              "Ensure leave accruals recorded, taken leave documented, balances accurate",
              "Only pay when taken",
              "No responsibility"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Why is payroll confidentiality important?",
            options: [
              "No reason",
              "Protects staff dignity and company reputation - prevents loss of trust, legal exposure",
              "Only for HR",
              "Only for management"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What must finance and HR design together?",
            options: [
              "Only salaries",
              "KPIs, incentive schemes, review performance outcomes quarterly",
              "Only disciplinary actions",
              "Only hiring processes"
            ],
            correctAnswer: 1
          }
        ]
      },
      'systems-digital-tools-data-integrity': {
        id: 'systems-digital-tools-data-integrity',
        title: 'Systems, Digital Tools & Data Integrity',
        modulenumber: '3.1.7',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769088600/account8_l6ntdb.mp4',
        duration: 90,
        description: 'Ensuring financial system accuracy, secure data storage, CRM integration, and strict confidentiality to protect profit.',
        requiredRoles: ['head_of_finance', 'finance_manager', 'accountant'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Financial systems must be:",
            options: [
              "Fast only",
              "Accurate, secure, controlled, and auditable",
              "Open to everyone",
              "Casual"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Access rights are important because:",
            options: [
              "They slow work",       
              "They reduce transparency",
              "They prevent errors and fraud",
              "They increase confusion"
            ],
            correctAnswer: 2
          },
          {
            id: 3,
            question: "Job folders are important because:",
            options: [
              "They waste time",
              "They provide financial and legal evidence",
              "They confuse staff",
              "They are optional"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "CRM helps finance by:",
            options: [
              "Posting social media",
              "Showing future revenue and cash inflows",
              "Replacing accounting",
              "Hiding sales"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "Data confidentiality means:",
            options: [
              "Sharing freely",
              "Zero tolerance for leaks",
              "Public discussion",
              "Ignoring rules"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "The Kajja principle is:",
            options: [
              "Data is flexible",
              "If the data is wrong, every decision is wrong",
              "Decisions come first",
              "Data is optional"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What should a job folder contain?",
            options: [
              "Only invoices",
              "Approved quotation, design approvals, purchase orders, supplier invoices, payment receipts",
              "Personal files",
              "Marketing materials"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What does a purchasing dashboard show?",
            options: [
              "Only supplier names",
              "What is being bought, from whom, at what price, for which project",
              "Employee performance",
              "Social media metrics"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "Finance's responsibility with CRM is to:",
            options: [
              "Ignore it",
              "Match CRM deals to invoices, track deposits, flag unpaid deals",
              "Delete old data",
              "Use it for marketing only"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Uncontrolled system access leads to:",
            options: [
              "More teamwork",
              "Fraud risk",
              "Better decisions",
              "Faster reporting"
            ],
            correctAnswer: 1
          }
        ]
      },
      'foundation-of-bookkeeping': {
        id: 'foundation-of-bookkeeping',
        title: 'Foundation of Bookkeeping',
        modulenumber: '3.2.0',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769155594/book1_nernnj.mp4',
        duration: 90,
        description: 'Core principles of accurate financial recording, strict confidentiality, and proper coordination with Finance and HR.',
        requiredRoles: ['bookkeeper', 'accountant', 'finance_manager'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Bookkeeping is mainly about:",
            options: [
              "Making pricing decisions",
              "Recording financial transactions accurately",
              "Approving supplier payments",
              "Negotiating with clients"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Financial accuracy is important because:",
            options: [
              "Only auditors care about accuracy",
              "Mistakes don't matter if they're small",
              "Small errors grow into big problems",
              "It makes the bookkeeper look good"
            ],
            correctAnswer: 2
          },
          {
            id: 3,
            question: "Confidential financial data should:",
            options: [
              "Be discussed openly with colleagues",
              "Be posted on company notice boards",
              "Be protected at all times",
              "Be shared with trusted friends"
            ],
            correctAnswer: 2
          },
          {
            id: 4,
            question: "If a bookkeeper makes a mistake, they should:",
            options: [
              "Ignore it and hope no one notices",
              "Change the records quietly",
              "Blame it on the system",
              "Report and correct it immediately"
            ],
            correctAnswer: 3
          },
          {
            id: 5,
            question: "The bookkeeper works best when:",
            options: [
              "Making independent financial decisions",
              "Ignoring approval processes",
              "Working alone without supervision",
              "Coordinating closely with Head of Finance and HR"
            ],
            correctAnswer: 3
          },
          {
            id: 6,
            question: "Bookkeeping is NOT:",
            options: [
              "Recording supplier bills and invoices",
              "Making pricing decisions for products",
              "Tracking client payments",
              "Maintaining payroll records"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "A UGX 20,000 error daily becomes:",
            options: [
              "Only UGX 20,000 monthly",
              "UGX 600,000 monthly",
              "An insignificant amount",
              "The auditor's problem, not ours"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Financial information includes:",
            options: [
              "Office rumors and gossip",
              "Company marketing strategies",
              "Public news articles",
              "Salaries, supplier prices, and client invoices"
            ],
            correctAnswer: 3
          },
          {
            id: 9,
            question: "The Bookkeeper's Golden Rule is:",
            options: [
              "Work slowly to avoid all mistakes",
              "Make independent decisions when unsure",
              "Hide unusual transactions from management",
              "Record exactly what happened, with proof, and report unusual items"
            ],
            correctAnswer: 3
          },
          {
            id: 10,
            question: "Working with HR, the bookkeeper:",
            options: [
              "Hires and fires staff members",
              "Sets employee salary levels",
              "Approves staff vacation requests",
              "Processes payroll entries and maintains confidential records"
            ],
            correctAnswer: 3
          }
        ]
      },
      'documents-recording-systems': {
        id: 'documents-recording-systems',
        title: 'Documents & Recording Systems',
        modulenumber: '3.2.1',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769157624/book2_lmsulc.mp4',
        duration: 90,
        description: 'Source document management, transaction classification, filing systems, and daily recording discipline.',
        requiredRoles: ['bookkeeper', 'accountant', 'finance_manager'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Source documents are important because:",
            options: [
              "They confuse auditors",
              "They are optional for small amounts",
              "They prove transactions happened",
              "They slow down the accounting process"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "A credit transaction means:",
            options: [
              "Money moves immediately",
              "No supporting document is needed",
              "Payment will happen later",
              "The transaction should be ignored"
            ],
            correctAnswer: 2
          },
          {
            id: 3,
            question: "Job folders are used to:",
            options: [
              "Hide incomplete work",
              "Store personal documents",
              "Mix multiple projects together",
              "Store all records for one project"
            ],
            correctAnswer: 3
          },
          {
            id: 4,
            question: "Bookkeeping entries should be done:",
            options: [
              "When convenient each week",
              "Only at month end",
              "Daily, on the same day",
              "Whenever the bookkeeper has time"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "The chart of accounts helps to:",
            options: [
              "Hide certain expenses",
              "Confuse financial reporting",
              "Classify transactions correctly",
              "Delay the audit process"
            ],
            correctAnswer: 2
          },
          {
            id: 6,
            question: "Which document proves AUTHORIZATION to purchase?",
            options: [
              "Supplier invoice",
              "Receipt",
              "Delivery note",
              "Local Purchase Order (LPO)"
            ],
            correctAnswer: 3
          },
          {
            id: 7,
            question: "A receipt is proof of:",
            options: [
              "Future payment promise",
              "Money that was paid or received",
              "Goods being ordered",
              "Credit approval"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Mixing cash and credit transactions causes:",
            options: [
              "Faster reporting",
              "Confusion and false cash position",
              "Better audit results",
              "More organized records"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What is the golden rule for source documents?",
            options: [
              "Documents are optional for small amounts",
              "No document means no entry",
              "Backdate if documents are missing",
              "Create fake documents if needed"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "If a bookkeeper is unsure about which account to use:",
            options: [
              "Invent a new account",
                  "Use whatever account seems closest",
              "Ask before posting",
                  "Skip the transaction entirely"
            ],
            correctAnswer: 2
          }
        ]
      },
      'cash-handling': {
        id: 'cash-handling',
        title: 'Cash Handling',
        modulenumber: '3.2.2',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769159008/book3_gymfkx.mp4',
        duration: 90,
        description: 'Petty cash management, approval processes, receipt handling, daily balancing, and fraud prevention.',
        requiredRoles: ['bookkeeper', 'accountant', 'finance_manager'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Petty cash is used for:",
            options: [
              "Personal staff loans",
              "Paying monthly salaries",
              "Minor approved expenses like transport",
              "Large equipment purchases"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "Cash should be given out only when:",
            options: [
              "The bookkeeper knows the person well",
              "There is urgent pressure to pay",
              "A properly approved requisition exists",
              "Someone promises to bring paperwork later"
            ],
            correctAnswer: 2
          },
          {
            id: 3,
            question: "Receipts are important because:",
            options: [
              "They are optional for small amounts",
              "They create unnecessary paperwork",
              "They prove money was spent correctly",
              "They help hide expenses"
            ],
            correctAnswer: 2
          },
          {
            id: 4,
            question: "Petty cash should be balanced:",
            options: [
              "Weekly when time allows",
              "At the end of each month",
              "Daily, at the end of each day",
              "When the bookkeeper remembers"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "If cash does not balance, the bookkeeper should:",
            options: [
              "Adjust the records to match",
              "Ignore small differences",
              "Report and investigate immediately",
              "Borrow money to cover the gap"
            ],
            correctAnswer: 2
          },
          {
            id: 6,
            question: "What is NOT allowed with petty cash?",
            options: [
              "Office supplies",
              "Transport for urgent errands",
              "Personal loans to staff",
              "Minor repairs"
            ],
            correctAnswer: 2
          },
          {
            id: 7,
            question: "The bookkeeper's role in approvals is to:",
            options: [
              "Approve expenses personally",
              "Execute payments after proper approvals",
              "Reject all requests to be safe",
              "Approve only for senior staff"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Weekly reconciliation helps to:",
            options: [
              "Hide errors until month end",
              "Detect issues and prevent fraud",
              "Reduce paperwork",
              "Avoid daily balancing"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What should happen before ANY cash is given?",
            options: [
              "Get verbal approval from a manager",
              "Complete Petty Cash Requisition Form with approvals",
              "Trust the person to bring a receipt later",
              "Check if there is enough cash in the box"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "The golden rule for missing receipts is:",
            options: [
              "Create a handwritten note",
              "Report it immediately as unaccounted",
              "Ignore it for small amounts",
              "Deduct it from the employee's salary"
            ],
            correctAnswer: 1
          }
        ]
      },
      'bank-mobile-money-transactions': {
        id: 'bank-mobile-money-transactions',
        title: 'Bank & Mobile Money Transactions',
        modulenumber: '3.2.3',
        department: 'Finance',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769161086/book4_aqgu7g.mp4',
        duration: 90,
        description: 'Bank transaction recording, payment authorization, monthly reconciliation, and electronic payment tracking.',
        requiredRoles: ['bookkeeper', 'accountant', 'finance_manager'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Bank transactions must be:",
            options: [
              "Estimated to save time",
              "Ignored if small amounts",
              "Recorded accurately and immediately",
              "Recorded at month end only"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "Payment vouchers are used to:",
            options: [
              "Delay payments intentionally",
              "Hide certain expenses from view",
              "Justify and approve payments properly",
              "Replace missing invoices"
            ],
            correctAnswer: 2
          },
          {
            id: 3,
            question: "Bank reconciliation ensures:",
            options: [
              "More unnecessary paperwork",
              "Delayed financial reporting",
              "Confusion between departments",
              "Company records match bank records"
            ],
            correctAnswer: 3
          },
          {
            id: 4,
            question: "EFT and mobile money transactions must be:",
            options: [
              "Recorded twice for safety",
              "Estimated when receipts are missing",
              "Tracked using unique reference numbers",
              "Ignored as they are automatic"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "Duplicate entries cause:",
            options: [
              "More accurate financial reports",
              "False balances and wrong reports",
              "Faster completion of work",
              "Improved cash flow visibility"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "When recording bank deposits, you should:",
            options: [
              "Record immediately without checking",
              "Confirm the source and reason for the money",
              "Wait until you have multiple deposits",
              "Estimate the amount if unsure"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "The bookkeeper's role in payments is to:",
            options: [
              "Approve all payments under UGX 500,000",
              "Execute payments after proper approvals",
              "Make payments based on verbal requests",
              "Reject payments to save money"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Bank reconciliation should be done:",
            options: [
              "Only when there is time",
              "Once per year before audit",
              "Every month without exception",
              "When the bank sends a reminder"
            ],
            correctAnswer: 2
          },
          {
            id: 9,
            question: "To prevent duplicate entries:",
            options: [
              "Record every transaction twice",
              "Check previous entries before posting",
              "Ignore reference numbers",
              "Wait for bank statement to record"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "Without proper bank reconciliation:",
            options: [
              "Work becomes faster",
              "Errors and fraud can be hidden",
              "Cash position is always accurate",
              "Trust in financial reports increases"
            ],
            correctAnswer: 1
          }
        ]
      },
      'pricing-financial-awareness': {
        id: 'pricing-financial-awareness',
        title: 'Pricing & Financial Awareness',
        modulenumber: '2.4.4',
        department: 'Sales',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768989368/sale5_kbt5n0.mp4',
        duration: 85,
        description: 'Management cost explanation, payment terms, agreement protection, documentation, and avoiding free work',
        requiredRoles: ['sales_manager', 'sales_representative', 'finance_manager', 'ceo', 'marketing-sales'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Management cost includes:",
            options: [
              "Guesswork",
              "Project supervision and QC systems",
              "Free services",
              "Uncontrolled risk"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "When does production start?",
            options: [
              "When client promises verbally",
              "After 70% deposit + design approval",
              "Immediately after inquiry",
              "Without money"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "All agreements must be:",
            options: [
              "Verbal",
              "Written and signed",
              "Based on trust only",
              "Secret"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Installation must wait until:",
            options: [
              "Client pays final balance",
              "We feel like it",
              "Client smiles",
              "A random promise is made"
            ],
            correctAnswer: 0
          },
          {
            id: 5,
            question: "Free consulting leads to:",
            options: [
              "More respect",
              "Time loss & financial risk",
              "Guaranteed deals",
              "Better clients magically"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What does management cost cover?",
            options: [
              "Only raw materials",
              "Operations planning, skilled labor oversight, QC inspections, warranty, risk allowance",
              "Only transport",
              "Only marketing"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What is standard payment terms?",
            options: [
              "Pay after 6 months",
              "70% deposit to start, 30% before delivery",
              "100% after delivery",
              "No payment needed"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What must sales never promise?",
            options: [
              "Clear timelines",
              "What is not documented in written agreements",
              "Quality",
              "Warranty"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What must be completed before production?",
            options: [
              "Nothing",
              "Deposit + design approval signed + payment confirmation",
              "Only handshake",
              "Only phone call"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What protects Kajja time and knowledge?",
            options: [
              "Giving free advice",
              "Charging commitment fee for site visits and technical consulting",
              "Working for free",
              "Ignoring costs"
            ],
            correctAnswer: 1
          }
        ]
      },
      'followup-client-handling': {
        id: 'followup-client-handling',
        title: 'Follow-Up & Client Handling',
        modulenumber: '2.4.5',
        department: 'Sales',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768990806/sale6_uzomfy.mp4',
        duration: 85,
        description: 'Follow-up systems, expectation management, objection handling, production communication, and handover satisfaction',
        requiredRoles: ['sales_manager', 'sales_representative', 'client_relations_officer', 'marketing-sales'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Follow-up must be:",
            options: [
              "Aggressive & annoying",
              "Structured and supportive",
              "Random",
              "Non-existent"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Managing expectations prevents:",
            options: [
              "Trust",
              "Delivery surprises and confusion",
              "Smooth projects",
              "On-time work"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "When a client objects:",
            options: [
              "Get angry",
              "Listen and guide with value",
              "Argue aggressively",
              "Ignore them"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "During production, sales should:",
            options: [
              "Disappear",
              "Give weekly updates",
              "Hide problems",
              "Provide no clarity"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "After installation, sales must:",
            options: [
              "Rush away",
              "Ensure sign-off and client satisfaction",
              "Start a new argument",
              "Ignore feedback"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What is standard follow-up timeline after quotation?",
            options: [
              "No follow-up",
              "Day 1, 3, 7, 14, then monthly check-ins",
              "Call every hour",
              "Wait 6 months"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What reduces complaints by 90%?",
            options: [
              "Lower prices",
              "Clear expectations from beginning",
              "Silence",
              "Free gifts"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "How should you respond to price objections?",
            options: [
              "Immediately discount",
              "'Our pricing reflects quality systems and warranty. Let's review scope'",
              "Get angry",
              "Ignore"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What builds trust during production?",
            options: [
              "Silence",
              "Weekly updates sharing progress and changes immediately",
              "Hiding issues",
              "Avoiding calls"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "When is project complete?",
            options: [
              "After delivery only",
              "After client says 'Yes, this is perfect' and sign-off signed",
              "After partial payment",
              "When sales forgets"
            ],
            correctAnswer: 1
          }
        ]
      },
      'lead-qualification': {
        id: 'lead-qualification',
        title: 'Lead Qualification',
        modulenumber: '2.4.2',
        department: 'Sales',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768985029/sale3_vwjdxv.mp4',
        duration: 85,
        description: 'Prospect qualification, commitment fees, disqualification criteria, red flags, and CRM pipeline management',
        requiredRoles: ['sales_manager', 'sales_representative', 'client_relations_officer', 'marketing-sales'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "Qualification is important to:",
            options: [
              "Waste time on everyone",
              "Focus on serious clients",
              "Avoid making sales",
              "Sell to wrong clients"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "Commitment fee purpose:",
            options: [
              "Free gift",
              "Confirm seriousness & secure professional time",
              "Punishment",
              "Just for fun"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "A client who keeps postponing decisions:",
            options: [
              "Priority",
              "Likely unserious",
              "Best client",
              "Should get free visits"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Red flags indicate:",
            options: [
              "Perfect projects",
              "High risk & low value",
              "Free profits",
              "Easy life"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "CRM is used for:",
            options: [
              "Losing contact details",
              "Tracking the pipeline and ensuring follow-up",
              "Gossip",
              "Guessing the next step"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What must you check before investing time?",
            options: [
              "Nothing",
              "Budget, timeline, seriousness, decision-maker authority",
              "Only client's name",
              "Only phone number"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What is the commitment fee amount?",
            options: [
              "Free",
              "200,000 UGX",
              "1,000,000 UGX",
              "No fee required"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "When should you disqualify a lead?",
            options: [
              "Never disqualify anyone",
              "No budget but wants high-end, refuses commitment fee, postpones decisions",
              "Only if client is rude",
              "Always disqualify everyone"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What is a major red flag?",
            options: [
              "Clear requirements",
              "Wants luxury finishes at cheapest price",
              "On-time payments",
              "Professional communication"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What happens if not recorded in CRM?",
            options: [
              "It's still valid",
              "It does not exist",
              "It becomes priority",
              "It automatically wins"
            ],
            correctAnswer: 1
          }
        ]
      },
      'professional-sales-communication': {
        id: 'professional-sales-communication',
        title: 'Professional Sales Communication',
        modulenumber: '2.4.1',
        department: 'Sales',
        videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768916112/sale2_dg2ytg.mp4',
        duration: 90,
        description: 'First contact etiquette, discovery questioning, listening skills, documentation, site visits, and quotation presentation',
        requiredRoles: ['sales_manager', 'sales_representative', 'client_relations_officer', 'marketing-sales'],
        validityMinutes: 259200,
        quiz: [
          {
            id: 1,
            question: "The first WhatsApp message should be:",
            options: [
              "'Hi.'",
              "'Who is this?'",
              "Professional introduction & purpose",
              "Emoji only"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "Discovery questions help:",
            options: [
              "Waste time",
              "Understand client needs & qualify the project",
              "Avoid selling",
              "Confuse the client"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "Listening before selling turns you into:",
            options: [
              "A hustler",
              "A consultant who understands needs",
              "A noisy salesperson",
              "Someone guessing"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "Site visits must be:",
            options: [
              "Random",
              "Late",
              "Properly scheduled and confirmed",
              "Unnecessary"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "Quotations should be sent:",
            options: [
              "As unclear screenshots",
              "Without explanation",
              "As a clean, branded PDF with follow-up",
              "Without portfolio"
            ],
            correctAnswer: 2
          },
          {
            id: 6,
            question: "What is the first contact rule for WhatsApp?",
            options: [
              "Respond after 2 days",
              "Respond within 10–30 minutes and use professional introduction",
              "Never respond",
              "Only use emojis"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What questions help qualify a client?",
            options: [
              "No questions needed",
              "Purpose, timeline, drawings, quantity, location, budget",
              "Only ask about payment",
              "Ask personal questions"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "Why does listening matter most?",
            options: [
              "To interrupt faster",
              "Builds trust, avoids misunderstandings, elevates you to consultant",
              "To show you're busy",
              "To prepare your sales pitch"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "How should drawings be handled?",
            options: [
              "Screenshot and guess measurements",
              "Save clearly with client name + date, confirm measurements",
              "Ignore drawings",
              "Share without checking"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What must you confirm for site visits?",
            options: [
              "Nothing",
              "Date/time in writing, team names, arrive early",
              "Only the address",
              "Only after arriving"
            ],
            correctAnswer: 1
          }
        ]
      },
  'human-resource-management': {
    id: 'human-resource-management',
    title: 'Human Resource Management',
    modulenumber: '1.3.3',
    department: 'Management & Administration',
    videoUrl: '/videos/hro.mp4',
    duration: 100,
    description: 'Recruitment, hiring SOPs, interviewing skills, performance management, labor law compliance, and HR systems for effective workforce management',
    requiredRoles: ['manager', 'ceo'],
    validityMinutes: 259200, // 6 months in minutes
    quiz: [
      {
        "id": 1,
        "question": "Successful recruitment focuses on:",
        "options": [
          "Hiring quickly",
          "Hiring friends",
          "Hiring based on skill + values alignment",
          "Avoiding interviews"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "What is the purpose of practical testing in interviews?",
        "options": [
          "To scare candidates",
          "To confirm if they can do what they claim",
          "To fill time",
          "To avoid paperwork"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "How long is probation at Kajja Galleries?",
        "options": [
          "1 week",
          "1 month",
          "3 months",
          "2 years"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Attendance discipline is important because:",
        "options": [
          "It punishes workers",
          "It protects productivity and deadlines",
          "It helps HR relax",
          "It is not important"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Why must performance reviews be done monthly?",
        "options": [
          "To stress employees",
          "To correct and improve early, not at year end",
          "To increase paperwork",
          "To reduce work"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "NSSF contributions are:",
        "options": [
          "5% employer + 10% employee",
          "Equal shares",
          "10% employer + 5% employee",
          "Optional"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "What should be the GM's principle when hiring?",
        "options": [
          "Hire for skill only, attitude doesn't matter",
          "Hire for attitude, train for skill",
          "Hire based on personal connections",
          "Hire the cheapest option available"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "What is the final step in recruitment before issuing a contract?",
        "options": [
          "Personal friendship check",
          "Passing probation policy",
          "Checking social media profiles",
          "Meeting family members"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "How should misconduct be handled according to Kajja's disciplinary procedures?",
        "options": [
          "Immediate termination without process",
          "Fair, documented, structured process: counseling → written warning → final warning → termination",
          "Ignored until it becomes serious",
          "Public shaming as punishment"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "What is the consequence of wrong hiring according to the module?",
        "options": [
          "No consequence",
          "Costly firing",
          "Extra training opportunities",
          "Lower team morale only"
        ],
        "correctAnswer": 1
      }
    ]
  },
  'sales-customer-finance-documents': {
    id: 'sales-customer-finance-documents',
    title: 'Sales & Customer Finance Documents',
    modulenumber: '3.2.4',
    department: 'Finance',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769163114/book5_sfvf5e.mp4',
    duration: 90,
    description: 'Customer receipts, quotation support, job card payment tracking, EFRIS invoicing, and tax recording.',
    requiredRoles: ['bookkeeper', 'accountant', 'finance_manager'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Customer receipts must be issued:",
        options: [
          "Only for large payments",
          "When convenient at week's end",
          "Immediately after payment received",
          "Monthly with statements"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Clear quotations help to:",
        options: [
          "Hide real costs from clients",
          "Reduce disputes and speed up approvals",
          "Make invoices more complicated",
          "Delay the production process"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Job card finance tracking ensures:",
        options: [
          "Production can proceed without payment",
          "Work progresses only according to paid milestones",
          "Clients get unlimited credit",
          "No need for receipts"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "EFRIS invoices are important because:",
        options: [
          "They replace all other documents",
          "They ensure compliance with URA regulations",
          "They are optional for small sales",
          "They allow manual adjustments later"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "VAT recorded by Kajja is:",
        options: [
          "Extra profit for the company",
          "A discount given to clients",
          "A tax liability owed to URA",
          "Personal income for staff"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "What must a Kajja quotation clearly contain?",
        options: [
          "Vague descriptions only",
          "Only total price with no breakdown",
          "Client name, detailed items, quantities, payment terms",
          "Secret profit margins hidden"
        ],
        correctAnswer: 2
      },
      {
        id: 7,
        question: "A golden rule is 'no production beyond':",
        options: [
          "Client request",
          "Paid milestone",
          "Manager's verbal order",
          "Material delivery"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Withholding Tax (WHT) certificates must be:",
        options: [
          "Ignored as they are for the client",
          "Filed and recorded properly",
          "Thrown away after payment",
          "Shared with all staff"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Client financial records should be:",
        options: [
          "Shared freely for transparency",
          "Kept confidential and secure",
          "Discarded after project ends",
          "Stored only on personal devices"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "The bookkeeper's role in quotations is to:",
        options: [
          "Create prices independently",
          "File approved quotes and ensure invoices match them",
          "Negotiate terms with clients",
          "Approve all quotations"
        ],
        correctAnswer: 1
      }
    ]
  },
  'documentation-information-management': {
    id: 'documentation-information-management',
    title: 'Documentation & Information Management',
    modulenumber: '4.2.5',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769683010/q6_ztk3ok.mp4',
    duration: 90,
    description: 'QC record management, form completion, file uploading, version control, confidentiality, and traceability procedures.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "QC records are important because they:",
        options: [
          "Waste valuable production time",
          "Provide clear evidence that inspections were completed",
          "Replace the need for actual production",
          "Decorate the office with colorful files"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Poor record management leads to:",
        options: [
          "Easy and fast retrieval of important files",
          "Better quality control outcomes",
          "Lost evidence, confusion, and repeated mistakes",
          "Faster completion of QC work"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "QC folder naming should be:",
        options: [
          "Random to avoid patterns",
          "Personalized to each inspector's style",
          "Clear, consistent, and follow company rules",
          "As short as possible without meaningful information"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "QC files should be stored:",
        options: [
          "On personal mobile phones for easy access",
          "In the company's designated job folders and CRM system",
          "Only on USB sticks carried by the QC officer",
          "In personal notebooks that stay with the inspector"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "QC forms must be:",
        options: [
          "Partly filled to save time",
          "Filled later when there is free time",
          "Based on guesses when unsure",
          "Fully completed, signed, and dated immediately"
        ],
        correctAnswer: 3
      },
      {
        id: 6,
        question: "Uploading QC records to CRM ensures:",
        options: [
          "Beautiful decoration of digital files",
          "Management visibility, backup, and team awareness",
          "File loss through technical problems",
          "Slower workflow due to extra steps"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "If a QC report is not uploaded to company systems:",
        options: [
          "It is still fully visible to management",
          "It can replace Job Cards in the workshop",
          "It is automatically approved for payment",
          "It cannot support proper decision-making"
        ],
        correctAnswer: 3
      },
      {
        id: 8,
        question: "Version control prevents:",
        options: [
          "Clean and organized digital folders",
          "Use of outdated inspection documents and standards",
          "Effective training of new staff",
          "Communication between departments"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Old versions of QC forms should be:",
        options: [
          "Deleted immediately to save space",
          "Used in current production to save paper",
          "Archived properly for future reference",
          "Shared externally with clients"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "QC reports should be shared externally:",
        options: [
          "Anytime someone asks for them",
          "Always with clients for transparency",
          "On social media for marketing",
          "Never without proper management approval"
        ],
        correctAnswer: 3
      }
    ]
  },
  'purchasing-supplier-records': {
    id: 'purchasing-supplier-records',
    title: 'Purchasing & Supplier Records',
    modulenumber: '3.2.5',
    department: 'Finance',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769164285/book6_hzk8e5.mp4',
    duration: 90,
    description: 'LPO preparation, invoice verification, goods received confirmation, expense tracking, and supplier reconciliation.',
    requiredRoles: ['bookkeeper', 'accountant', 'finance_manager'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "An LPO is used to:",
        options: [
          "Make immediate payment to a supplier",
          "Authorize a purchase from a supplier",
          "Replace the supplier's invoice",
          "Hide expense details from management"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Supplier invoices should be paid only after:",
        options: [
          "Verification against LPO and GRN, with approvals",
          "Verbal approval from any manager",
          "Supplier threatens to stop deliveries",
          "The bookkeeper assumes it's correct"
        ],
        correctAnswer: 0
      },
      {
        id: 3,
        question: "A GRN confirms that:",
        options: [
          "Payment has been processed",
          "Goods were received and quantities checked",
          "The price is the lowest available",
          "The supplier has been paid in full"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Expense categorization helps management to:",
        options: [
          "Delay budget approvals",
          "Confuse financial reports",
          "Control costs and analyze business performance",
          "Hide specific purchases"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Supplier reconciliation helps to:",
        options: [
          "Identify errors and prevent duplicate payments",
          "Intentionally overpay for future favors",
          "Increase the company's expenses",
          "Delay all payments as long as possible"
        ],
        correctAnswer: 0
      },
      {
        id: 6,
        question: "Why are LPOs mandatory at Kajja?",
        options: [
          "To slow down the purchasing process",
          "They are optional for small amounts",
          "To prevent unauthorized purchases and price manipulation",
          "To give suppliers more work"
        ],
        correctAnswer: 2
      },
      {
        id: 7,
        question: "Before recording an expense, the bookkeeper must ensure:",
        options: [
          "A GRN exists to confirm delivery",
          "The department head is happy",
          "The supplier is a friend",
          "The price seems reasonable"
        ],
        correctAnswer: 0
      },
      {
        id: 8,
        question: "The invoice verification checklist includes:",
        options: [
          "How urgently the supplier needs payment",
          "The color of the invoice",
          "The supplier's reputation",
          "Matching invoice to LPO and checking quantities"
        ],
        correctAnswer: 3
      },
      {
        id: 9,
        question: "A supplier statement shows:",
        options: [
          "The company's bank balance",
          "Invoices issued and payments received",
          "Only future orders",
          "Employee salaries"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What is the golden rule for payments?",
        options: [
          "Trust all known suppliers",
          "No LPO, no invoice, no payment",
          "Pay first, ask questions later",
          "Prioritize the loudest supplier"
        ],
        correctAnswer: 1
      }
    ]
  },
  'inventory-cost-control-support': {
    id: 'inventory-cost-control-support',
    title: 'Inventory & Cost Control Support',
    modulenumber: '3.2.6',
    department: 'Finance',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769165487/book7_osxo2o.mp4',
    duration: 90,
    description: 'Stock card tracking, BoM usage monitoring, waste documentation, and collaboration with storekeeping.',
    requiredRoles: ['bookkeeper', 'accountant', 'finance_manager', 'storekeeper'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "A stock card is used to:",
        options: [
          "Approve purchase orders",
          "Track materials received and materials used",
          "Make payments to material suppliers",
          "Hide material shortages from management"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "BoM tracking helps to:",
        options: [
          "Delay project timelines",
          "Increase material waste intentionally",
          "Compare planned vs actual material usage",
          "Create confusion in the workshop"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Material waste should be:",
        options: [
          "Hidden to avoid blame",
          "Estimated roughly at month end",
          "Ignored as part of normal operations",
          "Documented with reasons and supervisor sign-off"
        ],
        correctAnswer: 3
      },
      {
        id: 4,
        question: "When suspicious material usage is detected, the bookkeeper should:",
        options: [
          "Confront the workshop staff directly",
          "Adjust the records to hide the variance",
          "Document the evidence and escalate to Head of Finance",
          "Ignore it unless it happens again"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Inventory accuracy improves when:",
        options: [
          "The bookkeeper works completely independently",
          "The storekeeper estimates all stock levels",
          "Bookkeeper and storekeeper cooperate with clear roles",
          "Physical stock counts are avoided"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "What does a negative stock balance indicate?",
        options: [
          "Perfect inventory management",
          "A red flag that requires investigation",
          "That more materials have been ordered",
          "A system error that can be ignored"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What is the bookkeeper's role regarding the Bill of Materials (BoM)?",
        options: [
          "To create the BoM for each project",
          "To track actual usage and report variances",
          "To judge why waste occurred",
          "To order materials based on the BoM"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Undocumented waste can become:",
        options: [
          "A source of cost savings",
          "Theft or loss for the company",
          "An opportunity for staff bonuses",
          "A way to reduce paperwork"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "A key joint control between bookkeeper and storekeeper is:",
        options: [
          "Keeping separate, unshared records",
          "Regular physical stock counts",
          "Avoiding communication to maintain independence",
          "Letting the storekeeper handle all documentation"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What is a golden rule for inventory?",
        options: [
          "No issue note means stock can still be reduced",
          "No GRN means stock can still be increased",
          "No BoM comparison means waste is invisible",
          "Suspicious activity should be handled personally"
        ],
        correctAnswer: 2
      }
    ]
  },
  'leadership-production-culture': {
    id: 'leadership-production-culture',
    title: 'Leadership & Production Culture',
    modulenumber: '4.1.0',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769589178/prod1_jzxo8l.mp4',
    duration: 90,
    description: 'Production leadership fundamentals: ownership, brand protection, professional communication, and building a high-performance workshop culture.',
    requiredRoles: ['head_of_production', 'quality-control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "The Head of Production is primarily responsible for:",
        options: [
          "Managing the company's bank accounts",
          "Owning and controlling workshop operations and output",
          "Designing client marketing materials",
          "Selling products directly to customers"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Ownership in production leadership means:",
        options: [
          "Waiting for instructions from management",
          "Taking full responsibility for workshop results",
          "Avoiding difficult decisions",
          "Blaming workers for all problems"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Kajja's brand promise is:",
        options: [
          "Cheap, Fast, Popular",
          "Efficiency, Creativity, Trust",
          "Sales, Profit, Marketing",
          "Wood, Steel, and Fabric"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Protecting the brand in production means:",
        options: [
          "Ignoring minor quality issues",
          "Ensuring every product meets promised standards",
          "Rushing work to meet deadlines carelessly",
          "Allowing artisans to set their own quality standards"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Professional workshop communication should be:",
        options: [
          "Shouting instructions to be heard",
          "Clear, respectful, and direct",
          "Based on gossip and rumors",
          "Minimal and silent at all times"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Workplace discipline ensures:",
        options: [
          "Fear and intimidation in the workshop",
          "Order, punctuality, and accountability",
          "No room for creativity or innovation",
          "Slower but more careful production"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "A high-performing workshop culture is built through:",
        options: [
          "Ignoring small mistakes",
          "Clear standards, training, and teamwork",
          "Punishing everyone for one person's error",
          "Allowing flexible chaos for creativity"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "When mistakes happen, a production leader should:",
        options: [
          "Hide them to protect the team",
          "Learn from them, correct, and prevent recurrence",
          "Blame one person publicly",
          "Ignore them if they are small"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Authority of the Head of Production comes from:",
        options: [
          "Personal friendships with staff",
          "Responsibility and accountability for results",
          "Physical strength and intimidation",
          "Seniority and age alone"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Efficiency in production means:",
        options: [
          "Using time, labor, and materials wisely",
          "Working without any planning",
          "Buying excess materials 'just in case'",
          "Rushing through work carelessly"
        ],
        correctAnswer: 0
      },
      {
        id: 11,
        question: "Creativity in production refers to:",
        options: [
          "Decorating the workshop walls",
          "Solving production challenges intelligently",
          "Guessing measurements without drawings",
          "Ignoring design specifications"
        ],
        correctAnswer: 1
      },
      {
        id: 12,
        question: "Trust in production is built when:",
        options: [
          "Products fail only after delivery",
          "Clients receive quality work as promised",
          "Deadlines are frequently missed",
          "Materials are visibly wasted"
        ],
        correctAnswer: 1
      },
      {
        id: 13,
        question: "The Head of Production must coordinate with:",
        options: [
          "Only the workshop artisans",
          "Only senior management",
          "Design, Sales, Finance, and Installation teams",
          "Nobody; the workshop is independent"
        ],
        correctAnswer: 2
      },
      {
        id: 14,
        question: "A strong workshop culture discourages:",
        options: [
          "Teamwork and collaboration",
          "Disorder and carelessness",
          "Personal responsibility",
          "Reporting problems early"
        ],
        correctAnswer: 1
      },
      {
        id: 15,
        question: "The ultimate goal of production leadership at Kajja is:",
        options: [
          "Finishing work anyhow, no matter the quality",
          "Protecting brand reputation through quality and reliability",
          "Reducing labor wages to save costs",
          "Closing the workshop early each day"
        ],
        correctAnswer: 1
      }
    ]
  },
  'communication-through-media': {
    id: 'communication-through-media',
    title: 'Communication Through Media',
    modulenumber: '4.2.6',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769684254/q7_f6ouns.mp4',
    duration: 90,
    description: 'Video recording standards, photo documentation, functional defect demonstration, early reporting, and client privacy protection.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "QC videos are used to:",
        options: [
          "Decorate QC officers' mobile phones",
          "Clearly show defects and avoid misunderstandings",
          "Replace the need for physical inspection",
          "Entertain workshop staff during breaks"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Proper lighting in videos helps to:",
        options: [
          "Hide problems to avoid immediate action",
          "Show defects clearly for accurate assessment",
          "Save phone battery during recording",
          "Increase background noise for effect"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "QC videos must always mention:",
        options: [
          "The personal name of the worker involved",
          "The job code and location of the issue",
          "The brand of phone used for recording",
          "Only the time of day of the recording"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "A shaking or unstable video:",
        options: [
          "Looks professional and artistic",
          "Makes defects hard to see and understand",
          "Saves time during the recording process",
          "Improves the overall quality of evidence"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Good QC photos should include:",
        options: [
          "Random angles from multiple perspectives",
          "A wide context shot and a close-up detail shot",
          "Only wide shots to show the whole workshop",
          "Only zoomed shots without any context"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Functional issues like sticky drawers are best shown by:",
        options: [
          "Written reports with detailed descriptions",
          "Video demonstration of the problem in action",
          "Audio recording of the workshop sounds",
          "Guessing what might be wrong"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Reporting defects early prevents:",
        options: [
          "The need for extra lighting during inspection",
          "Clients discovering problems before Kajja does",
          "Regular machine maintenance schedules",
          "Staff training sessions from happening"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "QC must send issues and defects:",
        options: [
          "After the product has been delivered",
          "Immediately when they are detected",
          "Only at the end of the month in reports",
          "When the client first complains about them"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Client interiors and private spaces should:",
        options: [
          "Be posted online for marketing purposes",
          "Be kept confidential and protected",
          "Be shared freely with all staff members",
          "Be sent to friends and family as examples"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Recording people without their permission is:",
        options: [
          "Allowed if they are Kajja employees",
          "Not allowed and violates privacy rules",
          "Encouraged to document all activities",
          "Required for complete QC documentation"
        ],
        correctAnswer: 1
      }
    ]
  },
  'reporting-accountability': {
    id: 'reporting-accountability',
    title: 'Reporting & Accountability',
    modulenumber: '4.2.7',
    department: 'Quality Control',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769685579/q8_q2s9mz.mp4',
    duration: 90,
    description: 'Structured reporting to management and clients, escalation procedures, weekly QC KPIs, and improvement recognition.',
    requiredRoles: ['quality-control', 'head_quality_control', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Structured reporting helps management to:",
        options: [
          "Delay important decisions intentionally",
          "Hide problems from higher management",
          "Act quickly and correctly with clear information",
          "Ignore minor defects to save time"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "The correct QC report structure to management is:",
        options: [
          "Problem → Solution only, nothing else",
          "Evidence → Timeline → Blame assigned",
          "Problem → Evidence → Cause → Solution → Responsible Person → Timeline",
          "Cause → Punishment → Avoidance strategy"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Evidence in QC reporting should include:",
        options: [
          "Personal opinions and assumptions",
          "Rumors heard in the workshop",
          "Guesses about what might have happened",
          "Photos, videos, and completed QC forms"
        ],
        correctAnswer: 3
      },
      {
        id: 4,
        question: "Client communication must always use:",
        options: [
          "Angry tone to show seriousness",
          "Technical jargon to impress them",
          "Blame-focused language",
          "Polite, respectful, and professional tone"
        ],
        correctAnswer: 3
      },
      {
        id: 5,
        question: "When reporting a problem to a client, Kajja should:",
        options: [
          "Explain the technical problem first in detail",
          "Blame the workshop team openly",
          "Present the solution first, then brief explanation",
          "Avoid giving any reassurance about resolution"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "Serious issues such as safety risks must be:",
        options: [
          "Hidden to protect company reputation",
          "Solved by the QC officer alone",
          "Waited for the weekly meeting to discuss",
          "Escalated immediately through proper channels"
        ],
        correctAnswer: 3
      },
      {
        id: 7,
        question: "The escalation chain for serious issues starts with:",
        options: [
          "The Managing Director directly",
          "The client who reported the problem",
          "The QC Officer who identified the issue",
          "The installation team leader"
        ],
        correctAnswer: 2
      },
      {
        id: 8,
        question: "Weekly QC reports should track:",
        options: [
          "Worker salary calculations and payments",
          "Sales revenue and marketing metrics",
          "Defect trends, rework frequency, and improvement actions",
          "Brands and models of machines used"
        ],
        correctAnswer: 2
      },
      {
        id: 9,
        question: "A QC weekly report without an improvement plan is:",
        options: [
          "Complete and ready for approval",
          "Excellent as it saves management time",
          "Incomplete and missing a critical element",
          "Automatically approved by default"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "Recognizing improvements helps to:",
        options: [
          "Hide underlying problems better",
          "Reduce necessary communication",
          "Build a positive quality culture",
          "Punish workers indirectly"
        ],
        correctAnswer: 2
      }
    ]
  },
  'payroll-support': {
    id: 'payroll-support',
    title: 'Payroll Support',
    modulenumber: '3.2.7',
    department: 'Finance',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769166570/book8_vvjqb1.mp4',
    duration: 90,
    description: 'Attendance verification, overtime approval, staff loan tracking, tax compliance, and payroll confidentiality.',
    requiredRoles: ['bookkeeper', 'accountant', 'finance_manager', 'hr_manager'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Attendance sheets are important because they:",
        options: [
          "Are optional for senior staff",
          "Slow down the payroll process unnecessarily",
          "Determine correct wages and overtime pay",
          "Cause disputes between departments"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Overtime should be paid only when it is:",
        options: [
          "Claimed by the employee",
          "Pre-approved and properly documented",
          "A common practice in the workshop",
          "Demanded by staff under pressure"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Staff advances must be:",
        options: [
          "Given verbally based on trust",
          "Documented with written requests and approvals",
          "Unlimited for long-serving employees",
          "Ignored in the payroll records"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "PAYE and NSSF errors can cause:",
        options: [
          "Higher employee satisfaction",
          "Legal penalties and interest for the company",
          "Faster processing of future payroll",
          "Increased company profits"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Payroll confidentiality means:",
        options: [
          "Discussing salaries openly to ensure fairness",
          "Sharing payroll data via WhatsApp for convenience",
          "Protecting employee financial data from unauthorized access",
          "Posting salary lists for transparency"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "The bookkeeper should reject attendance sheets that are:",
        options: [
          "Signed daily by employees",
          "Complete and approved by supervisors",
          "Missing supervisor signatures or days",
          "Submitted on time every month"
        ],
        correctAnswer: 2
      },
      {
        id: 7,
        question: "What is a key risk control for staff loans?",
        options: [
          "Allowing verbal loan agreements",
          "Making multiple loans without clearing old ones",
          "No deductions without written employee consent",
          "Letting managers approve unlimited amounts"
        ],
        correctAnswer: 2
      },
      {
        id: 8,
        question: "What is part of the bookkeeper's payroll data role?",
        options: [
          "Setting employee salary levels",
          "Approving final payroll payments",
          "Compiling accurate figures and attaching documents",
          "Hiring and firing staff"
        ],
        correctAnswer: 2
      },
      {
        id: 9,
        question: "Employee financial data that must be confidential includes:",
        options: [
          "Public holiday schedules",
          "Office supply lists",
          "Salaries, loans, and tax records",
          "Company marketing plans"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "What is a golden rule for payroll support?",
        options: [
          "No attendance record still means pay can be estimated",
          "Overtime without approval is still payable",
          "No documentation means no loan should be recorded",
          "Payroll details can be discussed with colleagues"
        ],
        correctAnswer: 2
      }
    ]
  },
  'design-leadership-brand-culture': {
    id: 'design-leadership-brand-culture',
    title: 'Design Leadership & Brand Culture',
    modulenumber: '4.3.0',
    department: 'Design',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769759745/d1_xjqdk8.mp4',
    duration: 90,
    description: 'Design leadership principles, brand promise alignment, cross-department communication, and timeline management.',
    requiredRoles: ['head_of_design', 'designer', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "The Head of Design's primary role is to:",
        options: [
          "Handle marketing and sales activities exclusively",
          "Bridge creative vision with practical production reality",
          "Approve supplier payments and financial decisions",
          "Focus only on artistic aesthetics without constraints"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "A beautiful design that cannot be built is:",
        options: [
          "An innovative breakthrough to celebrate",
          "Acceptable if the client approves it",
          "A business risk and liability for the company",
          "A creative success regardless of practicality"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Kajja's brand promise includes:",
        options: [
          "Speed, Low Price, and High Volume production",
          "Sales Growth, Profit, and Market Share targets",
          "Efficiency, Creativity, and Trust in execution",
          "Wood, Steel, and Fabric material selection"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "Efficiency in design helps to:",
        options: [
          "Increase rework and production delays",
          "Slow down the design process intentionally",
          "Reduce delays, confusion, and revision cycles",
          "Increase client revisions and changes"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Creativity at Kajja should primarily:",
        options: [
          "Ignore production limits and constraints",
          "Increase material costs for better appearance",
          "Focus only on artistic expression",
          "Solve client problems intelligently within realistic limits"
        ],
        correctAnswer: 3
      },
      {
        id: 6,
        question: "Trust between design and client is broken when:",
        options: [
          "Design drawings are clear and detailed",
          "Production follows the design plans precisely",
          "The delivered product matches approved design exactly",
          "The final product differs from what was approved"
        ],
        correctAnswer: 3
      },
      {
        id: 7,
        question: "Communication with Sales should ensure:",
        options: [
          "Delays in sharing design information",
          "Silence to avoid potential conflicts",
          "Guesswork about client expectations",
          "Clear alignment on what was promised to the client"
        ],
        correctAnswer: 3
      },
      {
        id: 8,
        question: "Feedback from Production should be:",
        options: [
          "Ignored as irrelevant to design creativity",
          "Hidden from the design team members",
          "Avoided to maintain complete creative freedom",
          "Used to improve design practicality and buildability"
        ],
        correctAnswer: 3
      },
      {
        id: 9,
        question: "Communication with clients should be:",
        options: [
          "Full of technical jargon and complexity",
          "Defensive when questions or concerns arise",
          "Vague to allow flexibility later in the process",
          "Clear, professional, and honest about possibilities"
        ],
        correctAnswer: 3
      },
      {
        id: 10,
        question: "Poor design timeline management leads to:",
        options: [
          "Faster product delivery to clients",
          "Better design quality through more time",
          "No significant impact on the business",
          "Production delays and client frustration"
        ],
        correctAnswer: 3
      }
    ]
  },
  'reporting-review': {
    id: 'reporting-review',
    title: 'Reporting & Review',
    modulenumber: '3.2.8',
    department: 'Finance',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769167519/book9_oqhm5n.mp4',
    duration: 90,
    description: 'Weekly and monthly reporting, variance explanation, audit preparation, and continuous accuracy improvement.',
    requiredRoles: ['bookkeeper', 'accountant', 'finance_manager', 'ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Weekly finance reports help management to:",
        options: [
          "Confuse other departments",
          "Delay important supplier payments",
          "Plan cash flow and avoid surprises",
          "Guess the company's financial position"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Monthly expense reports should:",
        options: [
          "Hide certain costs to look good",
          "Show all expenses accurately and be grouped by category",
          "Be estimated when receipts are missing",
          "Only be prepared once per year"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Variance explanations should be:",
        options: [
          "Based on personal opinions",
          "Emotional to show concern",
          "Factual and supported by documents",
          "Ignored if the variance is small"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "Audit preparation requires:",
        options: [
          "Hiding incomplete records",
          "Organized, complete, and accessible records",
          "Guessing answers to auditor questions",
          "Delaying document requests"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Continuous improvement means:",
        options: [
          "Ignoring small mistakes",
          "Learning from errors and reducing them over time",
          "Working as slowly as possible",
          "Avoiding feedback from managers"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What should a weekly cash report include?",
        options: [
          "Only estimated figures",
          "Personal opinions on spending",
          "Petty cash balance and bank balances",
          "Future sales projections"
        ],
        correctAnswer: 2
      },
      {
        id: 7,
        question: "The bookkeeper's role in variance reporting is to:",
        options: [
          "Explain why management made certain decisions",
          "Provide factual data on what happened with documents",
          "Give opinions on whether spending was justified",
          "Hide variances to avoid questions"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "During an audit, the bookkeeper should:",
        options: [
          "Answer all questions, even complex ones beyond their role",
          "Provide requested records quickly and truthfully",
          "Delay providing documents to protect the company",
          "Guess answers if they are unsure"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "How can a bookkeeper improve accuracy?",
        options: [
          "By never asking questions",
          "By reviewing errors and improving filing discipline",
          "By working faster to finish early",
          "By hiding mistakes from the Head of Finance"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "A golden rule for reporting is:",
        options: [
          "Estimate when you're unsure",
          "Explain variances with opinions",
          "Report regularly and factually",
          "Prepare reports only when asked"
        ],
        correctAnswer: 2
      }
    ]
  },
  'complaints-loyalty': {
    id: 'complaints-loyalty',
    title: 'Complaints & Loyalty',
    modulenumber: '2.4.6',
    department: 'Sales',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1768992035/sale7_o8wxoy.mp4',
    duration: 85,
    description: 'Issue management, apology protocols, feedback collection, referral strategies, and repeat business development',
    requiredRoles: ['sales_manager', 'sales_representative', 'client_relations_officer','marketing-sales'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "When issues occur, the first step is:",
        options: [
          "Panic",
          "Stay calm, listen & report it",
          "Argue back",
          "Hide the problem"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Apology protocol:",
        options: [
          "Blame workshop",
          "Fix first, explain later",
          "Talk too much",
          "Ignore it"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Feedback after handover helps:",
        options: [
          "Nothing",
          "Improve future service & build testimonials",
          "Hurt the company",
          "Waste time"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Asking for referrals should be:",
        options: [
          "Aggressive",
          "Respectful and well-timed",
          "Never",
          "Done only by GM"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Repeat business strategy:",
        options: [
          "Only contact clients when desperate",
          "Consistent value-based check-ins",
          "Forget clients after delivery",
          "Disappear forever"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is the golden rule for problems?",
        options: [
          "Ignore them",
          "Report early. Fix immediately. Learn forever.",
          "Blame the client",
          "Make excuses"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What must you never do when problems occur?",
        options: [
          "Listen carefully",
          "Blame workshop or coworkers publicly",
          "Take notes",
          "Inform management"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "When should you ask for feedback?",
        options: [
          "Never ask",
          "After installation, ask for honest rating and improvement points",
          "During production",
          "Before signing contract"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What is the best referral request script?",
        options: [
          "Give us referrals or else",
          "'If you know another business planning furniture, we’d be grateful for introduction'",
          "Never ask",
          "Demand immediately"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "How often should you check in after delivery?",
        options: [
          "Never",
          "30 days check-in, quarterly updates, yearly upgrade ideas",
          "Only after 5 years",
          "Only when client complains"
        ],
        correctAnswer: 1
      }
    ]
  },
    'operations-production-management': {
      id: 'operations-production-management',
      title: 'Operations & Production Management',
      modulenumber: '1.6',
      department: 'Operations Department',
      videoUrl: '/videos/operationsmanagement.mp4',
      duration: 110,
      description: 'Project lifecycle management, daily operations planning, job card systems, lean production principles, inventory control, and workshop safety standards',
      requiredRoles: ['ceo', 'manager','quality-control' ,'production-staff'],
      validityMinutes: 259200, // 6 months in minutes
      quiz: [
        {
          "id": 1,
          "question": "What is the purpose of the job card system?",
          "options": [
            "To make production look busy",
            "To track tasks and ensure accountability and accuracy",
            "To decorate the workshop walls",
            "To reduce teamwork"
          ],
          "correctAnswer": 1
        },
        {
          "id": 2,
          "question": "Which department must approve designs before production?",
          "options": [
            "HR",
            "Design + GM sign-off",
            "Client only",
            "Installation team"
          ],
          "correctAnswer": 1
        },
        {
          "id": 3,
          "question": "Why must installation include a sign-off form?",
          "options": [
            "To force the client to leave",
            "To confirm client satisfaction and protect the company",
            "To increase paperwork",
            "Because clients like signatures"
          ],
          "correctAnswer": 1
        },
        {
          "id": 4,
          "question": "Which Lean principle focuses on cleaning and inspection?",
          "options": [
            "Sort",
            "Shine",
            "Sustain",
            "Set in order"
          ],
          "correctAnswer": 1
        },
        {
          "id": 5,
          "question": "Why must tools be well-maintained?",
          "options": [
            "To keep employees entertained",
            "Because damaged tools cause safety risks and poor-quality products",
            "So tools never get old",
            "So GM can show off new tools"
          ],
          "correctAnswer": 1
        },
        {
          "id": 6,
          "question": "When can production begin?",
          "options": [
            "When workers are ready",
            "When materials and job card are approved",
            "When the client visits",
            "Anytime"
          ],
          "correctAnswer": 1
        },
        {
          "id": 7,
          "question": "What must every stage of the project lifecycle leave?",
          "options": [
            "A verbal agreement",
            "A document trail",
            "A personal note to the GM",
            "No record needed"
          ],
          "correctAnswer": 1
        },
        {
          "id": 8,
          "question": "What should the GM know about daily operations?",
          "options": [
            "Only the total production cost",
            "What is being done, who is doing it, how long it should take, and what tools/materials are required",
            "Only client names",
            "Only the profit margin"
          ],
          "correctAnswer": 1
        },
        {
          "id": 9,
          "question": "What is the consequence if production stops due to material failure?",
          "options": [
            "No consequence",
            "Production must never stop due to material failure",
            "Blame the store manager",
            "Delay all other projects"
          ],
          "correctAnswer": 1
        },
        {
          "id": 10,
          "question": "How quickly should installation issues be fixed?",
          "options": [
            "Within 7 days",
            "Within 72 hours",
            "When convenient",
            "During next maintenance visit"
          ],
          "correctAnswer": 1
        }
      ]
    },
      'hr-foundations-company-culture': {
        id: 'hr-foundations-company-culture',
        title: 'HR Foundations & Company Culture',
        modulenumber: '1.4.1',
        department: 'Human Resources',
        videoUrl: '/videos/hrculture.mp4',
        duration: 90,
        description: 'Strategic HR role, culture guardianship, values enforcement, professional communication, and HR brand representation',
        requiredRoles: ['hr-admin', 'ceo', 'manager', 'office-staff'],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            "id": 1,
            "question": "HR's primary purpose at Kajja Galleries is:",
            "options": [
              "Police employees",
              "Ensure the right people perform the right roles in the right way",
              "Keep archives",
              "Approve leave only"
            ],
            "correctAnswer": 1
          },
          {
            "id": 2,
            "question": "Which value requires zero tolerance for dishonesty?",
            "options": [
              "Creativity",
              "Integrity",
              "Teamwork",
              "Confidence"
            ],
            "correctAnswer": 1
          },
          {
            "id": 3,
            "question": "HR communication must be:",
            "options": [
              "Emotional and flexible",
              "Clear, respectful, confidential, and documented",
              "Verbal always",
              "Aggressive when needed"
            ],
            "correctAnswer": 1
          },
          {
            "id": 4,
            "question": "What shows company culture most clearly?",
            "options": [
              "Posters on walls",
              "What HR and management reward or punish consistently",
              "Written mission statement only",
              "Free lunches"
            ],
            "correctAnswer": 1
          },
          {
            "id": 5,
            "question": "Why must HR be professional always?",
            "options": [
              "To look important",
              "HR's behavior sets the standard for the entire company",
              "Because employees fear HR",
              "To please clients"
            ],
            "correctAnswer": 1
          },
          {
            "id": 6,
            "question": "What is HR described as at Kajja Galleries?",
            "options": [
              "Only a file keeping department",
              "The guardian of culture, people quality, and compliance",
              "The personal assistant to the GM",
              "The company police force"
            ],
            "correctAnswer": 1
          },
          {
            "id": 7,
            "question": "According to Kajja's culture statement, what do we reward?",
            "options": [
              "Laziness and shortcuts",
              "Accountability, professionalism, and continuous improvement",
              "Gossip and complaining",
              "Working in isolation"
            ],
            "correctAnswer": 1
          },
          {
            "id": 8,
            "question": "What is one of the zero tolerance behaviors at Kajja?",
            "options": [
              "Innovation and creativity",
              "Stealing time or materials",
              "Team collaboration",
              "Following SOPs"
            ],
            "correctAnswer": 1
          },
          {
            "id": 9,
            "question": "What happens when HR behaves well according to the module?",
            "options": [
              "Employees ignore HR",
              "Employees follow the example",
              "Culture collapses",
              "Production slows down"
            ],
            "correctAnswer": 1
          },
          {
            "id": 10,
            "question": "What is HR's mission regarding talent?",
            "options": [
              "To make hiring as slow as possible",
              "To ensure Kajja always has the right people, doing the right work, in the right way, with the right attitude",
              "To reduce employee benefits",
              "To handle only disciplinary actions"
            ],
            "correctAnswer": 1
          }
        ]
      }, 
        'recruitment-selection-excellence': {
          id: 'recruitment-selection-excellence',
          title: 'Recruitment & Selection Excellence',
          modulenumber: '1.4.2',
          department: 'Human Resources',
          videoUrl: '/videos/recruitment.mp4',
          duration: 95,
          description: 'Structured hiring SOPs, job descriptions, candidate sourcing, interviewing techniques, practical testing, and competency-based selection',
          requiredRoles: ['hr-admin', 'ceo', 'manager', 'office-staff'],
          validityMinutes: 259200, // 6 months in minutes
          quiz: [
            {
              "id": 1,
              "question": "Why must we test technical skills?",
              "options": [
                "To scare candidates",
                "To verify they can do what they claim",
                "To waste time",
                "It is optional"
              ],
              "correctAnswer": 1
            },
            {
              "id": 2,
              "question": "Which factor matters most when selecting a candidate?",
              "options": [
                "Personal liking",
                "Highest score on evaluation criteria",
                "Their jokes during interview",
                "Who they know"
              ],
              "correctAnswer": 1
            },
            {
              "id": 3,
              "question": "A good Job Description must include:",
              "options": [
                "Only the job title",
                "Clear responsibilities, KPIs, and skills needed",
                "A long story about the company",
                "Favorite food of the manager"
              ],
              "correctAnswer": 1
            },
            {
              "id": 4,
              "question": "When should reference checks be done?",
              "options": [
                "Only after confirming hire",
                "Before the final offer is made",
                "It is unnecessary",
                "Only for interns"
              ],
              "correctAnswer": 1
            },
            {
              "id": 5,
              "question": "A talent pool helps HR to:",
              "options": [
                "Store CVs that are useless",
                "Quickly hire when opportunities rise",
                "Show off many applications",
                "Increase paperwork"
              ],
              "correctAnswer": 1
            },
            {
              "id": 6,
              "question": "What is the golden rule in Kajja's hiring process?",
              "options": [
                "Hire only friends and family",
                "No hiring without scoring + testing + references",
                "Hire based on first impressions only",
                "Hire the cheapest candidate"
              ],
              "correctAnswer": 1
            },
            {
              "id": 7,
              "question": "What should HR do during candidate sourcing?",
              "options": [
                "Wait for candidates to come to us",
                "Maintain a Talent Pool File and collect CVs even when not hiring",
                "Only use one recruitment channel",
                "Ignore staff referrals"
              ],
              "correctAnswer": 1
            },
            {
              "id": 8,
              "question": "Why are practical tests important for artisans and designers?",
              "options": [
                "To waste their time",
                "Words lie — hands don't",
                "To make the process longer",
                "To impress other candidates"
              ],
              "correctAnswer": 1
            },
            {
              "id": 9,
              "question": "What is the consequence of a single wrong hire?",
              "options": [
                "No consequence at all",
                "Can damage culture, increase mistakes, cause client complaints",
                "Only affects HR department",
                "Improves team dynamics"
              ],
              "correctAnswer": 1
            },
            {
              "id": 10,
              "question": "What is the HR Manager success principle regarding hiring?",
              "options": [
                "Hire fast, fire slow",
                "Hire slowly → Fire fast (if integrity issues appear)",
                "Never fire anyone",
                "Hire based on emotional connection"
              ],
              "correctAnswer": 1
            }
          ]
        },
          'onboarding-employee-experience': {
            id: 'onboarding-employee-experience',
            title: 'Onboarding & Employee Experience',
            modulenumber: '1.4.3',
            department: 'Human Resources',
            videoUrl: '/videos/onboarding.mp4',
            duration: 85,
            description: 'Structured onboarding processes, documentation management, probation tracking, cultural integration, and professional behavior standards',
            requiredRoles: ['hr-admin', 'ceo', 'manager', 'office-staff'],
            validityMinutes: 259200, // 6 months in minutes
            "quiz": [
              {
                "id": 1,
                "question": "Why is onboarding critical?",
                "options": [
                  "To entertain new staff",
                  "It increases retention and reduces early mistakes",
                  "To fill the day",
                  "To train HR"
                ],
                "correctAnswer": 1
              },
              {
                "id": 2,
                "question": "What must be provided before an employee starts?",
                "options": [
                  "Verbal agreement only",
                  "Signed contract + Job Description + basic records",
                  "Gifts and free lunch",
                  "Only uniform"
                ],
                "correctAnswer": 1
              },
              {
                "id": 3,
                "question": "Who leads probation monitoring for new employees?",
                "options": [
                  "The employee alone",
                  "Supervisor + HR support",
                  "The client",
                  "Nobody"
                ],
                "correctAnswer": 1
              },
              {
                "id": 4,
                "question": "Why is professional behavior on-site important?",
                "options": [
                  "Clients judge the company by what they see",
                  "Workers must be quiet always",
                  "Clients don't care about behavior",
                  "HR says so"
                ],
                "correctAnswer": 0
              },
              {
                "id": 5,
                "question": "Why should HR do weekly check-ins with new hires?",
                "options": [
                  "To look busy",
                  "To detect challenges early and improve experience",
                  "Supervisor cannot handle everything",
                  "To write more reports"
                ],
                "correctAnswer": 1
              },
              {
                "id": 6,
                "question": "What prevents a great onboarding process?",
                "options": [
                  "Confusion, low morale, early mistakes, wasted training effort, early resignations",
                  "Too much paperwork",
                  "High salaries",
                  "Short working hours"
                ],
                "correctAnswer": 0
              },
              {
                "id": 7,
                "question": "How long is the probation period at Kajja?",
                "options": [
                  "1 month",
                  "3 months",
                  "6 months",
                  "1 year"
                ],
                "correctAnswer": 1
              },
              {
                "id": 8,
                "question": "What should happen if an employee is a toxic fit during probation?",
                "options": [
                  "Promote them quickly",
                  "A toxic employee must never pass probation",
                  "Give them extra training",
                  "Ignore the behavior"
                ],
                "correctAnswer": 1
              },
              {
                "id": 9,
                "question": "What should be on a Day 1 orientation checklist?",
                "options": [
                  "Only salary discussion",
                  "Company history, mission, values, organizational structure, HR policies, safety rules",
                  "Only a tour of the office",
                  "Only introduction to teammates"
                ],
                "correctAnswer": 1
              },
              {
                "id": 10,
                "question": "What protects the company in case of misconduct or work injury?",
                "options": [
                  "HR's memory",
                  "Complete employee documentation (contracts, records, files)",
                  "Verbal agreements",
                  "Employee promises"
                ],
                "correctAnswer": 1
              }
            ]
          },
        
  'general-manager': {
    id: 'general-manager',
    title: 'General Manager',
    department: 'Management & Administration',
    videoUrl: '/videos/generalmanager.mp4',
    modulenumber: '1.3.9',
    duration: 120,
    description: 'Leadership, management skills, and operational excellence for General Managers',
    requiredRoles: ['ceo', 'hr-admin', 'manager','quality-control', 'office-staff','manager'],
    validityMinutes:259200,
    quiz: [
      {
        id: 1,
        question: "What is the GM's primary role?",
        options: [
          "Supervise only",
          "Execute the vision & mission daily",
          "Approve purchases",
          "Solve disputes only"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "What does a high-performance culture mean?",
        options: [
          "Work late always",
          "Collaboration, standards, improvement",
          "Only skilled workers matter",
          "Employees guess tasks"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Which value means 'doing right unseen'?",
        options: [
          "Innovation",
          "Integrity",
          "Customer focus",
          "Excellence"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "What leadership style is appropriate for an urgent dangerous task?",
        options: [
          "Delegative",
          "Coaching",
          "Supportive",
          "Directive"
        ],
        correctAnswer: 3
      },
      {
        id: 5,
        question: "How is trust with clients built?",
        options: [
          "Promising too much",
          "Clear updates + fast correction",
          "Casual communication",
          "Allow delays silently"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What does emotional intelligence mean?",
        options: [
          "Ignoring feelings",
          "Managing your emotions professionally",
          "Emotion-led decisions",
          "Avoiding tough talks"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What is the first step in conflict resolution?",
        options: [
          "Write warning",
          "Dismiss",
          "Private listening discussion",
          "Escalate to MD"
        ],
        correctAnswer: 2
      },
      {
        id: 8,
        question: "What should you do when a fast decision is needed?",
        options: [
          "Guess",
          "Ask MD only",
          "Use available data and consult",
          "Let workers decide"
        ],
        correctAnswer: 2
      },
      {
        id: 9,
        question: "What does accountability mean?",
        options: [
          "Blame others",
          "Delegate & forget",
          "Follow up to completion",
          "Avoid mistakes responsibility"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "What should you do when a mistake is found?",
        options: [
          "Hide it",
          "Blame team",
          "Correct & communicate",
          "Wait for complaint"
        ],
        correctAnswer: 2
      },
      {
        id: 11,
        question: "Which behavior is unacceptable for a General Manager?",
        options: [
          "Fair rules",
          "Coaching",
          "Shortcuts on client property",
          "Leading by example"
        ],
        correctAnswer: 2
      },
      {
        id: 12,
        question: "What does situational leadership mean?",
        options: [
          "Same style always",
          "Only hire skilled staff",
          "Adjust style to skill & urgency",
          "Employees decide everything"
        ],
        correctAnswer: 2
      },
      {
        id: 13,
        question: "Why are clean workspaces important?",
        options: [
          "GM appearance",
          "Safety, efficiency, reputation",
          "Reduce work effort",
          "Avoid buying cleaning gear"
        ],
        correctAnswer: 1
      },
      {
        id: 14,
        question: "How can conflicts be prevented?",
        options: [
          "Ignoring issues",
          "Letting employees fight it out",
          "Fair rules + early intervention",
          "Supervisors apply personal rules"
        ],
        correctAnswer: 2
      },
      {
        id: 15,
        question: "Why is documentation important?",
        options: [
          "For fear",
          "If not written → It didn't happen",
          "More papers",
          "Avoid communication"
        ],
        correctAnswer: 1
      }
    ]
  },
  'digital-tools-admin-systems': {
    id: 'digital-tools-admin-systems',
    title: 'Digital Tools & Admin Systems',
    department: 'Management & Administration',
    videoUrl: '/videos/digital.mp4',
    duration: 90,
    modulenumber: '1.3.6',
    description: 'Digital discipline, CRM usage, project management, and data security for effective management',
    requiredRoles: ['ceo', 'hr-admin', 'manager', 'quality-control'],
    validityMinutes:259200,
    quiz: [
      {
        id: 1,
        question: "What three qualities must a General Manager demonstrate in digital discipline?",
        options: [
          "Digitally organised, paper-backed, and data-driven",
          "Technically skilled, fast-typing, and always online",
          "Social media savvy, app-friendly, and cloud-based",
          "Hardware expert, software developer, and network administrator"
        ],
        correctAnswer: 0
      },
      {
        id: 2,
        question: "What negative outcomes can technology errors cause?",
        options: [
          "Increased paper usage only",
          "Longer meetings and more coffee breaks",
          "Miscommunication, delays, unhappy clients, and financial loss",
          "Slower internet speeds and software updates"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "What is the key principle regarding information in the CRM system?",
        options: [
          "If it's important, keep it in your head",
          "If it is not in the CRM, it does not exist",
          "Only major clients need CRM entries",
          "Update CRM once a month is sufficient"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "What must be recorded in the CRM according to the training?",
        options: [
          "Only client payments and invoices",
          "Only major project milestones",
          "Every inquiry, site visit, quotation, approval, update, and promise",
          "Only negative client feedback"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "What must the GM do with weekly CRM and sales reports?",
        options: [
          "Keep them private for personal reference",
          "Share them with the Managing Director",
          "Archive them after one week",
          "Print and file them in physical cabinets"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What must the GM always know from the project management dashboard?",
        options: [
          "Only the project budget",
          "Only team member vacation schedules",
          "What is late, why, and how it will be fixed",
          "Only the client's personal preferences"
        ],
        correctAnswer: 2
      },
      {
        id: 7,
        question: "What must be cross-checked using the project management dashboard?",
        options: [
          "Only employee attendance records",
          "Job cards, plans, and CRM data",
          "Only supplier delivery schedules",
          "Only marketing campaign results"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What are the email standards mentioned in the training?",
        options: [
          "Emails must be casual and friendly",
          "Emails must be answered within one week",
          "Emails must be professional and answered within four hours",
          "Emails should be avoided in favor of phone calls"
        ],
        correctAnswer: 2
      },
      {
        id: 9,
        question: "What is a critical rule for data security?",
        options: [
          "Use personal accounts for convenience",
          "Share information freely with all team members",
          "Never use personal accounts and never share without approval",
          "Store all data on personal devices for backup"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "What can one data leak potentially cause according to the training?",
        options: [
          "Temporary inconvenience only",
          "Damage to the brand forever",
          "Small financial penalty",
          "Short-term client dissatisfaction"
        ],
        correctAnswer: 1
      }
    ]
  },
  'organizational-structure-systems': {
    id: 'organizational-structure-systems',
    title: 'Organizational Structure & Systems',
    department: 'Management & Administration',
    videoUrl: '/videos/structure.mp4',
    duration: 100,
    modulenumber: '1.3.2',
    description: 'Understanding organizational hierarchy, SOPs, document control, and reporting systems for effective management',
    requiredRoles: ['ceo', 'hr-admin','quality-control', 'manager'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Where does the General Manager sit in the organizational structure?",
        options: [
          "Below all operational departments",
          "Above the Managing Director",
          "Between the MD and all operational departments",
          "At the same level as department heads"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "What is the correct hierarchy flow according to the organogram?",
        options: [
          "Board → GM → MD → Departments",
          "MD → Board → GM → Departments",
          "Board → MD → GM → Production, Design, Sales, etc.",
          "Departments → GM → MD → Board"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "When may staff bypass supervisors in communication?",
        options: [
          "When they want faster responses",
          "Only safety or ethical issues",
          "For all technical questions",
          "When supervisors are on vacation"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "What is the primary purpose of Standard Operating Procedures (SOPs)?",
        options: [
          "To create more paperwork",
          "To make work predictable and consistent",
          "To limit employee creativity",
          "To satisfy audit requirements only"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "How often should SOPs be reviewed and updated?",
        options: [
          "Annually",
          "Only when problems occur",
          "Quarterly",
          "Every 5 years"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "What is the 'one source of truth' principle in document control?",
        options: [
          "Everyone can have their own version",
          "Use the latest drawings only",
          "Keep multiple versions for backup",
          "Use whichever version is most convenient"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What is the correct document naming format?",
        options: [
          "Project_Name_V01_Date_ApprovedBy",
          "Document1_final_final2",
          "Project_rough_draft",
          "File_new_version"
        ],
        correctAnswer: 0
      },
      {
        id: 8,
        question: "When can design or material changes be made?",
        options: [
          "Whenever the team thinks it's better",
          "Without sign-off if urgent",
          "No design/material change without sign-off",
          "Only with verbal approval"
        ],
        correctAnswer: 2
      },
      {
        id: 9,
        question: "What is included in daily reports?",
        options: [
          "Only financial transactions",
          "Work progress, attendance, installation updates with photos",
          "Only employee complaints",
          "Monthly sales projections"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What must the GM compile for the MD on a weekly basis?",
        options: [
          "Daily attendance sheets",
          "Quarterly financial forecasts",
          "Weekly Digest",
          "Annual performance reviews"
        ],
        correctAnswer: 2
      },
      {
        id: 11,
        question: "What is the purpose of the knowledge management system?",
        options: [
          "To store old files for archive",
          "So new staff learn from documents, not memory",
          "To reduce training costs",
          "To track employee working hours"
        ],
        correctAnswer: 1
      },
      {
        id: 12,
        question: "What does the GM present to the MD/Board monthly?",
        options: [
          "Only financial statements",
          "Daily work logs",
          "Finance statement, HR report, departmental KPIs, lessons learned",
          "Only production updates"
        ],
        correctAnswer: 2
      },
      {
        id: 13,
        question: "What are key SOP areas mentioned in the training?",
        options: [
          "Only production and design",
          "Design, Production, QC, Finance, Sales, Installation",
          "Only finance and HR",
          "Only quality control"
        ],
        correctAnswer: 1
      },
      {
        id: 14,
        question: "What is the first execution principle mentioned?",
        options: [
          "Wing it and adapt",
          "Document everything",
          "Keep it flexible",
          "Trust memory over systems"
        ],
        correctAnswer: 1
      },
      {
        id: 15,
        question: "What is the relationship between systems and performance?",
        options: [
          "Systems limit performance",
          "Systems first → performance follows",
          "Performance comes before systems",
          "Systems are irrelevant to performance"
        ],
        correctAnswer: 1
      }
    ]
  },
  'client-centered-needs-analysis': {
    id: 'client-centered-needs-analysis',
    title: 'Client-Centered Needs Analysis',
    modulenumber: '4.3.1',
    department: 'Design',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769761312/d2_dk4e83.mp4',
    duration: 90,
    description: 'B2B client understanding, needs translation, discovery questioning, approval control, presentation skills, and scope protection.',
    requiredRoles: ['head_of_design', 'designer', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Kajja's main client focus is on:",
        options: [
          "Residential homeowners and private individuals",
          "Casual walk-in customers without appointments",
          "B2B institutional and commercial clients",
          "Furniture dealers who resell to others"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "B2B clients typically prioritize:",
        options: [
          "Decoration and visual trends above all",
          "Lowest possible price regardless of quality",
          "Durability, functionality, and delivery timelines",
          "Artistic expression over practical use"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Translating client needs means:",
        options: [
          "Copying popular designs from social media",
          "Ignoring budget constraints for better aesthetics",
          "Turning vague ideas into buildable, practical solutions",
          "Guessing dimensions without proper measurements"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "Functional questions focus on:",
        options: [
          "Client's favorite colors and finishes",
          "Corporate logos and branding elements",
          "How the furniture will be used daily",
          "Marketing strategies for the space"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Technical questions should address:",
        options: [
          "The client's personal design preferences",
          "Available space, power access, and installation routes",
          "Social media trends in furniture design",
          "Competitor pricing in the market"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Aesthetic questions help to:",
        options: [
          "Increase rework and revision cycles",
          "Align designs with client brand image",
          "Delay the approval process intentionally",
          "Avoid direct communication with clients"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Formal approvals are required to:",
        options: [
          "Slow down production unnecessarily",
          "Prevent disputes and control scope creep",
          "Increase confusion between departments",
          "Avoid taking clear responsibility"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Verbal approvals are considered:",
        options: [
          "Sufficient and legally binding",
          "Risky, unacceptable, and not valid",
          "Preferred for faster decision-making",
          "The fastest way to proceed"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Design presentations should be:",
        options: [
          "Crowded with technical details and jargon",
          "Artistic expressions without practical context",
          "Clean, clear, and logically structured",
          "Verbal discussions without visual aids"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "Storytelling in design helps clients:",
        options: [
          "Get confused about the solution",
          "Focus only on the price and cost",
          "Understand the solution clearly and logically",
          "Skip the approval process entirely"
        ],
        correctAnswer: 2
      }
    ]
  },
  'design-for-manufacturability': {
    id: 'design-for-manufacturability',
    title: 'Design for Manufacturability (DFM)',
    modulenumber: '4.3.2',
    department: 'Design',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769763862/d3_b2gwr2.mp4',
    duration: 90,
    description: 'CNC nesting optimization, standard material usage, waste reduction, modular design, and production-ready technical drawings.',
    requiredRoles: ['head_of_design', 'designer', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Design for Manufacturability (DFM) means:",
        options: [
          "Designing only for visual appeal and aesthetics",
          "Ignoring production constraints for creativity",
          "Designing for efficient, repeatable production",
          "Designing exclusively for client preferences"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "CNC nesting primarily aims to:",
        options: [
          "Increase material waste intentionally",
          "Slow down the cutting process for accuracy",
          "Maximize board usage and reduce material waste",
          "Complicate panel layouts for variety"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Poor nesting is usually caused by:",
        options: [
          "CNC machine technical failures",
          "Skilled operator mistakes",
          "Poor design decisions and random dimensions",
          "High-quality detailed drawings"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "Using standard board sizes helps to:",
        options: [
          "Limit creativity and design options",
          "Increase confusion in the workshop",
          "Control material waste and production costs",
          "Reduce drawing accuracy and precision"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Edge band specifications must clearly include:",
        options: [
          "Only the supplier's brand name",
          "Price and cost information only",
          "Thickness, color, and which edges to cover",
          "Only the client's preferred color name"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "Using non-standard hardware typically:",
        options: [
          "Reduces overall project costs",
          "Improves production efficiency",
          "Increases risk, delays, and costs",
          "Has no noticeable impact on timelines"
        ],
        correctAnswer: 2
      },
      {
        id: 7,
        question: "Design waste increases when:",
        options: [
          "Panel sizes are standardized",
          "Too many unique dimensions are used",
          "Modules are repeated across projects",
          "Realistic tolerances are allowed"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Smart design reduces rework by:",
        options: [
          "Ignoring machine and production limits",
          "Adding complexity to impress clients",
          "Guessing dimensions when unsure",
          "Simplifying assembly and allowing realistic tolerances"
        ],
        correctAnswer: 3
      },
      {
        id: 9,
        question: "Standard modules are beneficial because they:",
        options: [
          "Reduce production scalability",
          "Increase speed, consistency, and reduce errors",
          "Limit what can be produced",
          "Increase manufacturing complexity"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Deviations from standard modules should be:",
        options: [
          "Allowed freely without documentation",
          "Ignored during production planning",
          "Hidden from management review",
          "Properly justified and formally approved"
        ],
        correctAnswer: 3
      }
    ]
  },
  'design-software-documentation': {
    id: 'design-software-documentation',
    title: 'Design Software & Documentation',
    modulenumber: '4.3.3',
    department: 'Design',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769766468/d4_lvwxdt.mp4',
    duration: 90,
    description: 'Master design software, 3D visualization for clients, export correct manufacturing files, and enforce strict file naming and version control.',
    requiredRoles: ['head_of_design', 'designer'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "According to the theme, a design file is:",
        options: [
          "Artwork for client presentation",
          "A production instruction, not art",
          "A creative concept draft",
          "A marketing tool only"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "At Kajja, wrong files mean:",
        options: [
          "Design team retraining",
          "Wrong production",
          "Client discount",
          "Longer timeline"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Software mastery includes:",
        options: [
          "Only 3D rendering skills",
          "Layers, views, layouts, dimensioning, annotation",
          "Basic drawing only",
          "Ignoring standards"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Why is 3D needed for clients?",
        options: [
          "To replace all drawings",
          "Clients struggle with drawings",
          "It's cheaper than 2D",
          "It's legally required"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "3D models must:",
        options: [
          "Be more artistic than 2D",
          "Match 2D exactly",
          "Ignore dimensions",
          "Focus only on beauty"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What is more important than beauty?",
        options: [
          "Client color choices",
          "Accuracy",
          "Render speed",
          "Artistic freedom"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Never show in renders:",
        options: [
          "Realistic materials",
          "Unmakeable details",
          "Accurate dimensions",
          "Proper lighting"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Production needs exports for:",
        options: [
          "Client presentations",
          "CNC, nesting, BOM",
          "Marketing materials",
          "Budget plans"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Wrong exports cause:",
        options: [
          "Faster production",
          "Wrong panels, machine errors, waste",
          "Better creativity",
          "Lower costs"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "The latest approved file is:",
        options: [
          "A suggestion",
          "The law",
          "Optional",
          "A draft"
        ],
        correctAnswer: 1
      }
    ]
  },
  'collaboration-production-alignment': {
    id: 'collaboration-production-alignment',
    title: 'Collaboration & Production Alignment',
    modulenumber: '4.3.4',
    department: 'Design',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770021084/d5_b7hzv8.mp4',
    duration: 90,
    description: 'Handover designs to production with zero ambiguity, communicate complex details, use site visits to validate decisions, solve field issues quickly, and balance creativity with production realities.',
    requiredRoles: ['head_of_design', 'designer', 'head_of_production'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Design is complete only when it is:",
        options: [
          "Beautifully rendered",
          "Delivered successfully",
          "Approved by client",
          "Finished on computer"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "A design that cannot be explained to production:",
        options: [
          "Is highly creative",
          "Has not been designed properly",
          "Should be built anyway",
          "Is the workshop's problem"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "If handover to production is weak:",
        options: [
          "Production works faster",
          "Production guesses and errors multiply",
          "Design team gets more time",
          "Costs are reduced"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "If production has to ask basic questions:",
        options: [
          "They are learning",
          "The handover failed",
          "Design is too complex",
          "It's normal process"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Complex details like unusual junctions must be:",
        options: [
          "Hidden from production",
          "Explained, not assumed",
          "Ignored in drawings",
          "Left for installers"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Regarding production figuring things out:",
        options: [
          "They should always figure it out",
          "Never assume they will figure it out",
          "It saves design time",
          "It's part of their job"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Why must designers visit site?",
        options: [
          "To avoid office work",
          "To reveal real dimensions and site realities",
          "To socialize with installers",
          "To delay projects"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Design must respond to:",
        options: [
          "Only creative vision",
          "Reality, not fight it",
          "Client's every wish",
          "Latest trends only"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "When solving field issues:",
        options: [
          "Rush to fix quickly",
          "Speed without thinking creates bigger problems",
          "Ignore the cost impact",
          "Let installers decide"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Design leadership is measured by:",
        options: [
          "Number of drawings",
          "Smooth production and clean installation",
          "Client compliments",
          "Design complexity"
        ],
        correctAnswer: 1
      }
    ]
  },

  'cnc-machinery-management': {
    id: 'cnc-machinery-management',
    title: 'CNC & Machinery Management',
    modulenumber: '4.1.2',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769593790/prod3_ljc096.mp4',
    duration: 90,
    description: 'CNC nesting optimization, panel saw waste control, edge banding quality, dust extraction safety, and machine maintenance planning.',
    requiredRoles: ['head_of_production', 'quality_control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "CNC nesting is used to:",
        options: [
          "Decorate panels with patterns",
          "Store panels in the warehouse",
          "Optimize board cutting and reduce material waste",
          "Dry wood before assembly"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Poor nesting results in:",
        options: [
          "Higher production efficiency",
          "Faster project delivery",
          "Increased material wastage and higher costs",
          "Better finishing quality"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Before cutting begins, the Head of Production must confirm:",
        options: [
          "The workshop music system is working",
          "The nesting file matches approved drawings and the BoM",
          "All workers are wearing the same color",
          "Tools are arranged by color"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Panel saw waste reduction requires:",
        options: [
          "Guessing measurements quickly",
          "Using cut lists from the nesting plan",
          "Cutting panels randomly as needed",
          "Ignoring all offcuts"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "The principle 'Measure twice, cut once' is about:",
        options: [
          "Saving time during production",
          "Avoiding cutting errors and material waste",
          "Making decorative patterns",
          "Increasing cutting speed"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Edge banding is important because it:",
        options: [
          "Makes panels heavier and stronger",
          "Protects panels from moisture and gives professional finishing",
          "Increases the cutting speed of panels",
          "Stores excess glue for future use"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Poor edge banding leads to:",
        options: [
          "Stronger, more durable panels",
          "Peeling, poor appearance, and loss of brand trust",
          "Faster assembly times",
          "Lower material costs"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Dust extraction systems are necessary to:",
        options: [
          "Decorate the workshop interior",
          "Protect health, machinery, and product quality",
          "Provide background noise for workers",
          "Cool down the workshop temperature"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Machine maintenance prevents:",
        options: [
          "Clean and organized workshops",
          "Unexpected breakdowns and project delays",
          "Staff training sessions",
          "Design approval meetings"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Maintenance logs are important because they:",
        options: [
          "Waste valuable production time",
          "Record service history and schedule future needs",
          "Replace the need for actual maintenance",
          "Impress clients during visits"
        ],
        correctAnswer: 1
      }
    ]
  },
  'production-planning-workflow': {
    id: 'production-planning-workflow',
    title: 'Production Planning & Workflow',
    modulenumber: '4.1.1',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1770111473/q122_ks3jlz.mp4',
    duration: 90,
    description: 'Understand Kajjas full production workflow, plan weekly and daily production effectively, use Job Cards accurately, balance machines, manpower and time, coordinate with procurement and stores, manage outsourcing partners.',
    requiredRoles: ['head_of_production','quality-control', 'production_manager'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Plan the work. Control the flow. Deliver:",
        options: [
          "When possible",
          "On time",
          "Cheaply",
          "Beautifully"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Good planning prevents delays. Bad planning destroys:",
        options: [
          "Only materials",
          "Profit and trust",
          "Only time",
          "Machines"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Kajja production flow starts with Sales and then:",
        options: [
          "Cutting directly",
          "Design, then nesting",
          "Assembly first",
          "QC first"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "No approved drawings means:",
        options: [
          "Fast production",
          "No cutting starts",
          "Guess work",
          "Material waste"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Good nesting equals:",
        options: [
          "Higher waste",
          "Lower material cost",
          "Slower cutting",
          "More workers"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Weekly planning answers:",
        options: [
          "What to eat",
          "What must be completed this week",
          "Who gets paid",
          "Supplier choice"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "No Job Card means:",
        options: [
          "Creative freedom",
          "No authorized production start",
          "Faster work",
          "Less paperwork"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Capacity planning prevents:",
        options: [
          "Too many jobs at once",
          "Worker happiness",
          "Machine use",
          "Material orders"
        ],
        correctAnswer: 0
      },
      {
        id: 9,
        question: "Production coordinates with procurement to ensure:",
        options: [
          "Beautiful designs",
          "Materials available on time",
          "Client meetings",
          "Sales targets"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Production planning is not guessing. It is:",
        options: [
          "Hopeful thinking",
          "Controlled movement design to delivery",
          "Random work",
          "Optional activity"
        ],
        correctAnswer: 1
      }
    ]
  },
  'workmanship-quality-control': {
    id: 'workmanship-quality-control',
    title: 'Workmanship & Quality Control',
    modulenumber: '4.1.3',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769595303/prod4_ww23k0.mp4',
    duration: 90,
    description: 'Cutting accuracy, drilling consistency, finishing standards, assembly practices, and immediate defect rejection.',
    requiredRoles: ['head_of_production', 'quality-control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Cutting accuracy is important because:",
        options: [
          "It decorates the panels with patterns",
          "It ensures parts fit correctly during assembly",
          "It increases the noise in the workshop",
          "It intentionally delays production"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Squareness in cutting means:",
        options: [
          "Panels are painted in square patterns",
          "Corners are exactly 90 degrees",
          "Panels are heavy and thick",
          "Boards are polished on all sides"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "First-cut inspection is important because:",
        options: [
          "It wastes valuable production time",
          "Errors multiply if not corrected early",
          "It makes workers tired",
          "It helps machines warm up properly"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Poor drilling causes:",
        options: [
          "Stronger and better joints",
          "Loose and misaligned joints",
          "Faster completion of work",
          "No significant impact on quality"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Drilling jigs are used to:",
        options: [
          "Increase mistakes for learning",
          "Ensure consistent hole positioning",
          "Decorate the furniture surface",
          "Slow down the drilling process"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Good joinery is identified by:",
        options: [
          "Visible gaps between parts",
          "Tight and flush joints",
          "Loose screws and fasteners",
          "Uneven and rough edges"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Clients judge quality mainly by:",
        options: [
          "The brand of machines used",
          "The surface finishing appearance",
          "The size of the workshop",
          "The uniforms workers wear"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Poor finishing leads to:",
        options: [
          "Higher perceived product value",
          "Client complaints and brand damage",
          "Faster sales cycles",
          "Reduced production costs"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Assembly jigs help to:",
        options: [
          "Increase inconsistency in products",
          "Align parts accurately and consistently",
          "Hide mistakes from inspectors",
          "Reduce the overall quality standard"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Substandard work should be:",
        options: [
          "Passed to the next stage to save time",
          "Rejected immediately and corrected",
          "Fixed only after delivery to client",
          "Ignored if it is a small defect"
        ],
        correctAnswer: 1
      }
    ]
  },
  'rework-prevention-cost-control': {
    id: 'rework-prevention-cost-control',
    title: 'Rework Prevention & Cost Control',
    modulenumber: '4.1.4',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769596475/prod5_ihmyh8.mp4',
    duration: 90,
    description: 'Identifying rework causes, root cause analysis, waste tracking, labor efficiency, and accountability culture.',
    requiredRoles: ['head_of_production', 'quality-control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Rework means:",
        options: [
          "Doing work faster than planned",
          "Designing new furniture concepts",
          "Repeating work due to errors or defects",
          "Delivering products to clients"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "A major effect of rework is:",
        options: [
          "Higher company profits",
          "Loss of materials, labor time, and profit",
          "Better finishing quality",
          "Faster project delivery"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Cutting from unapproved drawings causes:",
        options: [
          "Faster completion of work",
          "Creativity and innovation",
          "Rework and financial losses",
          "Better design outcomes"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "Root cause analysis focuses on:",
        options: [
          "Hiding problems from management",
          "Blaming individual workers",
          "Finding the real underlying reason defects occur",
          "Fixing only the visible symptoms"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Asking 'Why?' repeatedly helps to:",
        options: [
          "Waste production time",
          "Confuse the workshop team",
          "Find the true source of a problem",
          "Avoid actual work"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "Wastage tracking is important because:",
        options: [
          "Waste is unavoidable and should be ignored",
          "What is measured can be controlled and reduced",
          "It slows down production unnecessarily",
          "It hides financial losses from view"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Offcuts and damaged panels are examples of:",
        options: [
          "Increased company profit",
          "Material wastage that reduces profit",
          "Production efficiency",
          "Quality improvement"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Labor efficiency means:",
        options: [
          "Paying workers regardless of their output",
          "Monitoring actual output versus expected work",
          "Avoiding planning to save time",
          "Allowing idle time for relaxation"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "A busy workshop always means:",
        options: [
          "High productivity and efficiency",
          "Low material waste",
          "Good cost control",
          "Not necessarily productive output"
        ],
        correctAnswer: 3
      },
      {
        id: 10,
        question: "Zero-excuse culture means:",
        options: [
          "Blaming others for failures",
          "Hiding mistakes from supervisors",
          "Owning personal responsibility for work",
          "Ignoring errors if they are small"
        ],
        correctAnswer: 2
      }
    ]
  },
  'human-capital-team-management': {
    id: 'human-capital-team-management',
    title: 'Human Capital & Team Management',
    modulenumber: '4.1.5',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769597623/prod6_qfti2h.mp4',
    duration: 90,
    description: 'Supervision techniques, motivation through praise and discipline, delegation, shift rotation, coaching, and conflict management.',
    requiredRoles: ['head_of_production', 'quality-control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Supervision in production is necessary to:",
        options: [
          "Decorate the workshop walls",
          "Replace expensive machinery",
          "Ensure tasks are done correctly and on schedule",
          "Enter financial data into the system"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Effective supervision requires:",
        options: [
          "Staying in the office all day",
          "Sending messages from a distance",
          "Being physically present on the workshop floor",
          "Avoiding interaction with workers"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Praising workers helps to:",
        options: [
          "Increase mistakes and carelessness",
          "Encourage repeated good performance",
          "Cause conflicts between staff",
          "Waste valuable production time"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Fair discipline means:",
        options: [
          "Punishing workers randomly to keep them afraid",
          "Applying clear rules consistently and respectfully",
          "Ignoring bad behavior to avoid conflict",
          "Shouting at workers to make a point"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Delegation without follow-up is:",
        options: [
          "An example of good leadership",
          "A form of motivation for workers",
          "Abandonment of the task and worker",
          "A method to increase efficiency"
        ],
        correctAnswer: 2
      },
      {
        id: 6,
        question: "Shift rotation helps to:",
        options: [
          "Reduce the overall skills in the workshop",
          "Build multi-skilled and flexible teams",
          "Cause confusion and lower quality",
          "Stop workers from learning new things"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Hands-on coaching is used to:",
        options: [
          "Replace skilled workers with cheaper labor",
          "Develop worker skills and reduce errors",
          "Waste time during production hours",
          "Delay project completion intentionally"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Good coaching requires:",
        options: [
          "Embarrassing learners to teach them a lesson",
          "Patience and clear, repeated demonstration",
          "Ignoring questions from workers",
          "Rushing through the teaching process"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Common causes of workshop conflict include:",
        options: [
          "Clear, written instructions",
          "Misunderstood tasks and instructions",
          "Good forward planning",
          "Proper delegation of duties"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "The first step in conflict resolution is to:",
        options: [
          "Punish someone immediately",
          "Listen carefully to both sides",
          "Ignore the issue and hope it goes away",
          "Report the matter to external authorities"
        ],
        correctAnswer: 1
      }
    ]
  },
  "electrician-role-conduct": {
    "id": "electrician-role-conduct",
    "title": "Electrician's Role & Conduct",
    "modulenumber": "4.8.0",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771229931/e1_o0fbes.mp4",
    "duration": 85,
    "description": "To clearly define the electrician's professional role, behavior standards, communication responsibilities, and safety culture required to support reliable workshop operations and high-quality client installations at Kajja Galleries.",
    "requiredRoles": ["electrician", "maintenance-technician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "At Kajja Galleries, the electrician's main role is to:",
        "options": [
          "Supervise carpenters",
          "Control stores",
          "Support safe and reliable electrical systems for production and installations",
          "Approve job cards"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "Why is the electrician described as a 'production enabler'?",
        "options": [
          "Because they supervise installers",
          "Because machines and installations depend on reliable power",
          "Because they manage schedules",
          "Because they prepare drawings"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Which task is part of the electrician's workshop responsibility?",
        "options": [
          "Cutting panels",
          "Programming CNC machines",
          "Inspecting cables and distribution boards",
          "Issuing tools"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "During client installations, the electrician must also support:",
        "options": [
          "Painting and polishing",
          "Furniture packing",
          "Power points, lighting and equipment connections",
          "Sales presentations"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Poor electrical work mainly results in:",
        "options": [
          "Faster installations",
          "Lower material usage",
          "Downtime, safety risks and client dissatisfaction",
          "Better appearance"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Why is professional appearance important on client sites?",
        "options": [
          "For marketing only",
          "To reduce supervision",
          "To build trust and reflect company professionalism",
          "To increase working hours"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Who must the electrician coordinate with during installations?",
        "options": [
          "Store Manager only",
          "Marketing team",
          "Installers, Head of Production and QC",
          "Clients only"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Which issue must be communicated immediately by the electrician?",
        "options": [
          "Staff attendance",
          "Electrical risks affecting machines or installations",
          "Delivery delays",
          "Store shortages"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Why is there zero tolerance for electrical shortcuts?",
        "options": [
          "To increase paperwork",
          "To slow production",
          "Because shortcuts can cause shock, fire and serious accidents",
          "To reduce supervision"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Which action is mandatory before working on electrical systems?",
        "options": [
          "Inform QC only",
          "Isolate and verify absence of voltage",
          "Wear gloves only",
          "Call procurement"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "carpenter-role-kajja-culture": {
    "id": "carpenter-role-kajja-culture",
    "title": "Carpenter Role & Kajja Culture",
    "modulenumber": "4.9.0",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771243951/f1_sfrukg.mp4",
    "duration": 90,
    "description": "To define clearly who a Skilled Carpenter is at Kajja Galleries, embed the company's brand promise into daily work, and establish professional behaviour standards in both workshop and client-site environments.",
    "requiredRoles": ["carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "A Skilled Carpenter at Kajja is mainly:",
        "options": [
          "A labourer",
          "A machine operator only",
          "A precision craftsman and brand ambassador",
          "A store assistant"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "What makes a carpenter 'skilled' at Kajja?",
        "options": [
          "Speed only",
          "Precision, discipline and responsibility",
          "Strength",
          "Experience alone"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Efficiency means:",
        "options": [
          "Working slowly and carefully",
          "Avoiding rework and waste",
          "Ignoring timelines",
          "Using more materials"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Creativity at Kajja means:",
        "options": [
          "Ignoring drawings",
          "Making personal changes",
          "Paying attention to aesthetics within standards",
          "Changing designs freely"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Trust means:",
        "options": [
          "Working alone",
          "Hiding mistakes",
          "Being honest and responsible",
          "Blaming others"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "In the workshop, a carpenter must:",
        "options": [
          "Argue when corrected",
          "Respect workflow hierarchy",
          "Ignore supervisors",
          "Work independently without coordination"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "On client sites, carpenters must:",
        "options": [
          "Play loud music",
          "Speak casually",
          "Represent Kajja professionally",
          "Ignore clients"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Professional appearance helps to:",
        "options": [
          "Increase supervision",
          "Build client trust",
          "Slow work",
          "Reduce cost"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "If unsure about instructions, the carpenter must:",
        "options": [
          "Guess",
          "Ignore",
          "Ask for clarification",
          "Continue cutting"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Which behaviour is unacceptable?",
        "options": [
          "Reporting mistakes",
          "Asking questions",
          "Hiding defects",
          "Wearing PPE"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "tool-mastery": {
    "id": "tool-mastery",
    "title": "Tool Mastery",
    "modulenumber": "4.9.1",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771246508/f2_mgmyxo.mp4",
    "duration": 85,
    "description": "To ensure every Skilled Carpenter handles tools with precision, safety, discipline and accountability, protecting both production quality and company property.",
    "requiredRoles": ["carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Hand tools mainly determine:",
        "options": [
          "Speed only",
          "Finishing quality and accuracy",
          "Machine performance",
          "Store control"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Before cutting, a carpenter should:",
        "options": [
          "Cut immediately",
          "Measure twice",
          "Ask others",
          "Estimate"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Which tool helps confirm right angles?",
        "options": [
          "Hammer",
          "Square",
          "Drill",
          "Chisel"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Before using a power tool, the carpenter must:",
        "options": [
          "Start immediately",
          "Inspect the tool condition",
          "Increase speed",
          "Remove PPE"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Over-sanding edges can cause:",
        "options": [
          "Better finishing",
          "Laminate damage",
          "Faster production",
          "No effect"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Dull tools result in:",
        "options": [
          "Better cuts",
          "Faster work",
          "Tear-out and inaccuracy",
          "Lower noise"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Where should tools be stored?",
        "options": [
          "On the floor",
          "In designated storage areas",
          "In pockets",
          "On machines"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Batteries must be charged:",
        "options": [
          "Anywhere",
          "Near wood dust",
          "In designated safe areas",
          "Inside cabinets"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Damaged tools should be:",
        "options": [
          "Used carefully",
          "Hidden",
          "Reported immediately",
          "Ignored"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Who is responsible for tools signed out in your name?",
        "options": [
          "Supervisor",
          "Store manager",
          "You",
          "Workshop manager"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "cabinetry-assembly-excellence": {
    "id": "cabinetry-assembly-excellence",
    "title": "Cabinetry Assembly Excellence",
    "modulenumber": "4.9.2",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771248193/f3_crmphe.mp4",
    "duration": 90,
    "description": "To ensure all cabinetry produced at Kajja Galleries meets high standards of alignment, drilling precision, structural strength, hardware installation quality, and smooth functional performance before passing to QC or installation.",
    "requiredRoles": ["carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Unequal diagonal measurements in a cabinet indicate:",
        "options": [
          "Strong structure",
          "Perfect alignment",
          "Cabinet is not square",
          "Good finishing"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "Cabinet assembly should be done on:",
        "options": [
          "Uneven floor",
          "Flat and stable surface",
          "Soft mattress",
          "Slanted table"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Incorrect hinge drilling may cause:",
        "options": [
          "Better door closing",
          "Misaligned doors",
          "Faster production",
          "Lower cost"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Drawer runners must be installed:",
        "options": [
          "Randomly",
          "At different heights",
          "Level and aligned",
          "Without measurement"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Shelf pin holes must:",
        "options": [
          "Be uneven",
          "Be straight and aligned",
          "Penetrate through panel",
          "Be forced"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Proper joinery ensures:",
        "options": [
          "Decorative effect",
          "Long-term structural strength",
          "Reduced weight",
          "Faster assembly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Pre-drilling prevents:",
        "options": [
          "Faster work",
          "Cracks and laminate damage",
          "Increased noise",
          "Loose handles"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "A properly installed door should:",
        "options": [
          "Rub against side panel",
          "Close with force",
          "Have even gaps and smooth movement",
          "Remain loose"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Glue residue must be:",
        "options": [
          "Left to dry",
          "Ignored",
          "Cleaned immediately",
          "Hidden"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Before passing to QC, the carpenter must:",
        "options": [
          "Stop working",
          "Operate all doors and drawers",
          "Leave adjustments to QC",
          "Skip inspection"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "furniture-installation-standards": {
    "id": "furniture-installation-standards",
    "title": "Furniture Installation Standards",
    "modulenumber": "4.9.3",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771249190/f4_ewc1bn.mp4",
    "duration": 85,
    "description": "To ensure all furniture installations are executed with precision, structural safety, neat finishing and professional site conduct that reflects Kajja Galleries' brand promise of Efficiency • Creativity • Trust.",
    "requiredRoles": ["carpenter", "installation-carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Before installing furniture, the carpenter must first:",
        "options": [
          "Start fixing immediately",
          "Read and confirm drawings",
          "Estimate placement",
          "Ask client randomly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Why must unit orientation be confirmed before fixing?",
        "options": [
          "To reduce screws",
          "To avoid mirror-image mistakes",
          "To save time",
          "To reduce weight"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "What tool ensures horizontal and vertical alignment?",
        "options": [
          "Tape measure",
          "Spirit level",
          "Hammer",
          "Clamp"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Base cabinets must be leveled:",
        "options": [
          "After upper cabinets",
          "Before fixing upper units",
          "After sealing",
          "After installation"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Improper anchoring can lead to:",
        "options": [
          "Better support",
          "Structural instability",
          "Faster installation",
          "Lower cost"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Before drilling into walls, the carpenter must:",
        "options": [
          "Drill quickly",
          "Identify wall type and hidden services",
          "Ignore electrical lines",
          "Use random anchors"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Tight corner joints ensure:",
        "options": [
          "Decorative value only",
          "Structural and visual quality",
          "Faster installation",
          "Lower cost"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Excess sealant must be:",
        "options": [
          "Left to dry",
          "Hidden",
          "Cleaned immediately",
          "Painted over"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Continuous cabinet runs must be:",
        "options": [
          "Installed individually without alignment check",
          "Checked for consistent height and alignment",
          "Forced into position",
          "Uneven for ventilation"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Before leaving site, the carpenter must:",
        "options": [
          "Leave packaging",
          "Leave tools on site",
          "Conduct final walk-through",
          "Turn off lights only"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "surface-finishing-care": {
    "id": "surface-finishing-care",
    "title": "Surface & Finishing Care",
    "modulenumber": "4.9.4",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771250284/f5_yq4ksu.mp4",
    "duration": 85,
    "description": "To ensure all finished furniture leaving Kajja Galleries is free from scratches, dents, residue and cosmetic defects, reflecting a premium, professional standard consistent with the company's brand promise of Efficiency • Creativity • Trust.",
    "requiredRoles": ["carpenter", "installation-carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Most scratches occur during:",
        "options": [
          "Design stage",
          "Movement and careless handling",
          "Painting",
          "Measuring"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Panels should be moved by:",
        "options": [
          "Dragging",
          "Sliding",
          "Lifting carefully",
          "Pushing"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Tools should be placed:",
        "options": [
          "On finished surfaces",
          "On floors",
          "On protected areas only",
          "On cabinet tops"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Before handover, surfaces must be:",
        "options": [
          "Left dusty",
          "Cleaned and wiped",
          "Painted again",
          "Ignored"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Aggressive scraping of adhesive is:",
        "options": [
          "Efficient",
          "Professional",
          "Dangerous to surfaces",
          "Required"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Laminated edges can chip if:",
        "options": [
          "Drilled carefully",
          "Handled gently",
          "Mishandled or drilled carelessly",
          "Wiped"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Painted surfaces require:",
        "options": [
          "Rough handling",
          "Soft, padded handling",
          "Hammer adjustment",
          "Extra screws"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Edge band lifting indicates:",
        "options": [
          "Good adhesion",
          "Premium quality",
          "Defect requiring correction",
          "Finished product"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Visible glue lines on edge bands are:",
        "options": [
          "Acceptable",
          "Normal",
          "Quality defect",
          "Decorative"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Final wipe-down should include:",
        "options": [
          "Only outside surfaces",
          "Inside drawers and cabinets",
          "Only handles",
          "None"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "quality-problem-prevention": {
    "id": "quality-problem-prevention",
    "title": "Quality & Problem Prevention",
    "modulenumber": "4.9.5",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771251488/f6_vsvr7c.mp4",
    "duration": 85,
    "description": "To instill a strong quality mindset in every Skilled Carpenter, prevent recurring installation errors, promote timely escalation of issues, enforce photo-based reporting discipline, and encourage respectful adherence to QC standards.",
    "requiredRoles": ["carpenter", "installation-carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "'First-time-right' mainly means:",
        "options": [
          "Working quickly",
          "Letting QC correct mistakes",
          "Completing work correctly before inspection",
          "Skipping checks"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "Rework affects the company by:",
        "options": [
          "Increasing profit",
          "Saving time",
          "Increasing cost and delays",
          "Improving creativity"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "If a cabinet is uneven during installation, the carpenter should:",
        "options": [
          "Ignore it",
          "Cover it",
          "Stop and correct it",
          "Leave for QC"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Which is a common installation fault?",
        "options": [
          "Clean joints",
          "Even alignment",
          "Door rubbing",
          "Proper leveling"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Escalation is required when:",
        "options": [
          "Minor dust exists",
          "Structural or design conflicts occur",
          "Work is slow",
          "Tools are missing"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Which action is unacceptable?",
        "options": [
          "Reporting issues",
          "Modifying design without approval",
          "Asking supervisor",
          "Correcting faults"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Photo reporting helps to:",
        "options": [
          "Increase paperwork",
          "Protect the company and document quality",
          "Slow installation",
          "Replace QC"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Before leaving site, carpenters must:",
        "options": [
          "Leave quietly",
          "Take completion and defect photos",
          "Ignore small issues",
          "Skip reporting"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "QC exists mainly to:",
        "options": [
          "Criticize workers",
          "Delay work",
          "Protect quality standards",
          "Increase cost"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "When QC identifies a fault, the carpenter should:",
        "options": [
          "Argue",
          "Ignore",
          "Correct it professionally",
          "Blame others"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "assistant-carpenter-introduction-conduct": {
    "id": "assistant-carpenter-introduction-conduct",
    "title": "Introduction & Conduct",
    "modulenumber": "4.10.0",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771313369/cap1_vla0f5.mp4",
    "duration": 80,
    "description": "To clearly define the role of an Assistant Carpenter, establish behavioural expectations, embed Kajja's core values, and build a strong foundation of teamwork and respect within the workshop and installation teams.",
    "requiredRoles": ["assistant-carpenter", "carpenter-helper"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "An Assistant Carpenter is primarily:",
        "options": [
          "A labourer only",
          "A structured learner and support technician",
          "A supervisor",
          "A store manager"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "The Assistant Carpenter role prepares one to become:",
        "options": [
          "Director",
          "Supervisor immediately",
          "Skilled Carpenter",
          "Driver"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Efficiency at assistant level means:",
        "options": [
          "Waiting for instructions",
          "Being ready and proactive",
          "Working slowly",
          "Avoiding tasks"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Creativity at assistant level must:",
        "options": [
          "Replace instructions",
          "Ignore supervisors",
          "Respect structure and guidance",
          "Modify designs freely"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Trust includes:",
        "options": [
          "Hiding mistakes",
          "Protecting company property",
          "Ignoring damage",
          "Blaming others"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "On client sites, assistants must:",
        "options": [
          "Argue with clients",
          "Use phones freely",
          "Represent Kajja professionally",
          "Ignore supervisor"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "When given instructions, the assistant should:",
        "options": [
          "Argue",
          "Delay",
          "Confirm and execute",
          "Ignore"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Carrying panels carelessly can cause:",
        "options": [
          "Faster work",
          "Scratches and damage",
          "Stronger structure",
          "Better finishing"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Teamwork means:",
        "options": [
          "Competing negatively",
          "Supporting the skilled carpenter",
          "Working alone",
          "Ignoring instructions"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "A strong assistant avoids:",
        "options": [
          "Learning",
          "Supporting",
          "Complaining",
          "Improving"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "assistant-carpenter-basic-tool-skills": {
    "id": "assistant-carpenter-basic-tool-skills",
    "title": "Basic Tool Skills",
    "modulenumber": "4.10.1",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771315035/cap2_rvbtwf.mp4",
    "duration": 85,
    "description": "To ensure Assistant Carpenters can correctly identify, handle, measure with, store and protect tools safely, while understanding their support role in tool management and power tool discipline.",
    "requiredRoles": ["assistant-carpenter", "carpenter-helper"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Tool identification helps to:",
        "options": [
          "Slow work",
          "Improve response and efficiency",
          "Reduce supervision",
          "Increase mistakes"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Tools should never be:",
        "options": [
          "Carried",
          "Cleaned",
          "Thrown",
          "Stored"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Using the wrong screwdriver can cause:",
        "options": [
          "Stronger screws",
          "Stripped screw heads",
          "Faster work",
          "Better finish"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "When using a chisel, you must:",
        "options": [
          "Cut toward body",
          "Leave blade exposed",
          "Cut away from body",
          "Hammer randomly"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Tape measurements should be:",
        "options": [
          "Estimated",
          "Confirmed and rechecked",
          "Guessed",
          "Rounded"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "The bubble in a spirit level shows:",
        "options": [
          "Speed",
          "Temperature",
          "Alignment",
          "Weight"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Tools must be passed:",
        "options": [
          "Thrown gently",
          "Handle-first",
          "Blade-first",
          "Quickly without warning"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "After using tools, assistants must:",
        "options": [
          "Leave them on floor",
          "Hide them",
          "Clean and store properly",
          "Give to client"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Assistant carpenters may operate power tools:",
        "options": [
          "Anytime",
          "Without supervision",
          "Only when authorized and supervised",
          "Never under any condition"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Charging batteries should be done:",
        "options": [
          "Anywhere",
          "Near wood dust",
          "In designated safe area",
          "Inside cabinet"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "assistant-carpenter-workshop-support": {
    "id": "assistant-carpenter-workshop-support",
    "title": "Workshop Support Duties",
    "modulenumber": "4.10.2",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771316137/cap3_nis5h2.mp4",
    "duration": 85,
    "description": "To ensure Assistant Carpenters effectively support Skilled Carpenters and Technicians by handling materials safely, maintaining organized workspaces, preparing hardware correctly, and preventing errors before delivery.",
    "requiredRoles": ["assistant-carpenter", "carpenter-helper"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Improper panel carrying may cause:",
        "options": [
          "Faster production",
          "Injury and surface damage",
          "Better alignment",
          "Stronger structure"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Large panels should be carried:",
        "options": [
          "Alone",
          "By dragging",
          "With team lifting",
          "By sliding"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Clean workstations improve:",
        "options": [
          "Confusion",
          "Safety and efficiency",
          "Delays",
          "Noise"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "Off-cuts should be:",
        "options": [
          "Left on floor",
          "Hidden",
          "Removed immediately",
          "Stacked randomly"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "During assembly, assistants must:",
        "options": [
          "Distract technicians",
          "Stay idle",
          "Listen and support actively",
          "Override instructions"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Hardware preparation helps to prevent:",
        "options": [
          "Strong joints",
          "Delays and missing parts",
          "Over-assembly",
          "Rework only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Screws and fittings should be:",
        "options": [
          "Mixed randomly",
          "Organized and counted",
          "Left scattered",
          "Estimated"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Before delivery, parts must be:",
        "options": [
          "Assumed complete",
          "Confirmed against job card",
          "Ignored",
          "Packed loosely"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Dragging panels on the floor is:",
        "options": [
          "Efficient",
          "Acceptable",
          "Poor practice",
          "Required"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Assistant carpenters should never say:",
        "options": [
          "I confirmed",
          "I thought it was included",
          "I checked",
          "I reported"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "assistant-carpenter-installation-support": {
    "id": "assistant-carpenter-installation-support",
    "title": "Installation Support",
    "modulenumber": "4.10.3",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771317299/cap4_hfvxqf.mp4",
    "duration": 85,
    "description": "To ensure Assistant Carpenters support installation teams professionally, protect client property, maintain order during installations, and leave client spaces clean and presentable.",
    "requiredRoles": ["assistant-carpenter", "installation-helper"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Careless movement in client spaces can cause:",
        "options": [
          "Faster installation",
          "Wall and floor damage",
          "Better teamwork",
          "No impact"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Before carrying items into a client space, assistants must:",
        "options": [
          "Rush",
          "Plan the route",
          "Slide panels",
          "Ignore surroundings"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Passing wrong fittings causes:",
        "options": [
          "Faster work",
          "Efficiency",
          "Delays and confusion",
          "Better alignment"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "During alignment, the assistant must:",
        "options": [
          "Release immediately",
          "Move unit randomly",
          "Hold unit steady",
          "Leave area"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Before releasing a cabinet, assistants should:",
        "options": [
          "Assume secure",
          "Walk away",
          "Confirm stability",
          "Push it"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Protecting floors prevents:",
        "options": [
          "Noise",
          "Client complaints and damage",
          "Faster installation",
          "Lower cost"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Tools should never be placed:",
        "options": [
          "On protective sheet",
          "On finished floors without protection",
          "In tool bag",
          "On stable table"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Dragging panels through door frames is:",
        "options": [
          "Efficient",
          "Acceptable",
          "Risky and unprofessional",
          "Faster"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Cleaning before leaving site improves:",
        "options": [
          "Delay",
          "Client trust",
          "Noise",
          "Rework"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Packaging materials must be:",
        "options": [
          "Left behind",
          "Hidden",
          "Removed before departure",
          "Burned"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "assistant-carpenter-material-surface-care": {
    "id": "assistant-carpenter-material-surface-care",
    "title": "Material & Surface Care",
    "modulenumber": "4.10.4",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771324772/cap5_l7dtgp.mp4",
    "duration": 85,
    "description": "To ensure Assistant Carpenters protect all materials, finished panels and client property from scratches, dents, dust and adhesive stains during workshop handling and site installation.",
    "requiredRoles": ["assistant-carpenter", "installation-helper"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Panel edges are vulnerable because they are:",
        "options": [
          "Hidden",
          "Decorative only",
          "Easily chipped during movement",
          "Stronger than faces"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "Panels should be moved by:",
        "options": [
          "Dragging",
          "Lifting carefully",
          "Pushing",
          "Sliding"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Tools must not be placed on:",
        "options": [
          "Tool bench",
          "Protective mat",
          "Visible cabinet faces",
          "Storage table"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Glue residue should be removed:",
        "options": [
          "At the end of the day",
          "Immediately",
          "After client inspection",
          "Never"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "Aggressive scraping on laminate can:",
        "options": [
          "Improve shine",
          "Damage the surface",
          "Increase speed",
          "Remove dust faster"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Protective sheets help to prevent:",
        "options": [
          "Faster work",
          "Floor scratches",
          "Stronger joints",
          "Noise"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Leaning panels against painted walls may cause:",
        "options": [
          "Alignment",
          "Surface damage",
          "Stability",
          "Efficiency"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "During loading, panels should be:",
        "options": [
          "Stacked without padding",
          "Secured and protected",
          "Thrown carefully",
          "Leaned on metal edges"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Most scratches occur during:",
        "options": [
          "Design",
          "Transport and handling",
          "Drawing",
          "Pricing"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Stacking panels without separation can cause:",
        "options": [
          "Alignment",
          "Scratches",
          "Stability",
          "Faster unloading"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "assistant-carpenter-learning-quality": {
    "id": "assistant-carpenter-learning-quality",
    "title": "Learning Quality & Problem Prevention",
    "modulenumber": "4.10.5",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771325926/cap6_aos8lu.mp4",
    "duration": 90,
    "description": "To train Assistant Carpenters to recognize quality standards, prevent common mistakes, report issues early, and develop pride in contributing to beautiful, professional furniture that reflects Kajja Galleries' brand promise: Efficiency • Creativity • Trust.",
    "requiredRoles": ["assistant-carpenter", "carpenter-helper"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Quality instructions from supervisors are:",
        "options": [
          "Optional",
          "Suggestions",
          "Mandatory standards",
          "Flexible"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "Ignoring small quality details can lead to:",
        "options": [
          "Faster completion",
          "Rework and complaints",
          "Better results",
          "No impact"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Good finishing includes:",
        "options": [
          "Visible glue lines",
          "Uneven gaps",
          "Smooth surfaces and clean edges",
          "Exposed scratches"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "If you see a scratch, you should:",
        "options": [
          "Ignore it",
          "Hide it",
          "Report it immediately",
          "Cover it with dust"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Guessing measurements can cause:",
        "options": [
          "Perfection",
          "Rework and material waste",
          "Speed",
          "Stronger panels"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Asking questions shows:",
        "options": [
          "Weakness",
          "Inexperience",
          "Responsibility",
          "Delay"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "A defect includes:",
        "options": [
          "Clean surface",
          "Even alignment",
          "Loose screw",
          "Proper fit"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Reporting defects early helps to:",
        "options": [
          "Increase cost",
          "Reduce problems",
          "Delay work",
          "Hide mistakes"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "If you can see a defect, the client will likely:",
        "options": [
          "Not notice",
          "Ignore it",
          "See it too",
          "Appreciate it"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Assistant carpenters grow by:",
        "options": [
          "Staying silent",
          "Observing and learning",
          "Guessing",
          "Ignoring QC"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "assistant-carpenter-safety-first": {
    "id": "assistant-carpenter-safety-first",
    "title": "Safety First",
    "modulenumber": "4.10.6",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771326888/cap7_u3ty5o.mp4",
    "duration": 85,
    "description": "To ensure Assistant Carpenters understand basic safety principles, wear proper protective equipment, lift safely, remain alert around machines, and maintain a zero-tolerance approach to unsafe behavior. At Kajja Galleries: Safety is not optional. It is mandatory.",
    "requiredRoles": ["assistant-carpenter", "carpenter-helper"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "PPE is required because it:",
        "options": [
          "Looks professional only",
          "Protects against injury",
          "Slows production",
          "Is optional"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Safety shoes protect against:",
        "options": [
          "Dust",
          "Falling panels",
          "Noise",
          "Heat"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Correct lifting requires:",
        "options": [
          "Bending back",
          "Twisting body",
          "Bending knees and keeping back straight",
          "Pulling quickly"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Heavy panels should be lifted:",
        "options": [
          "Alone",
          "With speed",
          "By team lifting",
          "By dragging"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Assistant carpenters may operate machines:",
        "options": [
          "Anytime",
          "Without supervision",
          "Only when authorized",
          "Secretly"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Distracting a machine operator can cause:",
        "options": [
          "Faster cutting",
          "Injury",
          "Better alignment",
          "Efficiency"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Before using a ladder, you must:",
        "options": [
          "Jump on it",
          "Check for damage",
          "Lean it anywhere",
          "Shake it"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Standing on the top step of a ladder is:",
        "options": [
          "Safe",
          "Efficient",
          "Unsafe",
          "Required"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Horseplay includes:",
        "options": [
          "Cleaning",
          "Running and pushing",
          "Following instructions",
          "Wearing PPE"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Staying alert around machines means:",
        "options": [
          "Using headphones",
          "Watching blades closely",
          "Avoiding distractions",
          "Talking loudly"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "ssafety-risk-control": {
    "id": "ssafety-risk-control",
    "title": "Safety & Risk Control",
    "modulenumber": "4.9.6",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771253261/f66_oefnku.mp4",
    "duration": 85,
    "description": "To ensure all Skilled Carpenters understand and apply strict safety standards in the workshop and on client sites, preventing injuries, protecting property, and maintaining a safe, productive working environment.",
    "requiredRoles": ["carpenter", "installation-carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "PPE is mandatory because it:",
        "options": [
          "Improves speed",
          "Protects against injury",
          "Looks uniform",
          "Reduces supervision"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Safety shoes protect against:",
        "options": [
          "Dust only",
          "Falling objects and sharp materials",
          "Noise",
          "Heat"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "When lifting heavy panels, the carpenter must:",
        "options": [
          "Bend back",
          "Twist body",
          "Bend knees and keep panel close",
          "Rush"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Large panels should be lifted:",
        "options": [
          "Alone",
          "Quickly",
          "By two or more people",
          "By dragging"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Blocked walkways can cause:",
        "options": [
          "Faster work",
          "Trips and accidents",
          "Better storage",
          "Stronger structure"
        ],
        "correctAnswer": 1
      },
      {
        "id": 6,
        "question": "Before using a ladder, the carpenter must:",
        "options": [
          "Paint it",
          "Check for damage",
          "Shake it",
          "Lean it anywhere"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "When on a ladder, the carpenter must:",
        "options": [
          "Stand on top step",
          "Overreach",
          "Maintain three-point contact",
          "Jump down"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Wood dust accumulation increases risk of:",
        "options": [
          "Smooth finishing",
          "Fire hazard",
          "Faster installation",
          "Noise reduction"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Emergency exits must:",
        "options": [
          "Be blocked with materials",
          "Remain clear",
          "Be locked",
          "Be hidden"
        ],
        "correctAnswer": 1
      },
      {
        "id": 10,
        "question": "Attempting to lift oversized panels alone is:",
        "options": [
          "Efficient",
          "Risky and unacceptable",
          "Creative",
          "Faster"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "discipline-team-excellence": {
    "id": "discipline-team-excellence",
    "title": "Discipline & Team Excellence",
    "modulenumber": "4.9.7",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771254366/f7_r6g3bc.mp4",
    "duration": 85,
    "description": "To build disciplined, professional and growth-oriented carpenters who respect company structure, protect client relationships, manage time responsibly, and strive for continuous improvement within Kajja Galleries.",
    "requiredRoles": ["carpenter", "installation-carpenter"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Respecting schedules helps the company by:",
        "options": [
          "Increasing stress",
          "Improving profitability and trust",
          "Slowing work",
          "Reducing supervision"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Time discipline means:",
        "options": [
          "Arriving late",
          "Starting work immediately and minimizing idle time",
          "Waiting for supervision",
          "Working only when reminded"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Respect for supervisors ensures:",
        "options": [
          "Conflict",
          "Clear workflow and teamwork",
          "Confusion",
          "Slower production"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "If disagreement arises, the carpenter should:",
        "options": [
          "Shout",
          "Ignore",
          "Discuss respectfully",
          "Walk away angrily"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Clients judge the company based on:",
        "options": [
          "Only product",
          "Only pricing",
          "Behaviour and communication",
          "Store size"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Which behaviour is unacceptable?",
        "options": [
          "Reporting delays",
          "Respectful speech",
          "Insulting language",
          "Asking supervisor"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "A positive carpenter focuses on:",
        "options": [
          "Complaints",
          "Blame",
          "Solutions",
          "Excuses"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Negative attitude affects:",
        "options": [
          "Only the individual",
          "Entire team and client perception",
          "Tools only",
          "Production speed only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Promotion at Kajja is based on:",
        "options": [
          "Age",
          "Friendship",
          "Performance and discipline",
          "Time served only"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Growth path starts with:",
        "options": [
          "Supervisor",
          "Apprentice",
          "Manager",
          "Director"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "workshop-electrical-systems": {
    "id": "workshop-electrical-systems",
    "title": "Workshop Electrical Systems",
    "modulenumber": "4.8.1",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771231825/e2_bkxtan.mp4",
    "duration": 90,
    "description": "To equip electricians with a clear understanding of the workshop electrical layout, safe power distribution practices, correct machine connection procedures and early-fault detection to protect people, machines and production uptime.",
    "requiredRoles": ["electrician", "maintenance-technician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Why must an electrician understand the full workshop electrical layout?",
        "options": [
          "To prepare quotations",
          "To decorate the workshop",
          "To safely isolate and supply machines correctly",
          "To supervise carpenters"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "Which point must an electrician always know in the workshop?",
        "options": [
          "Store location",
          "Main distribution and isolation points",
          "Client entrance",
          "Marketing office"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Which condition inside a distribution board is dangerous?",
        "options": [
          "Clear labels",
          "Clean floor",
          "Burnt or discoloured terminals",
          "Locked door"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "What is the correct practice when inspecting distribution boards?",
        "options": [
          "Leave covers open",
          "Allow dust to build up",
          "Keep panels clean, closed and labelled",
          "Store tools inside the panel"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Why must cables around machines be routed in trays or conduits?",
        "options": [
          "For appearance",
          "To reduce cable cost",
          "To protect against mechanical damage",
          "To speed up installation"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Which routing practice is NOT acceptable?",
        "options": [
          "Cables in trays",
          "Cables in conduits",
          "Cables lying on workshop floors",
          "Cables protected at sharp edges"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Before installing a new machine power point, the electrician must first confirm:",
        "options": [
          "Client preference",
          "Machine electrical rating and requirements",
          "Workshop colour scheme",
          "Delivery schedule"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Why must new machine outlets be tested before handover?",
        "options": [
          "To satisfy store records",
          "To improve speed",
          "To confirm correct voltage, phase and earthing",
          "To train operators"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Load balancing is important because it:",
        "options": [
          "Improves lighting",
          "Reduces cable length",
          "Prevents overheating and nuisance tripping",
          "Reduces machine size"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Which of the following is an early electrical warning sign?",
        "options": [
          "Clean panel cover",
          "Warm room temperature",
          "Burning smell or visible sparks",
          "Normal machine sound"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "machinery-electrical-support": {
    "id": "machinery-electrical-support",
    "title": "Machinery Electrical Support",
    "modulenumber": "4.8.2",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771233152/e3_oqz6xk.mp4",
    "duration": 90,
    "description": "To equip electricians with safe, practical skills for supporting production machines electrically, maintaining emergency systems, diagnosing simple faults within safe limits, coordinating with certified service providers, and enforcing preventive maintenance discipline.",
    "requiredRoles": ["electrician", "maintenance-technician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Basic electrical support for machines mainly includes:",
        "options": [
          "Programming CNC software",
          "Checking external power, connectors and earthing",
          "Adjusting machine speeds",
          "Changing production files"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Which activity is within the electrician's responsibility on machines?",
        "options": [
          "Editing PLC programs",
          "Inspecting flexible cables and connectors",
          "Changing servo parameters",
          "Modifying machine interlocks"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Which activity is NOT allowed for the electrician?",
        "options": [
          "Checking voltage at the socket",
          "Inspecting isolators",
          "Modifying internal machine control logic",
          "Inspecting cable damage"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Why must emergency stop systems be tested regularly?",
        "options": [
          "To increase machine speed",
          "To reduce maintenance costs",
          "To ensure they protect people and machines",
          "To satisfy procurement"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "After an emergency stop is pressed, a machine must:",
        "options": [
          "Restart automatically",
          "Restart when power returns",
          "Require deliberate reset before restarting",
          "Restart when the operator presses start"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Which condition shows correct emergency stop practice?",
        "options": [
          "Emergency stop covered to prevent accidental use",
          "Emergency stop clearly visible and accessible",
          "Emergency stop bypassed during busy periods",
          "Emergency stop wired permanently closed"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Which is considered a 'simple fault' the electrician may diagnose?",
        "options": [
          "PLC software failure",
          "Safety relay malfunction",
          "Damaged plug or cable",
          "Servo drive alarm"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Before touching any conductor during fault checks, the electrician must:",
        "options": [
          "Inform QC",
          "Wear gloves only",
          "Isolate and verify absence of voltage",
          "Call installers"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Which situation requires involvement of certified technicians?",
        "options": [
          "Loose socket cover",
          "Damaged extension cable",
          "Control system or safety circuit fault",
          "Dust around the machine"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Why must electrical maintenance activities be recorded?",
        "options": [
          "For decoration",
          "For audits, traceability and fault history",
          "To control attendance",
          "To replace supervision"
        ],
        "correctAnswer": 1
      }
    ]
  },
  "portable-equipment-tools": {
    "id": "portable-equipment-tools",
    "title": "Portable Equipment & Tools",
    "modulenumber": "4.8.3",
    "department": "Production",
    "videoUrl": "",
    "duration": 85,
    "description": "To ensure electricians manage all portable electrical equipment safely, prevent shocks and fires, control battery charging risks, apply basic PAT discipline, and correctly remove unsafe tools from service.",
    "requiredRoles": ["electrician", "maintenance-technician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Why are extension cables considered high-risk equipment?",
        "options": [
          "They are expensive",
          "They are frequently moved and easily damaged",
          "They use low voltage",
          "They are only for offices"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Which extension-cable practice is safe?",
        "options": [
          "Daisy-chaining several leads",
          "Using taped repairs",
          "Fully uncoiling the cable before use",
          "Passing cables under machines"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Battery charging should only be done:",
        "options": [
          "Anywhere near machines",
          "In offices",
          "At designated and ventilated charging areas",
          "Inside distribution boards"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Which battery must NOT be charged?",
        "options": [
          "A new battery",
          "A warm battery",
          "A swollen or leaking battery",
          "A half-charged battery"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Why must tool power cords be inspected regularly?",
        "options": [
          "To reduce tool noise",
          "To improve appearance",
          "To prevent electric shock and fire",
          "To increase tool speed"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "If a damaged power cord is found, the electrician must:",
        "options": [
          "Continue using the tool",
          "Tape the cable",
          "Remove it from service and label it",
          "Ask the user to be careful"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "PAT mainly focuses on:",
        "options": [
          "Tool performance",
          "Mechanical strength",
          "Electrical safety of portable equipment",
          "Productivity"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Which item must be included under PAT discipline?",
        "options": [
          "Fixed distribution boards",
          "CNC machines",
          "Extension leads and portable tools",
          "Lighting poles"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "What must be done when a tool fails a PAT check?",
        "options": [
          "Return it to the store",
          "Allow limited use",
          "Label and isolate it",
          "Lend it to another team"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Which is the correct first step when decommissioning faulty equipment?",
        "options": [
          "Repair it immediately",
          "Store it in the workshop",
          "Disconnect and isolate it",
          "Give it to installers"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "installation-electrical-coordination": {
    "id": "installation-electrical-coordination",
    "title": "Installation Electrical Coordination",
    "modulenumber": "4.8.4",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771234523/e4_mauajb.mp4",
    "duration": 90,
    "description": "To ensure electricians can accurately interpret project electrical drawings, execute precise furniture-integrated electrical works, conceal cabling professionally, mount lighting systems correctly, and deliver clean, high-end finishes consistent with Kajja Galleries' brand standards.",
    "requiredRoles": ["electrician", "installation-electrician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Why must electrical drawings be strictly followed?",
        "options": [
          "To increase speed",
          "To avoid rework and poor finishes",
          "To reduce cable cost",
          "To reduce supervision"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Before drilling socket holes, the electrician must:",
        "options": [
          "Drill immediately",
          "Guess the position",
          "Measure and confirm from fixed references",
          "Ask store manager"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Which reference point is best when measuring socket placement?",
        "options": [
          "Temporary support blocks",
          "Finished cabinet edges",
          "Ceiling height",
          "Floor tiles"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "What is the first step before drilling laminate surfaces?",
        "options": [
          "Increase drill speed",
          "Remove hardware",
          "Protect surface and mark clearly",
          "Ignore alignment"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Concealed cabling must:",
        "options": [
          "Be visible for inspection",
          "Hang freely inside cabinets",
          "Be protected and hidden",
          "Be loosely tied"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Why must cables avoid hinge areas?",
        "options": [
          "To reduce cost",
          "To avoid structural damage and interference",
          "To improve brightness",
          "To shorten cable length"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "When mounting shelf lighting, drivers must be:",
        "options": [
          "Visible for design",
          "Mounted outside cabinets",
          "Hidden but accessible",
          "Fixed under shelves openly"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "What indicates good lighting installation?",
        "options": [
          "Visible screws",
          "Crooked alignment",
          "Even spacing and straight alignment",
          "Hanging wires"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "What should be used at cable entry points?",
        "options": [
          "Tape",
          "Open holes",
          "Grommets or trims",
          "Loose insulation"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Who is responsible for final finish quality of electrical installation?",
        "options": [
          "Client",
          "Installer only",
          "Electrician",
          "Store manager"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "site-safety-client-protection": {
    "id": "site-safety-client-protection",
    "title": "Site Safety & Client Protection",
    "modulenumber": "4.8.5",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771237146/e6_ule295.mp4",
    "duration": 85,
    "description": "To ensure electricians maintain the highest safety standards during site installations, protect client property, prevent accidents, communicate professionally during power interruptions, and strictly follow approved procedures with zero improvisation.",
    "requiredRoles": ["electrician", "installation-electrician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Why is PPE mandatory on client sites?",
        "options": [
          "To look uniform",
          "To comply with dress code",
          "To protect from injury and liability",
          "To increase speed"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "Which PPE is required when drilling?",
        "options": [
          "Helmet only",
          "Safety goggles",
          "Apron",
          "Gloves only"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "What is the first step before working on electrical systems?",
        "options": [
          "Inform store manager",
          "Switch off and isolate supply",
          "Remove cover",
          "Call installer"
        ],
        "correctAnswer": 1
      },
      {
        "id": 4,
        "question": "After isolating power, the electrician must:",
        "options": [
          "Start work immediately",
          "Assume power is off",
          "Test for absence of voltage",
          "Close panel"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Why is live work prohibited?",
        "options": [
          "It slows installation",
          "It increases cost",
          "It creates serious injury risk",
          "It reduces lighting"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Which action helps prevent tripping hazards?",
        "options": [
          "Leaving cables loose",
          "Organizing and routing cables properly",
          "Storing tools randomly",
          "Working quickly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "Before interrupting power, the electrician must:",
        "options": [
          "Switch off immediately",
          "Inform client representative",
          "Ignore communication",
          "Finish other tasks"
        ],
        "correctAnswer": 1
      },
      {
        "id": 8,
        "question": "Why must power interruptions be communicated clearly?",
        "options": [
          "To avoid paperwork",
          "To reduce work time",
          "To prevent disruption and equipment damage",
          "To impress client"
        ],
        "correctAnswer": 2
      },
      {
        "id": 9,
        "question": "Improvised electrical solutions are dangerous because they:",
        "options": [
          "Save time",
          "Look temporary",
          "Can cause fire and failure",
          "Reduce supervision"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "When unsure about installation standards, the electrician must:",
        "options": [
          "Guess",
          "Follow previous habits",
          "Stop and consult supervisor",
          "Ask client"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "einventory-documentation": {
    "id": "einventory-documentation",
    "title": "Inventory & Documentation",
    "modulenumber": "4.8.6",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771238607/e7_ozvhec.mp4",
    "duration": 85,
    "description": "To ensure electricians maintain strict control of electrical consumables, document all repairs and modifications accurately, coordinate with the Store Manager properly, and maintain professional circuit labelling standards that support safety, traceability, and operational efficiency.",
    "requiredRoles": ["electrician", "installation-electrician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "Why must electrical consumables be tracked?",
        "options": [
          "To increase paperwork",
          "To prevent shortages and financial loss",
          "To slow production",
          "To reduce supervision"
        ],
        "correctAnswer": 1
      },
      {
        "id": 2,
        "question": "Which item is considered a high-control electrical spare?",
        "options": [
          "Tape",
          "LED driver",
          "Paper labels",
          "Marker pen"
        ],
        "correctAnswer": 1
      },
      {
        "id": 3,
        "question": "Materials must be withdrawn from stores using:",
        "options": [
          "Verbal request",
          "Personal agreement",
          "Approved documentation or job card",
          "Phone call only"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Why are repair logs important?",
        "options": [
          "For decoration",
          "To track recurring faults and support maintenance history",
          "To increase speed",
          "To replace supervision"
        ],
        "correctAnswer": 1
      },
      {
        "id": 5,
        "question": "If maintenance is not documented, it is considered:",
        "options": [
          "Completed",
          "Approved",
          "Not done",
          "Optional"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "Why must material usage be reported to the Store Manager?",
        "options": [
          "To reduce documentation",
          "To enable proper reordering",
          "To increase inspection",
          "To avoid meetings"
        ],
        "correctAnswer": 1
      },
      {
        "id": 7,
        "question": "What is the risk of undocumented electrical modifications?",
        "options": [
          "Faster work",
          "Improved flexibility",
          "Future safety hazards and confusion",
          "Reduced cost"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "Which change must always be documented?",
        "options": [
          "Cleaning cables",
          "Circuit relocation",
          "Wiping dust",
          "Wearing PPE"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "Why is circuit labelling critical?",
        "options": [
          "To improve decoration",
          "To speed installation",
          "To ensure safe isolation and fault tracing",
          "To reduce supervision"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Which practice is unacceptable?",
        "options": [
          "Permanent labelling",
          "Clear breaker identification",
          "Relying on memory for circuit identification",
          "Updating circuit schedules"
        ],
        "correctAnswer": 2
      }
    ]
  },
  "emergency-response": {
    "id": "emergency-response",
    "title": "Emergency Response",
    "modulenumber": "4.8.7",
    "department": "Production",
    "videoUrl": "https://res.cloudinary.com/dgfm6l4ea/video/upload/v1771239848/e8_kmj1xw.mp4",
    "duration": 85,
    "description": "To ensure electricians respond correctly, calmly and safely during electrical emergencies, protect lives first, prevent escalation of incidents, and maintain full transparency and reporting discipline after any electricity-related event.",
    "requiredRoles": ["electrician", "installation-electrician"],
    "validityMinutes": 259200,
    "quiz": [
      {
        "id": 1,
        "question": "What is the first rule in electrical first aid?",
        "options": [
          "Start CPR immediately",
          "Call client",
          "Protect yourself first",
          "Move the victim quickly"
        ],
        "correctAnswer": 2
      },
      {
        "id": 2,
        "question": "If someone is in contact with live current, you must first:",
        "options": [
          "Pull them away",
          "Pour water",
          "Isolate power source",
          "Call store manager"
        ],
        "correctAnswer": 2
      },
      {
        "id": 3,
        "question": "Why must electrical shock victims seek medical evaluation?",
        "options": [
          "For insurance",
          "For documentation",
          "Because internal injuries may not be visible",
          "For compliance"
        ],
        "correctAnswer": 2
      },
      {
        "id": 4,
        "question": "Which extinguisher is safe for electrical fires?",
        "options": [
          "Water",
          "Foam",
          "CO₂ or dry chemical",
          "Sand only"
        ],
        "correctAnswer": 2
      },
      {
        "id": 5,
        "question": "Why must water never be used on live electrical fires?",
        "options": [
          "It evaporates",
          "It spreads fire",
          "It conducts electricity",
          "It damages paint"
        ],
        "correctAnswer": 2
      },
      {
        "id": 6,
        "question": "If fire spreads beyond control, you must:",
        "options": [
          "Continue fighting",
          "Ignore it",
          "Evacuate immediately",
          "Close door only"
        ],
        "correctAnswer": 2
      },
      {
        "id": 7,
        "question": "Which is unsafe when assisting someone exposed to live current?",
        "options": [
          "Switching off power",
          "Using insulated object",
          "Touching victim with bare hands",
          "Calling emergency services"
        ],
        "correctAnswer": 2
      },
      {
        "id": 8,
        "question": "After any electrical incident, the area must be:",
        "options": [
          "Cleaned only",
          "Secured and isolated",
          "Left untouched",
          "Re-energized quickly"
        ],
        "correctAnswer": 1
      },
      {
        "id": 9,
        "question": "What must be included in incident reporting?",
        "options": [
          "Opinions",
          "Blame",
          "Factual description of what happened",
          "Personal assumptions"
        ],
        "correctAnswer": 2
      },
      {
        "id": 10,
        "question": "Minor electrical incidents should be:",
        "options": [
          "Ignored",
          "Hidden",
          "Reported",
          "Discussed privately"
        ],
        "correctAnswer": 2
      }
    ]
  },
  'health-safety-cleanliness': {
    id: 'health-safety-cleanliness',
    title: 'Health, Safety & Cleanliness',
    modulenumber: '4.1.6',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769598789/prod7_wdqvsv.mp4',
    duration: 90,
    description: 'PPE enforcement, safe material handling, fire safety, 5S cleanliness system, and workshop hygiene.',
    requiredRoles: ['head_of_production', 'quality-control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "PPE is important because it:",
        options: [
          "Slows down work intentionally",
          "Makes workers look more professional",
          "Protects workers from injuries and health hazards",
          "Creates more noise in the workshop"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Workers without PPE should:",
        options: [
          "Be allowed to work if they are careful",
          "Be stopped from working immediately",
          "Just receive a verbal warning",
          "Work only on non-dangerous tasks"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Emergency procedures help to:",
        options: [
          "Confuse the workshop staff",
          "Respond quickly and safely during accidents",
          "Waste valuable production time",
          "Lock emergency exits for safety"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Panels should be handled properly to:",
        options: [
          "Increase the risk of worker injuries",
          "Avoid worker injuries and prevent board damage",
          "Slow down the production process",
          "Test the strength of the materials"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Blade changes should be done:",
        options: [
          "While the machine is still running to save time",
          "By trained operators with the machine switched off",
          "By any available worker",
          "Without safety gloves for better grip"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Chemicals should be:",
        options: [
          "Stored anywhere that is convenient",
          "Stored in clearly labeled containers in safe locations",
          "Mixed freely to create new finishes",
          "Kept near heat sources to dry faster"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Fire safety inspections help to:",
        options: [
          "Decorate fire extinguishers nicely",
          "Prevent workshop fires and protect assets",
          "Reduce production output",
          "Increase wood dust accumulation"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Smoking in the workshop is:",
        options: [
          "Allowed in designated areas",
          "Strictly prohibited at all times",
          "Encouraged during breaks",
          "Ignored if done carefully"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "The first 'S' in 5S stands for:",
        options: [
          "Shine - cleaning everything",
          "Sort - removing unnecessary items",
          "Set - organizing tools",
          "Sustain - maintaining discipline"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "'Shine' in 5S refers to:",
        options: [
          "Decorating workshop walls with paint",
          "Daily cleaning of machines, floors, and work areas",
          "Only polishing finished products",
          "Workers wearing shiny, clean shoes"
        ],
        correctAnswer: 1
      }
    ]
  },
  'documentation-reporting': {
    id: 'documentation-reporting',
    title: 'Documentation & Reporting',
    modulenumber: '4.1.7',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769600540/prod8_cnqomq.mp4',
    duration: 90,
    description: 'Production dashboards, daily reports, quality documentation, job closure procedures, and truthful data culture.',
    requiredRoles: ['head_of_production', 'quality-control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "A production dashboard is used to:",
        options: [
          "Decorate the office walls",
          "Track key workshop performance indicators (KPIs)",
          "Replace Job Cards and instructions",
          "Calculate worker payments"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "KPIs help management to:",
        options: [
          "Guess how the workshop is performing",
          "See progress and identify problems clearly",
          "Hide production delays from clients",
          "Avoid planning future work"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Daily workshop reports answer the question:",
        options: [
          "Who designed the furniture?",
          "What exactly happened in production today?",
          "How much profit was made today?",
          "Which supplier delivered materials?"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Missing daily reports result in:",
        options: [
          "Better control over production",
          "No visibility and poor planning",
          "Faster production output",
          "More disciplined workers"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Quality documentation is important because it:",
        options: [
          "Wastes paper and time",
          "Proves QC was done and protects the company",
          "Decorates the filing cabinet",
          "Replaces the need for actual inspection"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "First-piece inspection ensures:",
        options: [
          "Machines are making enough noise",
          "Cutting accuracy before mass production begins",
          "Workers are paid on time",
          "Designs use colorful materials"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "A job should be closed only after:",
        options: [
          "Sales gives verbal approval",
          "Final QC sign-off is completed",
          "Workers give their permission",
          "The machine is shut down for the day"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "No QC sign-off means:",
        options: [
          "Delivery is allowed to proceed",
          "Delivery is not allowed",
          "Installation can begin immediately",
          "The client has already been informed"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Guessing production data leads to:",
        options: [
          "Correct management decisions",
          "Wrong management decisions and hidden problems",
          "Higher trust in the workshop",
          "Faster project delivery"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Data truth means:",
        options: [
          "Adjusting numbers to look good for management",
          "Reporting only measured and verified information",
          "Hiding waste to avoid questions",
          "Reporting from memory without checking"
        ],
        correctAnswer: 1
      }
    ]
  },
  'strategic-finance-growth': {
    id: 'strategic-finance-growth',
    title: 'Strategic Finance & Growth',
    modulenumber: '3.2.9',
    department: 'Finance',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773307425/fy1_yicjib.mp4',
    duration: 100,
    description: 'Capital budgeting, investor relations, banking relationships, expansion risk analysis, and board-level financial presentations',
    requiredRoles: ['head-of-finance', 'finance-manager', 'accountant'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Capital budgeting is about:",
        options: [
          "Daily expenses",
          "Long-term investment decisions",
          "Payroll only",
          "Small purchases"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Investors primarily want:",
        options: [
          "Stories only",
          "Transparent numbers and returns",
          "Promises",
          "Guesswork"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Overdrafts should be used:",
        options: [
          "Permanently",
          "To fund losses",
          "Temporarily for cash gaps",
          "For luxury spending"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "Expansion risk analysis helps to:",
        options: [
          "Stop growth",
          "Identify dangers before entering new markets",
          "Delay decisions unnecessarily",
          "Impress competitors"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Board financial presentations should:",
        options: [
          "Confuse directors",
          "Show clear trends, risks, and recommendations",
          "Hide problems",
          "Focus only on accounting rules"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "What must finance ask before capital investment?",
        options: [
          "Only the purchase price",
          "What problem it solves, cost, revenue/savings, payback period, cash flow impact",
          "Only the brand name",
          "Only installation cost"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "What do investor documents typically include?",
        options: [
          "Only company history",
          "Financial projections, use-of-funds, profitability model, risk mitigation",
          "Only employee names",
          "Only product photos"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "What should overdrafts never be used for?",
        options: [
          "Short-term cash gaps",
          "Covering losses or long-term costs",
          "Seasonal inventory",
          "Temporary supplier delays"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "What must finance assess before expansion?",
        options: [
          "Only competitor locations",
          "Market demand, pricing, cost structure, cash flow, tax compliance, worst-case scenarios",
          "Only exchange rates",
          "Only weather patterns"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "What builds board confidence?",
        options: [
          "Complex spreadsheets",
          "Clarity and honesty, not perfection",
          "Accounting jargon",
          "Hidden problems"
        ],
        correctAnswer: 1
      }
    ]
  },
  'strategic-growth-mindset': {
    id: 'strategic-growth-mindset',
    title: 'Strategic Growth Mindset',
    modulenumber: '4.1.8',
    department: 'Production',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1769601993/prod9_hpgi0j.mp4',
    duration: 90,
    description: 'Technology adoption, skill matrix development, cost benchmarking, continuous improvement, and scaling preparation.',
    requiredRoles: ['head_of_production', 'quality-control', 'head_quality_control'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Technology in production is important because it:",
        options: [
          "Makes the workshop noisier and less efficient",
          "Stops the need for worker training and supervision",
          "Enables speed, precision, and supports business growth",
          "Replaces the need for all human workers"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "A skill matrix helps to:",
        options: [
          "Slow down the production process intentionally",
          "Identify team skills, gaps, and training needs clearly",
          "Decorate the workshop walls with charts",
          "Reduce teamwork and encourage competition"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Without a skill matrix:",
        options: [
          "Teams become more flexible and adaptable automatically",
          "Work quality automatically improves without effort",
          "One person's absence can stop production entirely",
          "Production costs are always reduced naturally"
        ],
        correctAnswer: 2
      },
      {
        id: 4,
        question: "Benchmarking means:",
        options: [
          "Ignoring what competitors do completely",
          "Reducing product quality to save money",
          "Comparing production costs and efficiency to industry standards",
          "Copying competitors without understanding their methods"
        ],
        correctAnswer: 2
      },
      {
        id: 5,
        question: "Benchmarking helps protect:",
        options: [
          "Only the gross profit figure on reports",
          "Worker salary levels regardless of performance",
          "The size of the workshop and number of machines",
          "The target net profit margin (25–35%)"
        ],
        correctAnswer: 3
      },
      {
        id: 6,
        question: "Continuous improvement focuses on:",
        options: [
          "One-time, large-scale changes only",
          "Ignoring ideas from workshop staff",
          "Delaying production work for analysis",
          "Ongoing small improvements in processes"
        ],
        correctAnswer: 3
      },
      {
        id: 7,
        question: "Encouraging worker ideas helps to:",
        options: [
          "Waste valuable production time on discussions",
          "Reduce discipline and standards in the workshop",
          "Increase errors and rework through experimentation",
          "Build ownership and find better solutions"
        ],
        correctAnswer: 3
      },
      {
        id: 8,
        question: "Scaling to East Africa requires:",
        options: [
          "Random workshop setups in each new location",
          "Only marketing and sales efforts, not production systems",
          "No documentation of processes or methods",
          "Standardized, documented production systems"
        ],
        correctAnswer: 3
      },
      {
        id: 9,
        question: "The Head of Production supports expansion by:",
        options: [
          "Managing only today's immediate jobs and deadlines",
          "Selling products directly to new clients",
          "Standardizing SOPs and training future supervisors",
          "Posting on social media about the company"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "Automation opportunities should be:",
        options: [
          "Ignored to save immediate costs",
          "Left only to the finance department to decide",
          "Decided by workers without management review",
          "Identified and tested by production leadership"
        ],
        correctAnswer: 3
      }
    ]
  },
  'foundational-leadership-company-purpose': {
    id: 'foundational-leadership-company-purpose',
    title: 'Foundational Leadership & Company Purpose',
    modulenumber: '1.2.0',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773045742/med1_du6vqo.mp4',
    duration: 95,
    description: 'Stewardship vs management, vision-mission-values, high-performance culture, executive communication, and ethical governance',
    requiredRoles: ['managing-director','ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "What is the main difference between stewardship and management?",
        options: [
          "Stewardship focuses on daily tasks while management focuses on strategy",
          "Stewardship focuses on protecting the long-term future while management handles daily operations",
          "Stewardship focuses on finances while management focuses on marketing",
          "There is no difference"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "The vision of a company describes:",
        options: [
          "How employees should behave daily",
          "Where the company wants to be in the future",
          "The financial reports of the company",
          "The salary structure of employees"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "The mission of a company explains:",
        options: [
          "The company's internal policies",
          "How the company creates value for customers",
          "The company's accounting procedures",
          "The recruitment process"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Organizational culture is mainly shaped by:",
        options: [
          "Government regulations",
          "Leadership behavior and decisions",
          "Office furniture design",
          "Company location"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "High-performance culture means employees:",
        options: [
          "Avoid responsibility",
          "Deliver quality work and respect deadlines",
          "Work only when supervised",
          "Focus only on creativity"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Leadership influence at the executive level comes from:",
        options: [
          "Authority alone",
          "Knowledge, integrity, and consistency",
          "Company size",
          "Marketing campaigns"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Ethical governance helps protect a company from:",
        options: [
          "Growth opportunities",
          "Legal risks and reputational damage",
          "Customer relationships",
          "Strategic planning"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Ethical leadership requires decisions based on:",
        options: [
          "Personal preference",
          "Immediate convenience",
          "Long-term sustainability and integrity",
          "Employee popularity"
        ],
        correctAnswer: 2
      },
      {
        id: 9,
        question: "Who is primarily responsible for protecting the company's culture?",
        options: [
          "Human resource department",
          "Production manager",
          "Managing Director",
          "Store manager"
        ],
        correctAnswer: 2
      },
      {
        id: 10,
        question: "The Managing Director's most important role is to:",
        options: [
          "Perform all company tasks personally",
          "Guide the company strategically and protect its future",
          "Control employee attendance",
          "Manage accounting records"
        ],
        correctAnswer: 1
      }
    ]
  },
  'strategic-management-business-growth': {
    id: 'strategic-management-business-growth',
    title: 'Strategic Management & Business Growth',
    modulenumber: '1.2.1',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773047553/med2_awskbd.mp4',
    duration: 100,
    description: 'Strategic planning frameworks, market intelligence, competitive positioning, business model evolution, expansion pathways, and stakeholder management',
    requiredRoles: ['managing-director','ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "What is the purpose of strategic planning?",
        options: [
          "Managing daily tasks",
          "Defining long-term direction and allocating resources",
          "Hiring employees",
          "Reducing staff workload"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "SWOT analysis evaluates:",
        options: [
          "Finance reports only",
          "Strengths, weaknesses, opportunities, and threats",
          "Employee performance",
          "Government regulations only"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "PESTLE analysis helps organizations understand:",
        options: [
          "Customer complaints",
          "External environmental factors affecting the business",
          "Employee salaries",
          "Production techniques"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Market intelligence refers to:",
        options: [
          "Internal employee training",
          "Understanding customers, competitors, and industry trends",
          "Financial auditing",
          "Production scheduling"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Competitive positioning means:",
        options: [
          "Offering the lowest prices always",
          "Clearly defining why customers should choose the company",
          "Ignoring competitors",
          "Selling as many products as possible"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "A business model explains:",
        options: [
          "How employees are paid",
          "How the company creates value and generates revenue",
          "How products are manufactured",
          "How marketing campaigns are designed"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Innovation in a business primarily aims to:",
        options: [
          "Increase complexity",
          "Improve efficiency and value creation",
          "Reduce employee responsibility",
          "Avoid competition"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Expansion into new regions should only occur when:",
        options: [
          "The company has adequate operational and financial capacity",
          "Competitors expand first",
          "Employees request it",
          "Marketing campaigns are successful"
        ],
        correctAnswer: 0
      },
      {
        id: 9,
        question: "Business networks such as BNI are useful because they provide:",
        options: [
          "Free advertising",
          "Referrals and collaboration opportunities",
          "Government contracts",
          "Manufacturing equipment"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Strong stakeholder relationships help a company by:",
        options: [
          "Reducing employee workload",
          "Creating opportunities and strengthening market credibility",
          "Eliminating competition",
          "Increasing production costs"
        ],
        correctAnswer: 1
      }
    ]
  },
  'corporate-governance-board-relations': {
    id: 'corporate-governance-board-relations',
    title: 'Corporate Governance & Board Relations',
    modulenumber: '1.2.2',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773049283/med3_qxbbig.mp4',
    duration: 100,
    description: 'Board vs management roles, board reporting and KPIs, risk governance, policy development, and leadership succession planning',
    requiredRoles: ['managing-director', 'ceo', 'director', 'executive', 'board-member'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "What is the main responsibility of the Board of Directors?",
        options: [
          "Managing daily operations",
          "Supervising production teams",
          "Providing strategic oversight and governance",
          "Managing customer relationships"
        ],
        correctAnswer: 2
      },
      {
        id: 2,
        question: "Who is responsible for executing the company's strategy?",
        options: [
          "Board of Directors",
          "Managing Director and Management Team",
          "External consultants",
          "Customers"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Board dashboards are useful because they:",
        options: [
          "Replace financial reports",
          "Provide a clear visual summary of company performance",
          "Eliminate management meetings",
          "Reduce the need for strategic planning"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "KPIs are used to:",
        options: [
          "Track measurable progress toward company goals",
          "Replace employee supervision",
          "Monitor competitor activities only",
          "Reduce financial reporting"
        ],
        correctAnswer: 0
      },
      {
        id: 5,
        question: "Risk governance refers to:",
        options: [
          "Avoiding all business risks",
          "Identifying and managing risks responsibly",
          "Ignoring operational challenges",
          "Transferring risk to employees"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Compliance oversight helps ensure that a company:",
        options: [
          "Avoids legal and regulatory violations",
          "Increases employee salaries",
          "Reduces production output",
          "Eliminates competition"
        ],
        correctAnswer: 0
      },
      {
        id: 7,
        question: "Company policies exist mainly to:",
        options: [
          "Increase paperwork",
          "Provide clear rules and operational guidelines",
          "Replace leadership decisions",
          "Reduce communication"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Effective policy enforcement requires:",
        options: [
          "Ignoring minor violations",
          "Applying rules consistently across the organization",
          "Leaving enforcement to individual employees",
          "Avoiding disciplinary action"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Leadership succession planning is important because it:",
        options: [
          "Reduces employee training",
          "Ensures leadership continuity during transitions",
          "Eliminates management responsibilities",
          "Avoids hiring new staff"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Talent continuity strengthens an organization by:",
        options: [
          "Reducing knowledge sharing",
          "Preparing employees for future leadership roles",
          "Limiting employee development",
          "Removing management oversight"
        ],
        correctAnswer: 1
      }
    ]
  },
  'financial-leadership-sustainability': {
    id: 'financial-leadership-sustainability',
    title: 'Financial Leadership & Sustainability',
    modulenumber: '1.2.3',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773050750/med4_iatz5n.mp4',
    duration: 105,
    description: 'Financial statements analysis, capital budgeting, pricing strategies, tax compliance, and fraud prevention controls',
    requiredRoles: ['managing-director','ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "The Profit and Loss statement primarily shows:",
        options: [
          "The company's assets",
          "Revenue, expenses, and net profit or loss",
          "Employee performance",
          "Customer feedback"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "The Balance Sheet shows:",
        options: [
          "Daily sales activities",
          "The financial position of the company at a specific time",
          "Customer satisfaction levels",
          "Production schedules"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Why is cash flow important for a business?",
        options: [
          "It measures employee performance",
          "It shows the movement of money in and out of the company",
          "It replaces profit calculations",
          "It determines marketing strategy"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Capital budgeting refers to:",
        options: [
          "Planning employee salaries",
          "Evaluating large long-term investments",
          "Reducing operational expenses",
          "Monitoring daily sales"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Profit margin represents:",
        options: [
          "The total number of sales made",
          "The percentage of profit remaining after costs",
          "The company's total assets",
          "The cost of production"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Pricing decisions should ensure that products:",
        options: [
          "Are always the cheapest in the market",
          "Cover costs and generate reasonable profit",
          "Ignore competitor prices",
          "Reduce production"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "VAT is:",
        options: [
          "A government tax applied to goods and services",
          "A salary deduction",
          "A supplier discount",
          "A production cost"
        ],
        correctAnswer: 0
      },
      {
        id: 8,
        question: "EFRIS is used to:",
        options: [
          "Monitor electronic invoices and receipts",
          "Manage employee attendance",
          "Track production machinery",
          "Monitor supplier deliveries"
        ],
        correctAnswer: 0
      },
      {
        id: 9,
        question: "Internal controls help organizations:",
        options: [
          "Increase marketing budgets",
          "Prevent errors and financial fraud",
          "Reduce customer service",
          "Avoid financial reporting"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Audits are conducted to:",
        options: [
          "Increase employee workload",
          "Verify accuracy and compliance of financial records",
          "Replace financial reports",
          "Reduce tax obligations"
        ],
        correctAnswer: 1
      }
    ]
  },
  'sales-marketing-business-oversight': {
    id: 'sales-marketing-business-oversight',
    title: 'Sales, Marketing & Business Development Oversight',
    modulenumber: '1.2.4',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773052732/md5_nayqmr.mp4',
    duration: 100,
    description: 'B2B sales strategy, key account management, brand building, digital marketing leadership, and customer lifetime value',
    requiredRoles: ['managing-director', 'ceo', 'director', 'executive', 'sales-manager', 'marketing-manager'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "B2B sales refer to sales made primarily to:",
        options: [
          "Individual consumers",
          "Business organizations and institutions",
          "Government only",
          "Retail customers only"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Which of the following is an example of a B2B client?",
        options: [
          "Individual homeowner",
          "Furniture retail shop",
          "Bank or corporate office",
          "Local street vendor"
        ],
        correctAnswer: 2
      },
      {
        id: 3,
        question: "Key accounts are clients that:",
        options: [
          "Purchase small quantities occasionally",
          "Contribute significantly to company revenue",
          "Are new customers",
          "Only buy discounted products"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Effective key account management requires:",
        options: [
          "Ignoring client feedback",
          "Strong relationships and consistent service",
          "Reducing communication",
          "Competing only on price"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Brand building helps a company by:",
        options: [
          "Increasing employee workload",
          "Strengthening market recognition and trust",
          "Reducing production costs",
          "Eliminating competitors"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Public relations primarily focuses on:",
        options: [
          "Managing company reputation with stakeholders",
          "Increasing factory production",
          "Reducing operational costs",
          "Managing employee schedules"
        ],
        correctAnswer: 0
      },
      {
        id: 7,
        question: "Digital marketing allows companies to:",
        options: [
          "Ignore customer feedback",
          "Measure marketing performance using data",
          "Avoid advertising",
          "Reduce customer communication"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Customer Lifetime Value refers to:",
        options: [
          "The value of a single purchase",
          "The total revenue generated from a client over time",
          "The cost of acquiring a customer",
          "The number of customers in a market"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Customer retention strategies focus on:",
        options: [
          "Only acquiring new clients",
          "Maintaining long-term relationships with existing clients",
          "Reducing customer communication",
          "Increasing product prices"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Strong B2B sales strategies prioritize:",
        options: [
          "One-time transactions",
          "Long-term partnerships and repeat business",
          "Discount pricing only",
          "Retail customers only"
        ],
        correctAnswer: 1
      }
    ]
  },
  'operations-excellence-quality': {
    id: 'operations-excellence-quality',
    title: 'Operations Excellence & Quality',
    modulenumber: '1.2.5',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773054607/md6_sigxab.mp4',
    duration: 105,
    description: 'Production efficiency, lean manufacturing, 5S workplace organization, procurement, quality assurance, installation discipline, and health safety governance',
    requiredRoles: ['managing-director','ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Lean manufacturing primarily focuses on:",
        options: [
          "Increasing production complexity",
          "Eliminating waste in production processes",
          "Increasing product prices",
          "Hiring more workers"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "The 5S system helps organizations:",
        options: [
          "Increase marketing budgets",
          "Organize and maintain efficient workplaces",
          "Replace quality inspections",
          "Reduce employee training"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Effective procurement helps a company by:",
        options: [
          "Increasing production delays",
          "Ensuring quality materials at controlled costs",
          "Reducing supplier communication",
          "Eliminating inventory management"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "Supply-chain partnerships are important because they:",
        options: [
          "Reduce employee responsibilities",
          "Improve collaboration and reliability of supply",
          "Increase marketing costs",
          "Replace procurement systems"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Quality assurance ensures that products:",
        options: [
          "Are produced faster only",
          "Meet defined standards and customer expectations",
          "Are always the cheapest",
          "Require frequent repairs"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Rework occurs when:",
        options: [
          "Products are delivered early",
          "Products must be corrected due to errors",
          "Materials are purchased in bulk",
          "Projects are completed successfully"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Installation discipline is important because:",
        options: [
          "Installation affects the final client experience",
          "It reduces employee training",
          "It increases marketing efforts",
          "It replaces production quality"
        ],
        correctAnswer: 0
      },
      {
        id: 8,
        question: "A proper client handover should include:",
        options: [
          "Immediate departure after installation",
          "Demonstrating completed work and confirming client satisfaction",
          "Ignoring client feedback",
          "Avoiding communication with the client"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Health and safety governance aims to:",
        options: [
          "Increase production speed only",
          "Protect employees and clients from workplace risks",
          "Reduce training requirements",
          "Increase machinery use"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Safety training helps employees:",
        options: [
          "Avoid responsibility",
          "Understand safe work procedures and risk prevention",
          "Reduce production output",
          "Eliminate supervision"
        ],
        correctAnswer: 1
      }
    ]
  },
  'human-capital-management': {
    id: 'human-capital-management',
    title: 'Human Capital Management',
    modulenumber: '1.2.6',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773056262/md7_qfycft.mp4',
    duration: 100,
    description: 'Organizational design, workforce planning, performance scorecards, leadership pipeline development, disciplinary governance, and culture transformation',
    requiredRoles: ['managing-director','ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "Organizational design refers to:",
        options: [
          "Hiring new employees only",
          "Structuring roles, responsibilities, and reporting relationships",
          "Reducing staff numbers",
          "Increasing marketing activities"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Workforce planning helps ensure that:",
        options: [
          "Employees work longer hours",
          "The company has the right number of employees with appropriate skills",
          "Departments operate independently",
          "Recruitment is avoided"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Performance scorecards are used to:",
        options: [
          "Monitor and measure management performance",
          "Replace employee training",
          "Increase employee salaries",
          "Reduce communication"
        ],
        correctAnswer: 0
      },
      {
        id: 4,
        question: "Leadership pipeline development focuses on:",
        options: [
          "Hiring external consultants only",
          "Preparing employees for future leadership roles",
          "Eliminating management training",
          "Reducing employee responsibilities"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Disciplinary governance ensures that:",
        options: [
          "Workplace rules are enforced fairly and consistently",
          "Employees are punished frequently",
          "Managers avoid difficult conversations",
          "Company policies are ignored"
        ],
        correctAnswer: 0
      },
      {
        id: 6,
        question: "HR legal compliance helps organizations:",
        options: [
          "Increase marketing budgets",
          "Avoid legal disputes and regulatory penalties",
          "Reduce employee communication",
          "Eliminate performance reviews"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Organizational culture refers to:",
        options: [
          "The office building design",
          "Shared values and behaviors within the company",
          "Employee salary levels",
          "Marketing strategies"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Culture transformation may be required when:",
        options: [
          "The company needs to improve performance standards",
          "Employees request new furniture",
          "The company relocates offices",
          "Production increases"
        ],
        correctAnswer: 0
      },
      {
        id: 9,
        question: "Employee well-being contributes to:",
        options: [
          "Reduced productivity",
          "Higher motivation and improved performance",
          "Increased operational risks",
          "Reduced teamwork"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "A strong leadership pipeline helps organizations:",
        options: [
          "Depend on a single leader",
          "Maintain leadership continuity and long-term stability",
          "Avoid employee development",
          "Reduce training programs"
        ],
        correctAnswer: 1
      }
    ]
  },
  'innovation-technology-digital-transformation': {
    id: 'innovation-technology-digital-transformation',
    title: 'Innovation, Technology & Digital Transformation',
    modulenumber: '1.2.7',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773058497/md8_njfv6z.mp4',
    duration: 100,
    description: 'CNC-enabled manufacturing, automation roadmap, ERP/CRM adoption, data-driven decision making, intellectual property protection, and green manufacturing',
    requiredRoles: ['managing-director','ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "CNC technology is primarily used for:",
        options: [
          "Managing employee schedules",
          "Computer-controlled cutting and shaping of materials",
          "Financial reporting",
          "Marketing campaigns"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Automation in manufacturing helps organizations by:",
        options: [
          "Increasing manual work",
          "Improving production efficiency and accuracy",
          "Eliminating product design",
          "Reducing product quality"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "ERP systems help organizations by:",
        options: [
          "Managing marketing campaigns only",
          "Integrating operations across departments",
          "Replacing financial reporting",
          "Reducing customer communication"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "CRM systems are primarily used to:",
        options: [
          "Track machine maintenance",
          "Manage customer relationships and sales opportunities",
          "Monitor employee attendance",
          "Control inventory levels"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Data-driven decision-making means:",
        options: [
          "Making decisions based on assumptions",
          "Using reliable data and analysis to guide decisions",
          "Ignoring business reports",
          "Avoiding performance measurements"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Intellectual property refers to:",
        options: [
          "Physical company buildings",
          "Unique ideas, designs, and innovations created by the company",
          "Financial records",
          "Supplier contracts"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Protecting intellectual property helps organizations:",
        options: [
          "Reduce marketing efforts",
          "Prevent competitors from copying innovations",
          "Increase production costs",
          "Avoid product development"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Green manufacturing focuses on:",
        options: [
          "Increasing production waste",
          "Minimizing environmental impact",
          "Eliminating automation",
          "Reducing product quality"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Sustainability strategies can benefit a company by:",
        options: [
          "Improving brand reputation and regulatory compliance",
          "Reducing employee productivity",
          "Increasing operational risk",
          "Eliminating innovation"
        ],
        correctAnswer: 0
      },
      {
        id: 10,
        question: "Technology adoption helps companies remain:",
        options: [
          "Unpredictable",
          "Competitive and efficient in modern markets",
          "Dependent on manual processes",
          "Less innovative"
        ],
        correctAnswer: 1
      }
    ]
  },
  'crisis-risk-leadership': {
    id: 'crisis-risk-leadership',
    title: 'Crisis & Risk Leadership',
    modulenumber: '1.2.8',
    department: 'Executive Leadership',
    videoUrl: 'https://res.cloudinary.com/dgfm6l4ea/video/upload/v1773060011/md9_amkm3e.mp4',
    duration: 100,
    description: 'Crisis communication, reputation protection, project risk mapping, legal risk management, financial shock preparedness, and business continuity planning',
    requiredRoles: ['managing-director','ceo'],
    validityMinutes: 259200,
    quiz: [
      {
        id: 1,
        question: "A business crisis refers to:",
        options: [
          "A normal business meeting",
          "An unexpected event that threatens company operations or reputation",
          "A successful project",
          "A marketing campaign"
        ],
        correctAnswer: 1
      },
      {
        id: 2,
        question: "Effective crisis communication should be:",
        options: [
          "Delayed and informal",
          "Clear, timely, and responsible",
          "Limited to internal staff only",
          "Avoided to prevent attention"
        ],
        correctAnswer: 1
      },
      {
        id: 3,
        question: "Risk mapping helps organizations:",
        options: [
          "Eliminate all risks completely",
          "Identify potential risks before they occur",
          "Increase project costs",
          "Delay project planning"
        ],
        correctAnswer: 1
      },
      {
        id: 4,
        question: "A contract primarily defines:",
        options: [
          "Employee schedules",
          "Terms and responsibilities between parties",
          "Marketing strategies",
          "Production techniques"
        ],
        correctAnswer: 1
      },
      {
        id: 5,
        question: "Warranties provide assurance that:",
        options: [
          "Employees will meet deadlines",
          "Products or services meet agreed quality standards",
          "Suppliers reduce prices",
          "Customers will pay on time"
        ],
        correctAnswer: 1
      },
      {
        id: 6,
        question: "Legal liabilities refer to:",
        options: [
          "Marketing expenses",
          "Financial responsibilities for damages or losses",
          "Production targets",
          "Employee training programs"
        ],
        correctAnswer: 1
      },
      {
        id: 7,
        question: "Cash reserves help companies:",
        options: [
          "Increase marketing campaigns",
          "Survive financial shocks and unexpected expenses",
          "Reduce production capacity",
          "Avoid financial planning"
        ],
        correctAnswer: 1
      },
      {
        id: 8,
        question: "Managing receivables involves:",
        options: [
          "Reducing production costs",
          "Ensuring customer payments are collected promptly",
          "Hiring more employees",
          "Increasing marketing activities"
        ],
        correctAnswer: 1
      },
      {
        id: 9,
        question: "Business continuity planning helps organizations:",
        options: [
          "Avoid strategic planning",
          "Continue operating during disruptions",
          "Eliminate employee responsibilities",
          "Reduce customer service"
        ],
        correctAnswer: 1
      },
      {
        id: 10,
        question: "Organizations with strong continuity plans are able to:",
        options: [
          "Avoid all disruptions",
          "Recover faster from crises",
          "Reduce leadership responsibilities",
          "Ignore operational risks"
        ],
        correctAnswer: 1
      }
    ]
  },
 
    
   
      'marketing-social-media-foundation': {
        id: 'marketing-social-media-foundation',
        title: 'Marketing & Social Media Foundation',
        department: 'Management & Administration',
        videoUrl: '/videos/marketting-social.mp4',
        duration: 95,
        modulenumber: '1.3.7',
        description: 'Marketing fundamentals, brand positioning, customer segmentation, social media strategy, and B2B lead generation',
        requiredRoles: ['ceo', 'quality-control','manager','office-staff'],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            id: 1,
            question: "What is the primary role of the Marketing Team at Kajja Galleries?",
            options: [
              "To create noise and entertainment",
              "To close deals and negotiate prices",
              "To create demand and generate qualified B2B leads",
              "To manage production timelines"
            ],
            correctAnswer: 2
          },
          {
            id: 2,
            question: "What three elements make up the Kajja brand promise?",
            options: [
              "Speed, Quality, Luxury",
              "Efficiency, Creativity, Trust",
              "Innovation, Tradition, Excellence",
              "Affordability, Speed, Style"
            ],
            correctAnswer: 1
          },
          {
            id: 3,
            question: "How should Kajja be positioned in the market?",
            options: [
              "As a household carpentry service",
              "As a luxury boutique furniture maker",
              "As a commercial and bulk furniture partner",
              "As a custom one-off furniture artist"
            ],
            correctAnswer: 2
          },
          {
            id: 4,
            question: "What do developers value most according to customer segmentation?",
            options: [
              "Lowest possible prices",
              "Artistic design only",
              "Reliability and timelines",
              "Social media presence"
            ],
            correctAnswer: 2
          },
          {
            id: 5,
            question: "What is the role of social media in Kajja's marketing strategy?",
            options: [
              "To close deals directly with clients",
              "To post personal opinions about competitors",
              "To support sales by attracting, educating, converting, or reinforcing trust",
              "To replace face-to-face meetings entirely"
            ],
            correctAnswer: 2
          },
          {
            id: 6,
            question: "How should creativity be shown according to Kajja's brand promise?",
            options: [
              "Through abstract artistic concepts",
              "Through modern design, CNC precision, and smart solutions",
              "Through expensive materials only",
              "Through following international trends blindly"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "What must marketing highlight about Kajja's capabilities?",
            options: [
              "Only finished product photos",
              "Employee personal stories",
              "CNC capacity, large B2B projects, and disciplined processes",
              "Competitor weaknesses"
            ],
            correctAnswer: 2
          },
          {
            id: 8,
            question: "What do hotels typically need from a furniture partner?",
            options: [
              "Custom artwork for each room",
              "Volume consistency across multiple units",
              "The cheapest possible materials",
              "Flexible delivery dates"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What should happen to all marketing inquiries?",
            options: [
              "They should be negotiated directly by marketing",
              "They must be qualified, recorded, and handed to the Client Relations Officer",
              "They should be ignored until confirmed by client",
              "They should be posted on social media"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What type of evidence builds trust according to the training?",
            options: [
              "Empty marketing claims",
              "Case studies, testimonials, before-and-after visuals, and partnerships",
              "Loud advertising",
              "Competitive pricing only"
            ],
            correctAnswer: 1
          },
          {
            id: 11,
            question: "What should marketing track and report weekly?",
            options: [
              "Only expenses and costs",
              "Which posts generate inquiries and reduce what does not",
              "Employee attendance only",
              "Production delays"
            ],
            correctAnswer: 1
          },
          {
            id: 12,
            question: "What is the main difference between Marketing and Sales at Kajja?",
            options: [
              "Marketing focuses on closing deals, Sales on advertising",
              "Marketing creates demand and leads, Sales focuses on closing deals",
              "There is no difference - they do the same work",
              "Marketing handles production, Sales handles design"
            ],
            correctAnswer: 1
          },
          {
            id: 13,
            question: "What must marketing coordinate with before posting content?",
            options: [
              "Only the CEO",
              "Design, production, QC, and sales departments",
              "Only the finance department",
              "External advertising agencies only"
            ],
            correctAnswer: 1
          },
          {
            id: 14,
            question: "What does the training say about making claims in marketing?",
            options: [
              "Make bold claims to attract attention",
              "Never communicate claims without evidence",
              "Exaggerate slightly to stand out",
              "Copy claims from competitors"
            ],
            correctAnswer: 1
          },
          {
            id: 15,
            question: "What type of clients should marketing focus on generating leads from?",
            options: [
              "Individual household customers only",
              "Developers, offices, hotels, institutions, and bulk buyers",
              "Only government institutions",
              "Only international luxury clients"
            ],
            correctAnswer: 1
          }
        ]
      },
      'on-site-conduct-client-relationships': {
        id: 'on-site-conduct-client-relationships',
        title: 'On-Site Conduct & Client Relationships',
        department: 'Client Relations',
        videoUrl: '/videos/siteconduct.mp4',
        modulenumber: '1.8.1',
        duration: 90,
        description: 'Professional on-site behavior, installation standards, documentation procedures, and long-term relationship building',
        requiredRoles: ['marketing-sales', 'ceo', 'manager', ],
        validityMinutes: 259200, // 6 months in minutes
        quiz: [
          {
            id: 1,
            question: "What does every client site visit represent for Kajja Galleries?",
            options: [
              "Just another job completion",
              "A live reflection of our brand",
              "A chance to take shortcuts",
              "Only a technical installation task"
            ],
            correctAnswer: 1
          },
          {
            id: 2,
            question: "How should you always introduce yourself on client sites?",
            options: [
              "Casually and informally",
              "Only if the client asks",
              "Clearly and professionally",
              "Through social media tags only"
            ],
            correctAnswer: 2
          },
          {
            id: 3,
            question: "What feeling should clients always have during site visits?",
            options: [
              "'We are saving money'",
              "'We are in the hands of professionals'",
              "'This is taking too long'",
              "'They are inexperienced'"
            ],
            correctAnswer: 1
          },
          {
            id: 4,
            question: "What should the CRO check during installation visits?",
            options: [
              "Only the invoice amount",
              "Alignment, smooth door movement, clean joints, secure fittings, and zero scratches",
              "Only client payment status",
              "Only transportation costs"
            ],
            correctAnswer: 1
          },
          {
            id: 5,
            question: "What should you do if something looks wrong during installation?",
            options: [
              "Fix it immediately without telling anyone",
              "Report immediately to Operations and QC",
              "Ignore it if the client doesn't notice",
              "Blame the production team on the spot"
            ],
            correctAnswer: 1
          },
          {
            id: 6,
            question: "What should you NEVER promise on client sites?",
            options: [
              "Your contact information",
              "Fixes without approval from the company",
              "To arrive on time",
              "To wear safety shoes"
            ],
            correctAnswer: 1
          },
          {
            id: 7,
            question: "How should you handle client spaces?",
            options: [
              "Leave tools scattered for efficiency",
              "Respect them at all times and clean before leaving",
              "Treat them like our workshop",
              "Let the client clean up afterwards"
            ],
            correctAnswer: 1
          },
          {
            id: 8,
            question: "What should you always ask permission for?",
            options: [
              "Taking lunch breaks",
              "Moving client items or using power outlets",
              "Wearing branded clothing",
              "Speaking to the client"
            ],
            correctAnswer: 1
          },
          {
            id: 9,
            question: "What type of photos should be captured?",
            options: [
              "Only artistic shots",
              "Clear before, during, and after photos with good lighting",
              "Only photos of the team",
              "Only when problems occur"
            ],
            correctAnswer: 1
          },
          {
            id: 10,
            question: "What do installation photos serve as?",
            options: [
              "Social media content only",
              "Quality proof and future trust-building tools",
              "Employee performance records",
              "Competitor research material"
            ],
            correctAnswer: 1
          },
          {
            id: 11,
            question: "What should happen during handover?",
            options: [
              "Just leave the keys and go",
              "Walk through installation, explain warranties, collect sign-off",
              "Send an email later",
              "Let the client figure everything out"
            ],
            correctAnswer: 1
          },
          {
            id: 12,
            question: "How is trust built with clients?",
            options: [
              "Through lowest prices only",
              "Through reliability, honesty, and proactive communication",
              "Through aggressive marketing",
              "Through ignoring small issues"
            ],
            correctAnswer: 1
          },
          {
            id: 13,
            question: "What do key accounts (banks, developers, institutions) require?",
            options: [
              "Discounts only",
              "VIP care through quick responses and regular check-ins",
              "Less communication to not bother them",
              "Casual informal relationships"
            ],
            correctAnswer: 1
          },
          {
            id: 14,
            question: "When should you ask for referrals?",
            options: [
              "During the first meeting",
              "Never - it's unprofessional",
              "Politely after successful delivery",
              "Only if the client is unhappy"
            ],
            correctAnswer: 2
          },
          {
            id: 15,
            question: "What is installation considered at Kajja Galleries?",
            options: [
              "The end of the transaction",
              "The beginning of the relationship",
              "Just a technical procedure",
              "The marketing team's responsibility"
            ],
            correctAnswer: 1
          },
               
        
        ]
      }
    
  

};

// Helper function to get modules by role
export const getModulesByRole = (role) => {
  if (!role) {
    // console.log('No role provided to getModulesByRole');
    return [];
  }
  
  // console.log(`Checking modules for role: "${role}"`);
  
  // Filter modules where the user's role is included in requiredRoles
  const availableModules = Object.values(trainingModules).filter(module => {
    const hasAccess = module.requiredRoles.includes(role);
    // console.log(`Module "${module.title}": requiredRoles=${JSON.stringify(module.requiredRoles)}, hasAccess=${hasAccess}`);
    return hasAccess;
  });
  
  // console.log(`Found ${availableModules.length} modules for role "${role}"`);
  return availableModules;
};